_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[82,29],{

/***/ "+2AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SELLER_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellerInfoReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var GET_SELLER_INFOS = 'GET_SELLER_INFOS';
var initialState = {
  email: null,
  salesmanID: ''
};
var sellerInfoReducer = function sellerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_SELLER_INFOS:
      {
        var sellerInfo = action.payload.sellerInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          email: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.email) || null,
          salesmanID: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.salesmanID) || ''
        });
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "+7q0":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("eN33"),
    defineProperty = __webpack_require__("Pz+s"),
    identity = __webpack_require__("zWgn");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "+LXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COOKIE_PREFERENCES_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COOKIE_PREFERENCES_PERSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COOKIE_PREFERENCES_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COOKIE_PREFERENCES_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COOKIE_WARNING_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIES_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COOKIE_PREFERENCES_DIDOMI_CONSENT; });
var COOKIE_PREFERENCES_STATS = 'statsCookie';
var COOKIE_PREFERENCES_PERSO = 'persoCookie';
var COOKIE_PREFERENCES_MEDIA = 'mediaCookie';
var COOKIE_PREFERENCES_LAYER = 'cookiePreferences';
var COOKIE_WARNING_LOCALSTORAGE_KEY = 'cookieBanner';
var COOKIES_ARRAY = [COOKIE_PREFERENCES_STATS, COOKIE_PREFERENCES_PERSO, COOKIE_PREFERENCES_MEDIA];
var COOKIE_PREFERENCES_DIDOMI_CONSENT = 'didomiVendorsConsent';

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "+pJz":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "/+ub":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");
var createElement = __webpack_require__("a4SZ");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "/ExG":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var store = __webpack_require__("l6h7");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SELECTED_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_TRANSPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_CRITERIA_TRANSPORTS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_FILTERED_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SORT_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSameJourney; });
/* unused harmony export isSameTransport */
/* unused harmony export disableAdditionalTransportFilters */
/* unused harmony export toggleAdditionalTransportFilter */
/* unused harmony export unselectAdditionalTransportsFilterCategory */
/* unused harmony export updateAdditionalTransportsSort */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("uL19");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NLwV");
/* harmony import */ var _transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Fk4B");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var CLEAR_ADDITIONAL_TRANSPORTS = 'CLEAR_ADDITIONAL_TRANSPORTS';
var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
var CREATE_ADDITIONAL_TRANSPORTS_FILTERS = 'CREATE_ADDITIONAL_TRANSPORTS_FILTERS';
var SET_FILTERED_ADDITIONAL_TRANSPORTS = 'SET_FILTERED_ADDITIONAL_TRANSPORTS';
var TOGGLE_FILTER = 'TOGGLE_FILTER';
var DISABLE_FILTERS = 'DISABLE_FILTERS';
var UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY';
var UPDATE_FILTERED_RESULTS = 'UPDATE_FILTERED_RESULTS';
var SORT_ADDITIONAL_TRANSPORTS = 'SORT_ADDITIONAL_TRANSPORTS';
var UPDATE_SELECTED_TRANSPORT = 'UPDATE_SELECTED_TRANSPORT';

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(TOGGLE_FILTER, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filter: filter
  });
}

function _disableFilters(filters, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(DISABLE_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: filters
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    category: category
  });
}

function _updateFilteredTransports(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UPDATE_FILTERED_RESULTS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState())
  });
}

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_8__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        inbound { \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n        outboundList {  \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n       \n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "jd"]
  });
}

function updateAdditionalTransportsSort(sorter) {
  return function (dispatch, getState) {
    var additionalTransports = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState());
    var filters = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState());
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SORT_ADDITIONAL_TRANSPORTS, {
      additionalTransports: additionalTransports,
      filters: filters,
      sorter: sorter
    }));
  };
}

function clearAdditionalTransports() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(CLEAR_ADDITIONAL_TRANSPORTS);
}

var formatProposalLegacyTransportAsAlternative = function formatProposalLegacyTransportAsAlternative(_ref2) {
  var _proposal$price, _proposal$price$total, _proposal$price2, _proposal$price2$tota, _proposal$price3, _proposal$price3$tota, _proposal$price4, _proposal$price4$tota, _proposal$transports, _proposal$transports2;

  var proposal = _ref2.proposal,
      appContext = _ref2.appContext;

  if (!proposal) {
    return null;
  }

  var transportInfo = {
    id: proposal.id,
    // this id is added for unit testing - proposal id is not similar to AdditionalTransport id
    price: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$total = _proposal$price.total) === null || _proposal$price$total === void 0 ? void 0 : _proposal$price$total.value, (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$tota = _proposal$price2.totalWithoutTransport) === null || _proposal$price2$tota === void 0 ? void 0 : _proposal$price2$tota.value, appContext.locale),
    totalDifferentialPrice: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price3 = proposal.price) === null || _proposal$price3 === void 0 ? void 0 : (_proposal$price3$tota = _proposal$price3.totalWithoutTransport) === null || _proposal$price3$tota === void 0 ? void 0 : _proposal$price3$tota.value, (_proposal$price4 = proposal.price) === null || _proposal$price4 === void 0 ? void 0 : (_proposal$price4$tota = _proposal$price4.totalWithoutTransport) === null || _proposal$price4$tota === void 0 ? void 0 : _proposal$price4$tota.value, appContext.locale)
  };
  return {
    inbound: {
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'INBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound
    },
    outboundList: [{
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'OUTBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound
    }]
  };
};

var isSameJourney = function isSameJourney(firstTransport, secondTransport) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (firstTransport && firstTransport.journey && secondTransport && secondTransport.journey) {
    var _firstTransport$journ, _secondTransport$jour, _firstTransport$journ2, _secondTransport$jour2;

    var firstTravelSections = (_firstTransport$journ = firstTransport.journey) === null || _firstTransport$journ === void 0 ? void 0 : _firstTransport$journ.travelSections;
    var secondTravelSections = (_secondTransport$jour = secondTransport.journey) === null || _secondTransport$jour === void 0 ? void 0 : _secondTransport$jour.travelSections;
    var haveSameTravelSections = (firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === (secondTravelSections === null || secondTravelSections === void 0 ? void 0 : secondTravelSections.length) && ((firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === 0 || firstTravelSections.every(function (currentValue, index) {
      var selectedValue = secondTravelSections[index];
      return lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default()(currentValue, selectedValue);
    }));
    var haveSameDurationInMin = ((_firstTransport$journ2 = firstTransport.journey) === null || _firstTransport$journ2 === void 0 ? void 0 : _firstTransport$journ2.durationInMin) === ((_secondTransport$jour2 = secondTransport.journey) === null || _secondTransport$jour2 === void 0 ? void 0 : _secondTransport$jour2.durationInMin);
    return haveSameTravelSections && haveSameDurationInMin;
  }

  return defaultValue;
};

var isSameTransport = function isSameTransport(_ref3) {
  var transportId = _ref3.transportId,
      currentTransport = _ref3.currentTransport,
      selectedTransport = _ref3.selectedTransport,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? true : _ref3$defaultValue;

  if (currentTransport && selectedTransport) {
    var sameInbound = isSameJourney(currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.inbound, selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound, defaultValue);

    if (sameInbound && transportId) {
      var _selectedTransport$ou;

      var currentOutbound = currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.outboundList[0];
      var selectedOutbound = selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$ou = selectedTransport.outboundList) === null || _selectedTransport$ou === void 0 ? void 0 : _selectedTransport$ou.find(function (transport) {
        return transport.transportInfo.id === transportId;
      });
      return currentOutbound && selectedOutbound ? isSameJourney(currentOutbound, selectedOutbound, false) : false;
    }

    return sameInbound;
  }

  return defaultValue;
};

function fetchAdditionalTransports(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext,
      searchCriterias = _ref4.searchCriterias;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = formatProposalLegacyTransportAsAlternative({
      proposal: proposal,
      appContext: appContext
    });
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: searchCriterias
    }).then(function (_ref5) {
      var additionalTransports = _ref5.additionalTransports;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SEARCH_CRITERIA_TRANSPORTS, searchCriterias));
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}

function toggleAdditionalTransportFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function disableAdditionalTransportFilters(filters) {
  return function (dispatch, getState) {
    dispatch(_disableFilters(filters, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function unselectAdditionalTransportsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}



/***/ }),

/***/ "05v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME; });
// export const BACKSPACE = 8;
// export const SPACE = 32;
var ENTER = 13;
var ESCAPE = 27;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;
var END = 35;
var HOME = 36;

/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ADDITIONAL_ACCOMMODATIONS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_ACCOMMODATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_ACCOMMODATIONS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOGGLE_EXTRA_FEATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleAdditionalAccommodationFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return unselectAdditionalAccommodationsFilterCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleAdditionalAccommodationReducedMobilityFilter; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("uL19");









var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';
var TOGGLE_EXTRA_FEATURES = 'TOGGLE_EXTRA_FEATURES';

function _getSelectedProposal(state) {
  if (!state) return null;
  var proposals = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getProposals */ "u"])(state) || [];
  var resort = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getCurrentResort */ "l"])(state);
  var selectedProposal = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["find"])(proposals, {
    id: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getSelectedProposalId */ "z"])(state)
  }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__[/* getDefaultProposal */ "f"])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      getState = _ref.getState,
      i18n = _ref.i18n,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  var state = getState();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(state),
    selectedProposal: proposal,
    i18n: i18n,
    shouldPreselectFilters: shouldPreselectFilters,
    resort: resort
  });
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodationsFilters */ "e"])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate,
      _ref2$roomsArrangemen = _ref2.roomsArrangement,
      roomsArrangement = _ref2$roomsArrangemen === void 0 ? [] : _ref2$roomsArrangemen;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\", roomsArrangement:").concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* graphqlify */ "d"])(roomsArrangement), ") {\n        id\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          exclusiveCollection\n          connectingRoom\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */ "id"]
  });
}

function clearAdditionalAccommodations() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function fetchAdditionalAccommodations(_ref3) {
  var proposal = _ref3.proposal,
      resort = _ref3.resort,
      appContext = _ref3.appContext,
      _ref3$roomsArrangemen = _ref3.roomsArrangement,
      roomsArrangement = _ref3$roomsArrangemen === void 0 ? [] : _ref3$roomsArrangemen,
      _ref3$shouldPreselect = _ref3.shouldPreselectFilters,
      shouldPreselectFilters = _ref3$shouldPreselect === void 0 ? true : _ref3$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref4) {
      var additionalAccommodations = _ref4.additionalAccommodations,
          i18n = _ref4.config;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        proposal: proposal,
        resort: resort,
        getState: getState,
        i18n: i18n,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function toggleAdditionalAccommodationReducedMobilityFilter(i18n, accommodationsSets, visibility) {
  return function (dispatch) {
    Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
      additionalAccommodations: accommodationsSets
    });
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(TOGGLE_EXTRA_FEATURES, {
      i18n: i18n,
      accommodationsSets: accommodationsSets,
      reducedMobilityVisibility: visibility
    }));
  };
}



/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
/* harmony default export */ __webpack_exports__["a"] = (PRICE_TICKET_REQUEST);

/***/ }),

/***/ "0Sn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setEntryRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unsetEntryRoute; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m9Sl");


var setEntryRoute = function setEntryRoute(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__[/* SET_ENTRY_ROUTE */ "a"], payload);
};
var unsetEntryRoute = function unsetEntryRoute() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__[/* UNSET_ENTRY_ROUTE */ "b"]);
};

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "t"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Yd/I");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("/Mt0");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("3uBn");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qqKu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (props, ref) {
  var _classnames;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].WATER_GREEN : _props$color,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CONFIRMATION : _props$icon,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      onClose = props.onClose,
      _props$portalName = props.portalName,
      portalName = _props$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__[/* AFTER_APP */ "b"] : _props$portalName,
      style = props.style,
      visible = props.visible;

  if (!visible) {
    return null;
  }

  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"], {
    name: portalName
  }, __jsx("button", {
    "aria-disabled": !visible,
    "aria-hidden": !visible,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'bg-white fixed flex font-bold items-center p-px5 reset-button rtl:right-0 rounded-small transition-all', (_classnames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, "text-".concat(String(color)), color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:translate-x-100', !visible), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:mr-px40 shadow-md', visible), _classnames)),
    "data-testid": "Toast",
    onClick: onClose,
    ref: ref,
    style: _objectSpread({
      top: 150,
      width: 280
    }, style),
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "flex-shrink-0 m-px5",
    name: icon,
    width: "1.875rem"
  }), __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_10__[/* Text */ "a"], {
    className: "flex-1 rtl:mr-px25 p-px5",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])(label)
  }), __jsx("div", {
    className: "absolute leading-none p-px10 rtl:right-0 top-0"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CROSS,
    width: "0.625rem"
  }))));
});

/***/ }),

/***/ "1TCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/app.js
var app = __webpack_require__("Khd+");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/router/routerContext.js
var routerContext = __webpack_require__("BncX");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/constants.js
var APP_EVENTS = {
  MOUNTING: 'cm_app_mounting',
  MOUNTED: 'cm_app_mounted'
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.helper.js
var Responsive_helper = __webpack_require__("GRjW");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/Responsive.listener.js
/* eslint-env browser */

var componentsList = [];
var hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  if (currentBreakpoint !== component.state.currentBreakpoint) {
    component.setState({
      currentBreakpoint: currentBreakpoint
    });
  }
}

function listener() {
  var currentBreakpoint = Object(Responsive_helper["a" /* getCurrentBreakpoint */])('', true);
  componentsList.map(function (component) {
    return shouldBreakpointChange(component, currentBreakpoint);
  });
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    window.addEventListener('resize', listener);
    hasListener = true;
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter(function (item) {
    return item !== component;
  });

  if (!componentsList.length) {
    hasListener = false;
    window.removeEventListener('resize', listener);
  }
}


// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/getCurrentResponsive.js
var getCurrentResponsive = __webpack_require__("ZCNJ");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/ResponsiveLayout.jsx







var __jsx = react["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







 // prevent rerender of all component using ResponsiveContext when the breakpoint doesn't change

var memoizedGetCurrentResponsive = Object(lodash["memoize"])(getCurrentResponsive["a" /* default */]);

function sendEvent(name) {
  var event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, true, true);
  }

  document.dispatchEvent(event);
}

var ResponsiveLayout_ResponsiveLayout = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ResponsiveLayout, _React$Component);

  var _super = _createSuper(ResponsiveLayout);

  function ResponsiveLayout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResponsiveLayout);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(_this.props.userAgent || '', false),
      isAppMounted: false
    });

    if ( true && !window.cmAppMounted) {
      sendEvent(APP_EVENTS.MOUNTING);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(ResponsiveLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      subscribe(this);
      this.setState({
        currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(this.props.userAgent || '', true),
        isAppMounted: true
      });

      if (!window.cmAppMounted) {
        // Dispatch the info that the app is mounted
        window.cmAppMounted = true;
        sendEvent(APP_EVENTS.MOUNTED);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      unsubscribe(this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          currentBreakpoint = _this$state.currentBreakpoint,
          isAppMounted = _this$state.isAppMounted;
      return __jsx(responsive_responsiveContext["a" /* default */].Provider, {
        value: memoizedGetCurrentResponsive({
          currentBreakpoint: currentBreakpoint,
          isAppMounted: isAppMounted
        })
      }, children);
    }
  }]);

  return ResponsiveLayout;
}(react["Component"]);
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/views/comparator/Comparator.query.js
var Comparator_query = __webpack_require__("KVdF");

// EXTERNAL MODULE: ./src/client/context/ResortListContext.js
var ResortListContext = __webpack_require__("7hcC");

// CONCATENATED MODULE: ./src/client/context/ResortListProvider.jsx
var ResortListProvider_jsx = react_default.a.createElement;





var ResortListProvider_ResortListProvider = function ResortListProvider(_ref) {
  var children = _ref.children;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      resortList = _useState2[0],
      updateResortList = _useState2[1];

  var setResortList = function setResortList() {
    if (resortList.length === 0 && !isLoading) {
      setIsLoading(true);
      graphqlClient["a" /* default */].runQuery("{".concat(Object(Comparator_query["a" /* getAllResorts */])({
        withOpeningDates: true
      }), "}"), appContext).then(function (res) {
        return updateResortList(res.resortList);
      }).finally(function () {
        return setIsLoading(false);
      });
    }
  };

  var value = Object(react["useMemo"])(function () {
    return {
      resortList: resortList,
      setResortList: setResortList
    };
  }, [resortList]);
  return ResortListProvider_jsx(ResortListContext["a" /* ResortListContext */].Provider, {
    value: value
  }, children);
};
// EXTERNAL MODULE: ./src/client/context/DepartureCitiesContext.js
var DepartureCitiesContext = __webpack_require__("l5FB");

// CONCATENATED MODULE: ./src/client/context/DepartureCitiesProvider.jsx







var DepartureCitiesProvider_jsx = react_default.a.createElement;

function DepartureCitiesProvider_createSuper(Derived) { var hasNativeReflectConstruct = DepartureCitiesProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function DepartureCitiesProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var DepartureCitiesProvider_DepartureCitiesProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DepartureCitiesProvider, _Component);

  var _super = DepartureCitiesProvider_createSuper(DepartureCitiesProvider);

  function DepartureCitiesProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DepartureCitiesProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureCities: [],
      setDepartureCities: function setDepartureCities(departureCities) {
        _this.setState({
          departureCities: departureCities
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(DepartureCitiesProvider, [{
    key: "render",
    value: function render() {
      return DepartureCitiesProvider_jsx(DepartureCitiesContext["a" /* default */].Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return DepartureCitiesProvider;
}(react["Component"]);


// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// CONCATENATED MODULE: ./src/client/context/ABTestProvider.jsx








var ABTestProvider_jsx = react_default.a.createElement;

function ABTestProvider_createSuper(Derived) { var hasNativeReflectConstruct = ABTestProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ABTestProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-env browser */





var ABTestProvider_isValidValues = function isValidValues(src, values) {
  return Object(lodash["isObject"])(values) && !Object(lodash["isEmpty"])(values) && !Object.entries(values).every(function (_ref) {
    var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return src[key] === value;
  });
};

var ABTEST_PREFIX = 'testAB.';
var ABTEST_EVENT = 'testAB';

var ABTestProvider_fetchABTestData = function fetchABTestData() {
  return Object(sessionStorageApi["a" /* getEntries */])().filter(function (_ref3) {
    var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 1),
        key = _ref4[0];

    return key.startsWith(ABTEST_PREFIX);
  }).reduce(function (acc, _ref5) {
    var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, key.replace(ABTEST_PREFIX, ''), value.toString()));
  }, {});
};

var ABTestProvider_ABTestProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ABTestProvider, _Component);

  var _super = ABTestProvider_createSuper(ABTestProvider);

  function ABTestProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ABTestProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", _objectSpread({}, ABTestProvider_fetchABTestData()));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleEvent", function (e) {
      /**
       * TODO
       * When REACT 16 ready
       * this.setState((prevState) => isValidValues(prevState, e.values) ? { ...e.values } : null);
       */
      if (ABTestProvider_isValidValues(_this.state, e.values)) {
        _this.setState(function () {
          return _objectSpread({}, e.values);
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ABTestProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return ABTestProvider_jsx(ABTestContext["a" /* ABTestContext */].Provider, {
        value: this.state
      }, children ? react["Children"].only(children) : null);
    }
  }]);

  return ABTestProvider;
}(react["Component"]);


// CONCATENATED MODULE: ./src/client/app/AppProviders.jsx
var AppProviders_jsx = react_default.a.createElement;










var AppProviders_AppProviders = function AppProviders(_ref) {
  var children = _ref.children,
      appContext = _ref.appContext,
      pageContext = _ref.pageContext,
      reduxStore = _ref.reduxStore,
      routerContextValue = _ref.routerContextValue,
      toastRef = _ref.toastRef;
  return AppProviders_jsx(ReactAppContext["a" /* B2CAppContext */], {
    appContext: appContext
  }, AppProviders_jsx(context_pageContext["a" /* ReactPageContext */].Provider, {
    value: pageContext
  }, AppProviders_jsx(es["a" /* Provider */], {
    store: reduxStore
  }, AppProviders_jsx(ABTestProvider_ABTestProvider, null, AppProviders_jsx(routerContext["a" /* routerContext */].Provider, {
    value: routerContextValue
  }, AppProviders_jsx(ResponsiveLayout_ResponsiveLayout, {
    userAgent: appContext.userAgent
  }, AppProviders_jsx(DepartureCitiesProvider_DepartureCitiesProvider, null, AppProviders_jsx(ResortListProvider_ResortListProvider, null, AppProviders_jsx(ToastContext["a" /* ToastContext */].Provider, {
    value: {
      ref: toastRef
    }
  }, children)))))))));
};
// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var constants = __webpack_require__("Uq20");

// CONCATENATED MODULE: ./src/client/store/routing/routing.actions.js


function routingChange() {
  return Object(createAction["b" /* default */])(constants["a" /* ROUTING_CHANGE */], {});
}
// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryroute.action.js
var entryroute_action = __webpack_require__("0Sn7");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// CONCATENATED MODULE: ./src/client/app/RouteChangeListener.jsx













var hasNavigated = false;
var RouteChangeListener_RouteChangeListener = function RouteChangeListener() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var dispatch = Object(es["d" /* useDispatch */])();
  var previousLocation = Object(usePrevious["a" /* usePrevious */])(location);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var scrollUnderNav = !isDesktop;
  var href = Object(uriUtils["b" /* convertLocationToHref */])(location);
  Object(react["useEffect"])(function () {
    var _location$queryParams;

    // force oidc redirect in case the seller changed on cmta side
    if (appContext.isCmta && (location === null || location === void 0 ? void 0 : (_location$queryParams = location.queryParams) === null || _location$queryParams === void 0 ? void 0 : _location$queryParams.forceAuth) !== undefined) {
      redirectUtils["a" /* default */].redirectToOidc(appContext);
    }
  }, []);
  Object(react["useEffect"])(function () {
    dispatch(routingChange());

    if (location.hash) {
      scrollToHash["a" /* goToHash */](location.hash, scrollUnderNav);
    } else if (hasNavigated) {
      window.scrollTo(0, 0);
    }
  }, [href, location.hash]);
  Object(react["useEffect"])(function () {
    var showLoader = function showLoader(nextUri) {
      hasNavigated = true;
      var nextPath = new URI_default.a(nextUri).pathname();
      var previousPath = Object(uriUtils["c" /* convertLocationToURI */])(location).pathname(); // on the booking engine there is no loader between pages, no loader also if it is the same path

      if (!(nextUri.startsWith('/booking/') && location.pathname.startsWith('/booking/')) && nextPath !== previousPath) {
        if (!nextUri.startsWith('/booking/') && !nextUri.startsWith('/option/')) {
          dispatch(Object(entryroute_action["b" /* unsetEntryRoute */])());
        } // startLoading second arg it here to handle scroll correctly after navigation
        // see Components/widgets/loading/Loading.jsx


        dispatch(Object(globalLoader_action["d" /* startLoading */])('', true));
      }
    };

    var hideLoader = function hideLoader(nextUri) {
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      if (hasNavigated && !(nextUri.startsWith('/booking/') && previousLocation.pathname.startsWith('/booking/'))) {
        dispatch(Object(globalLoader_action["c" /* endLoading */])());
      }
    }; // Show the loader before each page transition, hide after


    history.events.on('routeChangeStart', showLoader);
    history.events.on('routeChangeComplete', hideLoader);
    return function () {
      history.events.off('routeChangeStart', showLoader);
      history.events.off('routeChangeComplete', hideLoader);
    };
  });
  return null;
};
// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// CONCATENATED MODULE: ./src/client/router/createRouterLocation.js


function createRouterLocation_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createRouterLocation_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createRouterLocation_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createRouterLocation_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var createRouterLocation_createRouterLocation = function createRouterLocation(_ref) {
  var asPath = _ref.asPath,
      query = _ref.query,
      originalUrl = _ref.originalUrl;
  var uri = new URI_default.a(asPath);
  var urlParams = {};
  var queryParams = {};
  /*
   * Due to a next-route implementation with a weird `.join('/')`
   * we need to check if the current query param has a slash as separator
   * and split it into an array.
   * cf: https://github.com/fridays/next-routes/issues/250
   */

  for (var queryParameter in query) {
    if (uri.hasSearch(queryParameter)) {
      queryParams[queryParameter] = query[queryParameter];
    } else {
      urlParams[queryParameter] = query[queryParameter];
    }
  }

  return {
    origin: true ? window.location.origin : undefined,
    pathname: uri.pathname(),
    hash: uri.hash(),
    urlParams: urlParams,
    queryParams: queryParams
  };
};
var createRouterLocation_updateShallowQueryParams = function updateShallowQueryParams(_ref2) {
  var location = _ref2.location,
      href = _ref2.href;
  if (!href) return location;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location); // We cannot reconstruct the URL simply from href since the front-end doesn't know what routes can
  // be rewritten (/r/Bali/y is {urlParams: { dynamicPage: '/r/Bali/y }})

  var currentUri = new URI_default.a(href);
  var newQueryParams = location.queryParams;
  var queryParamsList = Object.keys(uri.query(true));
  var currentQueryParamsList = Object.keys(currentUri.query(true)); // delete query params which are no longer in the new uri

  for (var queryParamName in uri.query(true)) {
    if (!currentQueryParamsList.includes(queryParamName)) {
      delete newQueryParams[queryParamName];
    }
  } // add missing query params or update the current ones


  for (var _queryParamName in currentUri.query(true)) {
    if (!queryParamsList.includes(_queryParamName) || newQueryParams[_queryParamName] !== currentUri.query(true)[_queryParamName]) {
      newQueryParams[_queryParamName] = currentUri.query(true)[_queryParamName];
    }
  }

  return createRouterLocation_objectSpread(createRouterLocation_objectSpread({}, location), {}, {
    queryParams: newQueryParams
  });
};
// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// CONCATENATED MODULE: ./src/client/components/frameworks/toast/Toast.container.jsx



var mapStateToProps = function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = state.toast || {},
      className = _ref.className,
      color = _ref.color,
      icon = _ref.icon,
      label = _ref.label,
      shouldDisplay = _ref.shouldDisplay,
      style = _ref.style;

  return {
    className: className,
    color: color,
    icon: icon,
    label: label,
    style: style,
    visible: shouldDisplay
  };
};
var mapDispatchToProps = {
  onClose: toast_actions["c" /* closeToast */]
};
var ToastContainer = Object(es["c" /* connect */])(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Toast["a" /* Toast */]);
// CONCATENATED MODULE: ./src/client/components/layouts/head-info/HeadInfos.jsx
var HeadInfos_jsx = react_default.a.createElement;



var HeadInfos_HeadInfos = function HeadInfos() {
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  return HeadInfos_jsx(react["Fragment"], null, HeadInfos_jsx(head_default.a, null, HeadInfos_jsx("meta", {
    key: "description",
    name: "description",
    content: pageContext.pageDescription || ''
  }), HeadInfos_jsx("link", {
    key: "canonical",
    rel: "canonical",
    href: pageContext.canonicalUrl
  }), (pageContext.hrefLang || []).filter(function (_ref) {
    var locale = _ref.locale,
        url = _ref.url;
    return url && locale;
  }).map(function (_ref2) {
    var locale = _ref2.locale,
        url = _ref2.url;
    return HeadInfos_jsx("link", {
      key: "".concat(locale, "_").concat(url),
      rel: "alternate",
      hrefLang: locale,
      href: url
    });
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/user-info/hoc/UserInfo.jsx
var UserInfo = __webpack_require__("EEuM");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlertLinkBanner.jsx
var CrisisAlertLinkBanner_jsx = react_default.a.createElement;









var CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';
var CrisisAlertLinkBanner_CrisisAlertLinkBanner = function CrisisAlertLinkBanner(_ref) {
  var alertDate = _ref.alertDate,
      className = _ref.className,
      linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useState = Object(react["useState"])(true),
      shouldDisplay = _useState[0],
      setShouldDisplay = _useState[1];

  if (!isAppMounted) {
    return null;
  }

  if (!shouldDisplay || Object(lodash["isEmpty"])(alertDate) || Object(lodash["isEmpty"])(linkLabel) || Object(local_storage_api["a" /* getFromLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate) {
    return null;
  }

  return CrisisAlertLinkBanner_jsx("div", {
    className: classnames_default()(className, 'bg-white flex items-center max-w-full p-px10 rtl:pr-px30 relative rounded-small shadow')
  }, CrisisAlertLinkBanner_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1.875rem"
  }), CrisisAlertLinkBanner_jsx(TextLink["a" /* TextLink */], {
    className: "underline rtl:ml-px20",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    iconRightName: null,
    label: linkLabel,
    url: linkUrl
  }), CrisisAlertLinkBanner_jsx("button", {
    className: "reset-button absolute leading-none p-px10 top-0 rtl:right-0",
    onClick: function onClick() {
      Object(local_storage_api["c" /* setInLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
      setShouldDisplay(false);
    },
    type: "button"
  }, CrisisAlertLinkBanner_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};
// CONCATENATED MODULE: ./src/utils/tracking/dataScore.js


var dataScore_getDataScore = function getDataScore(_ref) {
  var resortId = _ref.resortId,
      departureDate = _ref.departureDate,
      appContext = _ref.appContext;
  var neolaneId = appContext.neolaneId,
      googleTrackingId = appContext.googleTrackingId;
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    query{\n      dataScore(\n      resortId: \"".concat(resortId || '', "\",\n      departureDate: \"").concat(departureDate || '', "\",\n      neolaneId: \"").concat(neolaneId || '', "\",\n      gaTrackingId: \"").concat(googleTrackingId || '', "\") {\n        leadScoring\n      }\n    }\n  "));
};


// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var lead_info_constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfos.action.js



var leadInfos_action_setDataScore = function setDataScore(score) {
  return Object(createAction["b" /* default */])(lead_info_constants["b" /* SET_DATA_SCORE */], {
    score: score
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/data-score/DataScore.jsx


function DataScore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DataScore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataScore_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataScore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var pendingDataScoreTimeout = null;
/*
 * the following function is used to execute the fn arg on the last call only
 * the previous scheduled call to fn will be canceled at every new call
 * by clearing the setTimeout id stored in pendingDataScoreTimeout
 *
 */

var takeLast = function takeLast(fn) {
  clearTimeout(pendingDataScoreTimeout); // 5000ms is choosed arbitrarily

  pendingDataScoreTimeout = setTimeout(fn, 5000);
};

var DataScore_neolaneId = null;

var DataScore_DataScore = function DataScore() {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var resort = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentResort */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var dataScoreHasBeenFetched = !!Object(sessionStorageApi["b" /* getFromSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */]);
  Object(react["useEffect"])(function () {
    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('enableLeadScoring') && isAppMounted && ( // neolaneId will change after user sign in
    !DataScore_neolaneId && appContext.neolaneId || !dataScoreHasBeenFetched && (appContext.neolaneId || appContext.googleTrackingId))) {
      DataScore_neolaneId = appContext.neolaneId;
      /*
         every calls to the lead scoring API is billed so we want to make
         sure there is only one call to be done when the app state is stabilized
       */

      takeLast(function () {
        dataScore_getDataScore(DataScore_objectSpread(DataScore_objectSpread(DataScore_objectSpread({}, selectedProposal ? {
          departureDate: selectedProposal.departureDate
        } : null), resort ? {
          resortId: resort.id
        } : null), {}, {
          appContext: appContext
        })).then(function (_ref) {
          var leadScoring = _ref.dataScore.leadScoring;
          var score = parseFloat(leadScoring);
          tracking_api["b" /* setDataLayer */](DataScore_objectSpread(DataScore_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
            event: 'leadScoring',
            leadScoring: score
          }), appContext, pageContext.pageId);
          dispatch(leadInfos_action_setDataScore(leadScoring));
          Object(sessionStorageApi["d" /* setInSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */], leadScoring);
        }).catch(function () {
          /* we don't do anything if the call fails */
        });
      });
    }
  }, [isAppMounted, appContext, selectedProposal]);
  return null;
};


// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.tracking.js
var Navigation_tracking = __webpack_require__("4Grf");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.mapper.js




function mapSubItemsProps(parentLabel, items, index) {
  if (Object(lodash["isEmpty"])(items)) return [];
  return items.map(function (item, subIndex) {
    var dataLabel = "".concat(parentLabel, "_").concat(Object(lodash["camelCase"])(item.label));
    var subItemsProps = {
      id: "".concat(index).concat(subIndex),
      color: item.color || colors["a" /* COLORS */].GRAY_DARKER,
      hasImageBorder: item.frameForExclusiveCollection,
      label: item.label,
      link: {
        url: item.url,
        trackingData: Object(Navigation_tracking["g" /* getNavigationSubItemLinkTrackingData */])({
          label: dataLabel,
          parentLabel: parentLabel.split('_')[0]
        })
      },
      seeMoreLabel: item.seeMoreLabel || ''
    };

    if (!Object(lodash["isEmpty"])(item.imageUrl)) {
      subItemsProps.thumbnail = {
        imageUrl: item.imageUrl
      };
    }

    if (!Object(lodash["isEmpty"])(item.subItems)) {
      subItemsProps.subItems = mapSubItemsProps(dataLabel, item.subItems, "".concat(index).concat(subIndex));
    }

    return subItemsProps;
  });
}

var Navigation_mapper_buildNavigationMenuItems = function buildNavigationMenuItems(menus) {
  if (!menus || !menus.length) {
    return [];
  }

  return menus.map(function (menu, index) {
    return {
      color: menu.color || colors["a" /* COLORS */].GRAY_DARKER,
      id: "".concat(index),
      label: menu.label,
      link: {
        url: menu.url,
        trackingData: Object(Navigation_tracking["e" /* getNavigationItemLinkTrackingData */])(Object(lodash["camelCase"])(menu.label))
      },
      isList: menu.type === 'subItemsList',
      subItems: mapSubItemsProps(Object(lodash["camelCase"])(menu.label), menu.items, index)
    };
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 10 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/utils/languages/SwitchLanguageModel.js


var SwitchLanguageModel_jsx = react["createElement"];


function getUrl(locale) {
  return '/?locale=' + locale;
}

function SwitchLanguageModel_getLocales(localesConfig) {
  return Object.keys(localesConfig);
}

function getSwitchLocale(localesConfig, currentLocale) {
  return SwitchLanguageModel_getLocales(localesConfig).filter(function (locale) {
    return locale !== currentLocale;
  })[0];
}

var SwitchLanguageModel_SwitchLanguage = /*#__PURE__*/function () {
  function SwitchLanguage(availableLocalesConfig, currentLocale) {
    Object(classCallCheck["a" /* default */])(this, SwitchLanguage);

    this.localesConfig = availableLocalesConfig;
    this.currentLocale = currentLocale;
  }

  Object(createClass["a" /* default */])(SwitchLanguage, [{
    key: "getAvailableLocales",
    value: function getAvailableLocales() {
      return this.localesConfig;
    }
  }, {
    key: "getCurrentLocaleLabel",
    value: function getCurrentLocaleLabel() {
      return this.localesConfig[this.currentLocale].label;
    }
  }, {
    key: "getSwitchLocaleLabel",
    value: function getSwitchLocaleLabel() {
      return this.localesConfig[getSwitchLocale(this.localesConfig, this.currentLocale)].label;
    }
  }, {
    key: "getLabelWithUrls",
    value: function getLabelWithUrls() {
      var _this = this;

      return Object.keys(this.localesConfig).map(function (locale) {
        return {
          label: _this.localesConfig[locale].label,
          countryCode: _this.localesConfig[locale].PAYS,
          langCode: _this.localesConfig[locale].LANG,
          languageNativeName: _this.localesConfig[locale].languageNativeName,
          moment: _this.localesConfig[locale].moment,
          url: getUrl(locale)
        };
      });
    }
  }, {
    key: "getSwitchUrl",
    value: function getSwitchUrl() {
      return getUrl(getSwitchLocale(this.localesConfig, this.currentLocale));
    }
  }, {
    key: "isMultiLanguage",
    value: function isMultiLanguage() {
      return SwitchLanguageModel_getLocales(this.localesConfig).length > 1;
    }
    /* todo: es6 : make this class iterable */

  }, {
    key: "map",
    value: function map(mapper) {
      var _this2 = this;

      var mapping = function mapping() {
        return _this2.getLabelWithUrls().map(mapper);
      };

      return this.or(mapping.bind(this));
    }
  }, {
    key: "or",
    value: function or(callback) {
      return this.isMultiLanguage() ? callback() : SwitchLanguageModel_jsx("noscript", null);
    }
  }]);

  return SwitchLanguage;
}();

/* harmony default export */ var SwitchLanguageModel = (SwitchLanguageModel_SwitchLanguage);
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.themes.js
var themes = {
  inline: {
    thRoot: 'inline-flex items-center justify-around whitespace-no-wrap',
    thItemFirst: 'border-l-0 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItem: 'border-l-1 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'inline-block py-px5 px-px10 focus:underline hover:underline whitespace-no-wrap'
  },
  column: {
    thRoot: '',
    thItemFirst: 'border-t-0 border-gray-light capitalize text-center text-gray-dark',
    thItem: 'border-t-1 border-gray-light capitalize text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'block p-px10 focus:underline hover:underline whitespace-no-wrap'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.jsx

var Languages_jsx = react_default.a.createElement;






function Languages(props) {
  var className = props.className,
      _props$currentLocale = props.currentLocale,
      currentLocale = _props$currentLocale === void 0 ? '' : _props$currentLocale,
      getTrackingData = props.getTrackingData,
      isActive = props.isActive,
      locales = props.locales,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'inline' : _props$theme;
  if (Object(lodash["isEmpty"])(locales)) return null;
  var _themes$theme = themes[theme],
      thItem = _themes$theme.thItem,
      thItemCurrent = _themes$theme.thItemCurrent,
      thItemFirst = _themes$theme.thItemFirst,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot;
  var currentLangCode = currentLocale.split('-')[0].toUpperCase();
  var languages = new SwitchLanguageModel(locales, currentLocale);
  return Languages_jsx("ul", {
    className: classnames_default()(className, 'reset-list', thRoot)
  }, languages.map(function () {
    var localeInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var idx = arguments.length > 1 ? arguments[1] : undefined;
    var isCurrentItem = currentLangCode === localeInfos.langCode;
    var label = localeInfos.moment ? localeInfos.moment.slice(0, 2) : localeInfos.label;
    return Languages_jsx("li", {
      key: "".concat(localeInfos.countryCode, "-").concat(localeInfos.langCode),
      className: classnames_default()(idx === 0 ? thItemFirst : thItem, Object(defineProperty["a" /* default */])({}, "".concat(thItemCurrent), isCurrentItem))
    }, Languages_jsx(TrackClick["a" /* TrackClick */], {
      as: "a",
      "aria-current": isCurrentItem,
      "aria-label": "".concat(label, " ").concat(localeInfos.languageNativeName),
      className: classnames_default()('reset-anchor', thLink),
      "data-testid": "Languages-link",
      href: localeInfos.url,
      lang: localeInfos.moment,
      tabIndex: isActive ? 0 : -1,
      trackingData: getTrackingData ? getTrackingData(localeInfos.url.replace('/?locale=', '')) : null
    }, localeInfos.label));
  }));
}
// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchQuery.jsx



var GlobalSearchQuery_jsx = react_default.a.createElement;

function GlobalSearchQuery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchQuery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchQuery_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchQuery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var redirection = 'redirection_suggestedRequest';
var GlobalSearchQuery_ReferencedSearchQuery = function ReferencedSearchQuery(props) {
  var autocompleteQuery = props.autocompleteQuery,
      clearGlobalSearch = props.clearGlobalSearch,
      facetingSuggestedRequests = props.facetingSuggestedRequests,
      onChangeQuery = props.onChangeQuery,
      searchInputRef = props.searchInputRef,
      trackingData = props.trackingData;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller;

  var _useContext2 = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext2.isDesktop;

  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'layer'
  });
  var buttonSize = isDesktop ? 'large' : 'medium';
  var containerPadding = isDesktop ? {
    paddingLeft: '15%',
    paddingRight: '15%'
  } : {};
  var splitSuggests = Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(facetingSuggestedRequests.items), 2);
  var hasSuggestRequests = !!splitSuggests.length;
  return GlobalSearchQuery_jsx("div", {
    className: "bg-white",
    style: containerPadding
  }, GlobalSearchQuery_jsx("div", {
    className: classnames_default()('border-0 border-gray-light flex flex-no-wrap items-stretch justify-between m-auto max-w-site py-px25 w-full', {
      'border-b-1': isDesktop && !!autocompleteQuery || !isDesktop && hasSuggestRequests && !autocompleteQuery
    })
  }, GlobalSearchQuery_jsx("div", {
    className: "flex-grow h-12 lg:h-16"
  }, GlobalSearchQuery_jsx("label", {
    className: "block pb-px5 text-sm lg:text-md text-gray-medium transition-color",
    htmlFor: "global-search-query-input"
  }, Object(lodash["upperFirst"])(Object(i18n["g" /* t */])('faceting.autocomplete.enterYourSearch'))), GlobalSearchQuery_jsx("input", {
    className: "cursor-pointer leading-normal font-bold reset-input text-xl lg:text-2xl text-gray w-full",
    "data-testid": "global-search-input",
    id: "global-search-query-input",
    onChange: onChangeQuery,
    placeholder: Object(i18n["g" /* t */])('faceting.searchTitle'),
    ref: searchInputRef,
    type: "search",
    value: autocompleteQuery
  })), GlobalSearchQuery_jsx("div", {
    className: "flex justify-end",
    style: {
      minWidth: isDesktop ? 190 : 110
    }
  }, GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "flex-none lg:justify-center lg:leading-none ml-px5 lg:ml-px10 self-center",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "global-search-search-button",
    isExternalLink: false,
    minWidth: "initial",
    onClick: function onClick() {
      var query = {
        label: autocompleteQuery
      };
      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        location: location,
        searchCriteria: {
          query: query,
          departureCity: departureCity,
          departureDate: departureDate,
          duration: duration,
          keywords: '',
          kids: kids,
          kidsValidationState: kidsValidationState
        },
        searchPageRouteName: 'search'
      });
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
      clearGlobalSearch();
    },
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: {
      categoryGA: 'layer',
      actionGA: 'search',
      labelGA: 'validate',
      searchReferrer: 'layer'
    },
    url: autocompleteQuery ? "/s?search=".concat(autocompleteQuery) : '/s'
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1rem"
  })), GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "flex-none lg:justify-center lg:leading-none ml-px5 lg:ml-px10 self-center",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].GRAY_MEDIUM,
    dataTestId: "global-search-close-button",
    minWidth: "initial",
    onClick: clearGlobalSearch,
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: GlobalSearchQuery_objectSpread(GlobalSearchQuery_objectSpread({}, trackingData), {}, {
      labelGA: 'close'
    })
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    color: colors["a" /* COLORS */].GRAY_MEDIUM
  })))), !isSeller && hasSuggestRequests && !autocompleteQuery && GlobalSearchQuery_jsx("div", {
    className: "md:border-gray-light md:border-b-1 m-auto max-w-site py-px25 md:pt-0 md:pb-px10 mb-px10 w-full"
  }, GlobalSearchQuery_jsx("div", {
    className: "font-bold font-sans text-blue text-xs"
  }, facetingSuggestedRequests.title), GlobalSearchQuery_jsx("div", {
    className: "md:flex"
  }, splitSuggests.map(function (splitSuggest, i) {
    return GlobalSearchQuery_jsx("div", {
      className: "md:w-1/3",
      key: i
    }, GlobalSearchQuery_jsx("div", {
      className: "md:flex"
    }, splitSuggest.map(function (_ref) {
      var suggestLabel = _ref.label,
          suggestUrl = _ref.url;
      return GlobalSearchQuery_jsx("div", {
        className: "rtl:pr-px20 pt-px10 md:pt-0 md:w-1/2",
        key: suggestLabel
      }, GlobalSearchQuery_jsx("div", {
        className: "font-sans pt-px10 text-sm truncate w-full"
      }, GlobalSearchQuery_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "text-gray-darker focus:text-blue hover:text-blue transition-color",
        onClick: function onClick() {
          var isSearchUrl = suggestUrl.startsWith('/s');
          track({
            actionGA: 'search',
            categoryGA: 'layer',
            internalSearchEngineNbResults: isSearchUrl ? '' : redirection,
            labelGA: 'suggestedRequest',
            searchReferrer: 'layer',
            searchRequestType: 'Autocomplete',
            searchTerms: suggestLabel
          });

          if (!isSearchUrl) {
            trackSearchResults({
              internalSearchEngineNbResults: redirection,
              searchRequestType: 'Autocomplete',
              searchResorts: [],
              searchTerms: suggestLabel
            });
          }

          clearGlobalSearch();
        },
        url: suggestUrl
      }, suggestLabel)));
    })));
  }))));
};
var SearchQuery = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return GlobalSearchQuery_jsx(GlobalSearchQuery_ReferencedSearchQuery, Object(esm_extends["a" /* default */])({}, props, {
    searchInputRef: ref
  }));
});
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsGrid.jsx

var GlobalSearchSuggestionsGrid_jsx = react_default.a.createElement;





var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MAX_GRID_SUGGESTIONS = 4;
var GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid = function GlobalSearchSuggestionsGrid(props) {
  var products = props.blockSuggestions.slice(0, MAX_GRID_SUGGESTIONS).map(function (_ref) {
    var icon = _ref.icon,
        image = _ref.image,
        isExclusiveCollection = _ref.isExclusiveCollection,
        label = _ref.label,
        link = _ref.link,
        productColor = _ref.productColor,
        productId = _ref.productId,
        productType = _ref.productType,
        season = _ref.season,
        subLabel1 = _ref.subLabel1,
        subLabel2 = _ref.subLabel2,
        tagsColor = _ref.tagsColor;
    return {
      header: {
        badge: season,
        badgeColor: tagsColor,
        badgeIcon: {
          alt: '',
          color: colors["a" /* COLORS */].WHITE,
          colorBg: productColor,
          colorBorder: productColor,
          iconName: icon
        },
        hasECLogo: !icon,
        heading: {
          subtitle: productType === PRODUCT_TYPES.RESORT ? subLabel1 : subLabel2,
          title: label
        }
      },
      id: productId,
      thumbnail: {
        hasBorder: isExclusiveCollection,
        pictures: [{
          altMsg: label,
          src: image
        }],
        tagsColor: tagsColor
      },
      type: productType,
      url: link
    };
  });
  var grid = {
    desktop: 2,
    mobile: 1,
    phablet: 2,
    tablet: 3
  };
  return products.length > 0 && GlobalSearchSuggestionsGrid_jsx(Grid["a" /* default */], {
    className: "mb-px25",
    display: grid,
    grid: grid,
    hasSeeMore: false,
    totalNumberToDisplay: MAX_GRID_SUGGESTIONS
  }, products.map(function (product) {
    return GlobalSearchSuggestionsGrid_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      key: product.id
    }, product, {
      onClick: function onClick() {
        var query = {
          label: product.header.heading.title,
          type: 'resort'
        };
        props.onClick(query);
      }
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsList.jsx
var GlobalSearchSuggestionsList = __webpack_require__("RWDY");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestions.jsx


var GlobalSearchSuggestions_jsx = react_default.a.createElement;

function GlobalSearchSuggestions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchSuggestions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchSuggestions_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchSuggestions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var SuggestionsBlockTitle = function SuggestionsBlockTitle(_ref) {
  var title = _ref.title;
  return GlobalSearchSuggestions_jsx("h3", {
    className: "font-brand reset-heading leading-tight my-px25 lg:my-px30 text-base text-blue uppercase"
  }, title);
};

var GlobalSearchSuggestions_SearchSuggestions = function SearchSuggestions(props) {
  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var locale = location.queryParams.locale;
  var suggestionsBlocks = [{
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].AREA, GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY],
    title: Object(i18n["g" /* t */])('faceting.autocomplete.destinationsTitle'),
    linkLabel: Object(i18n["g" /* t */])('faceting.autocomplete.moreDestinationsLabel'),
    linkURL: Object(i18n["g" /* t */])('faceting.autocomplete.moreDestinationsURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: 1
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY],
    type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY,
    title: Object(i18n["g" /* t */])('faceting.autocomplete.activitiesTitle'),
    linkLabel: Object(i18n["g" /* t */])('faceting.autocomplete.moreActivitiesLabel'),
    linkURL: Object(i18n["g" /* t */])('faceting.autocomplete.moreActivitiesURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: isDesktop ? 2 : 3
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT],
    title: Object(i18n["g" /* t */])('faceting.autocomplete.productsTitle'),
    linkLabel: Object(i18n["g" /* t */])('faceting.autocomplete.moreProductsLabel'),
    linkURL: '/s',
    width: isDesktop ? 'w-1/2' : 'w-full',
    order: isDesktop ? 3 : 2
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO],
    title: Object(i18n["g" /* t */])('faceting.autocomplete.editorialTitle'),
    linkLabel: Object(i18n["g" /* t */])('faceting.autocomplete.seeMoreArticlesLabel'),
    linkURL: Object(i18n["g" /* t */])('faceting.autocomplete.seeMoreArticlesLink'),
    width: isDesktop ? 'w-1/2' : 'w-full',
    order: 4
  }];
  var trackingPayload = {
    categoryGA: 'layer',
    searchReferrer: 'layer'
  };
  return GlobalSearchSuggestions_jsx("div", {
    id: "search-suggestions",
    className: classnames_default()('flex m-auto max-w-site flex-wrap', {
      'mb-px60': !isDesktop
    })
  }, suggestionsBlocks.map(function (block) {
    var blockSuggestions = props.autocompleteResults.filter(function (result) {
      return !!result.label && block.types.includes(result.type);
    });
    var SuggestionsBlock = block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT ? GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid : GlobalSearchSuggestionsList["a" /* GlobalSearchSuggestionsList */];
    var linkURL = block.linkURL;
    var blockLinkURL = locale && linkURL ? new URI_default.a(linkURL).addQuery({
      locale: locale
    }).toString() : linkURL;
    return !isDesktop && Object(lodash["isEmpty"])(blockSuggestions) ? null : GlobalSearchSuggestions_jsx("div", {
      key: "search-suggestions-".concat(block.id),
      className: classnames_default()(block.width, {
        'border-gray-light border-t-1 mb-px25': !isDesktop
      }),
      style: {
        order: block.order
      }
    }, block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && !isDesktop ? GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }) : GlobalSearchSuggestions_jsx("div", {
      className: classnames_default()('flex items-strech justify-between', {
        'w-5/6': block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
      })
    }, GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }), (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT && blockSuggestions.length > MAX_GRID_SUGGESTIONS || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && blockLinkURL) && GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "leading-tight font-bold my-px25 lg:my-px30 text-sm text-gray underline",
      isExternalLink: false,
      onClick: function onClick() {
        if (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Nocomplete',
            searchTerms: props.autocompleteQuery
          }, {
            label: '',
            type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
          });
        }

        props.clearGlobalSearch();
      },
      sendTrackingDataBeforeOnClick: true,
      trackingData: GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
        actionGA: 'search',
        labelGA: "viewMore_".concat(Object(utils["d" /* getSearchMappedTypeForLabelGA */])(block.id))
      }),
      url: block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT ? "/s?search=".concat(props.autocompleteQuery) : blockLinkURL
    }, Object(lodash["upperFirst"])(block.linkLabel))), Object(lodash["isEmpty"])(blockSuggestions) ? GlobalSearchSuggestions_jsx("p", {
      className: "leading-tight mt-0 mb-px25 text-xl lg:text-2xl text-gray-light"
    }, Object(lodash["upperFirst"])(Object(i18n["g" /* t */])('faceting.autocomplete.noResult'))) : GlobalSearchSuggestions_jsx(SuggestionsBlock, Object(esm_extends["a" /* default */])({}, props, {
      blockSuggestions: blockSuggestions,
      blockType: block.id,
      isDesktop: isDesktop,
      onClick: function onClick(query) {
        props.clearGlobalSearch();

        if (query.type === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label,
            searchResorts: []
          });
        } else if (query.type === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection_editorial'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label
          }, query);

          if (query.link) {
            var queryLink = dist["url"].normalizeUrl(query.link);
            var queryLinkWithLocale = locale ? new URI_default.a(queryLink).addQuery({
              locale: locale
            }).toString() : queryLink;
            redirectUtils["a" /* default */].redirectTo()(queryLinkWithLocale);
          }
        } else {
          dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
          trackQueryChange(query, trackingPayload);
          Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
            criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
            location: location,
            searchCriteria: {
              query: query,
              departureCity: departureCity,
              departureDate: departureDate,
              duration: duration,
              keywords: '',
              kids: kids,
              kidsValidationState: kidsValidationState
            },
            searchPageRouteName: 'search'
          });
        }
      }
    })), block.linkLabel && blockLinkURL && (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && !isDesktop) ? GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "font-bold text-sm text-gray underline",
      isExternalLink: false,
      onClick: function onClick() {
        if (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Nocomplete',
            searchTerms: props.autocompleteQuery
          }, {
            label: '',
            type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
          });
        }

        props.clearGlobalSearch();
      },
      sendTrackingDataBeforeOnClick: true,
      trackingData: {
        categoryGA: 'layer',
        actionGA: 'search',
        labelGA: "viewMore_".concat(block.id),
        searchReferrer: 'layer'
      },
      url: blockLinkURL
    }, Object(lodash["upperFirst"])(block.linkLabel)) : null);
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearch.jsx

var GlobalSearch_jsx = react_default.a.createElement;

function GlobalSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















function DesktopSearchContainer(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      offsetTop = _ref.offsetTop;
  return GlobalSearch_jsx("aside", {
    className: classnames_default()('fadeIn fixed flex flex-col inset-0', {
      'invisible opacity-0': !isOpen
    }),
    style: {
      backgroundColor: 'rgba(1, 1, 1, 0.5)',
      top: "".concat(Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT + offsetTop, "px")
    }
  }, children);
}

var onScroll = Object(lodash["throttle"])(function () {
  Object(lib["forceCheck"])();
}, 250);

function MobileSearchContainer(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      offsetTop = _ref2.offsetTop;
  return GlobalSearch_jsx("div", {
    className: classnames_default()('bg-white bottom-0 fixed overflow-y-auto p-px15 rtl:right-0 w-full', {
      'translate-x-0': isOpen,
      'rtl:translate-x-100': !isOpen
    }),
    onScroll: onScroll,
    style: {
      top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
      transition: 'transform linear 330ms'
    }
  }, isOpen ? children : null);
}

var GlobalSearch_GlobalSearch = function GlobalSearch(_ref3) {
  var className = _ref3.className,
      facetingSuggestedRequests = _ref3.facetingSuggestedRequests,
      isOpen = _ref3.isOpen,
      offsetTop = _ref3.offsetTop,
      toggleOpen = _ref3.toggleOpen;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller;

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(),
      autocompleteQuery = _useAutocomplete.autocompleteQuery,
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'layer'
  }); // This effect is used to focus the search query input element when the GlobalSearch is opened
  // Use timer to wait for css transition

  var searchInput = /*#__PURE__*/Object(react["createRef"])();
  Object(react["useEffect"])(function () {
    var timer = null;

    if (isOpen && searchInput.current) {
      var _facetingSuggestedReq;

      if (!isSeller && !autocompleteQuery && !!(facetingSuggestedRequests === null || facetingSuggestedRequests === void 0 ? void 0 : (_facetingSuggestedReq = facetingSuggestedRequests.items) === null || _facetingSuggestedReq === void 0 ? void 0 : _facetingSuggestedReq.length)) {
        track({
          actionGA: 'search',
          labelGA: 'requestsDisplay'
        });
      }

      var input = searchInput.current;
      timer = setTimeout(function () {
        input.focus();
      }, 500);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [isOpen]);
  var trackingData = {
    categoryGA: 'headerMenu',
    actionGA: 'header_search'
  };
  var toggleGlobalSearch = Object(react["useCallback"])(function () {
    setAutocompleteQuery('');
    setAutocompleteResults([]);
    toggleOpen();
  }, []);

  var onChangeQuery = function onChangeQuery(e) {
    var value = e.currentTarget.value;
    setAutocompleteQuery(value);
  };

  var GLOBAL_SEARCH_ENABLED = config_default.a.get('featureFlipping.faceting.globalSearchEnabled');

  var searchComponent = GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(SearchQuery, {
    autocompleteQuery: autocompleteQuery,
    clearGlobalSearch: toggleGlobalSearch,
    facetingSuggestedRequests: facetingSuggestedRequests,
    onChangeQuery: onChangeQuery,
    ref: searchInput,
    trackingData: trackingData
  }), GlobalSearch_jsx("div", {
    className: classnames_default()('bg-white fadeIn slideInTop w-full', {
      'flex-1 overflow-y-auto': isDesktop,
      'pb-px50': !isDesktop,
      'invisible opacity-0': autocompleteQuery.length === 0
    }),
    "data-testid": "search-suggestions-container",
    style: isDesktop ? {
      paddingLeft: '15%',
      paddingRight: '15%'
    } : {}
  }, GlobalSearch_jsx(GlobalSearchSuggestions_SearchSuggestions, {
    autocompleteQuery: autocompleteQuery,
    autocompleteResults: autocompleteResults,
    clearGlobalSearch: toggleGlobalSearch
  })));

  var searchLinkLabel = Object(i18n["g" /* t */])('faceting.searchLinkLabel');
  return GLOBAL_SEARCH_ENABLED ? GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    "aria-expanded": isOpen,
    "aria-label": "Search",
    "aria-pressed": isOpen,
    as: "button",
    className: className,
    "data-testid": "global-search-button",
    onClick: toggleGlobalSearch,
    title: searchLinkLabel,
    trackingData: GlobalSearch_objectSpread(GlobalSearch_objectSpread({}, trackingData), {}, {
      labelGA: isOpen ? 'close' : 'open'
    }),
    type: "button",
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel)), isDesktop ? GlobalSearch_jsx(DesktopSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent) : GlobalSearch_jsx(MobileSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent)) : GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: className,
    "data-testid": "global-search-link",
    title: searchLinkLabel,
    trackingData: Navigation_tracking["c" /* NAVIGATION_TRACKING_SEARCH_BUTTON */],
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/member-access-button/NavigationMemberAccessButton.jsx







var NavigationMemberAccessButton_jsx = react_default.a.createElement;

function NavigationMemberAccessButton_createSuper(Derived) { var hasNativeReflectConstruct = NavigationMemberAccessButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationMemberAccessButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var NavigationMemberAccessButton_NavigationMemberAccessButton = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(NavigationMemberAccessButton, _Component);

  var _super = NavigationMemberAccessButton_createSuper(NavigationMemberAccessButton);

  function NavigationMemberAccessButton() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationMemberAccessButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      animate: false
    });

    return _this;
  }

  Object(createClass["a" /* default */])(NavigationMemberAccessButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var isAnimationEnable = !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('memberSpace.disableConnectionAnimation'); // $FlowFixMe

      this.timeoutID = setTimeout(function () {
        _this2.setState({
          animate: true
        });
      }, 1500);

      if (isAnimationEnable && !this.props.isAuthenticated) {
        // $FlowFixMe
        this.intervalID = setInterval(function () {
          _this2.setState({
            animate: true
          });
        }, 10000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      if (this.state.animate) {
        // $FlowFixMe
        this.timeoutID = setTimeout(function () {
          _this3.setState({
            animate: false
          });
        }, 2000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // $FlowFixMe
      clearTimeout(this.timeoutID); // $FlowFixMe

      clearInterval(this.intervalID);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isActive = _this$props.isActive,
          isAuthenticated = _this$props.isAuthenticated,
          isQuickLoggedIn = _this$props.isQuickLoggedIn,
          onClick = _this$props.onClick,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 1.25 : _this$props$size,
          title = _this$props.title;
      var animate = this.state.animate;
      var trackingData = {
        categoryGA: 'headerMenu',
        actionGA: 'header_memberSpace',
        labelGA: 'memberSpace'
      };
      return NavigationMemberAccessButton_jsx(TrackClick["a" /* TrackClick */], {
        "aria-expanded": isActive,
        as: "button",
        className: className,
        onClick: onClick,
        title: title,
        trackingData: isActive || isAuthenticated ? null : trackingData,
        type: "button"
      }, NavigationMemberAccessButton_jsx("span", {
        className: "flex relative"
      }, !!title && NavigationMemberAccessButton_jsx("span", {
        className: "sr-only"
      }, title), NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].USER,
        width: "".concat(size, "rem")
      }), (isAuthenticated || isQuickLoggedIn) && NavigationMemberAccessButton_jsx("span", {
        className: classnames_default()('absolute flex items-center justify-center leading-none rounded-half', {
          'bg-emerald': isAuthenticated && !isQuickLoggedIn,
          'bg-blue': isQuickLoggedIn
        }),
        style: {
          top: '-0.5625rem',
          right: '-0.3125rem',
          width: '0.75rem',
          height: '0.75rem'
        }
      }, NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        color: colors["a" /* COLORS */].WHITE,
        name: icons["a" /* ICONS */].CHECK,
        width: "0.5rem"
      })), animate && NavigationMemberAccessButton_jsx("span", {
        style: {
          position: 'absolute',
          top: "".concat(size * 0.22, "rem"),
          left: "".concat(-size * 0.65, "rem"),
          width: "".concat(size * 0.8, "rem"),
          height: "".concat(size * 0.6, "rem"),
          border: "solid ".concat(size * 0.06, "rem black"),
          borderRadius: '0 0 50% 80%',
          borderColor: 'transparent transparent black transparent',
          transformOrigin: 'bottom right',
          animation: 'memberAnimation 2s'
        }
      })));
    }
  }]);

  return NavigationMemberAccessButton;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationMemberAccessButton_NavigationMemberAccessButton, "contextType", ReactAppContext["b" /* default */]);
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeBackPanel.jsx
var NavigationLargeBackPanel_jsx = react_default.a.createElement;


var NavigationLargeBackPanel_NavigationLargeBackPanel = function NavigationLargeBackPanel(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;
  return NavigationLargeBackPanel_jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, NavigationLargeBackPanel_jsx("div", {
    className: "bg-white h-0 max-w-site mx-auto my-0 overflow-hidden pointer-events-none shadow transition-heights w-full",
    style: {
      height: "".concat(String(height), "px"),
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeElement.jsx

var NavigationLargeElement_jsx = react_default.a.createElement;

function NavigationLargeElement_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLargeElement_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLargeElement_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLargeElement_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NavigationLargeElement_NavigationLargeElement = function NavigationLargeElement(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      style = _ref.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeElement_jsx("div", {
    className: classnames_default()(className, 'absolute bg-white mt-px overflow-y-auto p-px20 rtl:right-0 top-full'),
    id: id,
    style: NavigationLargeElement_objectSpread({
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }, style)
  }, closeLabel && NavigationLargeElement_jsx("button", {
    className: "reset-button sr-only focus:not-sr-only float-right mb-px10 px-px5 text-blue text-sm",
    onClick: onClose,
    type: "button"
  }, closeLabel), children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/first-level-item/NavigationLargeFirstLevelItem.jsx


var NavigationLargeFirstLevelItem_jsx = react_default.a.createElement;




var NavigationLargeFirstLevelItem_NavigationLargeFirstLevelItem = function NavigationLargeFirstLevelItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasSubItems = _ref.hasSubItems,
      isActive = _ref.isActive,
      link = _ref.link;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeFirstLevelItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    "aria-haspopup": hasSubItems,
    as: DynamicLink["a" /* default */],
    className: classnames_default()(className, 'cursor-pointer flex font-sans font-bold items-center px-px15 relative reset-anchor focus:text-blue hover:text-blue transition-color uppercase', "text-".concat(color), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(color, "-active hover:text-").concat(color, "-active"), !!color), {
      'navigation-arrow': hasSubItems
    }, {
      'navigation-arrow-active': isActive && hasSubItems
    }),
    "data-testid": "NavigationLarge-item-link",
    style: {
      fontSize: '0.8125rem'
    }
  }), children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/NavigationLarge.jsx








var NavigationLarge_jsx = react_default.a.createElement;

function NavigationLarge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLarge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLarge_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLarge_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function NavigationLarge_createSuper(Derived) { var hasNativeReflectConstruct = NavigationLarge_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationLarge_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */




















var NavigationMemberAccess = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 42).then(__webpack_require__.bind(null, "uXT4")).then(function (x) {
    return x.NavigationMemberAccess;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uXT4")];
    },
    modules: ["../member-access/NavigationMemberAccess"]
  }
});
var NavigationLargePanel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 721).then(__webpack_require__.bind(null, "x5wo")).then(function (x) {
    return x.NavigationLargePanel;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("x5wo")];
    },
    modules: ["./panels/NavigationLargePanel"]
  }
});
var NavigationLargeSubNav = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 722).then(__webpack_require__.bind(null, "5Rjz")).then(function (x) {
    return x.NavigationLargeSubNav;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("5Rjz")];
    },
    modules: ["./subnavs/NavigationLargeSubNav"]
  }
});
var NavigationLargeSubNavList = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 723).then(__webpack_require__.bind(null, "h6Iw")).then(function (x) {
    return x.NavigationLargeSubNavList;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Iw")];
    },
    modules: ["./subnavs/NavigationLargeSubNavList"]
  }
});
var NavigationContact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 46).then(__webpack_require__.bind(null, "AY+A")).then(function (x) {
    return x.NavigationContact;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("AY+A")];
    },
    modules: ["../contact/NavigationContact"]
  }
});
var POPHOVER_IN_DELAY = 300;
var POPHOVER_OUT_DELAY = 500;
var NavigationLarge_NavigationLarge = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(NavigationLarge, _PureComponent);

  var _super = NavigationLarge_createSuper(NavigationLarge);

  function NavigationLarge(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationLarge);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      if (_this.state.activeElement) {
        if (!_this.navigationNode.current || !_this.navigationNode.current.contains(e.target)) {
          _this.setState({
            activeElement: null
          });
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setSubnav", function (activeIndex, isFocus) {
      return function () {
        var height = 0;

        if (true) {
          // $FlowFixMe
          height = _this["subnav".concat(activeIndex)] ? _this["subnav".concat(activeIndex)].clientHeight : 0;
        }

        clearTimeout(_this.hoverOutTimeout);
        _this.hoverInTimeout = setTimeout(function () {
          _this.setState({
            activeElement: null,
            activeIndex: activeIndex,
            height: height
          });
        }, isFocus ? 0 : POPHOVER_IN_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetSubnav", function (isFocus) {
      return function () {
        clearTimeout(_this.hoverInTimeout);
        _this.hoverOutTimeout = setTimeout(function () {
          _this.setState({
            activeIndex: -1,
            height: 0
          });
        }, isFocus ? 0 : POPHOVER_OUT_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            activeIndex: -1,
            height: 0
          };
        });
      };
    });

    _this.navigationNode = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      activeElement: null,
      activeIndex: -1,
      height: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationLarge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
      }

      clearTimeout(this.hoverInTimeout);
      clearTimeout(this.hoverOutTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          facetingSuggestedRequests = _this$props.facetingSuggestedRequests,
          id = _this$props.id,
          contact = _this$props.contact,
          items = _this$props.items,
          language = _this$props.language,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          isMicePage = _this$props.isMicePage,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;

      var _ref = userInfo || {},
          isLoggedIn = _ref.isLoggedIn,
          isQuickLoggedIn = _ref.isQuickLoggedIn;

      var activeElement = this.state.activeElement;
      var iconButtonClassNames = 'cursor-pointer flex items-center px-px15 relative reset-button focus:text-blue hover:text-blue';
      var offsetTop = promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var isGlobalSearchActiveElement = activeElement === Navigation_constants["d" /* elements */].SEARCH;
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      var logoTitle = isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage';
      return NavigationLarge_jsx("nav", {
        "aria-label": "ClubMed main navigation",
        className: "".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */], " absolute bg-white lg:block hidden inset-x-0 top-0 z-main-navigation"),
        id: id,
        role: "navigation"
      }, NavigationLarge_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(NavigationLargeBackPanel_NavigationLargeBackPanel, {
        height: this.state.height
      }), NavigationLarge_jsx("div", {
        className: "border-b-1 border-gray-light flex items-stretch justify-between px-px20",
        ref: this.navigationNode,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT
        }
      }, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "cursor-pointer flex flex-shrink-0 items-center px-px20 text-blue",
        "data-testid": "NavigationLarge-logo",
        onFocus: this.resetSubnav(true),
        queryParamsToIgnore: ['selectedProposalId', 'proposalIds', 'optionIds'],
        title: logoTitle,
        trackingData: Navigation_tracking["b" /* NAVIGATION_TRACKING_LOGO_BUTTON */],
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          '-mt-px5': !isMicePage,
          'mt-px5': isMicePage
        }),
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        isNotSquare: true,
        width: "10rem"
      }), NavigationLarge_jsx("span", {
        className: "sr-only"
      }, logoTitle)), NavigationLarge_jsx("ul", {
        className: "reset-list flex",
        style: {
          flex: '0 1 auto'
        }
      }, items.map(function (item, index) {
        var subItems = item.subItems || [];
        var hasSubItems = !!subItems.length;
        var isList = item.isList,
            label = item.label;
        var isActive = index === _this2.state.activeIndex;
        var subnavName = "subnav".concat(index);
        return !!label && NavigationLarge_jsx("li", {
          className: "flex items-stretch",
          "data-testid": "NavigationLarge-item",
          key: label,
          onBlur: _this2.resetSubnav(true),
          onFocus: _this2.setSubnav(index, true),
          onMouseEnter: _this2.setSubnav(index),
          onMouseLeave: _this2.resetSubnav()
        }, NavigationLarge_jsx(NavigationLargeFirstLevelItem_NavigationLargeFirstLevelItem, {
          color: item.color,
          hasSubItems: hasSubItems,
          isActive: isActive,
          link: item.link
        }, label), hasSubItems && NavigationLarge_jsx(NavigationLargePanel, {
          isActive: isActive // $FlowFixMe
          ,
          ref: function ref(elem) {
            return _this2[subnavName] = elem;
          }
        }, isList ? NavigationLarge_jsx(NavigationLargeSubNavList, {
          parentLabel: label,
          subItems: subItems
        }) : NavigationLarge_jsx(NavigationLargeSubNav, {
          subItems: subItems
        })));
      })), NavigationLarge_jsx("div", {
        className: "flex flex-shrink-0 relative"
      }, !Object(lodash["isEmpty"])(contact) && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: "button",
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        "data-testid": "NavigationLarge-contact-button",
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        style: {
          fontSize: '0.8125rem'
        },
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : Navigation_tracking["a" /* NAVIGATION_TRACKING_CONTACT_BUTTON */],
        type: "button"
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-px5",
        color: colors["a" /* COLORS */].BLUE,
        name: icons["a" /* ICONS */].PHONE,
        hasRtl: true,
        width: "1em"
      }), NavigationLarge_jsx("span", {
        className: "sr-only"
      }, contact.title, "\xA0"), NavigationLarge_jsx("span", {
        className: "font-bold text-blue whitespace-no-wrap",
        dir: "ltr"
      }, contact.phoneNumber)), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].CONTACT),
        style: {
          width: '18.75rem'
        }
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT ? NavigationLarge_jsx(NavigationContact, {
        contact: contact
      }) : null)), isMicePage && NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "cursor-pointer flex font-bold items-center leading-tight px-px15 relative reset-button text-base focus:text-blue hover:text-blue text-gray-darker underline",
        trackingData: {
          actionGA: 'header_backToB2C',
          categoryGA: 'headerMenu',
          labelGA: 'backToB2C'
        },
        url: backToB2CWebsiteLink
      }, backToB2CWebsiteLabel), !isMicePage && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(GlobalSearch_GlobalSearch, {
        className: "cursor-pointer flex items-center px-px15 relative reset-button focus:text-blue hover:text-blue text-gray-darker",
        facetingSuggestedRequests: facetingSuggestedRequests,
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), NavigationLarge_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'navigation-arrow-active text-blue': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: isLoggedIn,
        isQuickLoggedIn: isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: Object(i18n["g" /* t */])('account.authentication.yourAccount.title')
      }), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        className: "rounded-small shadow-md",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        style: NavigationLarge_objectSpread({
          width: '40rem'
        }, isLoggedIn || isQuickLoggedIn ? {
          width: '18.125rem',
          padding: '0'
        } : {})
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN ? NavigationLarge_jsx(NavigationMemberAccess, {
        userInfo: userInfo
      }) : null)), Object.keys((language === null || language === void 0 ? void 0 : language.locales) || {}).length > 1 && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx("button", {
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow text-center text-sm uppercase', {
          'navigation-arrow-active text-blue': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        }),
        "data-testid": "NavigationLarge-language-button",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES),
        style: {
          minWidth: '3.5rem'
        },
        title: "languages",
        type: "button"
      }, NavigationLarge_jsx("span", {
        className: classnames_default()('toggler', {
          'toggler-active': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        })
      }, language.locales[language.currentLocale].label)), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        className: "px-px5 py-0",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES)
      }, activeElement === Navigation_constants["d" /* elements */].LANGUAGES && NavigationLarge_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
        currentLocale: language.currentLocale,
        getTrackingData: Navigation_tracking["f" /* getNavigationLanguagesButtonTrackingData */],
        isActive: activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        locales: language.locales,
        theme: "column"
      })))))))));
    }
  }]);

  return NavigationLarge;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(NavigationLarge_NavigationLarge, "defaultProps", {
  id: 'Navigation',
  language: {}
});
// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/NavigationSticky.jsx








var NavigationSticky_jsx = react_default.a.createElement;

function NavigationSticky_createSuper(Derived) { var hasNativeReflectConstruct = NavigationSticky_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationSticky_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function stickyNav(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(NavigationSticky, _Component);

    var _super = NavigationSticky_createSuper(NavigationSticky);

    function NavigationSticky(props) {
      var _this;

      Object(classCallCheck["a" /* default */])(this, NavigationSticky);

      _this = _super.call(this, props);

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onLock", function () {
        var isLocked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _this.setState({
          isLocked: isLocked
        });
      });

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleScroll", Object(lodash["throttle"])(function () {
        var _this$state = _this.state,
            lastY = _this$state.lastY,
            isLocked = _this$state.isLocked;

        if (!isLocked) {
          var posY = Math.max(window.pageYOffset, 0);
          var stickyStart = Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT;
          var scrolledDown = posY > lastY;

          _this.setState(function () {
            return {
              isHidden: scrolledDown && posY > stickyStart,
              lastY: posY
            };
          });
        }
      }, 200));

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onStateChange", function (status) {
        _this.setState(function () {
          return {
            isSticky: status.status !== Sticky_default.a.STATUS_ORIGINAL
          };
        });
      });

      _this.state = {
        isHidden: false,
        isLocked: false,
        isSticky: false,
        lastY: 0
      };
      return _this;
    }

    Object(createClass["a" /* default */])(NavigationSticky, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('scroll', this.handleScroll, false);
        this.handleScroll();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state2 = this.state,
            isHidden = _this$state2.isHidden,
            isLocked = _this$state2.isLocked,
            isSticky = _this$state2.isSticky;
        return NavigationSticky_jsx(Sticky_default.a, {
          enableTransforms: false,
          innerClass: classnames_default()('w-full', {
            '-translate-y-100': isSticky && isHidden
          }),
          innerZ: isLocked ? 7 : 5,
          onStateChange: this.onStateChange
        }, NavigationSticky_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, this.props, {
          onLock: this.onLock,
          isSticky: isSticky
        })));
      }
    }]);

    return NavigationSticky;
  }(react["Component"]), _temp;
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigationItem.jsx

var SideNavigationItem_jsx = react_default.a.createElement;







var SideNavigationItem_SideNavigationItem = function SideNavigationItem(_ref) {
  var color = _ref.color,
      hasFocus = _ref.hasFocus,
      isRoot = _ref.isRoot,
      label = _ref.label,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      nextPanel = _ref.nextPanel,
      onClick = _ref.onClick,
      setActiveItem = _ref.setActiveItem,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var buttonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (hasFocus && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [hasFocus]);

  var handleClick = function handleClick() {
    onClick(nextPanel);
    setActiveItem();
  };

  var content = SideNavigationItem_jsx(react["Fragment"], {
    key: label
  }, SideNavigationItem_jsx("span", {
    className: classnames_default()("text-".concat(color), 'font-bold font-sans text-md', {
      uppercase: isRoot
    })
  }, label), SideNavigationItem_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  }));

  return link && link.url ? SideNavigationItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: DynamicLink["a" /* default */],
    className: "cursor-pointer flex h-full items-center justify-between py-px15 reset-anchor w-full",
    "data-testid": "SideNavigationItem-subitem-link",
    onClick: handleClick,
    tabIndex: tabIndex
  }), content) : SideNavigationItem_jsx("button", {
    className: "reset-button w-full",
    "data-testid": "SideNavigationItem-subitem-button",
    onClick: handleClick,
    ref: buttonRef,
    tabIndex: tabIndex,
    type: "button"
  }, SideNavigationItem_jsx("div", {
    className: "flex h-full items-center justify-between py-px15 w-full"
  }, content));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigation.jsx

var SideNavigation_jsx = react_default.a.createElement;












var SideNavigation_SideNavigation = function SideNavigation(_ref) {
  var backButtonLabel = _ref.backButtonLabel,
      backToB2CWebsiteLabel = _ref.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = _ref.backToB2CWebsiteLink,
      closeMenu = _ref.closeMenu,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'SideNavigation' : _ref$id,
      isActive = _ref.isActive,
      isHidden = _ref.isHidden,
      isMicePage = _ref.isMicePage,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      label = _ref.label,
      language = _ref.language,
      navBack = _ref.navBack,
      navForward = _ref.navForward,
      parent = _ref.parent,
      parentLabel = _ref.parentLabel,
      parentLink = _ref.parentLink,
      style = _ref.style;

  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      _setActiveItem = _useState[1];

  var backButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (!isHidden && backButtonRef && backButtonRef.current) {
      backButtonRef.current.focus();
    }

    if (isHidden) {
      _setActiveItem(-1);
    }
  }, [isHidden]);
  var classNames = isHidden ? 'rtl:-translate-x-100' : 'translate-x-0';
  var hasParentLink = parentLink && parentLink.url;
  var navItems = items.map(function (item, idx) {
    var itemProps = {
      color: item.color,
      isRoot: Object(lodash["isEmpty"])(parent),
      label: item.label,
      link: {},
      nextPanel: '',
      onClick: navForward,
      setActiveItem: function setActiveItem() {
        _setActiveItem(idx);
      },
      tabIndex: isActive ? 0 : -1
    };
    var subItems = item.subItems || [];
    var itemId = "".concat(item.label.replace(/ /g, '-').toLowerCase()).concat(item.id);

    if (subItems.length) {
      itemProps.nextPanel = itemId;
    } else {
      itemProps.link = Object(lodash["get"])(item, 'link');
    }

    return SideNavigation_jsx("li", {
      key: itemId
    }, SideNavigation_jsx(SideNavigationItem_SideNavigationItem, Object(esm_extends["a" /* default */])({}, itemProps, {
      hasFocus: isActive && activeItem === idx
    })));
  });
  return SideNavigation_jsx("div", {
    "aria-hidden": isHidden,
    className: classnames_default()('bg-white bottom-0 fixed rtl:left-0 w-full', classNames),
    id: id,
    style: style
  }, SideNavigation_jsx("div", {
    className: "bg-white h-full overflow-y-scroll p-px15"
  }, !!parent && !!label && SideNavigation_jsx("div", {
    className: "flex justify-between"
  }, SideNavigation_jsx("button", {
    className: "flex font-bold items-center rtl:-ml-px10 p-px10 reset-button text-base",
    "data-testid": "SideNavigation-back",
    onClick: navBack ? function () {
      return navBack();
    } : null,
    ref: backButtonRef,
    tabIndex: isActive ? 0 : -1,
    type: "button"
  }, SideNavigation_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.8125rem"
  }), !!backButtonLabel && SideNavigation_jsx("span", {
    className: "sr-only",
    "data-testid": "SideNavigation-back-label"
  }, Object(dist["messageFormat"])(backButtonLabel).format({
    item: parentLabel
  }))), SideNavigation_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, hasParentLink ? parentLink : null, {
    as: hasParentLink ? DynamicLink["a" /* default */] : 'div',
    className: "block font-bold py-px10 text-blue text-md uppercase",
    "data-testid": "SideNavigation-item-link",
    onClick: closeMenu,
    tabIndex: isActive ? 0 : -1,
    trackingData: parentLink && parentLink.trackingData
  }), label)), SideNavigation_jsx("ul", {
    className: "reset-list"
  }, !Object(lodash["isEmpty"])(items) && navItems), !parent && isMicePage && backToB2CWebsiteLabel && SideNavigation_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "block cursor-pointer font-bold leading-tight py-px15 relative reset-button focus:text-blue hover:text-blue text-gray-darker text-md underline",
    onClick: closeMenu,
    trackingData: {
      actionGA: 'header_backToB2C',
      categoryGA: 'headerMenu',
      labelGA: 'backToB2C'
    },
    url: backToB2CWebsiteLink
  }, backToB2CWebsiteLabel), !parent && language && Object.keys(Object(lodash["get"])(language, 'locales', {})).length > 1 && SideNavigation_jsx("div", {
    className: "border-b-1 border-t-1 border-gray-light overflow-x-auto"
  }, SideNavigation_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
    className: "min-w-full py-px15",
    getTrackingData: Navigation_tracking["f" /* getNavigationLanguagesButtonTrackingData */],
    isActive: isActive
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SubItems.jsx

var SubItems_jsx = react_default.a.createElement;



var SubItems_SubItems = function SubItems(props) {
  var backButtonLabel = props.backButtonLabel,
      backButtonMainNavLabel = props.backButtonMainNavLabel,
      closeMenu = props.closeMenu,
      items = props.items,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      panelStyles = props.panelStyles,
      parentId = props.parentId,
      parentLabel = props.parentLabel,
      sideNavigationPanels = props.sideNavigationPanels;
  return items.filter(function (item) {
    return item.subItems && item.subItems.length;
  }).map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        link = _ref.link,
        subItems = _ref.subItems;
    var itemId = "".concat(label.replace(/ /g, '-').toLowerCase()).concat(id);
    var panelProps = {
      backButtonLabel: parentId === Navigation_constants["c" /* ROOT_ID */] ? backButtonMainNavLabel : backButtonLabel,
      id: itemId,
      isActive: !!sideNavigationPanels.length && sideNavigationPanels[sideNavigationPanels.length - 1] === itemId,
      isHidden: !sideNavigationPanels.includes(itemId),
      items: subItems,
      label: label,
      language: language,
      navBack: navBack,
      navForward: navForward,
      closeMenu: closeMenu,
      parent: parentId,
      parentLabel: parentLabel,
      parentLink: link,
      style: panelStyles
    };
    return [SubItems_jsx(SideNavigation_SideNavigation, Object(esm_extends["a" /* default */])({
      key: label
    }, panelProps)), SubItems_jsx(SubItems, Object(esm_extends["a" /* default */])({
      key: itemId
    }, props, {
      parentId: itemId,
      parentLabel: label,
      items: subItems
    }))];
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrowElementPanel.jsx
var NavigationNarrowElementPanel_jsx = react_default.a.createElement;


var NavigationNarrowElementPanel_NavigationNarrowElementPanel = function NavigationNarrowElementPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      style = _ref.style;
  return NavigationNarrowElementPanel_jsx("div", {
    className: classnames_default()(className ? className : 'bg-white bottom-0 fixed p-px15 rtl:right-0 w-full', {
      'translate-x-0': isActive,
      'rtl:translate-x-100': !isActive
    }),
    style: style
  }, children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrow.jsx








var NavigationNarrow_jsx = react_default.a.createElement;

function NavigationNarrow_createSuper(Derived) { var hasNativeReflectConstruct = NavigationNarrow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationNarrow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





















var NavigationNarrow_NavigationContact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 46).then(__webpack_require__.bind(null, "AY+A")).then(function (x) {
    return x.NavigationContact;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("AY+A")];
    },
    modules: ["../contact/NavigationContact"]
  }
});
var NavigationNarrow_NavigationMemberAccess = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 42).then(__webpack_require__.bind(null, "uXT4")).then(function (x) {
    return x.NavigationMemberAccess;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uXT4")];
    },
    modules: ["../member-access/NavigationMemberAccess"]
  }
});
var NavigationNarrow_NavigationNarrow = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(NavigationNarrow, _PureComponent);

  var _super = NavigationNarrow_createSuper(NavigationNarrow);

  function NavigationNarrow(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationNarrow);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            sideNavigationPanels: []
          };
        }, function () {
          return _this.props.onLock(!!_this.state.activeElement);
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetNav", function () {
      _this.setState({
        activeElement: null,
        sideNavigationPanels: []
      }, function () {
        return _this.props.onLock(false);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navBack", function () {
      var sideNavigationPanels = _this.state.sideNavigationPanels;

      _this.setState({
        sideNavigationPanels: sideNavigationPanels.splice(0, sideNavigationPanels.length - 1)
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navForward", function (nextPanel) {
      var sideNavigationPanels = _this.state.sideNavigationPanels;
      nextPanel && !sideNavigationPanels.includes(nextPanel) ? _this.setState({
        sideNavigationPanels: [].concat(Object(toConsumableArray["a" /* default */])(sideNavigationPanels), [nextPanel])
      }) : _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeMenu", function () {
      _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeMemberPanel", function () {
      _this.toggleElement(Navigation_constants["d" /* elements */].LOGIN)();
    });

    _this.state = {
      activeElement: null,
      sideNavigationPanels: []
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationNarrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backButtonLabel = _this$props.backButtonLabel,
          backButtonMainNavLabel = _this$props.backButtonMainNavLabel,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          closeMainNavLabel = _this$props.closeMainNavLabel,
          contact = _this$props.contact,
          facetingSuggestedRequests = _this$props.facetingSuggestedRequests,
          id = _this$props.id,
          isMicePage = _this$props.isMicePage,
          isSticky = _this$props.isSticky,
          items = _this$props.items,
          language = _this$props.language,
          openMainNavLabel = _this$props.openMainNavLabel,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;
      var _this$state = this.state,
          activeElement = _this$state.activeElement,
          sideNavigationPanels = _this$state.sideNavigationPanels;
      var offsetTop = !isSticky && promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var panelStyles = {
        maxWidth: '31rem',
        // height: `calc(100vh - ${HEIGHTS.NAVIGATION_NARROW_HEIGHT + offsetTop}px)`,
        top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
        transition: 'transform linear 330ms'
      };
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.phoneNumber) || (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      return NavigationNarrow_jsx("nav", {
        className: classnames_default()('bg-white lg:hidden w-full', Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]),
        id: id,
        role: "navigation"
      }, NavigationNarrow_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: !!activeElement
      }, NavigationNarrow_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: !!activeElement
      }, NavigationNarrow_jsx("div", {
        className: "border-b-1 flex flex-no-wrap",
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        }
      }, NavigationNarrow_jsx("div", {
        className: "rtl:border-r-1 border-gray-light flex h-full items-center"
      }, NavigationNarrow_jsx("button", {
        className: "reset-button h-full p-px15 text-blue",
        id: "NavigationNarrow-toggleSideNav-button",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].MENU),
        type: "button"
      }, NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, activeElement === Navigation_constants["d" /* elements */].MENU ? closeMainNavLabel : openMainNavLabel), NavigationNarrow_jsx("div", {
        className: "hamburger"
      }, NavigationNarrow_jsx("span", {
        className: classnames_default()('hamburger-span', {
          'hamburger-span-active': activeElement === Navigation_constants["d" /* elements */].MENU
        })
      })))), NavigationNarrow_jsx(SideNavigation_SideNavigation, {
        backToB2CWebsiteLink: backToB2CWebsiteLink,
        backToB2CWebsiteLabel: backToB2CWebsiteLabel,
        closeMenu: this.closeMenu,
        id: Navigation_constants["c" /* ROOT_ID */],
        isActive: activeElement === Navigation_constants["d" /* elements */].MENU && !sideNavigationPanels.length,
        isHidden: activeElement !== Navigation_constants["d" /* elements */].MENU,
        isMicePage: isMicePage,
        items: items,
        language: language,
        navBack: this.navBack,
        navForward: this.navForward,
        style: panelStyles
      }), NavigationNarrow_jsx(SubItems_SubItems, {
        backButtonLabel: backButtonLabel,
        backButtonMainNavLabel: backButtonMainNavLabel,
        closeMenu: this.closeMenu,
        items: items,
        language: language,
        navBack: this.navBack,
        navForward: this.navForward,
        panelStyles: panelStyles,
        parentId: Navigation_constants["c" /* ROOT_ID */],
        sideNavigationPanels: sideNavigationPanels
      }), NavigationNarrow_jsx("div", {
        className: "flex-1 px-px10"
      }, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "flex items-center",
        "data-testid": "NavigationNarrow-logo-link",
        onClick: this.resetNav,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        },
        trackingData: Navigation_tracking["b" /* NAVIGATION_TRACKING_LOGO_BUTTON */],
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          'mt-px5': isMicePage
        }),
        color: colors["a" /* COLORS */].BLUE,
        isNotSquare: true,
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        width: isMicePage ? '9rem' : '6rem'
      }), NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage'))), NavigationNarrow_jsx("div", {
        className: "flex"
      }, !isMicePage && NavigationNarrow_jsx(GlobalSearch_GlobalSearch, {
        className: classnames_default()('flex items-center navigation-arrow px-px10 relative reset-button', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].SEARCH,
          'navigation-arrow-active text-blue': activeElement === Navigation_constants["d" /* elements */].SEARCH
        }),
        facetingSuggestedRequests: facetingSuggestedRequests,
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), !Object(lodash["isEmpty"])(contact) && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        as: "button",
        className: classnames_default()('flex items-center navigation-arrow px-px10 relative reset-button', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].CONTACT,
          'navigation-arrow-active text-blue': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        "data-testid": "NavigationNarrow-contact-button",
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : Navigation_tracking["a" /* NAVIGATION_TRACKING_CONTACT_BUTTON */],
        type: "button"
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PHONE,
        width: "1.1875rem"
      }), NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, contact.title)), NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
        isActive: activeElement === Navigation_constants["d" /* elements */].CONTACT,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT && NavigationNarrow_jsx(NavigationNarrow_NavigationContact, {
        contact: contact,
        hasTel: true
      }))), !isMicePage && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()('flex items-center navigation-arrow px-px10 relative reset-button', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].LOGIN,
          'navigation-arrow-active text-blue': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: userInfo && userInfo.isLoggedIn,
        isQuickLoggedIn: userInfo && userInfo.isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: Object(i18n["g" /* t */])('account.authentication.yourAccount.title')
      }), NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
        className: "bg-white bottom-0 fixed overflow-y-auto p-px20 rtl:right-0 w-9/10",
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN && NavigationNarrow_jsx(NavigationNarrow_NavigationMemberAccess, {
        closeMemberPanel: this.closeMemberPanel,
        userInfo: userInfo
      }))))))));
    }
  }]);

  return NavigationNarrow;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(NavigationNarrow_NavigationNarrow, "defaultProps", {
  backButtonLabel: '',
  contact: {},
  id: 'Navigation',
  items: [],
  onLock: function onLock() {}
});

var StickyNavigationNarrow = stickyNav(NavigationNarrow_NavigationNarrow);
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.jsx

var Navigation_jsx = react_default.a.createElement;







var Navigation_Navigation = function Navigation(_ref) {
  var facetingSuggestedRequests = _ref.facetingSuggestedRequests,
      id = _ref.id,
      language = _ref.language,
      navigation = _ref.navigation,
      promoBannerRef = _ref.promoBannerRef,
      userInfo = _ref.userInfo;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var backButtonLabel = navigation.backButtonLabel,
      backButtonMainNavLabel = navigation.backButtonMainNavLabel,
      backToB2CWebsiteLabel = navigation.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = navigation.backToB2CWebsiteLink,
      closeMainNavLabel = navigation.closeMainNavLabel,
      contact = navigation.contact,
      contactMICE = navigation.contactMICE,
      menus = navigation.menus,
      menusMICE = navigation.menusMICE,
      MICELogoRedirectionLink = navigation.MICELogoRedirectionLink,
      openMainNavLabel = navigation.openMainNavLabel;
  var isMicePage = dist["b2cPagesService"].isMicePage(pageType);
  var isClientSide = true;
  var navigationProps = {
    backToB2CWebsiteLabel: backToB2CWebsiteLabel,
    backToB2CWebsiteLink: backToB2CWebsiteLink,
    contact: isMicePage ? contactMICE : contact,
    facetingSuggestedRequests: facetingSuggestedRequests,
    id: id,
    isMicePage: isMicePage,
    items: Navigation_mapper_buildNavigationMenuItems(isMicePage ? menusMICE : menus),
    language: language,
    promoBannerRef: promoBannerRef,
    userInfo: userInfo,
    MICELogoRedirectionLink: MICELogoRedirectionLink
  };
  var shouldRenderDesktopNav = !isClientSide || isAppMounted && isDesktop;
  var shouldRenderMobileNav = !isClientSide || isAppMounted && !isDesktop;
  return Navigation_jsx(react["Fragment"], null, shouldRenderDesktopNav && Navigation_jsx(NavigationLarge_NavigationLarge, navigationProps), shouldRenderMobileNav && Navigation_jsx(StickyNavigationNarrow, Object(esm_extends["a" /* default */])({}, navigationProps, {
    backButtonLabel: backButtonLabel,
    backButtonMainNavLabel: backButtonMainNavLabel,
    closeMainNavLabel: closeMainNavLabel,
    openMainNavLabel: openMainNavLabel
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/widgets/cookie-warning/constants.js
var cookie_warning_constants = __webpack_require__("+LXU");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/promo-banner/PromoBanner.jsx

var PromoBanner_jsx = react_default.a.createElement;








function PromoBanner(props) {
  var _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? colors["a" /* COLORS */].GRENADINE : _props$bgColor,
      className = props.className,
      closeLabel = props.closeLabel,
      countdown = props.countdown,
      description = props.description,
      iconName = props.iconName,
      innerRef = props.innerRef,
      label = props.label,
      link = props.link,
      onClose = props.onClose,
      title = props.title,
      _props$titleColor = props.titleColor,
      titleColor = _props$titleColor === void 0 ? colors["a" /* COLORS */].WHITE : _props$titleColor,
      trackingData = props.trackingData,
      trackingDataClose = props.trackingDataClose;
  if (!title) return null;
  return PromoBanner_jsx("aside", {
    "data-id": "PromoBanner",
    className: classnames_default()(className, "bg-".concat(bgColor, " px-px15 relative shadow w-full")),
    ref: innerRef
  }, PromoBanner_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    as: DynamicLink["a" /* default */]
  }, link, {
    trackingData: trackingData,
    className: "block"
  }), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center justify-center -mx-px5 py-px10"
  }, countdown && PromoBanner_jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    size: "small",
    className: "mb-px10 lg:mb-0 mx-px5"
  })), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center lg:items-baseline justify-center text-center lg:text-initial text-white"
  }, !!iconName && PromoBanner_jsx(Icon["a" /* Icon */], {
    className: "mx-px5 hidden lg:block self-center",
    color: colors["a" /* COLORS */].WHITE,
    name: iconName,
    width: "2.2rem"
  }), !!label && PromoBanner_jsx("p", {
    className: "reset-paragraph hidden font-brand lg:block mx-px10",
    "data-testid": "PromoBanner-label"
  }, label), PromoBanner_jsx("h2", {
    className: "reset-heading font-brand text-lg lg:text-2xl mx-px10 text-".concat(titleColor, " text-shadow underline uppercase"),
    "data-testid": "PromoBanner-title"
  }, title), !!description && PromoBanner_jsx("p", {
    className: "reset-paragraph mt-px5 lg:mt-0 mx-px10 text-sm",
    "data-testid": "PromoBanner-description"
  }, description)))), PromoBanner_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: "reset-button absolute leading-none rtl:mr-px10 p-px10 top-0 rtl:right-0",
    onClick: onClose,
    trackingData: trackingDataClose,
    type: "button"
  }, PromoBanner_jsx("span", {
    className: "sr-only"
  }, closeLabel), PromoBanner_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/PromotionalBanner.jsx


var PromotionalBanner_jsx = react_default.a.createElement;







var PROMOTIONALBANNER_LOCALSTORAGE_KEY = 'disablePromotionalBanner';

function checkDuration() {
  var storaged = Object(local_storage_api["a" /* getFromLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY);
  if (!storaged) return true;
  var now = Date.now();
  var storagedDate = new Date(Number(storaged));
  var tomorrow = storagedDate.setDate(storagedDate.getDate() + 1);
  return now - tomorrow > 0;
}

var PromotionalBanner_PromotionalBannerClass = function PromotionalBannerClass(_ref) {
  var _ref$enabledPages = _ref.enabledPages,
      enabledPages = _ref$enabledPages === void 0 ? [] : _ref$enabledPages,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      bannerProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["enabledPages", "disabledPages"]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var pageMatch = function pageMatch(pages) {
    var pageId = pageContext.pageId;
    return pages.some(function (page) {
      return page && ( // testing pages that correspond to a resort/tour
      pageId === "resort-".concat(page.toUpperCase()) || pageId === "tour-".concat(page.toUpperCase()) || // pages that correspond to a url
      location.pathname === page || location.pathname.startsWith("".concat(page, "/")));
    });
  };

  var isPageEnabled = enabledPages.length ? pageMatch(enabledPages) : true;
  var isPageDisabled = disabledPages.length ? pageMatch(disabledPages) : false;

  var shouldBeDisplayed = function shouldBeDisplayed() {
    return checkDuration() && isPageEnabled && !isPageDisabled;
  };

  var _useState = Object(react["useState"])(shouldBeDisplayed()),
      isDisplayed = _useState[0],
      setDisplay = _useState[1];

  Object(react["useEffect"])(function () {
    setDisplay(shouldBeDisplayed());
  }, [enabledPages, responsiveContext]);

  var disable = function disable() {
    setDisplay(false);
    Object(local_storage_api["c" /* setInLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY, Date.now());
  };

  if (!isDisplayed) {
    return null;
  }

  var trackingData = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'click',
    valueGA: '0',
    nonInteraction: '0'
  };
  var trackingDataClose = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'close',
    valueGA: '0',
    nonInteraction: '0'
  };
  return PromotionalBanner_jsx(react["Fragment"], null, PromotionalBanner_jsx(PromoBanner, Object(esm_extends["a" /* default */])({}, bannerProps, {
    onClose: disable,
    trackingData: trackingData,
    trackingDataClose: trackingDataClose
  })), PromotionalBanner_jsx("script", {
    dangerouslySetInnerHTML: {
      // Render promo banner based on cookie to optimize LCP on initial hit
      __html: "\n            var banner = document ? document.querySelector(\"[data-id='PromoBanner']\") : null;\n            if (document && document.cookie.match(/".concat(cookie_warning_constants["g" /* COOKIE_WARNING_LOCALSTORAGE_KEY */], "=1/)) {\n              banner.remove();\n            }\n            ")
    }
  }));
}; // $FlowFixMe


var PromotionalBanner = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return PromotionalBanner_jsx(PromotionalBanner_PromotionalBannerClass, Object(esm_extends["a" /* default */])({
    innerRef: ref
  }, props));
});
// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/utils/analytics/analyticsUtils.js
var analyticsUtils = __webpack_require__("kdyR");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var api_status_constants = __webpack_require__("54uq");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/ftc-resort/FTCResort.jsx

var FTCResort_jsx = react_default.a.createElement;







var FTCResort_FTCResort = function FTCResort(_ref) {
  var className = _ref.className,
      title = _ref.title,
      text = _ref.text,
      subtitle = _ref.subtitle;

  var _useState = Object(react["useState"])(false),
      shouldDisplay = _useState[0],
      setShouldDisplay = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      viewed = _useState2[0],
      setViewed = _useState2[1];

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  Object(react["useEffect"])(function () {
    var timeoutID = setTimeout(function () {
      setShouldDisplay(true);
    }, 300);
    return function () {
      clearTimeout(timeoutID);
    };
  }, []);
  if (viewed && !shouldDisplay) return null;
  return FTCResort_jsx("div", {
    className: "absolute top-full rtl:right-0 w-full z-5"
  }, FTCResort_jsx("div", {
    className: "flex p-px20 max-w-site mt-navigation mx-auto"
  }, FTCResort_jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'rtl:ml-auto bg-white flex max-w-full p-px10 rtl:pr-px30 relative rounded border-1 border-grenadine shadow transition-all')
  }, !shouldDisplay ? {
    style: {
      transform: isRTL ? 'translateX(-200%)' : 'translateX(200%)'
    }
  } : {}), FTCResort_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].GRENADINE,
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "3.0625rem",
    isNotSquare: true
  }), FTCResort_jsx("div", {
    className: "font-sans rtl:ml-px10"
  }, FTCResort_jsx("h3", {
    className: "reset-heading text-base font-bold"
  }, title), !!subtitle && FTCResort_jsx("p", {
    className: "m-0 font-brand text-grenadine text-2xl"
  }, subtitle), FTCResort_jsx(Text["a" /* Text */], {
    text: text,
    theme: "text-sans-1"
  })), FTCResort_jsx("button", {
    className: "reset-button absolute leading-none p-px10 top-0 rtl:right-0",
    onClick: function onClick() {
      setShouldDisplay(false);
      setViewed(true);
    },
    type: "button"
  }, FTCResort_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/ftc-resort/FTCResortContainer.jsx
var FTCResortContainer_jsx = react_default.a.createElement;















var voucherQuery = "query {\n    vouchers {\n      type\n      items {\n        amount\n        currency\n        isExpired\n        originType\n        status\n      }\n    }\n }";
var FTCResortContainer_FTCResortContainer = function FTCResortContainer() {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var track = Object(useTracking["a" /* useTracking */])();
  var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
  var isAllowedPage = [PAGE_TYPES.RESORT, PAGE_TYPES.CRUISE].includes(pageType);
  var displayFTC = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit');

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: voucherQuery,
    queryOptions: {
      requestName: requestDictionary["J" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */],
      cacheFront: {
        key: requestDictionary["J" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
      }
    },
    cache: false,
    ignore: !isLogged || !isAllowedPage || !displayFTC
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var creditNotesVouchers = data === null || data === void 0 ? void 0 : data.vouchers.find(function (_ref) {
    var type = _ref.type;
    return type === 'CREDIT_NOTE';
  });
  var creditNoteVoucher = creditNotesVouchers === null || creditNotesVouchers === void 0 ? void 0 : creditNotesVouchers.items.find(function (voucher) {
    return voucher.status === api_status_constants["b" /* API_AVAILABLE */] && voucher.originType.startsWith('<DOS=');
  });
  var hasCreditNoteVoucher = !!creditNoteVoucher;
  Object(react["useEffect"])(function () {
    if (hasCreditNoteVoucher) {
      track({
        actionGA: 'FTC',
        labelGA: 'displayAmountToaster'
      });
    }
  }, [hasCreditNoteVoucher]);
  var title = Object(i18n["g" /* t */])(hasCreditNoteVoucher ? 'resort.futureTravelCredit.specificTitle' : 'resort.futureTravelCredit.genericTitle');
  var text = Object(i18n["g" /* t */])(hasCreditNoteVoucher ? 'resort.futureTravelCredit.message' : 'resort.futureTravelCredit.genericDescription');
  var subtitle = creditNoteVoucher && Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(creditNoteVoucher.amount, appContext.locale, creditNoteVoucher.currency);
  if (!isAllowedPage || !isAppMounted || !displayFTC) return null;
  if (isLoading && isLogged) return null;
  if (!isLoading && isLogged && !hasCreditNoteVoucher) return null;
  return Object(analyticsUtils["a" /* isAnalyticsEnabled */])(appContext.locale) && FTCResortContainer_jsx(FTCResort_FTCResort, {
    title: title,
    text: text,
    subtitle: subtitle
  });
};
// EXTERNAL MODULE: ./src/client/components/stylesheets/critical.css
var critical = __webpack_require__("yAUU");

// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.jsx


var Layout_jsx = react_default.a.createElement;









 // import { FooterContainer } from 'Components/layouts/footer/FooterContainer';





var FooterContainer = dynamic_default()( /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
  return regenerator_default.a.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(37), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "ByKL"));

        case 2:
          return _context.abrupt("return", _context.sent.FooterContainer);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ByKL")];
    },
    modules: ["../footer/FooterContainer"]
  }
});
var LazyLayout = dynamic_default()( /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
  return regenerator_default.a.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(117), __webpack_require__.e(122)]).then(__webpack_require__.bind(null, "nsiK"));

        case 2:
          return _context2.abrupt("return", _context2.sent.LazyLayout);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})), {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("nsiK")];
    },
    modules: ["./LazyLayout"]
  }
});
var NavigationBar = Object(UserInfo["a" /* userInfoWrapper */])(Navigation_Navigation);

var Layout_getLocales = function getLocales(currentLocale, availableLocales) {
  var _config$get;

  var hiddenLocales = ((_config$get = config_default.a.get('featureFlipping.hiddenLocales')) !== null && _config$get !== void 0 ? _config$get : '').split(',').filter(function (l) {
    return l !== currentLocale;
  });
  return Object(lodash["omit"])(availableLocales, hiddenLocales);
};

var Layout_Layout = /*#__PURE__*/Object(react["memo"])(function Layout(props) {
  var _CMSConfig$crisisAler, _CMSConfig$crisisAler2, _CMSConfig$crisisAler3, _CMSConfig$crisisAler4;

  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var promoBannerRef = Object(react["useRef"])();
  var _props$config = props.config,
      CMSConfig = _props$config === void 0 ? {} : _props$config,
      disableFooter = props.disableFooter,
      disableHeader = props.disableHeader,
      className = props.className,
      isMicePage = props.isMicePage,
      legalInformations = props.legalInformations,
      newsletters = props.newsletters,
      children = props.children;
  var availableLocales = context.availableLocales,
      currentLocale = context.locale;
  var navigationBar = CMSConfig.navigationBar,
      _CMSConfig$promotiona = CMSConfig.promotionalBanner,
      promotionalBanner = _CMSConfig$promotiona === void 0 ? {
    enabled: false
  } : _CMSConfig$promotiona,
      faceting = CMSConfig.faceting;
  Object(i18n["a" /* addTranslationKeys */])(CMSConfig);
  var navLanguage = {
    currentLocale: currentLocale,
    locales: Layout_getLocales(currentLocale, availableLocales)
  };
  var shouldDisplayPromoBanner = !disableHeader && !isMicePage && promotionalBanner.enabled && (Boolean(promotionalBanner.title) || Boolean(promotionalBanner.description));
  return Layout_jsx(react["Fragment"], null, Layout_jsx(LazyLayout, null), shouldDisplayPromoBanner && Layout_jsx(PromotionalBanner, {
    bgColor: promotionalBanner.color,
    className: "relative z-6",
    closeLabel: promotionalBanner.closeButtonLabel,
    countdown: promotionalBanner.countdown,
    description: promotionalBanner.description,
    disabledPages: promotionalBanner.disabledPages,
    enabledPages: promotionalBanner.enabledPages,
    iconName: promotionalBanner.icon,
    label: promotionalBanner.iconTitle,
    link: {
      url: promotionalBanner.link
    },
    title: promotionalBanner.title,
    titleColor: promotionalBanner.titleColor,
    ref: promoBannerRef
  }), Layout_jsx("div", {
    className: classnames_default()(className, 'Layout relative table table-fixed w-full')
  }, !disableHeader ? Layout_jsx("div", {
    className: "absolute top-0 inset-x-0"
  }, ((_CMSConfig$crisisAler = CMSConfig.crisisAlert) === null || _CMSConfig$crisisAler === void 0 ? void 0 : _CMSConfig$crisisAler.enabled) && Layout_jsx("div", {
    className: "absolute top-0 rtl:right-0 w-full z-5"
  }, Layout_jsx("div", {
    className: "flex p-px20 max-w-site mt-navigation mx-auto"
  }, Layout_jsx(CrisisAlertLinkBanner_CrisisAlertLinkBanner, {
    alertDate: (_CMSConfig$crisisAler2 = CMSConfig.crisisAlert.alertDate) !== null && _CMSConfig$crisisAler2 !== void 0 ? _CMSConfig$crisisAler2 : '',
    className: "rtl:ml-auto",
    linkLabel: (_CMSConfig$crisisAler3 = CMSConfig.crisisAlert.link) === null || _CMSConfig$crisisAler3 === void 0 ? void 0 : _CMSConfig$crisisAler3.label,
    linkUrl: (_CMSConfig$crisisAler4 = CMSConfig.crisisAlert.link) === null || _CMSConfig$crisisAler4 === void 0 ? void 0 : _CMSConfig$crisisAler4.url
  }))), Layout_jsx(FTCResortContainer_FTCResortContainer, null), Layout_jsx(NavigationBar, {
    facetingSuggestedRequests: faceting === null || faceting === void 0 ? void 0 : faceting.suggestedRequests,
    language: navLanguage,
    navigation: navigationBar,
    promoBannerRef: promoBannerRef
  })) : null, children, !disableFooter && Layout_jsx(FooterContainer, {
    newsletters: newsletters,
    legalInformations: legalInformations,
    config: CMSConfig
  })), Layout_jsx(DataScore_DataScore, null));
});
// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.query.js


var Layout_query_fetchLayoutConfig = function fetchLayoutConfig(appContext) {
  return graphqlClient["a" /* default */].runQuery('', appContext, {
    requestName: requestDictionary["e" /* CORE_LAYOUT */],
    queryId: requestDictionary["e" /* CORE_LAYOUT */]
  });
};
// EXTERNAL MODULE: ./src/client/components/third-party/thirdParty.utils.js
var thirdParty_utils = __webpack_require__("kD1E");

// CONCATENATED MODULE: ./src/client/components/third-party/GoogleTagManager.jsx
var GoogleTagManager_jsx = react_default.a.createElement;





var getGTMKey = function getGTMKey(_ref) {
  var isSeller = _ref.isSeller,
      isCmta = _ref.isCmta;

  if (isSeller && isCmta) {
    return 'GTM-P9H7QS7';
  }

  if (isSeller) {
    return 'GTM-N8CQ3J6';
  }

  return 'GTM-KJ3DSC';
};

var buildTrackingContext = function buildTrackingContext(context, queryParams) {
  var isFromCmta = queryParams.isFromCmta === 'true';
  var isSeller = context.isSeller,
      isCmta = context.isCmta;
  return {
    isSeller: isSeller || isFromCmta,
    isCmta: isCmta || isFromCmta
  };
};

var GoogleTagManager_GoogleTagManager = function GoogleTagManager() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var locale = context.locale;
  var trackingContext = buildTrackingContext(context, queryParams);

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled;

  var key = getGTMKey(trackingContext);

  if (enabled) {
    return GoogleTagManager_jsx(react["Fragment"], null, GoogleTagManager_jsx("noscript", null, GoogleTagManager_jsx("iframe", {
      title: "googletagmanager",
      src: "https://www.googletagmanager.com/ns.html?id=".concat(key),
      height: "0",
      width: "0",
      style: {
        display: 'none',
        visibility: 'hidden'
      }
    })), GoogleTagManager_jsx("script", {
      key: "GTM-script",
      dangerouslySetInnerHTML: {
        __html: "\n              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n              })(window,document,'script','clubMedLayer','".concat(key, "');\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/PriorityThirdPartyScripts.jsx
var PriorityThirdPartyScripts_jsx = react_default.a.createElement;


var PriorityThirdPartyScripts = /*#__PURE__*/Object(react["memo"])(function () {
  return PriorityThirdPartyScripts_jsx(react["Fragment"], null, PriorityThirdPartyScripts_jsx(GoogleTagManager_GoogleTagManager, null));
});
// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// CONCATENATED MODULE: ./src/client/components/third-party/AbTasty.jsx
var AbTasty_jsx = react_default.a.createElement;


var AbTasty_AbTasty = function AbTasty() {
  var _useAbTasty = Object(abTasty_utils["b" /* useAbTasty */])(),
      abTastyScriptUrl = _useAbTasty.abTastyScriptUrl,
      isAbTastyActive = _useAbTasty.isAbTastyActive;

  if (isAbTastyActive) {
    return AbTasty_jsx(react["Fragment"], null, AbTasty_jsx("script", {
      key: "abtasty-lib",
      async: true,
      defer: true,
      src: abTastyScriptUrl
    }), AbTasty_jsx("script", {
      key: "abtasty-inline-script"
      /* eslint-disable-next-line react/no-danger */
      ,
      dangerouslySetInnerHTML: {
        __html: "\n              document.addEventListener('cm_app_mounting', function () {\n                if (window.ABTasty && window.ABTasty.rollbackModifications) {\n                  window.ABTasty.rollbackModifications();\n                }\n              });\n              document.addEventListener('cm_app_mounted', function () {\n                if (window.ABTasty && window.ABTasty.applyModifications) {\n                  window.ABTasty.applyModifications();\n                }\n              });\n            "
      }
    }));
  }

  return null;
};
// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// CONCATENATED MODULE: ./src/client/components/third-party/ContentSquare.jsx
var ContentSquare_jsx = react_default.a.createElement;






var ContentSquare_ContentSquare = function ContentSquare() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller,
      locale = _useContext.locale;

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      contentsquare = _getConfigWithNoThird.contentsquare;

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(contextUtils["h" /* isStrictlyTestEnv */])(config_default.a) && !isSeller && enabled && contentsquare.devId) {
    return ContentSquare_jsx("script", {
      key: "contentsquare-lib",
      async: true,
      defer: true,
      src: "//t.contentsquare.net/uxa/".concat(contentsquare.devId, ".js"),
      type: "text/javascript",
      charSet: "utf-8"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Freespee.jsx
var Freespee_jsx = react_default.a.createElement;




var Freespee_Freespee = function Freespee() {
  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller;

  var accountId = config_default.a.get('freespee.accountId');

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !isSeller && accountId) {
    return Freespee_jsx(react["Fragment"], null, Freespee_jsx("script", {
      key: "freespee-lib",
      async: true,
      defer: true,
      type: "text/javascript",
      src: "//analytics.freespee.com/js/external/fs.js"
    }), Freespee_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              var __fs_conf = __fs_conf || [];\n              __fs_conf.push(['setAdv',{'id': '".concat(accountId, "' }]);\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Hosting.jsx
var Hosting_jsx = react_default.a.createElement;


var Hosting_Hosting = function Hosting() {
  var _appConfig$get = config_default.a.get('hosting'),
      pixel = _appConfig$get.pixel;

  if (pixel.enabled) {
    return Hosting_jsx("img", {
      src: "https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png",
      alt: "",
      width: "1",
      height: "1"
    });
  }

  return null;
};
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/third-party/Udesk.jsx
var Udesk_jsx = react_default.a.createElement;





var Udesk_Udesk = function Udesk() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller,
      locale = _useContext.locale;

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'udesk',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      code = _getConfigWithNoThird.code,
      link = _getConfigWithNoThird.link,
      scriptUrl = _getConfigWithNoThird.scriptUrl;

  if (!isSeller && enabled && code) {
    return Udesk_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n          (function(a,h,c,b,f,g){a[\"UdeskApiObject\"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,\"script\",\"".concat(scriptUrl, "\",\"ud\");\n          ud({\n            \"code\": \"").concat(code, "\",\n            \"link\": \"").concat(link, "\",\n            \"isInvite\": true,\n            \"mode\": \"inner\",\n            \"color\": \"#307AE8\",\n            \"panel\": {\n              \"css\" : {\n                \"left\": \"4%\",\n              },\n            },\n            \"pos_flag\": \"slb\",\n            \"language\": \"").concat(locale === locale_constants["a" /* LOCALES */].ZH_CN ? 'zh-cn' : 'en-us', "\",\n            \"mobile\": {\n              \"mode\": \"inner\",\n              \"color\": \"#307AE8\",\n              \"pos_flag\": \"clb\",\n            }\n          });\n    ")
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Cedexis.jsx
var Cedexis_jsx = react_default.a.createElement;



var Cedexis_Cedexis = function Cedexis() {
  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext.isSeller;

  var performance = config_default.a.get('performance');

  if (!isSeller && performance.cedexis.enabled) {
    return Cedexis_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n            (function(e,c,a,g,f){function d(){var b=c.createElement(\"script\");b.async=!0;\n              b.src=\"//radar.cedexis.com/1/10015/radar.js\";c.body.appendChild(b)}\n              (function(){for(var b=[/\bMSIE (5|6)/i],a=b.length;a--;)if(b[a]\n                .test(navigator.userAgent))return!1;return!0})()\n              &&(\"complete\"!==c.readyState?(a=e[a])?a(f,d,!1):(a=e[g])&&a(\"on\"+f,d):d())})\n            (window,document,\"addEventListener\",\"attachEvent\",\"load\");\n        "
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Sentry.jsx
var Sentry_jsx = react_default.a.createElement;



var Sentry_Sentry = function Sentry() {
  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      locale = _useContext.locale;

  var appVersion = config_default.a.get('APP_VERSION');
  var deploymentEnv = config_default.a.get('DEPLOYMENT_ENV');

  var _appConfig$get = config_default.a.get('clientError.sentry'),
      enabled = _appConfig$get.enabled,
      url = _appConfig$get.url,
      dsn = _appConfig$get.dsn;

  if (enabled && url && dsn) {
    return Sentry_jsx(react["Fragment"], null, Sentry_jsx("script", {
      key: "sentry-lib",
      async: true,
      defer: true,
      src: url,
      crossOrigin: "anonymous"
    }), Sentry_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              if (window.Sentry) {\n                Sentry.init({\n                  dsn: '".concat(dsn, "',\n                  environment: '").concat(deploymentEnv, "',\n                  release: '").concat(appVersion, "',\n                });\n                Sentry.configureScope(function (scope) {\n                  scope.setExtra('locale', '").concat(locale, "');\n                  scope.setTag('locale', '").concat(locale, "');\n                });\n              }\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/ThirdPartyScripts.jsx
var ThirdPartyScripts_config$get, _config$get2;

var ThirdPartyScripts_jsx = react_default.a.createElement;









var DELAY_LOAD = (ThirdPartyScripts_config$get = config_default.a.get('thirdParty.delayLoad')) !== null && ThirdPartyScripts_config$get !== void 0 ? ThirdPartyScripts_config$get : false;
var DELAY_TIMER = (_config$get2 = config_default.a.get('thirdParty.timer')) !== null && _config$get2 !== void 0 ? _config$get2 : 5000;
var LOAD_OPTIONS = {
  once: true,
  passive: true
};
var ThirdPartyScripts = /*#__PURE__*/Object(react["memo"])(function () {
  var _useState = Object(react["useState"])(DELAY_LOAD),
      delaying = _useState[0],
      setDelaying = _useState[1];

  Object(react["useEffect"])(function () {
    if (!DELAY_LOAD || false) {
      return;
    }

    var timeoutHandler = function timeoutHandler() {
      setDelaying(false);
    };

    var timeout = null;

    var loadHandler = function loadHandler() {
      timeout = setTimeout(timeoutHandler, DELAY_TIMER);
    };

    window.addEventListener('load', loadHandler, LOAD_OPTIONS);
    return function () {
      window.removeEventListener('load', loadHandler, LOAD_OPTIONS);
      clearTimeout(timeout);
    };
  }, []);

  if (delaying) {
    return null;
  }

  return ThirdPartyScripts_jsx(react["Fragment"], null, ThirdPartyScripts_jsx(Udesk_Udesk, null), ThirdPartyScripts_jsx(ContentSquare_ContentSquare, null), ThirdPartyScripts_jsx(Hosting_Hosting, null), ThirdPartyScripts_jsx(AbTasty_AbTasty, null), ThirdPartyScripts_jsx(Freespee_Freespee, null), ThirdPartyScripts_jsx(Cedexis_Cedexis, null), ThirdPartyScripts_jsx(Sentry_Sentry, null));
});
// CONCATENATED MODULE: ./src/client/components/utils/easy-testing/index.jsx
var easy_testing_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-onchange */

/* eslint-env browser */




var easy_testing_EasyTesting = function EasyTesting() {
  var _useState = Object(react["useState"])('ltr'),
      currentDirection = _useState[0],
      setCurrentDirection = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var responsive = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var handleDirectionChange = function handleDirectionChange(event) {
    var newDirection = event.target.value;
    setCurrentDirection(newDirection); // $FlowFixMe

    var docEl = document.documentElement;
    docEl.classList.remove('ltr', 'rtl');
    docEl.classList.add(newDirection);
    docEl.dir = newDirection; // $FlowFixMe

    document.body.dir = newDirection;
  };

  var handleVisibilityChange = function handleVisibilityChange() {
    setIsVisible(!isVisible);
  }; // don't render on server and initial boot. Fixes some weird SSR problems


  if (!Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a) || !responsive.isAppMounted) {
    return null;
  }

  var easyTestingStyle = {
    position: 'fixed',
    zIndex: 300,
    top: '210px',
    left: '10px',
    transform: 'rotateZ(-90deg)',
    WebkitTransform: 'rotateZ(-90deg)',
    transformOrigin: 'top left',
    WebkitTransformOrigin: 'top left',
    width: isVisible ? 'auto' : '25px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    direction: 'ltr'
  };
  var directionStyle = {
    margin: '0 3px',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: currentDirection === 'ltr' ? 'emerald' : 'red',
    width: '80px',
    verticalAlign: 'middle',
    outline: 0
  };
  var visibilityStyle = {
    border: 0,
    padding: 0,
    margin: '0 3px 0',
    verticalAlign: 'middle',
    background: 'transparent',
    outline: 0
  };
  var switchVisibilityStyle = {
    fontSize: 0,
    display: 'block',
    border: '2px solid rgba(0, 0, 0, 0.4)',
    width: '20px',
    height: '20px',
    backgroundColor: isVisible ? 'red' : 'yellow',
    borderRadius: '10px',
    transition: 'background-color ease-out 0.7s'
  };
  return easy_testing_jsx("div", {
    className: "easyTesting",
    style: easyTestingStyle
  }, easy_testing_jsx("button", {
    onClick: handleVisibilityChange,
    style: visibilityStyle,
    type: "button"
  }, easy_testing_jsx("span", {
    style: switchVisibilityStyle
  }, "x")), easy_testing_jsx("label", {
    className: "sr-only",
    htmlFor: "switchRTL"
  }, "Switch"), easy_testing_jsx("select", {
    id: "switchRTL",
    onChange: handleDirectionChange,
    style: directionStyle,
    value: currentDirection
  }, easy_testing_jsx("option", {
    value: "ltr"
  }, "L\u2192R"), easy_testing_jsx("option", {
    value: "rtl"
  }, "R\u2192L")));
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/components/widgets/cmta/InitializeCmtaSellerInfos.jsx





var sellerInfoQuery = "{\n  sellerInfo {\n    email\n    salesmanID\n  }\n}";
var InitializeCmtaSellerInfos_InitializeCmtaSellerInfos = function InitializeCmtaSellerInfos() {
  // initializes CMTA email & salesmanID in Redux store
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var sellerInfo = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo;
  });
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    var _appContext$cmta = appContext === null || appContext === void 0 ? void 0 : appContext.cmta,
        email = _appContext$cmta.email,
        salesmanID = _appContext$cmta.salesmanID;

    if (!sellerInfo.email || !sellerInfo.salesmanID) {
      // if sellerInfo is not initialized in the store
      if (email && salesmanID) {
        // no need to make a call if we have sellerInfo in the context
        dispatch({
          type: sellerInfoReducer["a" /* GET_SELLER_INFOS */],
          payload: {
            sellerInfo: {
              email: email,
              salesmanID: salesmanID
            }
          }
        });
      } else {
        graphqlClient["a" /* default */].runNoCacheQuery(sellerInfoQuery, appContext).then(function (data) {
          dispatch({
            type: sellerInfoReducer["a" /* GET_SELLER_INFOS */],
            payload: data
          });
        });
      }
    }
  }, []);
  return null;
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/layers/stopScroll.js
var stopScroll = __webpack_require__("qVkC");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/global-loader/storeHelper.js


var globalLoaderSelector = function globalLoaderSelector(_ref) {
  var globalLoader = _ref.globalLoader;
  return globalLoader || {};
};

var getShouldDisplayGlobalLoader = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref2) {
  var shouldDisplay = _ref2.shouldDisplay;
  return shouldDisplay;
});
var getGlobalLoaderLabel = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref3) {
  var label = _ref3.label;
  return label;
});
var getIsNavigation = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref4) {
  var isNavigation = _ref4.isNavigation;
  return isNavigation;
});

// CONCATENATED MODULE: ./src/client/components/widgets/loading/Loading.jsx
var Loading_jsx = react_default.a.createElement;











var Loading_Loading = function Loading() {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var shouldDisplay = Object(es["e" /* useSelector */])(getShouldDisplayGlobalLoader);
  var isNavigation = Object(es["e" /* useSelector */])(getIsNavigation);
  var isPreviousNavigation = Object(usePrevious["a" /* usePrevious */])(isNavigation);
  var previousShouldDisplay = Object(usePrevious["a" /* usePrevious */])(shouldDisplay);
  var label = Object(es["e" /* useSelector */])(getGlobalLoaderLabel);

  var _useState = Object(react["useState"])(0),
      bodyScrollTop = _useState[0],
      setBodyScrollTop = _useState[1];

  Object(react["useEffect"])(function () {
    if (shouldDisplay) {
      setBodyScrollTop(Object(stopScroll["a" /* getTopScrollValue */])(document));
      Object(stopScroll["b" /* lockBodyScroll */])(document);
    } else if (previousShouldDisplay) {
      // prevent removing the body locker when hydrate from server (there is no previousShouldDisplay)
      if (isPreviousNavigation) {
        // in case of navigation to another page we do not have to scroll to the last position
        Object(stopScroll["c" /* resumeBodyScroll */])(document, 0);
      } else {
        Object(stopScroll["c" /* resumeBodyScroll */])(document, bodyScrollTop);
      }

      setBodyScrollTop(0);
    }
  }, [shouldDisplay]);

  if (!isAppMounted || !shouldDisplay) {
    return null;
  }

  return Loading_jsx(Portal["a" /* default */], {
    name: Portal_constants["d" /* OVER_BOT */]
  }, Loading_jsx("div", {
    id: "loading",
    className: "fixed flex flex-col items-center justify-center bg-overlay-white-90 inset-0 z-4"
  }, Loading_jsx(Spinner["a" /* Spinner */], {
    iconName: icons["a" /* ICONS */].TRIDENT1
  }), Loading_jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    label: label
  })));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixty.jsx
var ThreeSixty_jsx = react_default.a.createElement;





var ThreeSixty_ThreeSixty = function ThreeSixty(_ref) {
  var clientName = _ref.clientName,
      lastVisitsLabel = _ref.lastVisitsLabel,
      lastVisits = _ref.lastVisits;

  var _useState = Object(react["useState"])(false),
      isOpened = _useState[0],
      toggleThreeSixty = _useState[1];

  return ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty', {
      open: isOpened
    })
  }, ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty-content', {
      open: isOpened
    }),
    onClick: function onClick() {
      return toggleThreeSixty(!isOpened);
    }
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-header"
  }, ThreeSixty_jsx("svg", {
    className: "ThreeSixty-cxoLogo",
    width: "130px",
    height: "60px",
    viewBox: "0 0 130 60",
    version: "1.1"
  }, ThreeSixty_jsx("defs", null, ThreeSixty_jsx("linearGradient", {
    x1: "44.7159195%",
    y1: "50%",
    x2: "75.035875%",
    y2: "50%",
    id: "linearGradient-1"
  }, ThreeSixty_jsx("stop", {
    stopColor: "#235472",
    offset: "0%"
  }), ThreeSixty_jsx("stop", {
    stopColor: "#A6DADE",
    offset: "100%"
  }))), ThreeSixty_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, ThreeSixty_jsx("g", {
    id: "10-B2B/Desktop/01-1_CXO",
    transform: "translate(0.000000, -403.000000)"
  }, ThreeSixty_jsx("g", {
    id: "Group-2",
    transform: "translate(0.000000, 403.160714)"
  }, ThreeSixty_jsx("path", {
    d: "M71.2064596,29.6873674 L85.6177833,42.8646077 C90.4453086,46.8799323 94.6046143,49.5481129 100.552511,49.5481129 C111.547972,49.5481129 120.461554,40.7137316 120.461554,29.81597 C120.461554,18.9182085 111.547972,10.0838272 100.552511,10.0838272 C94.4637587,10.0838272 89.1245616,12.6929064 85.219571,16.8145493 L71.2064596,29.6873674 Z M64.84932,23.3302278 L77.7054691,11.0848976 C84.1408993,4.71799111 91.2565906,0.502982484 100.390844,0.502982484 C116.691308,0.502982484 129.905444,13.7171187 129.905444,30.0175819 C129.905444,46.318045 116.691308,58.2393852 100.390844,58.2393852 C90.5625021,58.2393852 85.6177833,56.1114281 76.0119282,47.4843048 L64.3463874,36.5474396 L55.5310792,45.6122108 L48.7298497,38.8109814 L57.5340046,29.7350568 L47.9798065,20.32894 L54.9139193,13.3948271 L64.84932,23.3302278 Z M49.9291515,8.41005929 L42.9950386,15.3441722 C39.4697613,12.110536 34.7699391,10.0838272 29.6091556,10.0838272 C18.66937,10.0838272 9.80092149,19.0053746 9.80092149,29.9451602 C9.80092149,40.8849458 18.66937,48.7579875 29.6091556,48.7579875 C34.7678471,48.7579875 39.4659509,47.7813842 42.990751,44.5500801 L49.7919804,51.3513095 C44.5137473,56.3000378 37.4153607,59.3305694 29.6091556,59.3305694 C13.3086924,59.3305694 0.0945561695,46.1164332 0.0945561695,29.81597 C0.0945561695,13.5155069 13.3086924,0.301370651 29.6091556,0.301370651 C37.483187,0.301370651 44.6370464,3.38479421 49.9291515,8.41005929 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), ThreeSixty_jsx("path", {
    d: "M104.611739,34.6884892 L102.092025,37.2082036 L104.611739,39.7279181 L107.131453,37.2082036 L104.611739,34.6884892 Z M106.214867,18.7758278 C106.099844,18.2043091 104.726762,19.005873 101.750551,21.6370156 C102.893589,22.8950756 103.468702,22.2085343 104.496716,21.8670609 C105.29828,23.2401435 105.528326,29.764083 100.607514,31.7122788 C100.722537,25.1883392 100.837559,18.2043091 100.837559,18.2043091 C100.722537,18.0892865 100.607514,18.0892865 100.492491,18.0892865 C99.1194087,18.3193317 96.7147169,20.6090009 94.8815438,22.6686248 C95.9131529,24.3867753 97.1712129,22.7836474 98.2028221,22.4385795 C98.2028221,22.6686248 97.9727768,27.4744139 98.0877995,32.3988201 C93.0519651,32.7402935 93.853529,22.4385795 94.0799798,21.1805196 C94.1950025,20.0374822 90.8737241,22.4385795 89.1591681,23.9266848 C89.7306868,24.8432713 90.4172281,24.7282487 91.3338146,24.3831808 C90.9887468,28.9625191 94.1950025,33.1967896 98.0877995,33.0817669 C98.2028221,37.8911505 98.7743408,42.4668943 100.147423,42.8119622 C100.377469,42.8119622 100.492491,38.0025787 100.603919,32.5102483 C109.651168,29.764083 106.214867,18.7758278 106.214867,18.7758278 Z",
    id: "Shape",
    fill: "#005589",
    fillRule: "nonzero"
  }))))), isOpened ? ThreeSixty_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "16px",
    className: "ThreeSixty-closeIcon"
  }) : null), ThreeSixty_jsx(react_collapse_lib["UnmountClosed"], {
    theme: {
      collapse: 'ThreeSixty-collapse',
      content: 'ThreeSixty-collapseContent'
    },
    isOpened: isOpened
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-clientName"
  }, clientName), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisitsLabel"
  }, lastVisitsLabel), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisits"
  }, lastVisits.map(function (lastVisit, index) {
    return ThreeSixty_jsx("div", {
      key: lastVisit.name + index,
      className: "ThreeSixty-lastVisit"
    }, ThreeSixty_jsx("div", null, lastVisit.name), ThreeSixty_jsx("div", {
      className: "whitespace-no-wrap"
    }, ThreeSixty_jsx("span", null, "\xA0-\xA0"), lastVisit.category.join(' / ')));
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixtyContainer.jsx









var ThreeSixtyContainer_jsx = react_default.a.createElement;

function ThreeSixtyContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThreeSixtyContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThreeSixtyContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThreeSixtyContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ThreeSixtyContainer_createSuper(Derived) { var hasNativeReflectConstruct = ThreeSixtyContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ThreeSixtyContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var ThreeSixtyContainer_ThreeSixtyContainer = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(ThreeSixtyContainer, _PureComponent);

  var _super = ThreeSixtyContainer_createSuper(ThreeSixtyContainer);

  function ThreeSixtyContainer(props, context) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ThreeSixtyContainer);

    _this = _super.call(this, props, context);

    var _URI$search = new URI_default.a(dist["windowWrapper"].getLocation() || '').search(true),
        cxoMainContactId = _URI$search.cxo_primarycontact,
        _URI$search$cxo_villa = _URI$search.cxo_village,
        cxoLastResorts = _URI$search$cxo_villa === void 0 ? [] : _URI$search$cxo_villa; // when there is always one village it's not an array so we need to force it


    var arrayCxoLastResorts = Array.prototype.concat(cxoLastResorts);
    _this.cxoMainContactId = cxoMainContactId;
    _this.state = {
      i18n: null,
      cxoMainContact: null,
      cxoLastResorts: arrayCxoLastResorts.map(function (resort) {
        var _resort$split = resort.split(' '),
            _resort$split2 = Object(slicedToArray["a" /* default */])(_resort$split, 2),
            resortId = _resort$split2[0],
            roomCategories = _resort$split2[1];

        return {
          id: resortId,
          name: resortId,
          category: roomCategories.split(',')
        };
      }),
      shouldRender: Object(sellerUtils["g" /* isSeller */])(context) && cxoMainContactId && cxoLastResorts.length > 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ThreeSixtyContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _yield$graphQLClient$, resorts, config, profile;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.shouldRender) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return graphqlClient["a" /* default */].runNoCacheQuery("{\n        resorts(resortIds: [\"".concat(this.state.cxoLastResorts.map(function (_ref) {
                  var id = _ref.id;
                  return id;
                }).join('","'), "\"]) {\n          id\n          name\n        }\n        config {\n          booking {\n            cxo {\n              v360 {\n                resortsAndRooms\n              }\n            }\n          }\n        }\n        profile(userId: \"").concat(this.cxoMainContactId, "\", throw401Error: true) {\n          firstName\n          lastName\n        }\n    }"), this.context);

              case 5:
                _yield$graphQLClient$ = _context.sent;
                resorts = _yield$graphQLClient$.resorts;
                config = _yield$graphQLClient$.config;
                profile = _yield$graphQLClient$.profile;
                this.setState({
                  i18n: config,
                  cxoMainContact: "".concat(profile.firstName, " ").concat(profile.lastName),
                  cxoLastResorts: this.state.cxoLastResorts.map(function (resort) {
                    return ThreeSixtyContainer_objectSpread(ThreeSixtyContainer_objectSpread({}, resort), {}, {
                      name: Object(lodash["get"])(resorts.find(function (_ref2) {
                        var id = _ref2.id;
                        return id === resort.id;
                      }), 'name', resort.id)
                    });
                  }),
                  shouldRender: true
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(_context.t0, this.context);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender || !this.state.cxoMainContact) {
        return null;
      }

      return ThreeSixtyContainer_jsx(ThreeSixty_ThreeSixty, {
        clientName: this.state.cxoMainContact,
        lastVisitsLabel: Object(lodash["get"])(this.state.i18n, 'booking.cxo.v360.resortsAndRooms') // $FlowFixMe
        ,
        lastVisits: this.state.cxoLastResorts
      });
    }
  }]);

  return ThreeSixtyContainer;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(ThreeSixtyContainer_ThreeSixtyContainer, "contextType", ReactAppContext["b" /* default */]);
// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/utils/ple-utils/cookies.js
var ple_utils_cookies = __webpack_require__("H6pA");

// CONCATENATED MODULE: ./src/client/context/initAppContext.js









function initAppContext(uri) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cookies = _ref.cookies,
      cookies = _ref$cookies === void 0 ? {} : _ref$cookies,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'fr-FR' : _ref$locale,
      originalUrl = _ref.originalUrl,
      requestId = _ref.requestId,
      userAgent = _ref.userAgent;

  var _ref2 = domains_service_dist_default.a.isValidLocale(locale) ? locale.split('-') : [],
      _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
      language = _ref3[0],
      country = _ref3[1];

  var encodedUserInfo = cookies[ple_utils_cookies["d" /* USER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["d" /* USER_INFO */]]) : undefined;
  var sellerInfo = cookies[ple_utils_cookies["b" /* SELLER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["b" /* SELLER_INFO */]]) : undefined;
  var uriObject = new URI_default.a(uri);
  var queryParameters = uriObject.query(true);
  var domainServiceForHostname = domains_service_dist_default.a.forHostname(uriObject.hostname());
  var availableLocales = domainServiceForHostname.getAllLocales();
  var cm_ta = dist["appQueryParameters"].cmta.cm_ta,
      cxo_sales_network_id = dist["appQueryParameters"].cxo.cxo_sales_network_id,
      indirect = dist["appQueryParameters"].indirect;
  var isCmta = queryParameters[cm_ta] !== undefined;
  var isIndirect = queryParameters[indirect] !== undefined;
  var isDirectCxo = !!queryParameters[cxo_sales_network_id] && !isIndirect && !isCmta;
  var isIndirectCxo = !!queryParameters[cxo_sales_network_id] && isIndirect && !isCmta;
  var isCxo = isDirectCxo || isIndirectCxo;
  return {
    authenticationToken: cookies[ple_utils_cookies["a" /* ACCESS_TOKEN */]] || cookies.CM_SELLER_TOKEN || '',
    availableLocales: availableLocales,
    bypassCache: queryParameters[dist["appQueryParameters"].bypassCache] === 'true',
    canUseOnlinePayment: domains_service_dist_default.a.getEnabledPaymentProviders(locale).length > 0,
    cmsContent: queryParameters.commonContent || config_default.a.get('cms.commonContent'),
    cmsRelease: queryParameters.commonRelease || config_default.a.get('cms.commonRelease'),
    cmta: isCmta ? {
      agency: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agency) || '',
      agent: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agent) || '',
      isDelCredere: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isDelCredere) || false,
      email: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.email) || '',
      searchType: uriObject.path() === routes_constants["B" /* QUICK_SEARCH_URL */] ? 'quick' : 'advanced',
      salesmanID: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.salesmanID) || ''
    } : {},
    cookies: cookies,
    country: country || '',
    customerNeolaneId: queryParameters.cxo_neolid,
    customerType: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.customerType) || '',
    customerStatus: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.customerStatus) || '',
    cxoQueryParams: {
      cxo_azur_code: queryParameters.cxo_azur_code,
      cxo_sales_channel: queryParameters.cxo_sales_channel,
      cxo_country_code: queryParameters.cxo_country_code,
      cxo_user_id: typeof queryParameters.cxo_id === 'string' ? Object(sellerUtils["a" /* decryptHeptaSeller */])(queryParameters.cxo_id) : ''
    },
    displayUnicodeFields: domains_service_dist_default.a.shouldDisplayUnicodeFields(locale) || false,
    // TODO replace this by - and improve for SSR - GoogleAnalytics tracking helper
    googleTrackingId: queryParameters.visitorGUID || cookies._ga || null,
    headers: {},
    isProduction: Object(contextUtils["c" /* isProduction */])(),
    isCmta: isCmta,
    isCxo: isCxo,
    isDirectCxo: isDirectCxo,
    isIndirectCxo: isIndirectCxo,
    isSeller: isCmta || isDirectCxo || isIndirectCxo,
    isSellerLogged: cookies[ple_utils_cookies["c" /* SELLER_LOGGED */]] === 'true',
    isUserLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isLoggedIn) || false,
    isUserQuickLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isQuickLoggedIn) || false,
    language: language || '',
    lines: [],
    locale: locale,
    neolaneId: cookies.cm_client_uid || (encodedUserInfo ? encodedUserInfo.neolaneId : null),
    originalUrl: originalUrl,
    pagesContent: queryParameters.pagesContent || config_default.a.get('cms.pagesContent'),
    pagesRelease: queryParameters.pagesRelease || config_default.a.get('cms.pagesRelease'),
    requestId: requestId,
    userAgent: userAgent || '',
    setCustomerStatus: function setCustomerStatus() {}
  };
}
// CONCATENATED MODULE: ./src/client/context/createOrUpdateAppContext.js


function createOrUpdateAppContext_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createOrUpdateAppContext_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createOrUpdateAppContext_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createOrUpdateAppContext_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





 // Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps

var localAppContext; // $FlowFixMe

var getAppContext = function getAppContext() {
  return localAppContext;
};
var createOrUpdateAppContext_saveAppContext = function saveAppContext(appContext) {
  var data = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, appContext), {}, {
    cookies: js_cookie_default.a.get(),
    userAgent: Object(lodash["get"])(window, 'navigator.userAgent')
  });

  localAppContext = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, data), initAppContext(data.originalUrl, data));
  var momentLocale = Object(lodash["get"])(localAppContext, "availableLocales.".concat(localAppContext.locale, ".moment"), 'fr'); // $FlowFixMe async import for only one specific moment's locale file

  __webpack_require__("dIgr")("./".concat(momentLocale)).then(function () {
    moment_default.a.locale(momentLocale);
  });
  Object(i18n["f" /* setLocale */])(localAppContext.locale.slice(0, 2));
  return localAppContext;
};
// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// EXTERNAL MODULE: ./src/errors/clientErrorHandler.js
var clientErrorHandler = __webpack_require__("aPQG");

// EXTERNAL MODULE: ./src/routes/nextRoutes.js
var nextRoutes = __webpack_require__("qm5D");
var nextRoutes_default = /*#__PURE__*/__webpack_require__.n(nextRoutes);

// CONCATENATED MODULE: ./src/server/context/createAppContextFromReq.js


function createAppContextFromReq_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createAppContextFromReq_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createAppContextFromReq_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createAppContextFromReq_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var createAppContextFromReq_createAppContextFromProps = function createAppContextFromProps(appContext) {
  var uri = new URI_default.a(appContext.originalUrl);
  var hostname = uri.hostname();
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), {}, {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales()
  }, initAppContext(appContext.originalUrl, appContext));
};
var createAppContextFromReq_createAppContextFromReq = function createAppContextFromReq(req) {
  // $FlowFixMe: id is injected from express-request-id
  var requestId = req.headers[dist["httpHeaders"].X_REQUEST_ID] || req.id;
  var uri = Object(contextUtils["b" /* getCurrentUri */])(req);
  var queryParameters = dist["url"].decodeQueryParameters(uri.query(true));
  var requestedLocale = queryParameters.locale;
  var hostname = uri.hostname(); // $FlowFixMe we have a host

  var host = req.get('host');
  var appContext = {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales(),
    originalUrl: req.protocol + '://' + host + req.originalUrl,
    cookies: req.cookies,
    locale: Object(contextUtils["a" /* getCurrentLocale */])(requestedLocale, hostname),
    requestId: requestId,
    userAgent: req.headers['user-agent']
  };
  moment_default.a.locale(Object(lodash["get"])(appContext.availableLocales, "".concat(appContext.locale, ".moment"), 'fr'));
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), initAppContext(uri, appContext));
};
// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/store/getInitialReduxState.client.js


function getInitialReduxState_client_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function getInitialReduxState_client_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      getInitialReduxState_client_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      getInitialReduxState_client_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















var LOCAL_STORAGE_STATE_KEY = 'state';

function stateFromLocalStorage(locale, state) {
  var serializedState = Object(local_storage_api["a" /* getFromLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(locale));
  if (!serializedState) return {};
  var localStorageState = Object(lodash["merge"])(JSON.parse(serializedState), {
    tripInformation: {}
  });
  var _localStorageState$tr = localStorageState.tripInformation.kids,
      kids = _localStorageState$tr === void 0 ? [] : _localStorageState$tr;
  return {
    faceting: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.faceting), {}, {
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    }),
    tripInformation: {
      kids: kids.map(function (_ref) {
        var birthdate = _ref.birthdate;
        return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]), {}, {
          birthdate: birthdate
        });
      }),
      adults: kids.length > 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : []
    },
    seller: localStorageState.seller
  };
}

function stateFromCookies() {
  var encodedUserInfo = js_cookie_default.a.get(ple_utils_cookies["d" /* USER_INFO */]);
  var userInfo = encodedUserInfo ? dist["oidc"].fromUriEncodedState(encodedUserInfo) : {};
  var encodedSellerInfo = js_cookie_default.a.get(ple_utils_cookies["b" /* SELLER_INFO */]);
  var seller = encodedSellerInfo ? {
    seller: {
      sellerInfo: dist["oidc"].fromUriEncodedState(encodedSellerInfo)
    }
  } : {};
  return getInitialReduxState_client_objectSpread({
    userInfo: userInfo
  }, seller);
}

function parseCxoKids(cxoKids) {
  return cxoKids.length <= faceting_constants["u" /* KIDS_NUMBER_MAX_SELLER */] ? cxoKids.map(function (_ref2) {
    var neolid = _ref2.neolid,
        birthdate = _ref2.birthdate;
    return {
      neolid: neolid,
      birthdate: birthdate
    };
  }) : [];
}

function parseCxoAdults(cxoAdults) {
  return cxoAdults.length <= faceting_constants["y" /* MAX_PAX_SELLER */] ? cxoAdults.map(function (_ref3) {
    var neolid = _ref3.neolid,
        birthdate = _ref3.birthdate;
    return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]), {}, {
      neolid: neolid,
      birthdate: birthdate
    });
  }) : [{}, {}];
}

function parseAdultsQueryParam(adultQueryParam) {
  var nbAdults = parseInt(adultQueryParam, 10);
  var hasAdults = Object(lodash["isInteger"])(nbAdults) && nbAdults <= faceting_constants["y" /* MAX_PAX_SELLER */];
  return hasAdults ? Array(nbAdults).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : [];
}

function stateFromQueryParams() {
  // NOTE: getCxoTravelers() and getNeolids() rely on queryparams
  var neolids = Object(sellerUtils["c" /* getNeolids */])();
  var queryParams = Object(uriUtils["i" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var departureDate = queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]],
      cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]];
  var departureDateIsValid = Object(dateUtils["e" /* isYearsRangeValid */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */], faceting_constants["k" /* DEPARTURE_DATE_MAX_DATE */]);
  var kids = Object(facetingUtils["i" /* unserializeKidsFromQueryParam */])(queryParams[uri_constants["h" /* QUERY_KIDS */]]);
  var adults = parseAdultsQueryParam(queryParams[uri_constants["j" /* QUERY_NUMBER_OF_ADULTS */]]);
  var numberAttendees = kids.length + adults.length;
  var maxPaxByUser = cmtaQueryParam ? faceting_constants["y" /* MAX_PAX_SELLER */] : faceting_constants["x" /* MAX_PAX */];
  var numberAttendeesNotAllowed = numberAttendees > maxPaxByUser;
  return {
    calendar: {
      selectedMonth: departureDateIsValid ? Object(calendar_helper["c" /* getDefaultSelectedMonth */])(departureDate) : undefined
    },
    // null states are explicitly omitted further
    faceting: {
      query: {
        label: queryParams[faceting_constants["C" /* QUERY_QUERY_PARAM */]] || ''
      },
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    },
    facetingTripInformation: neolids.length > 0 ? null : undefined,
    seller: neolids.length > 0 ? {
      neolids: neolids
    } : undefined,
    tripCriteria: {
      departureDate: departureDateIsValid ? Object(dateUtils["d" /* getTimestamp */])(departureDate, uri_constants["e" /* QUERY_DATE_FORMAT */]) : undefined,
      duration: parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10) || null,
      departureCity: queryParams[uri_constants["k" /* QUERY_TRANSPORT */]]
    },
    tripInformation: {
      kids: numberAttendeesNotAllowed ? [] : kids,
      adults: adults.length === 0 && kids.length || numberAttendeesNotAllowed ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : adults
    }
  };
}

function getSellerTripInformation() {
  // CMTA sellers
  var queryParams = Object(uriUtils["i" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]];

  if (typeof cmtaQueryParam !== 'undefined') {
    var _stateFromQueryParams = stateFromQueryParams(),
        tripInformation = _stateFromQueryParams.tripInformation;

    return tripInformation;
  } // CXO sellers


  var cxoTravelers = Object(sellerUtils["b" /* getCxoTravelers */])() || [];

  if (cxoTravelers.length === 0) {
    return;
  }

  var numberAttendeesAllowed = cxoTravelers.length > 0 && cxoTravelers.length <= faceting_constants["y" /* MAX_PAX_SELLER */];
  return {
    kids: numberAttendeesAllowed ? parseCxoKids(cxoTravelers.filter(function (_ref4) {
      var isChild = _ref4.isChild;
      return isChild;
    })) : [],
    adults: numberAttendeesAllowed ? parseCxoAdults(cxoTravelers.filter(function (_ref5) {
      var isChild = _ref5.isChild;
      return !isChild;
    })) : Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */])
  };
}

function cleanTripInfoKids(state) {
  if (!state.tripInformation) return state;
  var _state$tripInformatio = state.tripInformation.kids,
      kids = _state$tripInformatio === void 0 ? [] : _state$tripInformatio;
  var cleanedKids = kids.map(function (_ref6) {
    var neolid = _ref6.neolid,
        birthdate = _ref6.birthdate,
        _ref6$childcareInclud = _ref6.childcareIncluded,
        childcareIncluded = _ref6$childcareInclud === void 0 ? false : _ref6$childcareInclud;
    return {
      neolid: neolid,
      birthdate: birthdate,
      childcareIncluded: childcareIncluded
    };
  });
  return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), {}, {
      kids: cleanedKids
    })
  });
}

function getInitialReduxState(initialState, locale) {
  var state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, initialState), stateFromLocalStorage(locale, {})), stateFromCookies()); // NOTE: With merge() behavior, subvalues that are undefined won't override existing values
  // ie: merge({ a: 1, b: 2 }, { a: undefined, b: null }) returns { a: 1, b: null }


  state = Object(lodash["merge"])({}, state, stateFromQueryParams()); // for seller erase tripInformation

  state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), getSellerTripInformation())
  });
  state = cleanTripInfoKids(state);
  state = Object(lodash["omitBy"])(state, function (value) {
    return value === null;
  });
  return state;
}
// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: ./src/client/store/configureStore.js
var configureStore = __webpack_require__("Crz2");

// CONCATENATED MODULE: ./src/client/store/withReduxStore.js
// https://github.com/zeit/next.js/blob/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux/lib/with-redux-store.js
// From this example https://github.com/zeit/next.js/tree/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux


var isServer = false;
var __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__'; // The store is a singleton on the client, but is created every time on the server

function getOrCreateStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Always make a new store if server, otherwise state is shared between requests

  if (isServer) {
    return Object(configureStore["a" /* init */])(initialState);
  } // Create store if unavailable on the client and set it on the window object


  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = Object(configureStore["a" /* init */])(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
// EXTERNAL MODULE: ./src/utils/booking-payment-status/bookingPaymentStatus.constants.js
var bookingPaymentStatus_constants = __webpack_require__("ycRU");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/utils/ple-utils/handleInvalidToken.js
var handleInvalidToken = __webpack_require__("bJ4E");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/views/errors/not-found/NotFoundView.jsx


var NotFoundView_jsx = react_default.a.createElement;








var NotFoundView_getInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var appContext, query;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext;
            query = "query {\n      config {\n        errors { notFound { image title } }\n        common { goToHome }\n      }\n    }";
            return _context.abrupt("return", graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Jc" /* PAGE_404 */]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var NotFoundView_NotFoundView = function NotFoundView(_ref3) {
  var _config$errors, _config$errors$notFou, _config$errors2, _config$errors2$notFo, _config$common;

  var config = _ref3.config;
  return NotFoundView_jsx(react_default.a.Fragment, null, NotFoundView_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], {
    pageName: "Shopping_NotFound",
    siteSection: "Shopping_NotFound"
  }), NotFoundView_jsx("main", {
    className: "NotFoundView",
    role: "main"
  }, NotFoundView_jsx(Hero["a" /* Hero */], {
    size: "total",
    url: config === null || config === void 0 ? void 0 : (_config$errors = config.errors) === null || _config$errors === void 0 ? void 0 : (_config$errors$notFou = _config$errors.notFound) === null || _config$errors$notFou === void 0 ? void 0 : _config$errors$notFou.image
  }), NotFoundView_jsx("div", {
    className: "NotFoundView-inner"
  }, NotFoundView_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "mini"
  }, NotFoundView_jsx("h1", {
    className: "NotFoundView-title font-brand"
  }, config === null || config === void 0 ? void 0 : (_config$errors2 = config.errors) === null || _config$errors2 === void 0 ? void 0 : (_config$errors2$notFo = _config$errors2.notFound) === null || _config$errors2$notFo === void 0 ? void 0 : _config$errors2$notFo.title), NotFoundView_jsx(TextLink["a" /* TextLink */], {
    url: "/",
    label: config === null || config === void 0 ? void 0 : (_config$common = config.common) === null || _config$common === void 0 ? void 0 : _config$common.goToHome,
    theme: "solid"
  })))));
};

NotFoundView_NotFoundView.getInitialProps = NotFoundView_getInitialProps;
/* harmony default export */ var not_found_NotFoundView = (NotFoundView_NotFoundView);
// CONCATENATED MODULE: ./pages/_app.js









var _app_jsx = react_default.a.createElement;

function _app_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _app_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      _app_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      _app_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _app_createSuper(Derived) {
  var hasNativeReflectConstruct = _app_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function _app_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}











































 // $FlowFixMe issue with next typings

var _app_App = /*#__PURE__*/function (_NextApp) {
  Object(inherits["a" /* default */])(App, _NextApp);

  var _super = _app_createSuper(App);

  Object(createClass["a" /* default */])(App, null, [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
        var Component, ctx, req, res, asPath, query, appContext, pageProps, reduxStore, currentUri, isUserQuickLogged, originalUrl, pageId, pageType, location, isOption, staticPageContext, layoutPromise, _require, getRedirect, RULES, _yield$getRedirect, status, url, pageContext, layoutData, appContextLight;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Component = _ref.Component, ctx = _ref.ctx;
                req = ctx.req, res = ctx.res, asPath = ctx.asPath, query = ctx.query;
                appContext = req ? createAppContextFromReq_createAppContextFromReq(req) : getAppContext(); // If no appContext, we reload the page. It's occurring when navigating back from an error layer

                if (!appContext && true && Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a)) {
                  window.location.reload();
                }

                pageProps = {}; // Get or Create the store with initialState from cookies
                // This allows you to set a custom default initialState

                reduxStore = getOrCreateStore(stateFromCookies());

                if (Component.requireAuthentication) {
                  currentUri = req ? Object(contextUtils["b" /* getCurrentUri */])(req) : new URI_default.a(window.location.href);
                  Object(handleInvalidToken["a" /* handleInvalidToken */])({
                    appContext: appContext,
                    currentUri: currentUri,
                    res: res,
                    userInfo: Object(userInfo_selectors["a" /* userInfoSelector */])(reduxStore.getState())
                  });
                } // Provide the store to getInitialProps of pages


                ctx.reduxStore = reduxStore;
                isUserQuickLogged = appContext.isUserQuickLogged, originalUrl = appContext.originalUrl;
                pageId = Component.pageId;
                pageType = Component.pageType || Component.pageId || 'none';
                location = createRouterLocation_createRouterLocation({
                  asPath: asPath,
                  query: query,
                  originalUrl: originalUrl
                });
                isOption = query.bookingStatusBeforePayment === bookingPaymentStatus_constants["c" /* BOOKING_PAYMENT_STATUS_OPTION */]; // There are two possibilities for the pageContext
                // - it's created in the getInitialProps of the page (DynamicPage.jsx)
                // - it's static, the properties depending on the pages can be statically resolved (e.g. pageId)
                // We create it before the getInitialProps and pass it to the getInitialProps because some
                // components might need it, like ThemeView which does render lines

                staticPageContext = {
                  pageId: pageId,
                  pageTitle: dist["constants"].WEBSITE_NAME,
                  pageDescription: '',
                  // usually we don't care about the statusCode in the pageContext, since a 404/500 will
                  // directly route us to a specific branch
                  statusCode: statusCode_constants["a" /* STATUS_CODE_200 */],
                  canonicalUrl: Object(uriUtils["h" /* getPageCanonicalUrl */])(appContext.originalUrl, appContext.originalUrl),
                  hrefLang: [],
                  pageMeta: {},
                  pageType: pageType || pageId || 'none',
                  siteSection: Object(utils["e" /* getSiteSection */])({
                    isOption: isOption,
                    isUserQuickLogged: isUserQuickLogged,
                    pageType: pageType
                  })
                }; // clear cms keys before handling page request to avoid getting unwanted data

                if (req) {
                  Object(i18n["b" /* clearAll */])();
                } // Call here, await later to make this call and the getInitialProps one parallels


                layoutPromise = req ? Layout_query_fetchLayoutConfig(appContext) : Promise.resolve({});

                if (!Component.getInitialProps) {
                  _context.next = 55;
                  break;
                }

                _context.prev = 17;
                _context.next = 20;
                return Component.getInitialProps(_app_objectSpread(_app_objectSpread({}, ctx), {}, {
                  appContext: appContext,
                  pageContext: staticPageContext,
                  location: location
                }));

              case 20:
                pageProps = _context.sent;
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](17);
                pageProps = _context.t0;

              case 26:
                if (!pageProps.statusCode) {
                  _context.next = 55;
                  break;
                }

                if (!(pageProps.statusCode === statusCode_constants["d" /* STATUS_CODE_404 */])) {
                  _context.next = 55;
                  break;
                }

                if (true) {
                  _context.next = 49;
                  break;
                }

                _context.prev = 29;
                _require = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module '@clubmed/redirects'"); e.code = 'MODULE_NOT_FOUND'; throw e; }())), getRedirect = _require.getRedirect, RULES = _require.RULES;
                _context.next = 33;
                return getRedirect(config_default.a.get(), req, [// Those rules only apply to b2c pages that couldn't be found in the CMS content b2c-pages
                RULES.NORMALIZE_B2C_SHOPPING_PATHS, // this redirection rule is temporary (i.e. issue #11090)
                RULES.B2C_CMS_CONTENT, RULES.PRODUCT_SHORT_LINKS, RULES.GLOBAL_B2C, RULES.LEGACY_B2C_NOT_FOUND]);

              case 33:
                _yield$getRedirect = _context.sent;
                status = _yield$getRedirect.status;
                url = _yield$getRedirect.url;
                return _context.abrupt("return", res.redirect(status, url));

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](29);
                _context.t2 = _app_objectSpread;
                _context.t3 = _app_objectSpread({}, pageProps);
                _context.next = 45;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 45:
                _context.t4 = _context.sent;
                pageProps = (0, _context.t2)(_context.t3, _context.t4);

              case 47:
                _context.next = 55;
                break;

              case 49:
                _context.t5 = _app_objectSpread;
                _context.t6 = _app_objectSpread({}, pageProps);
                _context.next = 53;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 53:
                _context.t7 = _context.sent;
                pageProps = (0, _context.t5)(_context.t6, _context.t7);

              case 55:
                if (pageProps.pageContext) {
                  pageContext = pageProps.pageContext;
                } else {
                  Object(invariant["a" /* invariant */])(pageId, "The page corresponding to the url ".concat(asPath, " doesn't have a pageId. This is an error."));
                  pageContext = _app_objectSpread(_app_objectSpread({}, staticPageContext), {}, {
                    statusCode: pageProps.statusCode || staticPageContext.statusCode
                  });
                } // Sync store with url, works fine on SSR to have
                // last version of state before rendering on frontend.


                if (false) {}

                _context.next = 59;
                return layoutPromise;

              case 59:
                layoutData = _context.sent;
                appContextLight = {
                  locale: appContext.locale,
                  userAgent: appContext.userAgent,
                  originalUrl: appContext.originalUrl,
                  cookies: {// TODO is_mobile
                  }
                };

                if (false) {}

                return _context.abrupt("return", {
                  appContext: appContextLight,
                  pageContext: pageContext,
                  i18nData: Object(i18n["c" /* getAll */])(),
                  pageProps: pageProps,
                  layoutData: layoutData,
                  disableHeader: Object(sellerUtils["g" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableHeader === 'function' ? Component.disableHeader(appContext) : Component.disableHeader),
                  disableFooter: Object(sellerUtils["g" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableFooter === 'function' ? Component.disableHeader(appContext) : Component.disableFooter),
                  location: location,
                  initialReduxState: reduxStore.getState(),
                  statusCode: pageContext.statusCode
                });

              case 63:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[17, 23], [29, 39]]);
      }));

      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }

      return getInitialProps;
    }()
  }]);

  function App(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, App); // $FlowFixMe issue with next typings


    _this = _super.call(this, props);
    _this.toastRef = /*#__PURE__*/Object(react["createRef"])();
    _this.appContext = true ? createOrUpdateAppContext_saveAppContext(props.appContext) : undefined; // Get or Create the store with initialState from cookies

    _this.reduxStore = getOrCreateStore(true ? getInitialReduxState(props.initialReduxState, _this.appContext.locale) : undefined);
    Object(i18n["f" /* setLocale */])(_this.appContext.locale.slice(0, 2)); // First time on the render it comes from the props, then it's there and won't have to be refeched

    _this.layoutData = props.layoutData || _this.layoutData;
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  Object(createClass["a" /* default */])(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object(clientErrorHandler["c" /* start */])();
      nextRoutes_default.a.Router.events.on('routeChangeComplete', function () {
        // as shallow navigation may happen, ensure the store is synced with location.
        _this2.reduxStore.dispatch({
          type: store_constants["u" /* SYNC_WITH_LOCATION */],
          payload: {
            location: _this2.props.location,
            pageType: _this2.props.pageContext.pageType
          }
        });
      }); // https://github.com/zeit/next.js/issues/7814
      // Navigating back (clicking on the browser back button) triggers a getInitialProps every time
      // This makes change when changing of page. But we often do shallow-routing on a page to show a
      // layer (or to persist things in the url), but don' trigger getInitialProps
      // Sadly, back/forward means that we retrigger the getInitialProps, show the loader, etc.
      // So with this snippet we force same page navigation as shallow (since different pages skip
      // shallow routing)

      nextRoutes_default.a.Router.beforePopState(function (_ref2) {
        var options = _ref2.options; // this.props.location has not been updated yet, so we can check and prevent shallow navigation
        // between two different dynamic pages

        if (_this2.props.location.pathname === new URI_default.a(window.location.href).pathname()) {
          options.shallow = true;
        }

        return true;
      }); // Sync the state with the local storage

      this.reduxStore.subscribe(Object(lodash["throttle"])(function () {
        var state = _this2.reduxStore.getState();

        var persistedStore = JSON.stringify({
          tripInformation: {
            kids: Object(storeHelper["c" /* getKids */])(state)
          },
          seller: state.seller
        });
        Object(local_storage_api["c" /* setInLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(_this2.appContext.locale), persistedStore);
      }, 1000));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageContext = _this$props.pageContext,
          pageProps = _this$props.pageProps,
          i18nData = _this$props.i18nData,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader,
          unUpdatedLocation = _this$props.location; // With shallow routing, the page is rerendered and the query params are updated, but
      // getInitialProps is not called. So we need to manually update the queryParams

      var location = createRouterLocation_updateShallowQueryParams({
        location: unUpdatedLocation,
        href: true ? window.location.href : undefined
      });
      var routerContextValue = {
        history: nextRoutes_default.a.Router,
        location: location
      };

      if (true) {
        Object(i18n["a" /* addTranslationKeys */])(i18nData);
      }

      return _app_jsx(react["Fragment"], null, _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], {
        useNativeErrorHandling: true
      }, _app_jsx(head_default.a, null, _app_jsx("meta", {
        key: "viewport",
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      }), _app_jsx("title", {
        key: "title"
      }, pageContext.pageTitle)), _app_jsx(AppProviders_AppProviders, {
        appContext: this.appContext,
        pageContext: pageContext,
        reduxStore: this.reduxStore,
        routerContextValue: routerContextValue,
        toastRef: this.toastRef
      }, _app_jsx(PriorityThirdPartyScripts, null), _app_jsx(RouteChangeListener_RouteChangeListener, null), _app_jsx(HeadInfos_HeadInfos, null), _app_jsx(ThreeSixtyContainer_ThreeSixtyContainer, null), this.appContext.isCmta && _app_jsx(InitializeCmtaSellerInfos_InitializeCmtaSellerInfos, null), _app_jsx(Loading_Loading, null), _app_jsx(easy_testing_EasyTesting, null), _app_jsx("div", {
        id: pageContext.pageId || 'pageWrapper' // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        "data-cs-override-id": "page"
      }, _app_jsx(Layout_Layout, Object(esm_extends["a" /* default */])({}, this.layoutData, {
        disableHeader: disableHeader,
        disableFooter: disableFooter,
        isMicePage: dist["b2cPagesService"].isMicePage(pageContext.pageType)
      }), pageProps.statusCode === 404 ? _app_jsx(not_found_NotFoundView, pageProps) : _app_jsx(Component, pageProps))), _app_jsx(ToastContainer, {
        ref: this.toastRef
      }), _app_jsx(ThirdPartyScripts, null))));
    }
  }]);

  return App;
}(app_default.a); // eslint-disable-next-line import/no-default-export


/* harmony default export */ var _app = __webpack_exports__["default"] = (_app_App);

/***/ }),

/***/ "1YFU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "1a7w":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("wEFx");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1dAi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (re) {
	return Object.prototype.toString.call(re) === '[object RegExp]';
};


/***/ }),

/***/ "1m4l":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var anObject = __webpack_require__("ep/x");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);


var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'seasons', []);
  return seasons.length === 1 && seasons.includes('WINTER') && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocaleToDisplayDidomi; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qFX+");


var isChineseLocale = function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].ZH_CN;
};

var isLocaleToDisplayDidomi = function isLocaleToDisplayDidomi(locale) {
  return _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES_TO_DISPLAY_DIDOMI */ "b"].includes(locale);
};



/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("/Mt0");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("NJJ8");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("5xkM");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */












var Hero = function Hero(_ref) {
  var _ref2;

  var alt = _ref.alt,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      isLegacyMode = _ref.isLegacyMode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      url = _ref.url;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_5__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* generateBackgroundStylesAndClassName */ "d"])(url),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* getHeroDimensions */ "f"])(size, isDesktop),
      height = _getHeroDimensions.height,
      paddingBottom = _getHeroDimensions.paddingBottom,
      paddingTop = _getHeroDimensions.paddingTop;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* TITLE_POSITIONS */ "c"][contentPosition] : '';
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_11__[/* TrackClick */ "a"] : react__WEBPACK_IMPORTED_MODULE_1__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    as: _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"],
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('inline-block reset-anchor hover:scale-105 transition-all', linkSpacing),
    trackingData: tracking,
    url: link.url
  } : {
    className: linkSpacing
  };
  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  return __jsx("div", {
    "aria-label": alt,
    className: className,
    "data-size": size,
    id: id,
    role: "img",
    style: _objectSpread({
      height: height
    }, style)
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('relative', {
      'inset-border-after': isExclusiveCollection
    }),
    style: {
      height: height,
      paddingTop: paddingTop
    }
  }, __jsx("div", {
    className: "absolute bg-center bg-cover bg-no-repeat fadeIn h-full inset-x-0 top-0 w-full ".concat(imageClassName),
    style: {
      height: height
    }
  }), displayIcon && (icon === null || icon === void 0 ? void 0 : icon.link) && __jsx("div", {
    className: "absolute inset-0",
    style: {
      paddingTop: paddingTop,
      paddingBottom: hasOverlap ? '40px' : 0
    }
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('flex h-full m-auto max-w-site overflow-hidden p-px20 w-full', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_12__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "flex-none max-h-full",
    src: icon.link,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: "align-bottom flex flex-col h-full z-1 pt-px10 px-px20 relative",
    style: {
      paddingBottom: paddingBottom
    }
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("flex flex-col max-w-site mx-auto w-full ".concat(textAlignment), {
      'h-full': isHighlight
    })
  }, __jsx(TitleAndSubtitleWrapperTag, titleAndSubtitleWrapperProps, __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_9__[/* Heading */ "a"], {
    className: !isLegacyMode && !isHighlight && size !== 'small' ? 'lg:text-7xl' : '',
    color: titleColor,
    hLevel: hLevel,
    theme: isLegacyMode ? 'heading-brand-2' : 'heading-brand-1'
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_10__[/* Text */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mt-px5', {
      'font-serif': isExclusiveCollection
    }),
    color: subtitleColor,
    text: subtitle,
    theme: "text-sans-5"
  })), !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["isEmpty"])(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_7__[/* Countdown */ "a"], {
    className: "pt-px10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
      'mt-auto w-full': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mt-px15 md:mt-0', {
      'w-full': !isDesktop
    }),
    color: linkColor,
    colorBg: linkBackgroundColor,
    style: {
      maxWidth: isHighlight && !isDesktop ? 'none' : '17.5rem'
    },
    trackingData: tracking,
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0",
    style: (_ref2 = {
      /* eslint-disable no-dupe-keys */
      background: '-moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%)'
    }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref2, "background", '-webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref2, "background", 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), _ref2)
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "2CYk":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "30WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return open; });
/* unused harmony export close */
function fetch(name) {
  return "FETCH_".concat(name);
}
function clear(name) {
  return "CLEAR_".concat(name);
}
function open(name) {
  return "OPEN_".concat(name);
}
function close(name) {
  return "CLOSE_".concat(name);
}

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.getElementsByClassName(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "b"])[0];

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    var hashName = hash.split('#')[1];
    setTimeout(function () {
      var element = document.getElementById(hashName);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}

/***/ }),

/***/ "3K/D":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var create = __webpack_require__("Znn2");
var definePropertyModule = __webpack_require__("87KK");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "3LIW":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var isCallable = __webpack_require__("ANQd");
var classofRaw = __webpack_require__("XywU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "3dm5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classof = __webpack_require__("3LIW");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js



var Heading_themes_themes = function themes(_ref) {
  var _classnames, _classnames2;

  var color = _ref.color;
  return {
    'heading-brand-1': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-2xl lg:text-4xl', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames)),
      thSpan: 'mt-0 mb-px15'
    },
    'heading-brand-2': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-4xl lg:text-7xl', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames2, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames2)),
      thSpan: 'mt-0 mb-px15'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx

var __jsx = react_default.a.createElement;






var MARKDOWN_TEXT = ['break', 'emphasis', 'paragraph', 'strong', 'text'];

var Heading_markdownRootRenderer = function markdownRootRenderer(hLevel) {
  return function (props) {
    var RootElementTag = "h".concat(hLevel);

    var children = props.children,
        node = props.node,
        otherProps = Object(objectWithoutProperties["a" /* default */])(props, ["children", "node"]);

    return __jsx(RootElementTag, otherProps, children);
  };
};

var Heading_markdownNeutralRenderer = function markdownNeutralRenderer(className) {
  return function (_ref) {
    var children = _ref.children;
    return __jsx("span", {
      className: classnames_default()('last-child-mb-0', className)
    }, children);
  };
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = Heading_themes_themes({
    color: color
  })[theme],
      thRoot = _themes$theme.thRoot,
      thSpan = _themes$theme.thSpan;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_TEXT,
    className: classnames_default()(className, thRoot),
    children: children,
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Heading_markdownRootRenderer(hLevel),
      paragraph: Heading_markdownNeutralRenderer(thSpan)
    }
  });
};

/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* unused harmony export loadFacetingTopCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KL6I");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CONFIG */ "Fd"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      isMice: false,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;
    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCTS */ "Dd"]
    });
  });
}

function loadFacetingTopCountries(_ref2) {
  var appContext = _ref2.appContext;
  var query = "query {\n    config {\n      faceting {\n        topCountries {\n          enabled\n           title\n           items {\n             id\n           }\n        }\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_FACETING_TOP_COUNTRIES */ "Bd"]
  });
}
function loadOffsetSell(_ref3) {
  var appContext = _ref3.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_OFFSET_SELL */ "Cd"]
  });
}
function loadProducts(_ref4) {
  var appContext = _ref4.appContext,
      options = _ref4.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref5) {
  var appContext = _ref5.appContext,
      productIds = _ref5.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref6) {
  var criteria = _ref6.criteria,
      options = _ref6.options,
      appContext = _ref6.appContext;
  var facetingTopCountriesPromise = loadFacetingTopCountries({
    appContext: appContext
  });
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([facetingTopCountriesPromise, productsPromise, searchPromise]).then(function (_ref7) {
    var _ref8 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref7, 3),
        facetingTopCountriesInfo = _ref8[0],
        productsInfo = _ref8[1],
        pertimmResults = _ref8[2];

    var facetingTopCountries = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(facetingTopCountriesInfo, 'config.faceting.topCountries');
    var filteredProducts = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(result, 'meta.product_id[0]');
      var resort = productsInfo.resorts.find(function (_ref9) {
        var id = _ref9.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref10) {
        var birthdate = _ref10.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* getKidAgeInMonths */ "e"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);
    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({
      facetingTopCountries: facetingTopCountries
    }, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  });
  var selectedDepartureCity = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: criteria.defaultDepartureCity || ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria,
      withFlexibility = _ref11.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* cleanupArgs */ "a"])({
    isMice: false,
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_PRICE */ "Gd"]
  });
}
function loadChildcareAvailabilities(_ref12) {
  var appContext = _ref12.appContext,
      _ref12$criteria = _ref12.criteria,
      criteria = _ref12$criteria === void 0 ? {} : _ref12$criteria;
  var _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;

  if (!kids || kids.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(arrivalDate, 'YYYYMMDD') || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(kids.map(function (_ref13) {
    var birthdate = _ref13.birthdate;
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(birthdate, 'YYYYMMDD');
  }).join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "Ed"]
  });
}

/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackErrorOnAddService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesList; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("nv//");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_9__[/* hasChildcare */ "q"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_9__[/* hasTransfer */ "t"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_9__[/* isRecommendedTransport */ "A"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_10__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "l"])({
      resortKeyPath: isSeller ? 'booking.partners.accommodation.pageTitle' : 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getTransportIcon */ "g"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.outbound')),
    // eslint-disable-next-line no-nested-ternary
    title: isRecommendedTransportSelected ? isSeller ? i18n.booking.partners.transport.transportPageTitle : i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSFER,
    title: isSeller ? i18n.booking.partners.transport.transferPageTitle : i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: isCmta ? Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.partners.summary.pageTitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    eventPageName: isSeller && isDelCredere ? 'banking_Ducroire' : 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: isSeller && isDelCredere ? 'bankingDucroire' : 'banking',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_3___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_11__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    return history.replace(nextUrl, shownUrl);
  }

  return history.push(nextUrl, shownUrl);
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var trackErrorOnAddService = function trackErrorOnAddService(error, trackCallback, defaultValue) {
  if (error) {
    var _error$errors, _error$errors$, _error$errors$$respon, _error$errors$$respon2, _error$errors$$respon3;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : (_error$errors$$respon = _error$errors$.responseBody) === null || _error$errors$$respon === void 0 ? void 0 : (_error$errors$$respon2 = _error$errors$$respon.errors) === null || _error$errors$$respon2 === void 0 ? void 0 : (_error$errors$$respon3 = _error$errors$$respon2[0]) === null || _error$errors$$respon3 === void 0 ? void 0 : _error$errors$$respon3.error_code;
    trackCallback({
      labelGA: "error_".concat(errorCode ? errorCode : defaultValue)
    });
  }
};
var getAttendeesList = function getAttendeesList(attendeesWithInfos) {
  var adults = attendeesWithInfos.adults,
      children = attendeesWithInfos.children;
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(adults), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(children.map(function (kid) {
    return _objectSpread(_objectSpread({}, kid), {}, {
      isChild: true
    });
  })));
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4Bi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = action && action.type && handlers ? handlers[action.type] : undefined; // if no action was provided, return the actual state

    if (!handler) {
      return state;
    }

    state = handler(state, action);
    return state;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),

/***/ "4Grf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAVIGATION_TRACKING_LOGO_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAVIGATION_TRACKING_CONTACT_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAVIGATION_TRACKING_SEARCH_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNavigationCallCenterButtonTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNavigationLanguagesButtonTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNavigationItemLinkTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getNavigationSubItemLinkTrackingData; });
var categoryGA = 'headerMenu';
var NAVIGATION_TRACKING_LOGO_BUTTON = {
  actionGA: 'header_logo',
  categoryGA: categoryGA,
  labelGA: null // to override any value coming from previous tracking

};
var NAVIGATION_TRACKING_CONTACT_BUTTON = {
  actionGA: 'header_contact',
  categoryGA: categoryGA,
  labelGA: 'clickToCall'
};
var NAVIGATION_TRACKING_SEARCH_BUTTON = {
  actionGA: 'header_search',
  categoryGA: 'headerMenu'
};
var getNavigationCallCenterButtonTrackingData = function getNavigationCallCenterButtonTrackingData(label) {
  return {
    actionGA: 'header_contact',
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationLanguagesButtonTrackingData = function getNavigationLanguagesButtonTrackingData(label) {
  return {
    actionGA: 'header_language',
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationItemLinkTrackingData = function getNavigationItemLinkTrackingData(label) {
  return {
    actionGA: "header_".concat(label),
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationSubItemLinkTrackingData = function getNavigationSubItemLinkTrackingData(_ref) {
  var label = _ref.label,
      parentLabel = _ref.parentLabel;
  return {
    actionGA: "header_".concat(parentLabel),
    categoryGA: categoryGA,
    labelGA: label
  };
};

/***/ }),

/***/ "4I0e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-px20 text-blue text-xl', {
      'sr-only': !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4gXF":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "4jPf":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ZHK4");
module.exports = __webpack_require__("7xIC");


/***/ }),

/***/ "5LiQ":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("dNjr");
var toLength = __webpack_require__("DOIJ");
var toAbsoluteIndex = __webpack_require__("Jm8J");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "5WP5":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("dnX/");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "5h8T":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createPropertyDescriptor = __webpack_require__("OouP");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var has = __webpack_require__("DZWw");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "5iaM":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("oMzG");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "60DJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("C8GU").charAt;
var toString = __webpack_require__("vnfA");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "6XIJ":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "x"], options);
}



/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return childcaresQuery; });
/* unused harmony export transfersQuery */
/* unused harmony export servicesWithSchedulePricingInfoQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalPriceQuery; });
/* unused harmony export proposalTransfersQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return insurancesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MAH5");
/* harmony import */ var _client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("GZ82");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("NLwV");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      value\n      formattedValue(precision : ".concat(precision, ")\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var childcaresQuery = "\nchildcares {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    isPartiallyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n  }\n}";
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var servicesWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {...priceDetails, currency}\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {...priceDetails}\n          price {\n            value\n            formattedValue(precision:0)\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {...priceDetails}\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {...priceDetails}\n            }\n          }\n        }\n      }";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER, WELLNESS]) {\n    activities {\n      ".concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n      }\n    }\n    rentals {\n      ").concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ").concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n  }\n");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    ";
}

function insurancesQuery() {
  return "\n    listInsurances {\n      id\n      label\n      subscribed\n      price {\n        ...priceDetails\n      }\n      insuranceDetails{\n        id\n        label\n        images\n        description\n        shortDescription\n        videos\n        attachedDocuments {\n          label\n          url\n        }\n        company {\n          label\n          logo\n        }\n        coverageDescriptions\n        subscriptionConditions {\n          age_min\n          ageMax\n          byAttendees\n        }\n      }\n    }";
}

function proposalTransfersQuery() {
  return "\n    availableTransfers {\n      ...transferDetails\n    }\n    selectedTransfers {\n      ...transferDetails\n    }\n  ";
}

function proposalFields(params) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      exclusiveCollection\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    adultsCount\n    childrenCount\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n      }\n      adults {\n        id\n        customerId\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n     ").concat(insurancesQuery(), "\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentScheduleRequest = "paymentSchedule {\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  selectorId\n  label\n  logo\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        ").concat(getPaymentScheduleRequest(appContext), "\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "ld"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated

    return _objectSpread({
      customer_id: index === 0 && neolaneId ? neolaneId : neolid
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* timestampToApiDate */ "l"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(params, appContext) {
  var kids = params.kids,
      adults = params.adults;
  var attendees = adults && adults.length ? adults.concat(kids) : kids; // When quick logged neolaneId but should not call profile api
  // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

  var neolaneId = appContext.isUserLogged ? appContext.neolaneId : null; // $FlowFixMe

  var knownAttendeesInformation = getKnownAttendeesInformation(attendees, neolaneId);
  var proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), ["displayCounterDurations: ".concat(Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals') ? 'true' : 'false')]);
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
    withCommission: appContext.isCmta || appContext.isIndirectCxo
  })), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              href\n              id\n              images\n              isExplicitEC\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__[/* getResort */ "b"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      validationSchema(productId: \"").concat(params.productId, "\", resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__[/* getCxoAttendeesData */ "a"])(params), "\n    }\n\n    ").concat(_client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__[/* profileFragment */ "b"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_GET_SEVERAL */ "md"]
  });
}

function addTransportMutation(transportId, proposalsId, isJoyView, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: appContext.isCmta
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADD_TRANSPORT */ "gd"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: appContext.isCmta
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ACCOMMODATION_ADD */ "cd"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalsId), ", attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(services), ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "fd"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(proposalIds, attendees, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, attendees, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, attendees, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "ed"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "dd"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(id: \"".concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', ", customerId: ").concat(params.customerId, ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            amount {...priceDetails}\n            offerName\n            offerColor\n          }\n        }\n        paymentSchedule {\n          total {...priceDetails}\n          depositAmount {...priceDetails}\n          repaymentSchedules {\n            amount {...priceDetails}\n            deadline\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_USE_PROMO_CODE */ "ud"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_SWITCH_OFFER */ "qd"]
  });
}



/***/ }),

/***/ "7Pat":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("+7q0"),
    shortOut = __webpack_require__("kG2z");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showTemporaryToast; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className, style) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(OPEN_TOAST, {
    className: className,
    toastLabel: toastLabel,
    style: style
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "7hcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResortListContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useResortList; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ResortListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  resortList: [],
  setResortList: function setResortList() {}
});
var useResortList = function useResortList() {
  var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(ResortListContext);

  if (context === undefined) {
    throw new Error('useResortList must be used within a ResortListContext.Provider');
  }

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    context.setResortList();
  }, []);
  return context.resortList;
};

/***/ }),

/***/ "8+jV":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("SRps");
var store = __webpack_require__("l6h7");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "87KK":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");
var anObject = __webpack_require__("ep/x");
var toPropertyKey = __webpack_require__("RWUY");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8D46":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8WCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export catalogToState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return facetingReducer; });
/* unused harmony export filtersToActiveFacetsState */
/* unused harmony export filtersToState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalLabelsCount; });
/* unused harmony export initialState */
/* unused harmony export PERTIMM_DEPARTURE_MAX_DATE */
/* unused harmony export PERTIMM_DEPARTURE_MIN_DATE */
/* unused harmony export removeUnselectedFiltersFromActiveFacetsState */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4oK2");
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(entities__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("L73y");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sW3P");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cvSI");
/* harmony import */ var _utils_createReducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("4Bi9");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("9QcM");





var _createReducer;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var IGNORED_FILTERS_IDS = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* PRODUCT_FACET_ID */ "B"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* LOCALE_FACET_ID */ "v"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"]];

function catalogFacetItemToState(item) {
  return {
    label: item.i18n,
    value: item.filter,
    count: item.freq
  };
} // Pertimm will always send `interpretation_explanation.interpretations` dates
// in the format 'DD/MM/YYYY', for any locale


var PERTIMM_INTERPRETATION_DATE_FORMAT = 'DD/MM/YYYY';
var PERTIMM_DEPARTURE_MIN_DATE = 'departure_date_min';
var PERTIMM_DEPARTURE_MAX_DATE = 'departure_date_max';
/**
 * Takes the Pertimm catalog of facets and restructure it before storage in redux store.
 */

function catalogToState() {
  var catalogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacets = arguments.length > 1 ? arguments[1] : undefined;
  var completeCountriesFacetAsTree = arguments.length > 2 ? arguments[2] : undefined;
  var facetingTopCountries = arguments.length > 3 ? arguments[3] : undefined;
  var catalogIdsAsList = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* CHILDCARE_FACET_ID */ "d"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DEPARTURE_CITY_FACET_ID */ "i"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DURATION_FACET */ "o"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* FACET_COMFORT_ID */ "p"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* TYPES_OF_STAY_FACET_ID */ "E"]];
  var catalogIdsAsTree = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* ACTIVITIES_FACET_ID */ "a"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DESTINATIONS_FACET_ID */ "n"]];
  var facetsAsList = catalogs.filter(function (catalog) {
    return catalogIdsAsList.includes(catalog.id);
  }).map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        list = _ref.list;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: list.map(catalogFacetItemToState)
    };
  });
  var facetsAsTree = catalogs.filter(function (catalog) {
    return catalogIdsAsTree.includes(catalog.id);
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        tree = _ref2.tree;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: tree.map(function (list) {
        return _objectSpread(_objectSpread({
          id: list.name
        }, catalogFacetItemToState(list)), {}, {
          list: list.tree.map(catalogFacetItemToState)
        });
      })
    };
  });

  var _facetsAsList$filter = facetsAsList.filter(function (_ref3) {
    var id = _ref3.id;
    return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"];
  }),
      _facetsAsList$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_facetsAsList$filter, 1),
      countriesFacetAsList = _facetsAsList$filter2[0];

  var _facetsAsTree$filter = facetsAsTree.filter(function (_ref4) {
    var id = _ref4.id;
    return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DESTINATIONS_FACET_ID */ "n"];
  }),
      _facetsAsTree$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_facetsAsTree$filter, 1),
      destinationsFacetAsTree = _facetsAsTree$filter2[0];

  var topCountriesFacetAsList = getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList);
  var countriesFacetAsTree = countriesFacetAsList && destinationsFacetAsTree ? getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) : null;
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(facetsAsList.map(function (facet) {
    return facet.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"] ? countriesFacetAsTree : facet;
  }).filter(Boolean)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(facetsAsTree));
}

function filtersToActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.reduce(function (acc, filter) {
    var categoryId = filter.id;

    if (_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* FILTERABLE_FACETS_IDS */ "q"].includes(categoryId)) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, categoryId, _objectSpread(_objectSpread({}, acc[categoryId]), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, filter.value, true))));
    }

    return acc;
  }, {});
}

function sanitizeFilters(filters) {
  return filters.filter(function (filter) {
    return !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["includes"])(IGNORED_FILTERS_IDS, Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(filter, 'id'));
  });
}

function sanitizeLabel(label) {
  return label ? label.toLowerCase().replace(/\s+/g, '') : '';
}

function sanitizeValue(value) {
  return value ? value.toUpperCase().replace(/\s+/g, '') : '';
}

function removeDuplicateCountries(countryList) {
  var countryLabels = {};
  return countryList.reduce(function (result, country) {
    var label = sanitizeLabel(country.label);

    if (!countryLabels[label]) {
      countryLabels[label] = _objectSpread({}, country);
      result.push(countryLabels[label]);
    }

    return result;
  }, []);
}

function trimLabel(label) {
  return label ? label.trim() : '';
}

function filtersToState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sanitizeFilters(filters).map(function (filter) {
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(filter, 'id'),
      name: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(filter, 'value'),
      label: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(filter, 'value_i18n'),
      selected: true
    };
  });
}

function getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) {
  var destinationsActiveFacets = activeFacets[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* DESTINATIONS_FACET_ID */ "n"]];
  var initialValueForCountriesFacetAsTree = completeCountriesFacetAsTree && completeCountriesFacetAsTree.list.length >= destinationsFacetAsTree.list.length ? completeCountriesFacetAsTree : _objectSpread(_objectSpread({}, destinationsFacetAsTree), {}, {
    id: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"]
  });
  return _objectSpread(_objectSpread({}, initialValueForCountriesFacetAsTree), {}, {
    list: [topCountriesFacetAsList].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(initialValueForCountriesFacetAsTree.list.map(function (region) {
      var _destinationsFacetAsT, _completeCountriesFac;

      var regionLabel = region.label,
          value = region.value; // Retrieve updated data for the current region in destinationsFacetAsTree

      var destinationsFacetRegion = destinationsFacetAsTree === null || destinationsFacetAsTree === void 0 ? void 0 : (_destinationsFacetAsT = destinationsFacetAsTree.list) === null || _destinationsFacetAsT === void 0 ? void 0 : _destinationsFacetAsT.find(function (_ref5) {
        var regionLabelFromTree = _ref5.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      }); // Check if there are region filters selected, if there are but the current region is not in the active filters, remove it

      if (destinationsActiveFacets && !destinationsActiveFacets[value]) {
        return null;
      } // Retrieve stored data for the current region in completeCountriesFacetRegion


      var completeCountriesFacetRegion = completeCountriesFacetAsTree === null || completeCountriesFacetAsTree === void 0 ? void 0 : (_completeCountriesFac = completeCountriesFacetAsTree.list) === null || _completeCountriesFac === void 0 ? void 0 : _completeCountriesFac.find(function (_ref6) {
        var regionLabelFromTree = _ref6.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      });
      var completeCountriesFacetRegionList = (completeCountriesFacetRegion === null || completeCountriesFacetRegion === void 0 ? void 0 : completeCountriesFacetRegion.list) || [];
      var destinationsFacetRegionList = (destinationsFacetRegion === null || destinationsFacetRegion === void 0 ? void 0 : destinationsFacetRegion.list) || []; // Keep stored data if it's country list is bigger than the updated data

      var list = completeCountriesFacetRegionList.length > destinationsFacetRegionList.length ? completeCountriesFacetRegionList : destinationsFacetRegionList;
      return _objectSpread(_objectSpread({}, region), {}, {
        label: trimLabel(regionLabel),
        list: removeDuplicateCountries(list.map(function (country) {
          var countryLabel = country.label; // Retrieve updated data for the current country in countriesFacetAsList

          var countriesFacetCountry = countriesFacetAsList.list.find(function (_ref7) {
            var countryLabelFromList = _ref7.label;
            return sanitizeLabel(countryLabel) === sanitizeLabel(countryLabelFromList);
          }); // Update current country's data if it is in countriesFacetAsList, otherwise remove it

          return countriesFacetCountry ? _objectSpread(_objectSpread({}, country), {}, {
            count: countriesFacetCountry.count,
            label: trimLabel(countriesFacetCountry.label),
            value: countriesFacetCountry.value
          }) : null;
        }).filter(Boolean))
      });
    }).filter(Boolean).filter(function (_ref8) {
      var id = _ref8.id;
      return id !== _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* TOP_COUNTRIES_FACET_LIST_ID */ "D"];
    }))).filter(Boolean).filter(function (_ref9) {
      var list = _ref9.list;
      return list && list.length > 0;
    })
  });
}

function getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList) {
  var topCountries = facetingTopCountries.enabled ? facetingTopCountries.items.map(function (_ref10) {
    var id = _ref10.id;
    return id;
  }) : [];
  var topCountriesList = countriesFacetAsList && countriesFacetAsList.list ? topCountries.map(function (countryCode) {
    return countriesFacetAsList.list.find(function (_ref11) {
      var value = _ref11.value;
      return sanitizeValue(value) === countryCode;
    });
  }).filter(Boolean) : [];
  return topCountriesList.length > 0 ? {
    count: topCountriesList.reduce(function (result, country) {
      return country && country.count ? result + parseInt(country.count, 10) : result;
    }, 0).toString(),
    id: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* TOP_COUNTRIES_FACET_LIST_ID */ "D"],
    label: trimLabel(facetingTopCountries.title),
    list: removeDuplicateCountries(topCountriesList.map(function (country) {
      return _objectSpread(_objectSpread({}, country), {}, {
        label: trimLabel(country.label)
      });
    })),
    value: facetingTopCountries.title
  } : null;
}

function getTotalLabelsCount(facet) {
  return facet.list.reduce(function (result, facetList) {
    return facetList && facetList.list ? result + facetList.list.length : result;
  }, 0);
}

function parseBanners() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return banners.map(function (banner) {
      return _objectSpread(_objectSpread({}, banner), {}, {
        content: JSON.parse(banner.content)
      });
    });
  } catch (e) {
    return [];
  }
}

function removeUnselectedFiltersFromActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacetsState = arguments.length > 1 ? arguments[1] : undefined;

  var activeFacets = _objectSpread({}, activeFacetsState);

  var newActiveFacets = {};

  if (filters.length) {
    var _loop = function _loop(categoryId) {
      if (activeFacets.hasOwnProperty(categoryId)) {
        var categoryIdFilter = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(filters).filter(function (_ref12) {
          var id = _ref12.id;
          return id === categoryId;
        });

        if (categoryIdFilter.length) {
          newActiveFacets[categoryId] = {};

          var _loop2 = function _loop2(categoryName) {
            if (activeFacets[categoryId].hasOwnProperty(categoryName) && // $FlowFixMe
            categoryIdFilter.some(function (_ref13) {
              var name = _ref13.name,
                  id = _ref13.id;
              return name === categoryName && id === categoryId;
            })) {
              newActiveFacets[categoryId][categoryName] = activeFacets[categoryId][categoryName];
            }
          };

          for (var categoryName in activeFacets[categoryId]) {
            _loop2(categoryName);
          }
        }
      }
    };

    for (var categoryId in activeFacets) {
      _loop(categoryId);
    }
  }

  return newActiveFacets;
}

var initialState = {
  // Special pertimm marchandising rules with pre-parameterized criteria
  // such as `minDate` / `maxDate` for some user queries such as `noel`.
  pertimmInterpretations: {},
  products: [],
  recommandedProducts: [],
  facets: [],
  activeFacets: {},
  childcareAvailabilities: [],
  filters: [],
  completeCountriesFacetAsTree: null,
  query: {
    label: ''
  },
  redirection: null,
  scrollToResults: false,
  isLoading: true,
  isPriceLoading: true,
  isLoadingChildcareAvailabilities: false,
  isSearchEnabled: false,
  isSelectionModeEnabled: false,
  kidsValidationState: [],
  joyviewOffsetSell: -1,
  resortOffsetSell: -1,
  productsSelectedForComparison: [],
  prices: [],
  noResults: false,
  lastRequestId: -1,
  lastRecommandedRequestId: -1,
  isDateRequired: false
};
var facetingReducer = Object(_utils_createReducer__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(initialState, (_createReducer = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_RESET_REDIRECTION */ "f"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    redirection: null
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_RESET_SEARCH */ "g"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    products: [],
    prices: [],
    childcareAvailabilities: [],
    redirection: null,
    scrollToResults: false,
    isLoading: true,
    noResults: false,
    searchIsEnabled: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"]), function (state, action) {
  var locale = action.payload.locale;
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.joyviewOffsetSell) || -1,
    resortOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.resortOffsetSell) || -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRecommandedRequestId: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(action, 'optimist.id', -1),
    recommandedProducts: [],
    noResults: true,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"]), function (state, action) {
  var _action$optimist, _action$payload; // If there is another request in progress


  if ((action === null || action === void 0 ? void 0 : (_action$optimist = action.optimist) === null || _action$optimist === void 0 ? void 0 : _action$optimist.id) !== state.lastRecommandedRequestId) {
    return state;
  }

  var _ref14 = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {},
      resorts = _ref14.resorts;

  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    recommandedProducts: resorts,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SEARCH_REQUEST */ "h"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRequestId: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(action, 'optimist.id', -1),
    noResults: false,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SEARCH_REQUEST */ "h"]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(action, 'optimist.id') !== state.lastRequestId) {
    return state;
  }

  var products = action.payload.search.products;
  var productsSelectedForComparison = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(state, 'productsSelectedForComparison', []).filter(function (selectedProductId) {
    return products.some(function (product) {
      return product.id === selectedProductId;
    });
  });
  var pertimmInterpretations = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(action.payload, 'interpretation_explanation.interpretations', []).reduce(function (acc, interpretation) {
    if (interpretation.filter_name === PERTIMM_DEPARTURE_MIN_DATE) {
      acc.minDate = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_7__[/* getTimestamp */ "d"])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    if (interpretation.filter_name === PERTIMM_DEPARTURE_MAX_DATE) {
      acc.maxDate = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_7__[/* getTimestamp */ "d"])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    return acc;
  }, {});
  var activeFacets = filtersToActiveFacetsState(action.payload.filters);
  var facetingTopCountries = action.payload.facetingTopCountries;
  var facets = !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(action.payload.catalogs) ? catalogToState(action.payload.catalogs, activeFacets, state.completeCountriesFacetAsTree, facetingTopCountries) : state.facets || [];

  var _facets$filter = facets.filter(function (catalog) {
    return _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* COUNTRIES_FACET_ID */ "e"] === catalog.id;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_facets$filter, 1),
      countriesFacetAsTree = _facets$filter2[0];

  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: activeFacets,
    banners: parseBanners(action.payload.banners),
    // We need to store the complete country list because pertimm doesn't return all of them once a filter is selected
    completeCountriesFacetAsTree: !state.completeCountriesFacetAsTree || countriesFacetAsTree && getTotalLabelsCount(countriesFacetAsTree) > getTotalLabelsCount(state.completeCountriesFacetAsTree) ? countriesFacetAsTree : state.completeCountriesFacetAsTree,
    // If the catalog of facets is empty (e.g. "no results"), keep the previous state
    facets: facets,
    filters: filtersToState(action.payload.filters),
    isLoading: false,
    noResults: !action.payload.redirection && products.length === 0,
    pertimmInterpretations: pertimmInterpretations,
    products: products,
    productsSelectedForComparison: productsSelectedForComparison,
    query: _objectSpread(_objectSpread({}, state.query), {}, {
      label: Object(entities__WEBPACK_IMPORTED_MODULE_4__["decodeHTML"])(action.payload.query)
    }),
    redirection: action.payload.redirection
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SEARCH_REQUEST */ "h"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_PRICES_REQUEST */ "e"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: true,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_PRICES_REQUEST */ "e"]), function (state, action) {
  var _action$payload2;

  var _ref15 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {},
      resorts = _ref15.resorts;

  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: resorts,
    scrollToResults: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_PRICES_REQUEST */ "e"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: [],
    scrollToResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_CHILDCARE_REQUEST */ "a"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: true,
    childcareAvailabilities: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_CHILDCARE_REQUEST */ "a"]), function (state, action) {
  var childcareSearch = action.payload.childcareSearch;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: childcareSearch
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_CHILDCARE_REQUEST */ "a"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_FILTERS */ "i"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filters: action.payload.filters
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_INITIAL_PRICES */ "j"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    prices: action.payload.initialProductPrices,
    isPriceLoading: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_IS_SEARCH_ENABLED */ "l"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSearchEnabled: action.payload.isSearchEnabled
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "m"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    kidsValidationState: action.payload.kidsValidationState
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */ "n"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSelectionModeEnabled: action.payload.enable,
    productsSelectedForComparison: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */ "r"], function (state, action) {
  var productsCurrentlySelected = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(state, 'productsSelectedForComparison');
  var productToBeToggled = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(action, 'payload.productId', null);

  if (!productToBeToggled) {
    return state;
  }

  if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["includes"])(productsCurrentlySelected, productToBeToggled)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      productsSelectedForComparison: productsCurrentlySelected.filter(function (p) {
        return p !== productToBeToggled;
      })
    });
  }

  if (productsCurrentlySelected.length < _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* MAX_NUMBER_OF_SELECTED_PRODUCTS */ "w"]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      productsSelectedForComparison: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(productsCurrentlySelected), [productToBeToggled])
    });
  }

  return state;
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_9__[/* SYNC_WITH_LOCATION */ "u"], function (state, action) {
  var _action$payload3 = action.payload;
  _action$payload3 = _action$payload3 === void 0 ? {} : _action$payload3;
  var queryParams = _action$payload3.location.queryParams;

  if (!queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* QUERY_QUERY_PARAM */ "C"]]) {
    return state;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    query: _objectSpread(_objectSpread({}, state.query), {}, {
      label: queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_8__[/* QUERY_QUERY_PARAM */ "C"]]
    })
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_SEARCH_QUERY */ "o"], function (state, _ref16) {
  var value = _ref16.payload.value;

  if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isUndefined"])(value)) {
    return state;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    query: _objectSpread(_objectSpread({}, value), {}, {
      label: Object(entities__WEBPACK_IMPORTED_MODULE_4__["decodeHTML"])(value.label)
    })
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_CLEAR_FACETS */ "b"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, action.payload.categoryId, {}))
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_TOGGLE_FACET_SELECTED */ "p"], function (state, action) {
  var facet = action.payload;
  var categoryActiveFacets = state.activeFacets[facet.categoryId];
  var newState;

  if (facet.isSelected) {
    // lodash/fp
    // return set(`activeFacets.${facet.category}.${facet.value}`, action.payload.isSelected, state);
    newState = _objectSpread(_objectSpread({}, categoryActiveFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, facet.value, facet.isSelected));
  } else {
    var _facet$value = facet.value,
        _ = categoryActiveFacets[_facet$value],
        rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(categoryActiveFacets, [_facet$value].map(_toPropertyKey)); // eslint-disable-line


    newState = rest;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, facet.categoryId, _objectSpread({}, newState)))
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_SET_IS_DATE_REQUIRED */ "k"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isDateRequired: action.payload.isDateRequired
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_11__[/* FACETING_UPDATE_FILTERS */ "s"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filters: action.payload.filters,
    activeFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.filters, state.activeFacets)
  });
}), _createReducer));


/***/ }),

/***/ "8miM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DwNm");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var FormErrors = function FormErrors(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      _ref$texts = _ref.texts,
      texts = _ref$texts === void 0 ? [] : _ref$texts;
  return __jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, texts.map(function (text) {
    return __jsx(_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      key: text,
      isError: true,
      message: text
    });
  }));
};

/***/ }),

/***/ "9KBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterForm; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("/HC4");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var subscriptionSchema = function subscriptionSchema() {
  return yup__WEBPACK_IMPORTED_MODULE_1__["object"]().shape({
    civility: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.requiredField')),
    firstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(20, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.firstName'),
      maxlength: 20
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.requiredField')),
    lastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(30, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.lastName'),
      maxlength: 30
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.requiredField')),
    unicodeFirstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    unicodeLastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    email: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().email(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.invalidEmailField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.errors.requiredField'))
  });
};
var NewsletterForm = function NewsletterForm() {
  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"]),
      displayUnicodeFields = _useContext.displayUnicodeFields;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx("div", {
    className: "md:flex mt-px15 md:mt-0 -mx-px10"
  }, __jsx("div", {
    className: "px-px10 w-full md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.civility'),
    name: "civility",
    options: [{
      isDisabled: true,
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.civility'),
      value: ''
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('newsletter.signup.civilityMale'),
      value: 'M'
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('newsletter.signup.civilityFemale'),
      value: 'F'
    }],
    type: "select"
  })), __jsx("div", {
    className: "px-px10 mt-px15 md:mt-0 w-full md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.firstName'),
    name: "firstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.firstName'),
    type: "text"
  })), __jsx("div", {
    className: "px-px10 mt-px15 md:mt-0 w-full md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.lastName'),
    name: "lastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.lastName'),
    type: "text"
  }))), displayUnicodeFields && __jsx("div", {
    className: "md:flex mt-px15 -mx-px10"
  }, __jsx("div", {
    className: "px-px10 w-full md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.firstName'),
    name: "unicodeFirstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.firstName'),
    type: "text"
  })), __jsx("div", {
    className: "mt-px15 md:mt-0 px-px10 w-full md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.lastName'),
    name: "unicodeLastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.lastName'),
    type: "text"
  }))), __jsx("div", {
    className: "mt-px15"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_4__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('booking.participants.labels.email'),
    name: "email",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('common.form.inputFormats.email'),
    type: "email"
  })));
};

/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_UPDATE_FILTERS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';

/***/ }),

/***/ "9TP6":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("OBn4"),
    noop = __webpack_require__("nnm9"),
    setToArray = __webpack_require__("XlL0");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "9YYj":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "9jKB":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");
var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");
var createNonEnumerableProperty = __webpack_require__("g51W");
var objectHas = __webpack_require__("DZWw");
var shared = __webpack_require__("l6h7");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "A+R+":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("4gXF");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "A5Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SliderHandler_SliderHandler; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.helper.js
function getIndexInRange(index, max) {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandlerItems.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


// $FlowFixMe
var SliderHandlerItems = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var center = props.center,
      children = props.children,
      className = props.className,
      currentIndex = props.currentIndex,
      fadeUnseenItems = props.fadeUnseenItems,
      hasControls = props.hasControls,
      isSwiping = props.isSwiping,
      itemPercentSize = props.itemPercentSize,
      onSwipeEnd = props.onSwipeEnd,
      onSwipeMove = props.onSwipeMove,
      onSwipeStart = props.onSwipeStart,
      position = props.position,
      _props$spacerWidth = props.spacerWidth,
      spacerWidth = _props$spacerWidth === void 0 ? 0 : _props$spacerWidth;
  return __jsx("div", {
    className: classnames_default()(className, 'overflow-hidden'),
    ref: ref,
    tabIndex: hasControls ? 0 : -1
  }, __jsx("div", {
    className: classnames_default()('flex h-full will-change-transform', {
      'transition-transform': !isSwiping
    }),
    style: _objectSpread({
      transform: "translate(".concat(position, "%, 0)"),
      WebkitTapHighlightColor: 'transparent'
    }, center ? {
      padding: '0 25%'
    } : {}),
    onTouchStart: onSwipeStart,
    onTouchMove: onSwipeMove,
    onTouchEnd: onSwipeEnd
  }, react["Children"].map(children, function (child, idx) {
    var isCurrentItem = currentIndex === idx;
    return __jsx("div", {
      "aria-hidden": child.props.ariaHidden,
      className: "max-w-full will-change-transform ".concat(isSwiping ? '' : 'transition-opacity', " px-px").concat(spacerWidth),
      key: idx,
      style: {
        minWidth: "".concat(itemPercentSize, "%"),
        maxWidth: "".concat(itemPercentSize, "%"),
        opacity: isCurrentItem || !fadeUnseenItems ? 1 : 0.3
      },
      tabIndex: child.props.tabIndex
    }, child);
  })));
});
// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx







var SliderHandler_jsx = react_default.a.createElement;

function SliderHandler_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SliderHandler_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SliderHandler_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SliderHandler_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var SliderHandler_SliderHandler = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SliderHandler, _Component);

  var _super = _createSuper(SliderHandler);

  function SliderHandler(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SliderHandler);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onNext", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          maxIndex = _this$state.maxIndex,
          index = _this$state.index;

      var i = index + _this.getStep();

      if (i > maxIndex) {
        i = _this.props.hasInfiniteScroll ? 0 : maxIndex;
      }

      _this.goToIndex(i, _this.props.onNext);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onPrevious", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state2 = _this.state,
          maxIndex = _this$state2.maxIndex,
          index = _this$state2.index;
      var min = 0;

      var i = index - _this.getStep();

      if (i < min) {
        i = _this.props.hasInfiniteScroll ? maxIndex + i + 1 : min;
      }

      _this.goToIndex(i, _this.props.onPrevious);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyUp", function (event) {
      var isRTL = _this.state.isRTL;

      if (_this.props.hasKeyboardSupport) {
        switch (event.which) {
          case keyCodes["c" /* ARROW_RIGHT */]:
            event.stopPropagation();
            isRTL ? _this.onPrevious(event) : _this.onNext(event);
            break;

          case keyCodes["b" /* ARROW_LEFT */]:
            event.stopPropagation();
            isRTL ? _this.onNext(event) : _this.onPrevious(event);
            break;

          default:
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeStart", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var swipeStart = _this.getSwipeX(event);

        var slideWidth = _this.sliderRef.current ? _this.sliderRef.current.offsetWidth : 0;

        _this.setState(function (_ref) {
          var lastIndex = _ref.lastIndex;
          return {
            slideWidth: slideWidth,
            isSwiping: true,
            swipeStart: swipeStart,
            swipeX: lastIndex,
            swipeStartTime: new Date()
          };
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeMove", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var x = _this.getSwipeX(event);

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStart = prevState.swipeStart,
              slideWidth = prevState.slideWidth,
              maxIndex = prevState.maxIndex,
              isRTL = prevState.isRTL;
          var offset = swipeStart - x;
          var percentageOffset = offset / slideWidth;
          var swipeX = isRTL ? lastIndex - percentageOffset : lastIndex + percentageOffset;
          var index = getIndexInRange(Math.round(swipeX), maxIndex);

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return SliderHandler_objectSpread({
            swipeX: getIndexInRange(swipeX, maxIndex)
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeEnd", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStartTime = prevState.swipeStartTime,
              swipeX = prevState.swipeX,
              maxIndex = prevState.maxIndex;

          var step = _this.getStep();

          var timeElapsed = new Date().getTime() - swipeStartTime.getTime();
          var offset = lastIndex - swipeX;
          var velocity = Math.round(offset / timeElapsed * 10000);
          var index = Math.round(swipeX);

          if (Math.abs(velocity) > 5) {
            index = velocity < 0 ? lastIndex + step : lastIndex - step;
          }

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return SliderHandler_objectSpread({
            index: getIndexInRange(index, maxIndex),
            isSwiping: false,
            swipeStart: 0,
            swipeX: 0
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        }, function () {
          var _this$state3 = _this.state,
              index = _this$state3.index,
              lastIndex = _this$state3.lastIndex;
          var _this$props = _this.props,
              onPrevious = _this$props.onPrevious,
              onNext = _this$props.onNext;

          if (index < lastIndex && onPrevious) {
            onPrevious();
          } else if (index > lastIndex && onNext) {
            onNext();
          }

          _this.setState(function () {
            return {
              lastIndex: index
            };
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isItemVisible", function (itemIndex) {
      var index = _this.state.index;
      return itemIndex >= index && itemIndex < index + _this.props.nbItemsToShow;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldRenderItem", function (itemIndex) {
      return !_this.props.hasLazyload || _this.state.itemsToRender[itemIndex];
    });

    _this.sliderRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = _this.initState(props);
    return _this;
  }

  Object(createClass["a" /* default */])(SliderHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasAutoplay = _this$props2.hasAutoplay,
          hasKeyboardSupport = _this$props2.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.addEventListener('keyup', this.onKeyUp, false);
      }

      if (hasAutoplay) {
        this.intervalId = setInterval(function () {
          return _this2.onNext();
        }, 3000);
      }

      if (Object(lodash["get"])(document, 'documentElement.dir', 'ltr') === 'rtl') {
        this.setState({
          isRTL: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hasKeyboardSupport = this.props.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.removeEventListener('keyup', this.onKeyUp, false);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: "initState",
    value: function initState(props) {
      var hasLazyload = props.hasLazyload,
          initialIndex = props.initialIndex,
          items = props.items,
          nbItemsToShow = props.nbItemsToShow;
      var itemsCount = items.length;
      var maxIndex = itemsCount < nbItemsToShow ? 0 : Math.ceil(itemsCount - nbItemsToShow);
      var index = getIndexInRange(initialIndex, maxIndex);
      var initialItemsToRender = Array(itemsCount).fill(!hasLazyload, 0, itemsCount);
      var itemsToRender = this.getItemsToRender(initialItemsToRender, index, nbItemsToShow);
      return {
        index: index,
        isSwiping: false,
        isRTL: false,
        itemsCount: itemsCount,
        itemsToRender: itemsToRender,
        lastIndex: index,
        maxIndex: maxIndex,
        slideWidth: 0,
        swipeStart: 0,
        swipeStartTime: new Date(),
        swipeX: 0
      };
    }
  }, {
    key: "getItemsToRender",
    value: function getItemsToRender(itemsToRender, index, nbItemsToShow) {
      var hasLazyload = this.props.hasLazyload;
      var step = this.getStep();
      var minRange = index - step;
      var maxRange = index + nbItemsToShow + step;
      var newItemToRender = itemsToRender.map(function (isRendered, itemIndex) {
        return isRendered || Object(lodash["inRange"])(itemIndex, minRange, maxRange);
      });

      if (!hasLazyload || itemsToRender.every(function (isRendered) {
        return isRendered;
      }) || Object(lodash["isEqual"])(itemsToRender, newItemToRender)) {
        return itemsToRender;
      }

      return newItemToRender;
    }
  }, {
    key: "getStep",
    value: function getStep() {
      var _this$props$nbItemsTo = this.props.nbItemsToScroll,
          nbItemsToScroll = _this$props$nbItemsTo === void 0 ? 1 : _this$props$nbItemsTo;
      return nbItemsToScroll > 0 ? nbItemsToScroll : 1;
    } // Slide

  }, {
    key: "getItemPosition",
    value: function getItemPosition() {
      var _this$state4 = this.state,
          index = _this$state4.index,
          swipeX = _this$state4.swipeX,
          isSwiping = _this$state4.isSwiping,
          isRTL = _this$state4.isRTL;
      var center = this.props.center;
      var x = isSwiping ? swipeX : index;
      var reductionCoefficient = center ? 2 : 1;
      var increment = 100 / this.props.nbItemsToShow / reductionCoefficient;
      var posX = x * increment;
      return {
        position: isRTL ? posX : -posX,
        increment: increment
      };
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(index) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodash["noop"];

      if (this.props.onChangeIndex) {
        this.props.onChangeIndex(index);
      }

      this.setState(function (prevState) {
        var itemsToRender = _this3.getItemsToRender(prevState.itemsToRender, index, _this3.props.nbItemsToShow);

        return {
          index: index,
          itemsToRender: itemsToRender,
          lastIndex: index
        };
      }, callback);
    } // Events handlers

  }, {
    key: "getSwipeX",
    // Swipe
    value: function getSwipeX(event) {
      return event.touches[0].pageX;
    }
  }, {
    key: "isFirstItemVisible",
    value: function isFirstItemVisible() {
      return this.isItemVisible(0);
    }
  }, {
    key: "isLastItemVisible",
    value: function isLastItemVisible() {
      var itemsCount = this.state.itemsCount;
      return this.isItemVisible(itemsCount - 1);
    }
  }, {
    key: "hasControls",
    value: function hasControls() {
      return this.state.itemsCount > this.props.nbItemsToShow;
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this4 = this;

      var _this$state5 = this.state,
          index = _this$state5.index,
          isSwiping = _this$state5.isSwiping,
          itemsCount = _this$state5.itemsCount;
      if (!itemsCount) return null;
      var _this$props3 = this.props,
          center = _this$props3.center,
          children = _this$props3.children,
          className = _this$props3.className,
          fadeUnseenItems = _this$props3.fadeUnseenItems,
          hasInfiniteScroll = _this$props3.hasInfiniteScroll,
          items = _this$props3.items,
          nbItemsToShow = _this$props3.nbItemsToShow,
          spacerWidth = _this$props3.spacerWidth;
      var hasControls = this.hasControls();

      var _this$getItemPosition = this.getItemPosition(),
          position = _this$getItemPosition.position,
          increment = _this$getItemPosition.increment;

      var itemsNode = SliderHandler_jsx(SliderHandlerItems, {
        center: center,
        className: className,
        currentIndex: index,
        fadeUnseenItems: fadeUnseenItems,
        hasControls: hasControls,
        isSwiping: isSwiping,
        itemPercentSize: 100 / nbItemsToShow,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        position: position,
        increment: increment,
        ref: this.sliderRef,
        spacerWidth: spacerWidth
      }, items.map(function (item, idx) {
        return _this4.shouldRenderItem(idx) ? /*#__PURE__*/Object(react["cloneElement"])(item, {
          'aria-hidden': !_this4.isItemVisible(idx),
          tabIndex: -1
        }) : null;
      }).filter(Boolean));

      var childrenProps = {
        hasControls: hasControls,
        index: index,
        isNextControlDisabled: !hasInfiniteScroll && this.isLastItemVisible(),
        isPreviousControlDisabled: !hasInfiniteScroll && this.isFirstItemVisible(),
        itemsNode: itemsNode,
        onNext: this.onNext,
        onPrevious: this.onPrevious
      };
      return children(childrenProps);
    }
  }]);

  return SliderHandler;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SliderHandler_SliderHandler, "defaultProps", {
  initialIndex: 0,
  nbItemsToScroll: 1,
  nbItemsToShow: 1,
  spacerWidth: 0
});

/***/ }),

/***/ "ANQd":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument === 'function';
};


/***/ }),

/***/ "AZSF":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonProfileFieldsFragment; });
/* harmony import */ var _address_form_AddressForm_fragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("tJAy");

var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    passport{\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n  }\n  ".concat(_address_form_AddressForm_fragment__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id:customerId \n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "Bcqe":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("RNvQ"),
    isObject = __webpack_require__("tQYX");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "Bg8+":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("L1Xj");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "C56r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("eGzU");
var isObject = __webpack_require__("1YFU");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aCallable(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C8GU":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");
var toString = __webpack_require__("vnfA");
var requireObjectCoercible = __webpack_require__("4gXF");

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "CGO5":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("87KK").f;
var has = __webpack_require__("DZWw");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "Crz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9OUN");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_thunk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("V8Kl");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("igjW");
/* harmony import */ var _middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u9tP");
/* harmony import */ var _rootReducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("v315");









function getReduxMiddlewares() {
  return [redux_thunk__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default()(), Object(_middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__[/* createAuthenticationMiddleware */ "a"])()];
}

function init(initialState) {
  var enhancer = Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__[/* isStrictlyDevelopmentEnv */ "d"])(_config__WEBPACK_IMPORTED_MODULE_1___default.a) ? global.window && global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"] : redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"];
  return Object(redux__WEBPACK_IMPORTED_MODULE_2__[/* createStore */ "e"])(_rootReducer__WEBPACK_IMPORTED_MODULE_7__[/* rootReducer */ "a"], initialState, enhancer(redux__WEBPACK_IMPORTED_MODULE_2__[/* applyMiddleware */ "a"].apply(void 0, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getReduxMiddlewares()))));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterReducedMobilityAccomodation; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lZ21");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function sortAccommodations(accommodationsSets) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["sortBy"])(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal

  var filteredAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["reject"])(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEqual"])(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite

  return sortAccommodations(filteredAccommodations);
}

function filterReducedMobilityAccomodation(visibility, filteredAccommodations) {
  if (visibility) {
    return filteredAccommodations;
  }

  var pmr = filteredAccommodations.reduce(function (acc, filteredAccommodation) {
    var accommodations = filteredAccommodation.accommodations;

    if (accommodations.filter(function (_ref2) {
      var reducedMobilityAccess = _ref2.reducedMobilityAccess;
      return reducedMobilityAccess === true;
    }).length === 0) {
      return acc.concat(filteredAccommodation);
    }

    return acc;
  }, []);
  return pmr;
}



/***/ }),

/***/ "DOIJ":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("A5Hi");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var ImageSlideShow = function ImageSlideShow(_ref) {
  var center = _ref.center,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasControlsOnHover = _ref.hasControlsOnHover,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasInsetBorder = _ref.hasInsetBorder,
      hasLazyLoading = _ref.hasLazyLoading,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"], {
      altMsg: alt,
      groupKey: gk,
      hasInsetBorder: hasInsetBorder,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full reset-button w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_6__[/* SliderHandler */ "a"], {
    center: center,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('transition-opacity will-change-transform absolute flex items-center justify-between m-auto inset-0 pointer-events-none w-full z-2', {
        'px-px10 sm:px-px20': !hasOverlappingControls
      }, {
        'group-hover:opacity-100 opacity-0': hasControlsOnHover
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_3__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('rtl:mr-auto pointer-events-auto shadow-sm z-2', {
        '-translate-x-50': hasOverlappingControls
      }),
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_3__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('rtl:ml-auto pointer-events-auto shadow-sm z-2', {
        'translate-x-50': hasOverlappingControls
      }),
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_4__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-px10 sm:px-px20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_3__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_3__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DZWw":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("A+R+");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "DuXo":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "E3ZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMER_SEARCH_RESULT; });
/* unused harmony export UNSET_CUSTOMER_SEARCH_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customerSearch; });
var SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
var UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
var initialState = {};
var customerSearch = function customerSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "EEuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoWrapper; });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("uDfI");
/* harmony import */ var _userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("apzf");


var connector = Object(react_redux__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "c"])(function (state) {
  return {
    userInfo: Object(_userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__[/* userInfoSelector */ "a"])(state)
  };
});
function userInfoWrapper(ComponentToWrap) {
  return connector(ComponentToWrap);
}

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-sm sm:text-base text-gray-darker px-px5',
    thPriceTheme: 'thumbnail'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx

var __jsx = react_default.a.createElement;






var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? lodash["noop"] : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? lodash["noop"] : _ref$onEmptyPriceClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? lodash["noop"] : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (Object(lodash["isEmpty"])(price)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thPriceFrom = _themes$theme.thPriceFrom,
      thPriceTheme = _themes$theme.thPriceTheme;
  var hasPrice = !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex items-center justify-end w-full"
  }, Object(price_util["d" /* hasAtLeastOnePrice */])(price) && __jsx("span", {
    className: thPriceFrom
  }, price.from), __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "flex items-center h-full rounded-tiny",
    "data-testid": "ProductFlag-price",
    from: null,
    isLoading: isPriceLoading,
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    theme: thPriceTheme
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({
    className: "m-px5 z-2"
  }, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-px5"
  }, priceNode);
};

/***/ }),

/***/ "ENE1":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("IBsm");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Ed3r":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__("dNjr");
var $getOwnPropertyNames = __webpack_require__("8D46").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "F9U4":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var classof = __webpack_require__("XywU");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "FcTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CRITERIA_LIST; });
/* unused harmony export UNSET_CRITERIA_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return criteriaListReducer; });
var SET_CRITERIA_LIST = 'SET_CRITERIA_LIST';
var UNSET_CRITERIA_LIST = 'UNSET_CRITERIA_LIST';
var initialState = [];
var criteriaListReducer = function criteriaListReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CRITERIA_LIST:
      return action.payload;

    case UNSET_CRITERIA_LIST:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("igjW");



var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};

/***/ }),

/***/ "Fk4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalDifferentialPrice; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fO+d");
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("04nu");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var getTotalDifferentialPrice = function getTotalDifferentialPrice() {
  var price1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var price2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var locale = arguments.length > 2 ? arguments[2] : undefined;
  var diff = price1 - price2;
  return {
    value: diff,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(diff, locale)
  };
};
var sortPath = 'inbound.transportInfo.price.value';

var updateAlternativeTransports = function updateAlternativeTransports(_ref) {
  var selectedTransportId = _ref.selectedTransportId,
      state = _ref.state; // we do not change this value to keep track of the proposal's selected transport

  var proposalTransport = _objectSpread({}, state.proposalTransport); // fetched Alternative transports from api


  var previousAlternativeTransports = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.alternativeTransports); // current selected which also is the first recommended


  var currentSelectedTransport = _objectSpread({}, state.selectedTransport); // searching by id


  var selectedInboundInAlternative = previousAlternativeTransports.find(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound.transportInfo.id === selectedTransportId;
  }); // if it's not an alternative then we have selected the current selected (in the right)

  var newSelectedTransport = selectedInboundInAlternative || currentSelectedTransport;
  var proposalInAlternative = false;
  var currenAlternativeTransports = previousAlternativeTransports.map(function (_ref3) {
    var inbound = _ref3.inbound,
        outboundList = _ref3.outboundList,
        transportNumber = _ref3.transportNumber;

    if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(inbound, proposalTransport.inbound)) {
      proposalInAlternative = true; // the same selected recommended and alternative should have the same outboundlist

      var sameOutboundList = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default()(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposalTransport.outboundList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(outboundList), _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"]), sortPath); // if the proposal's transport was selected && there's a similar inbound in alternative transports

      if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(proposalTransport.inbound, newSelectedTransport.inbound)) {
        newSelectedTransport.outboundList = sameOutboundList;
      }

      return {
        inbound: inbound,
        outboundList: sameOutboundList,
        transportNumber: transportNumber
      };
    }

    return {
      inbound: inbound,
      outboundList: outboundList,
      transportNumber: transportNumber
    };
  });

  if (!proposalInAlternative && proposalTransport.inbound.transportInfo.id !== newSelectedTransport.inbound.transportInfo.id) {
    // after selecting an inbound, if the proposal's transport is not in the list we should add it to be able to find it afterwards
    currenAlternativeTransports.push(proposalTransport);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    // keep selectedTransportId in redux store
    selectedTransportId: selectedTransportId,
    selectedTransport: newSelectedTransport,
    alternativeTransports: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(currenAlternativeTransports, sortPath))
  });
};

var initialState = {
  alternativeTransports: [],
  selectedTransport: {},
  selectedTransportId: null
};

var hasAvailabilityCheckedWithAmadeus = function hasAvailabilityCheckedWithAmadeus(transport) {
  return (// the flight class should always be present, even for clubmed charter for which we have almost no data
    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(transport, 'inbound.journey.travelSections.0.transport.class'))
  );
};

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(action, 'type')) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* FETCH_ADDITIONAL_TRANSPORTS */ "d"]):
      var _action$payload = action.payload,
          additionalTransports = _action$payload.additionalTransports,
          selectedTransport = _action$payload.selectedTransport;
      var alternativeTransports = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(additionalTransports.filter(hasAvailabilityCheckedWithAmadeus), sortPath).map(function (transport, index) {
        return _objectSpread(_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });
      return {
        selectedTransport: selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports: alternativeTransports,
        selectedTransportId: null
      };

    case _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* UPDATE_SELECTED_TRANSPORT */ "j"]:
      var selectedTransportId = action.payload.selectedTransportId;
      return updateAlternativeTransports({
        selectedTransportId: selectedTransportId,
        state: state
      });

    default:
      return state;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (transportsReducer);

/***/ }),

/***/ "FtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useAbTasty; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7jla");
/* harmony import */ var _third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kD1E");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");





var sendTransaction = function sendTransaction(_ref) {
  var id = _ref.id,
      affiliation = _ref.affiliation,
      revenue = _ref.revenue,
      currency = _ref.currency;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window, _window$abtasty;

    if ((_window = window) === null || _window === void 0 ? void 0 : (_window$abtasty = _window.abtasty) === null || _window$abtasty === void 0 ? void 0 : _window$abtasty.send) {
      window.abtasty.send('transaction', {
        tid: id,
        // Transaction ID
        ta: affiliation,
        // Transaction Affiliation
        tr: revenue,
        // Transaction Revenue
        tc: currency // Transaction Currency

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_0___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};

var getABTastyId = function getABTastyId(abtasty, _ref2) {
  var isCmta = _ref2.isCmta,
      isCxo = _ref2.isCxo;

  if (isCmta) {
    return abtasty.cmta.id;
  }

  if (isCxo) {
    return abtasty.cxo.id;
  }

  return abtasty.id;
};

var useAbTasty = function useAbTasty() {
  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"]),
      isCmta = _useContext.isCmta,
      isCxo = _useContext.isCxo,
      locale = _useContext.locale;

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_2__[/* useRouter */ "a"])(),
      queryParams = _useRouter.location.queryParams;

  var _getConfigWithNoThird = Object(_third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__[/* getConfigWithNoThirdPartySupport */ "a"])({
    locale: locale,
    name: 'tracking',
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      abtasty = _getConfigWithNoThird.abtasty;

  var abTastyId = getABTastyId(abtasty, {
    isCmta: isCmta,
    isCxo: isCxo
  });
  var isAbTastyActive = Boolean(enabled && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.enabled) && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.host) && abTastyId);
  var abTastyScriptUrl = isAbTastyActive ? "https://".concat(abtasty.host, "/").concat(abTastyId, ".js") : '';
  return {
    abTastyScriptUrl: abTastyScriptUrl,
    isAbTastyActive: isAbTastyActive
  };
};

/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /opt/webapp/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
    window.removeEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /opt/webapp/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GZ82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaAddressFragment = "\n fragment ValidationSchemaAddress on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      display\n      name\n      required\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaAddressFragment);

/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Responsive, _React$Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
            ref: forwardRef
          }, rest, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]); // $FlowFixMe


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"](function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "Gy6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ArrowButton_ArrowButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.themes.js




var ArrowButton_themes_themes = function themes(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref$color,
      _ref$colorBg = _ref.colorBg,
      colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].WHITE : _ref$colorBg,
      _ref$colorDisabled = _ref.colorDisabled,
      colorDisabled = _ref$colorDisabled === void 0 ? colors["a" /* COLORS */].GRAY_MEDIUM : _ref$colorDisabled,
      _ref$colorBgDisabled = _ref.colorBgDisabled,
      colorBgDisabled = _ref$colorBgDisabled === void 0 ? colors["a" /* COLORS */].GRAY_LIGHT : _ref$colorBgDisabled,
      isDisabled = _ref.isDisabled;
  return {
    "default": {
      thRoot: classnames_default()('reset-button block flex items-center justify-center leading-none rounded-tiny text-sm transition-colors', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(colorBgDisabled, " cursor-default pointer-events-none text-").concat(colorDisabled), isDisabled), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(colorBg, " focus:bg-").concat(colorBg, "-active hover:bg-").concat(colorBg, "-active text-").concat(color), !isDisabled), _classnames)),
      thIconName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
      thLabel: 'sr-only'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx
var __jsx = react_default.a.createElement;





var ArrowButton_ArrowButton = function ArrowButton(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorDisabled = _ref.colorDisabled,
      colorBg = _ref.colorBg,
      colorBgDisabled = _ref.colorBgDisabled,
      hasNoRtl = _ref.hasNoRtl,
      isDisabled = _ref.isDisabled,
      label = _ref.label,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      _ref$rotation = _ref.rotation,
      rotation = _ref$rotation === void 0 ? 0 : _ref$rotation,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 28 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title,
      trackingData = _ref.trackingData;
  var _themes$theme = ArrowButton_themes_themes({
    color: color,
    colorBg: colorBg,
    colorDisabled: colorDisabled,
    colorBgDisabled: colorBgDisabled,
    isDisabled: isDisabled
  })[theme],
      thIconName = _themes$theme.thIconName,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  var style = {
    height: size,
    width: size
  };
  return __jsx(TrackClick["a" /* TrackClick */], {
    "aria-disabled": isDisabled,
    as: "button",
    className: classnames_default()(className, thRoot),
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    style: style,
    title: title,
    trackingData: trackingData,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    hasRtl: !hasNoRtl,
    name: thIconName,
    rotation: rotation,
    width: "1em"
  }), label && __jsx("span", {
    className: thLabel
  }, label));
};

/***/ }),

/***/ "HKx7":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var anObject = __webpack_require__("ep/x");
var objectKeys = __webpack_require__("X95k");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "HaU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__("IebI");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

var _asyncToGenerator = __webpack_require__("4mCN");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("Y3ZS");

exports.__esModule = true;
exports.Container = Container;
exports.createUrl = createUrl;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _utils = __webpack_require__("fvxO");

exports.AppInitialProps = _utils.AppInitialProps;
exports.NextWebVitalsMetric = _utils.NextWebVitalsMetric;
/**
* `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
* This allows for keeping state between navigation, custom error handling, injecting additional data.
*/

function appGetInitialProps(_x) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils.loadGetInitialProps)(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var App = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(App, _react$default$Compon);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "componentDidCatch",
    // Kept here for backwards compatibility.
    // When someone ended App they could call `super.componentDidCatch`.
    // @deprecated This method is no longer needed. Errors are caught at the top level
    value: function componentDidCatch(error, _errorInfo) {
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps,
          __N_SSG = _this$props.__N_SSG,
          __N_SSP = _this$props.__N_SSP;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps, // we don't add the legacy URL prop if it's using non-legacy
      // methods like getStaticProps and getServerSideProps
      !(__N_SSG || __N_SSP) ? {
        url: createUrl(router)
      } : {}));
    }
  }]);

  return App;
}(_react["default"].Component);

exports["default"] = App;
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
var warnContainer;
var warnUrl;

if (false) {} // @deprecated noop for now until removal


function Container(p) {
  if (false) {}
  return p.children;
}

function createUrl(router) {
  // This is to make sure we don't references the router object at call time
  var pathname = router.pathname,
      asPath = router.asPath,
      query = router.query;
  return {
    get query() {
      if (false) {}
      return query;
    },

    get pathname() {
      if (false) {}
      return pathname;
    },

    get asPath() {
      if (false) {}
      return asPath;
    },

    back: function back() {
      if (false) {}
      router.back();
    },
    push: function push(url, as) {
      if (false) {}
      return router.push(url, as);
    },
    pushTo: function pushTo(href, as) {
      if (false) {}
      var pushRoute = as ? href : '';
      var pushUrl = as || href;
      return router.push(pushRoute, pushUrl);
    },
    replace: function replace(url, as) {
      if (false) {}
      return router.replace(url, as);
    },
    replaceTo: function replaceTo(href, as) {
      if (false) {}
      var replaceRoute = as ? href : '';
      var replaceUrl = as || href;
      return router.replace(replaceRoute, replaceUrl);
    }
  };
}

/***/ }),

/***/ "HnW7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "I1fX":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("6XIJ");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "I2c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("dNjr");
var addToUnscopables = __webpack_require__("3K/D");
var Iterators = __webpack_require__("oa0l");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "I8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = Object.prototype.toString;

module.exports = function (x) {
  var prototype;
  return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

/***/ }),

/***/ "IYAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var isForced = __webpack_require__("wxLG");
var redefine = __webpack_require__("L1Xj");
var InternalMetadataModule = __webpack_require__("wKkN");
var iterate = __webpack_require__("ZuH9");
var anInstance = __webpack_require__("V/va");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var fails = __webpack_require__("fhLv");
var checkCorrectnessOfIteration = __webpack_require__("AZSF");
var setToStringTag = __webpack_require__("CGO5");
var inheritIfRequired = __webpack_require__("XmKO");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "Iev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAuthentication; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ub5k");


function useAuthentication() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"]);
  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged
  };
}

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.themes.js

var PriceItem_themes_themes = function themes(_ref) {
  var hasAction = _ref.hasAction;
  return {
    best: {
      "package": {
        thRoot: 'font-bold leading-one text-center',
        thLabel: 'block font-sans text-gray-darker text-base uppercase',
        thValue: 'block text-turquoise text-5xl',
        thLongValue: 'block text-turquoise text-3xl'
      },
      thumbnail: {
        thRoot: 'flex items-center text-base',
        thLabel: 'font-sans text-gray-darker',
        thValue: 'leading-tight px-px5 text-2xl underline',
        thLongValue: 'leading-tight px-px5 text-xl underline',
        thLongValueLimit: 10
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'leading-tight text-md underline font-bold',
        thLongValue: 'leading-tight text-2xl underline'
      },
      remote: {
        thRoot: 'leading-one font-bold px-px5 flex items-center',
        thLabel: 'align-top font-sans inline-block text-sm pr-px5 rtl:pr-px5',
        thValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        }),
        thLongValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        })
      }
    },
    initial: {
      "package": {
        thRoot: 'block font-bold leading-tight text-center',
        thLabel: 'inline-block font-sans text-gray-darker text-base',
        thValue: 'inline-block line-through text-gray-darker text-base',
        thLongValue: 'block line-through text-gray-darker text-base'
      },
      thumbnail: {
        thRoot: 'inline-block lowercase text-md',
        thLabel: 'hidden',
        thValue: 'line-through uppercase',
        thLongValue: 'line-through text-base uppercase',
        thLongValueLimit: 10
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      },
      remote: {
        thRoot: 'font-bold text-md text-grenadine',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      }
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.jsx
var __jsx = react_default.a.createElement;




var PriceItem_PriceItem = function PriceItem(_ref) {
  var className = _ref.className,
      formattedValue = _ref.formattedValue,
      hasAction = _ref.hasAction,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'best' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;

  if (!value || !formattedValue) {
    return null;
  }

  var _themes$type$theme = PriceItem_themes_themes({
    hasAction: hasAction
  })[type][theme],
      thLabel = _themes$type$theme.thLabel,
      thLongValue = _themes$type$theme.thLongValue,
      thLongValueLimit = _themes$type$theme.thLongValueLimit,
      thRoot = _themes$type$theme.thRoot,
      thValue = _themes$type$theme.thValue;
  var valueClasses = Object(price_util["g" /* isLongFormat */])(formattedValue, thLongValueLimit) ? thLongValue : thValue;
  return __jsx("span", {
    className: classnames_default()(className, thRoot)
  }, !!label && __jsx("span", {
    className: thLabel,
    "data-testid": "PriceItem-label"
  }, label), !!label && !!formattedValue && __jsx("span", null, " "), __jsx("span", {
    className: valueClasses,
    "data-testid": "PriceItem-value"
  }, formattedValue));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.themes.js
var PriceUnit_themes_themes = {
  "package": {
    thRoot: 'block font-sans font-bold text-center text-sm uppercase'
  },
  thumbnail: {
    thRoot: 'inline-block font-sans text-sm md:text-base text-gray-darker'
  },
  instagram: {
    thRoot: 'inline-block font-sans text-sm sm:text-base'
  },
  remote: {
    thRoot: 'font-bold font-sans inline-block text-sm'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.jsx
var PriceUnit_jsx = react_default.a.createElement;


var PriceUnit_PriceUnit = function PriceUnit(_ref) {
  var hasAsterisk = _ref.hasAsterisk,
      theme = _ref.theme,
      unit = _ref.unit;
  return unit ? PriceUnit_jsx("span", {
    className: PriceUnit_themes_themes[theme].thRoot,
    "data-testid": "Price-unit"
  }, unit, hasAsterisk && PriceUnit_jsx("sup", null, "*")) : null;
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js
var PriceDiscount_themes_themes = {
  "package": {},
  thumbnail: {
    thInitialPrice: 'flex-shrink-0 -mb-px5 -order-1 text-grenadine',
    thBestPrice: 'flex-shrink-0'
  },
  instagram: {
    thInitialPrice: 'text-grenadine'
  },
  remote: {
    thInitialPrice: '-order-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx

var PriceDiscount_jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAction = _ref.hasAction,
      hasAsterisk = _ref.hasAsterisk,
      hasInitialPrice = _ref.hasInitialPrice,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? [] : _ref$instalmentLocale,
      instead = _ref.instead,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var _themes$theme = PriceDiscount_themes_themes[theme],
      thBestPrice = _themes$theme.thBestPrice,
      thInitialPrice = _themes$theme.thInitialPrice;
  var displayInstalment = hasInstalment && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice');
  var locale = context.locale;
  return PriceDiscount_jsx(react["Fragment"], null, PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: from,
    theme: theme,
    type: "best"
  }, bestPrice, {
    className: thBestPrice,
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : bestPrice && bestPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), hasInitialPrice && PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: instead,
    theme: theme,
    type: "initial"
  }, initialPrice, {
    className: thInitialPrice,
    formattedValue: displayInstalment && initialPrice && instalmentLocales.includes(locale) ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
      precision: 0
    }) : initialPrice && initialPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), PriceDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/no-discount/PriceNoDiscount.jsx

var PriceNoDiscount_jsx = react_default.a.createElement;





var PriceNoDiscount_PriceNoDiscount = function PriceNoDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var price;

  if (Object(price_util["f" /* hasPrice */])(initialPrice)) {
    price = initialPrice;
  } else if (Object(price_util["f" /* hasPrice */])(bestPrice)) {
    price = bestPrice;
  }

  return PriceNoDiscount_jsx(react["Fragment"], null, PriceNoDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    label: from,
    theme: theme,
    type: "best"
  }, price, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(price, context.locale) : price && price.formattedValue
  })), PriceNoDiscount_jsx("span", null, " "), PriceNoDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "package": {
    thRoot: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    thLabel: 'rtl:ml-px10'
  },
  thumbnail: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-px5'
  },
  instagram: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-px5'
  },
  remote: {
    thRoot: 'flex items-center font-bold font-sans leading-one text-xl',
    thLabel: 'rtl:ml-px10'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx
var PriceViewRate_jsx = react_default.a.createElement;




var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var label = _ref.label,
      theme = _ref.theme;
  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("div", {
    className: thRoot
  }, PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), PriceViewRate_jsx("span", {
    className: thLabel,
    "data-testid": "Price-viewRate"
  }, label));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.themes.js

var Price_themes_themes = function themes(_ref) {
  var color = _ref.color;
  return {
    "package": {
      thRoot: 'overflow-hidden'
    },
    thumbnail: {
      thRoot: 'flex items-center overflow-hidden pt-px5 pb-px10 text-gray-darker',
      thPriceRoot: 'font-brand flex items-center'
    },
    instagram: {
      thRoot: 'w-full flex items-center truncate text-white',
      thPriceRoot: 'font-brand text-inherit'
    },
    remote: {
      thRoot: "inline-flex overflow-hidden text-".concat(color || colors["a" /* COLORS */].BLUE),
      thPriceRoot: 'flex items-center'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx
var Price_jsx = react_default.a.createElement;







var HEIGHT = '2.5rem';
var Price_Price = function Price(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      color = _ref.color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    minHeight: HEIGHT
  } : _ref$containerStyle,
      from = _ref.from,
      _ref$hasAsterisk = _ref.hasAsterisk,
      hasAsterisk = _ref$hasAsterisk === void 0 ? true : _ref$hasAsterisk,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? true : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? ['pt-BR', 'es-AR'] : _ref$instalmentLocale,
      instead = _ref.instead,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onClick = _ref.onClick,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      unit = _ref.unit,
      viewRates = _ref.viewRates;
  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (!displayPrice && !viewRates) {
    return null;
  }

  var _themes$theme = Price_themes_themes({
    color: color
  })[theme],
      thPriceRoot = _themes$theme.thPriceRoot,
      thRoot = _themes$theme.thRoot;
  var hasAction = !!onClick;
  var TagName = hasAction ? 'button' : 'div';
  return Price_jsx(TagName, {
    "data-testid": "Price-wrapper",
    className: classnames_default()(className, thRoot, {
      'reset-button': hasAction
    }),
    onClick: onClick,
    style: containerStyle
  }, Price_jsx("span", {
    className: thPriceRoot,
    style: style
  }, isLoading ? Price_jsx("span", {
    className: "loadingDots",
    "data-testid": "Price-loader"
  }) : Price_jsx(react["Fragment"], null, displayPrice ? Price_jsx(react["Fragment"], null, Object(price_util["e" /* hasDiscount */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  }) ? Price_jsx(PriceDiscount_PriceDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAction: hasAction,
    hasAsterisk: hasAsterisk,
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    instalmentLocales: instalmentLocales,
    instead: instead,
    theme: theme,
    unit: unit
  }) : Price_jsx(PriceNoDiscount_PriceNoDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAsterisk: hasAsterisk,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    theme: theme,
    unit: unit
  })) : Price_jsx(PriceViewRate_PriceViewRate, {
    label: viewRates,
    theme: theme
  }))));
};

/***/ }),

/***/ "Jm8J":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "JpEK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var create = __webpack_require__("Znn2");
var getPrototypeOf = __webpack_require__("yvHl");
var redefine = __webpack_require__("L1Xj");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "KVdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getComparatorCmsQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllResorts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComparatorQuery; });
var getComparatorCmsQuery = function getComparatorCmsQuery() {
  return "\n  config {\n    common { next previous }\n    productsComparison {\n      resortNotAvailable\n    }\n    booking {\n      form {\n        errors {\n          childcareUnavailable\n          transferUnavailable\n        }\n        dateFormat\n        dayPlaceholder\n        monthPlaceholder\n        yearPlaceholder\n        withoutTransport\n        selectAdultsLabels {\n          _1\n          n\n        }\n        selectChildrenLabels {\n          _1\n          n\n        }\n      }\n      counterProposalPopIn {\n        noAvailabilityOnCriterionLabel\n        notAvailableDates\n        weSuggestLabel\n        checkPriceLabel\n        fromTo\n        doNotCheckPriceLabel\n        rateCounterProposalTitle\n        seeOtherProposalsButton\n        callCenterAdvise\n        pleaseCallLabel\n        callCost\n        callCenterNumber\n        otherProposals\n        resortCounterProposalTitle\n        resortCounterProposalTransportReassurance\n        checkPriceLabelResort\n        durationsLabel\n        durationLabel\n        durationsSuggestions\n        checkPriceLabelDuration\n      }\n      common {\n        or\n      }\n    }\n    travelAdvisor {\n      phoneNumber\n    }\n    common {\n      backNavigation\n      comparator {\n        search\n        date\n        transport\n        participants\n        resetCriteria\n        price\n        select\n        resort\n        newCriteria\n        sameCriteria\n        backToSearch\n        warning {\n          date\n          search\n          resort\n          childrenDateOfBirth\n          noAvailability\n        }\n        standardSelect\n        nonRefundableRateSelect\n        seeOtherChoices\n        yourProposals\n        newProposal\n        otherProposals\n      }\n    }\n    faceting {\n      reset\n      validate\n      transport {\n        comment\n        departingFrom\n        introduction\n        reassurance {\n          iconName\n          label\n        }\n        subTitle\n      }\n      when {\n        nights\n        duration\n        durations\n        subTitle\n        arrivalDateTitle\n        departureDateTitle\n        durationPlural\n        durationSingular\n        reinsurance\n      }\n      who {\n        subTitle\n        adults\n        kids\n        ageSectionChildcareSubtitle\n        kidsAgeLimit\n        addChildcare\n      }\n    }\n    productsComparison {\n      resortNotAvailable\n      immersiveText\n      immersiveImage\n      title\n    }\n  }\n";
};

var resortOpeningDates = function resortOpeningDates() {
  return "\n  openingDates {\n    opening\n    closing\n  }\n";
};

var getAllResorts = function getAllResorts() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$withOpeningDates = _ref.withOpeningDates,
      withOpeningDates = _ref$withOpeningDates === void 0 ? false : _ref$withOpeningDates;

  return "\n  resortList: resorts(productTypes: [VILLAGE, JOYVIEW, VILLA]) {\n    badgeIcon\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    id\n    isExplicitEC\n    isJoyview\n    name\n    offsetSell\n    seasonTrad\n    type\n    ".concat(withOpeningDates ? resortOpeningDates() : '', "\n  }\n");
};
var getComparatorQuery = function getComparatorQuery() {
  return "{\n    ".concat(getComparatorCmsQuery(), "\n    ").concat(getAllResorts(), "\n  }");
};

/***/ }),

/***/ "Kb9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_VALIDATION_SCHEMA; });
var UPDATE_VALIDATION_SCHEMA = 'UPDATE_VALIDATION_SCHEMA';

/***/ }),

/***/ "Khd+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("HaU7")


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilters; });
/* unused harmony export COMFORT_CATEGORY */
/* unused harmony export EXTRA_FEATURES_CATEGORY */
/* unused harmony export CONFIGURATION_CATEGORY */
/* unused harmony export REDUCED_MOBILITY_CATEGORY */
/* unused harmony export REDUCED_MOBILITY_FILTER_ID */
/* unused harmony export matchConfiguration */
/* unused harmony export matchComfort */
/* unused harmony export matchExtraFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFilters; });
/* unused harmony export createConfigurationFilters */
/* unused harmony export createComfortFilters */
/* unused harmony export createExtraFeaturesFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unselectCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleReducedMobilityFilter; });
/* unused harmony export matchExtraFeaturesReducedMobility */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("h/fj");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("lZ21");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_CATEGORY = 'reduced_mobility';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var getOptions = function getOptions(v, c) {
  return v.filter(function (_ref) {
    var category = _ref.category;
    return category === c;
  }).map(function (o) {
    var _o$meta, _o$meta2;

    return {
      iconName: (_o$meta = o.meta) === null || _o$meta === void 0 ? void 0 : _o$meta.icon,
      id: o.id,
      isDisabled: !o.matchedOccurrences,
      isSelected: o.selected,
      label: (_o$meta2 = o.meta) === null || _o$meta2 === void 0 ? void 0 : _o$meta2.label,
      matched: o.matchedOccurrences || 0,
      value: o.value
    };
  });
};

var getFilters = function getFilters(i18n, resort) {
  var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return [{
    id: COMFORT_CATEGORY,
    label: Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(i18n, 'filters.comfort.categoryTitle'),
    options: getOptions(filterValues, COMFORT_CATEGORY)
  }, {
    id: CONFIGURATION_CATEGORY,
    label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "l"])({
      cruiseKeyPath: 'filters.configuration.categoryTitleCruise',
      resort: resort,
      resortKeyPath: 'filters.configuration.categoryTitle'
    }),
    options: getOptions(filterValues, CONFIGURATION_CATEGORY)
  }, {
    id: EXTRA_FEATURES_CATEGORY,
    label: Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(i18n, 'filters.extraFeatures.categoryTitle'),
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY)
  }, {
    id: REDUCED_MOBILITY_CATEGORY,
    label: '',
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY),
    customRenderParent: function customRenderParent(handleCheck) {
      return __jsx("div", {
        className: "flex flex items-center justify-center"
      }, __jsx("input", {
        type: "checkbox",
        className: "w1/4 h4 m-px5",
        name: "filters.reducedMobility",
        onChange: handleCheck
      }), __jsx("label", {
        htmlFor: "filters.reducedMobility",
        className: "w-5 h-5 ml-2.5"
      }, Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(i18n, 'filters.reducedMobilityCheckbox')));
    }
  }];
};

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'categories').find(function (category) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(category, 'id') === categoryId;
    });
  });
};

var matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'view.id', null) === strengthId || Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'strengths', []).find(function (strength) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, resort) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('roomType')])(accommodationsSets);
  return accommodations.map(function (_ref2) {
    var roomType = _ref2.roomType;
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      meta: {
        label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "l"])({
          resortKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* ROOM_TYPE */ "e"][roomType]),
          cruiseKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* CABIN_TYPE */ "b"][roomType]),
          resort: resort
        }),
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][roomType]
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('categoryId')])(accommodationsSets);
  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: COMFORT_CATEGORY,
      match: matchComfort,
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodationsSets);
  var strengths = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('strengths')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var views = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('view')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var features = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(strengths), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(views));
  return features.map(function (feature) {
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function handleReducedMobilityFilter(i18n, accommodationsSets, reducedMobilityVisibility, state) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodationsSets);
  var isReducedMobility = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
  var matchedReducedMobility = isReducedMobility ? accommodationsSets.filter(function (filteredAccomodation) {
    return filteredAccomodation.accommodations.filter(function (acc) {
      return acc.reducedMobilityAccess === true;
    }).length > 0;
  }).length : 0;
  var newItem = {
    id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
    category: EXTRA_FEATURES_CATEGORY,
    match: matchExtraFeaturesReducedMobility,
    matchedOccurrences: matchedReducedMobility,
    meta: {
      label: i18n.filters.reducedMobility,
      icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].reduced_mobility_access,
      iconClassName: 'icon--reduced_mobility_access',
      iconInheritColor: true
    },
    path: 'accommodations',
    selected: false,
    value: 'reduced_mobility_access'
  };
  return !reducedMobilityVisibility ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(state), [newItem]) : state.filter(function (feature) {
    return feature.value !== 'reduced_mobility_access';
  });
}

function createFilters(accommodationsSets, resort) {
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createExtraFeaturesFilters(accommodationsSets)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createConfigurationFilters(accommodationsSets, resort)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}



/***/ }),

/***/ "L1Xj":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");
var has = __webpack_require__("DZWw");
var createNonEnumerableProperty = __webpack_require__("g51W");
var setGlobal = __webpack_require__("edYw");
var inspectSource = __webpack_require__("/ExG");
var InternalStateModule = __webpack_require__("9jKB");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("mu8A").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "LFxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("Bg8+");
var getWeakData = __webpack_require__("wKkN").getWeakData;
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var anInstance = __webpack_require__("V/va");
var iterate = __webpack_require__("ZuH9");
var ArrayIterationModule = __webpack_require__("VrMI");
var $has = __webpack_require__("DZWw");
var InternalStateModule = __webpack_require__("9jKB");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ "LTtw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var getOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var setGlobal = __webpack_require__("edYw");
var copyConstructorProperties = __webpack_require__("sfoL");
var isForced = __webpack_require__("wxLG");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "M4Qz":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var toIndexedObject = __webpack_require__("dNjr");
var indexOf = __webpack_require__("5LiQ").indexOf;
var hiddenKeys = __webpack_require__("qXr/");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCxoAttendeesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return streetViewsByAccommodationCategoryId; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SQLw");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("BYx+");
/* harmony import */ var _store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("GZ82");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("L7OA");








var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      accommodations {\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        id\n        roomType\n      }\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childcareDetails {\n        isIncluded\n      }\n      childrenActivities: productActivities(idFilter: \"".concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n      }\n      href\n      id\n      image\n      images\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      name\n      offsetSell\n      openingDates {\n        opening\n        closing\n      }\n      seasonName\n      seasons\n      title\n      transportType\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            startDate\n            endDate\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n        wellness {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema() {
  var productId = new URL(window.location.href).searchParams.get('coderesort');

  if (productId) {
    return "\n      validationSchema(productId: \"".concat(productId, "\", resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n    ");
  }

  return "\n      validationSchema(resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n    ";
}

var getCxoAttendeesData = function getCxoAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n          address {\n            streetNumber\n            streetName\n            additionalInformation1\n            additionalInformation2\n            addOn\n            zipCode\n            city\n            town\n            stateOrDistrict\n            countryCode\n            country\n          }\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v1/proposals/{proposal_id}
 */


function proposalsByIdQuery(params, appContext) {
  var proposalsArgs = Array.isArray(params.proposalsId) ? ["ids: [\"".concat(params.proposalsId.join('","'), "\"]")] : ["ids: [\"".concat(params.proposalsId, "\"]")];
  var displayCommission = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n        ... on ProposalsType {\n          proposals {\n            ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__[/* getPaymentScheduleRequest */ "g"])(appContext) : '', "\n            ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__[/* proposalFields */ "l"])({
    isJoyView: true,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }), "\n          }\n          ").concat(getResort(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(getValidationSchema(), "\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat( // When it is an attendee identified on the Cxo side we already know the customerIds
  // via the cxo_traveler query param
  getCxoAttendeesData(params), "\n      ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__[/* paymentProvidersRequest */ "j"])() : '', "\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__[/* transportDetailsFragment */ "q"], "\n    ").concat(_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_5__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(appContext, 'locale')), "\n    ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_2__[/* profileFragment */ "b"] : '', "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_BY_ID */ "kd"]
  });
}
/*
 * * Used in fetchStreetViewsByAccommodationCategoryId to get street views list for <AccommodationRoomSlideshow/>
 * * Uses  API route GET /v0/products/{product_id}/accommodation_categories/{accommodation_category_id}/virtual_visits
 */


function streetViewsByAccommodationCategoryId(params, appContext) {
  var streetViewsArgs = ["productId: \"".concat(params.productId, "\"")];
  streetViewsArgs.push(Array.isArray(params.accommodationCategoryIds) ? "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds.join('","'), "\"]") : "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds, "\"]"));
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runNoCacheQuery("\n    {\n      streetViews(".concat(streetViewsArgs.join(', '), ") {\n        accommodationCategoryId\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* STREET_VIEW_GET_SEVERAL */ "Hd"]
  });
}



/***/ }),

/***/ "MRpX":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var setPrototypeOf = __webpack_require__("iBXc");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "MU85":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");
var getMethod = __webpack_require__("Uey1");
var Iterators = __webpack_require__("oa0l");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "MaE1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = global;


/***/ }),

/***/ "MwrP":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("4uJK"),
    getTag = __webpack_require__("kkM+"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD"),
    isArrayLike = __webpack_require__("9y2L"),
    isBuffer = __webpack_require__("3ajY"),
    isPrototype = __webpack_require__("CbIe"),
    isTypedArray = __webpack_require__("Qd2C");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "NLwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return graphqlify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return graphqlifyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildCruiseArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildArgs; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var EMPTY_STRING = '""';

function graphqlify(jsonObject) {
  if (jsonObject) {
    return JSON.stringify(jsonObject).replace(/\"([^(\")"]+)\":/g, '$1:').replace(/(null)/g, EMPTY_STRING);
  }

  return '';
}

function graphqlifyString(str) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isString"])(str)) {
    return JSON.stringify(str);
  }

  return EMPTY_STRING;
}

function buildArgs() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(args).reduce(function (acc, key) {
    var value = args[key];

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNull"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isUndefined"])(value)) {
      return acc;
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNumber"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isBoolean"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(value);
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isArray"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(graphqlify(value));
    }

    return "".concat(acc, " ").concat(key, ": \"").concat(value, "\"");
  }, initialArgs);
}

function getCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$arrivalDate = params.arrivalDate,
      arrivalDate = _params$arrivalDate === void 0 ? '' : _params$arrivalDate;
  return {
    cruiseDepartureDate: departureDate,
    cruiseArrivalDate: arrivalDate
  };
}

function buildCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionalArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var args = _objectSpread(_objectSpread({}, optionalArguments), getCruiseArgs(params));

  return buildArgs(args);
}

var CRUISE_RESORT_ID = 'CM2C';

function buildProductArgs(productId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var optionalArguments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!productId) {
    throw new Error('You must provide a productId');
  }

  var productArg;

  if (productId !== CRUISE_RESORT_ID) {
    productArg = "productId: \"".concat(productId, "\"");
  } else {
    var _getCruiseArgs = getCruiseArgs(params),
        cruiseDepartureDate = _getCruiseArgs.cruiseDepartureDate,
        cruiseArrivalDate = _getCruiseArgs.cruiseArrivalDate;

    productArg = "productId: \"".concat(productId, "_").concat(cruiseDepartureDate, "_").concat(cruiseArrivalDate, "\"");
  }

  return buildArgs(optionalArguments, productArg);
}



/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLongFormat; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = props || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;
  var totalWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(total, 'value', 0);
  var totalWithoutDiscountWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(totalWithoutDiscount, 'value', 0);
  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) return '';

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "Ndl3":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L"),
    isObjectLike = __webpack_require__("tLQN");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "Nhxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesToString; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable no-duplicate-imports  */


function attributesToString(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(data).reduce(function (acc, key) {
    if (options.ignoreUndefined && data[key] === undefined) {
      return '';
    }

    var value = data[key] === null ? '' : data[key];
    var dataToString = Array.isArray(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isBoolean"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isObject"])(value) ? stringify_object__WEBPACK_IMPORTED_MODULE_1___default()(value, {
      singleQuotes: false,
      inlineCharacterLimit: 1024,
      filter: function filter(o, p) {
        return options.ignoreUndefined ? o[p] !== undefined : true;
      }
    }) : "\"".concat(value, "\"");
    return "".concat(acc).concat(key, " : ").concat(dataToString, " ");
  }, '');
}

/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hPQF");
/* harmony import */ var _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("RWDY");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Jsmy");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zCbR");
/* harmony import */ var _store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("apzf");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}















var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_11__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_9__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_6__[/* facetingCriteriaSelector */ "c"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_7__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_9__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_6__[/* filteredProductsSelector */ "g"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_6__[/* filteredProductsCountSelector */ "e"])(state) || 0;
  });
  var facetingQuery = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var profile = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_14__[/* userInfoSelector */ "a"]);
  var isFromAutoComplete = Boolean(facetingQuery.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || facetingQuery.label ? facetingQuery.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload, query) {
    var trackingData = {};

    if (!query || query.type !== _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_5__[/* SUGGESTION_TYPES */ "b"].EDITO) {
      var _profile$loyaltyProgr;

      trackingData.fidelityStatus = (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || '';
      trackingData.resortAdult = nbAdults;
      trackingData.resortChildren = nbKids;
      trackingData.resortDepartureCityCode = departureCity;
      trackingData.resortNightNumber = duration;
      trackingData.resortTotalParticipant = nbParticipants;
      trackingData.resortTransport = departureCity ? 'with Transport' : null;
      trackingData.searchDepartureDate = departureDate ? moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* DATE_FORMAT */ "f"]) : null;
      trackingData.searchDestinationArea = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* DESTINATIONS_FACET_ID */ "n"]);
      trackingData.searchDestinationCountry = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* COUNTRIES_FACET_ID */ "e"]);
      trackingData.searchFilter = withFilter ? 'withFilter' : 'withoutFilter';
      trackingData.searchResorts = products.map(function (product) {
        return {
          resortCode: product.id,
          resortName: product.name,
          resortTrident: product.comfort,
          resortCountry: product.destination ? product.destination.country : null,
          resortRegion: product.destination ? product.destination.area : null,
          resortAdult: nbAdults,
          resortChildren: nbKids,
          resortDepartureCityCode: departureCity,
          resortSeasonType: product.seasonName || 'Summer',
          resortUrlImage: product.image,
          versionBooking: 'responsive',
          resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_13__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
          resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format('YYYY')
        };
      });
    } // $FlowFixMe


    track(_objectSpread(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_10__[/* VIRTUAL_PAGE_LOAD */ "y"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      searchDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* DATE_FORMAT */ "f"]),
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || ''
    }, trackingData), payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "O7yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return optionValidityReducer; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var UNSET_OPTION_VALIDITY = 'UNSET_OPTION_VALIDITY';
var initialState = null;
var optionValidityReducer = function optionValidityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_OPTION_VALIDITY:
      var locale = action.payload.locale;
      return locale.optionValidity;

    case UNSET_OPTION_VALIDITY:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "O94r":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OfKG":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "OouP":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["v"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

/* global window, document */


__webpack_require__("ZVqJ");

__webpack_require__("vuE1");

__webpack_require__("qs2G");

__webpack_require__("i2OK");

__webpack_require__("5iaM");

__webpack_require__("I2c1");

__webpack_require__("60DJ");

__webpack_require__("QRET");

__webpack_require__("bMl7");

__webpack_require__("zSnQ");

__webpack_require__("MRpX");

__webpack_require__("ieZH");

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _propTypes = _interopRequireDefault(__webpack_require__("aWzz"));

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = _interopRequireDefault(__webpack_require__("O94r"));

var _shallowequal = _interopRequireDefault(__webpack_require__("Pu0A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform'; // global variable for all instances

var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = /*#__PURE__*/function (_Component) {
  _inherits(Sticky, _Component);

  var _super = _createSuper(Sticky);

  function Sticky(props, context) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props, context);
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollStart = _this.handleScrollStart.bind(_assertThisInitialized(_this));
    _this.delta = 0;
    _this.stickyTop = 0;
    _this.stickyBottom = 0;
    _this.frozen = false;
    _this.skipNextScrollEvent = false;
    _this.scrollTop = -1;
    _this.bottomBoundaryTarget;
    _this.topTarget;
    _this.subscribers;
    _this.state = {
      top: 0,
      // A top offset from viewport top where Sticky sticks to when scrolling up
      bottom: 0,
      // A bottom offset from viewport top where Sticky sticks to when scrolling down
      width: 0,
      // Sticky width
      height: 0,
      // Sticky height
      x: 0,
      // The original x of Sticky
      y: 0,
      // The original y of Sticky
      topBoundary: 0,
      // The top boundary on document
      bottomBoundary: Infinity,
      // The bottom boundary on document
      status: STATUS_ORIGINAL,
      // The Sticky status
      pos: 0,
      // Real y-axis offset for rendering position-fixed and position-relative
      activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

    };
    return _this;
  }

  _createClass(Sticky, [{
    key: "getTargetHeight",
    value: function getTargetHeight(target) {
      return target && target.offsetHeight || 0;
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(top) {
      // a top argument can be provided to override reading from the props
      top = top || this.props.top || 0;

      if (typeof top === 'string') {
        if (!this.topTarget) {
          this.topTarget = doc.querySelector(top);
        }

        top = this.getTargetHeight(this.topTarget);
      }

      return top;
    }
  }, {
    key: "getTargetBottom",
    value: function getTargetBottom(target) {
      if (!target) {
        return -1;
      }

      var rect = target.getBoundingClientRect();
      return this.scrollTop + rect.bottom;
    }
  }, {
    key: "getBottomBoundary",
    value: function getBottomBoundary(bottomBoundary) {
      // a bottomBoundary can be provided to avoid reading from the props
      var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

      if (_typeof(boundary) === 'object') {
        boundary = boundary.value || boundary.target || 0;
      }

      if (typeof boundary === 'string') {
        if (!this.bottomBoundaryTarget) {
          this.bottomBoundaryTarget = doc.querySelector(boundary);
        }

        boundary = this.getTargetBottom(this.bottomBoundaryTarget);
      }

      return boundary && boundary > 0 ? boundary : Infinity;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        status: STATUS_ORIGINAL,
        pos: 0
      });
    }
  }, {
    key: "release",
    value: function release(pos) {
      this.setState({
        status: STATUS_RELEASED,
        pos: pos - this.state.y
      });
    }
  }, {
    key: "fix",
    value: function fix(pos) {
      this.setState({
        status: STATUS_FIXED,
        pos: pos
      });
    }
    /**
     * Update the initial position, width, and height. It should update whenever children change.
     * @param {Object} options optional top and bottomBoundary new values
     */

  }, {
    key: "updateInitialDimension",
    value: function updateInitialDimension(options) {
      options = options || {};

      if (!this.outerElement || !this.innerElement) {
        return;
      }

      var outerRect = this.outerElement.getBoundingClientRect();
      var innerRect = this.innerElement.getBoundingClientRect();
      var width = outerRect.width || outerRect.right - outerRect.left;
      var height = innerRect.height || innerRect.bottom - innerRect.top;
      ;
      var outerY = outerRect.top + this.scrollTop;
      this.setState({
        top: this.getTopPosition(options.top),
        bottom: Math.min(this.state.top + height, winHeight),
        width: width,
        height: height,
        x: outerRect.left,
        y: outerY,
        bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
        topBoundary: outerY
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(e, ae) {
      if (this.props.shouldFreeze()) {
        return;
      }

      winHeight = ae.resize.height;
      this.updateInitialDimension();
      this.update();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart(e, ae) {
      this.frozen = this.props.shouldFreeze();

      if (this.frozen) {
        return;
      }

      if (this.scrollTop === ae.scroll.top) {
        // Scroll position hasn't changed,
        // do nothing
        this.skipNextScrollEvent = true;
      } else {
        this.scrollTop = ae.scroll.top;
        this.updateInitialDimension();
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e, ae) {
      // Scroll doesn't need to be handled
      if (this.skipNextScrollEvent) {
        this.skipNextScrollEvent = false;
        return;
      }

      scrollDelta = ae.scroll.delta;
      this.scrollTop = ae.scroll.top;
      this.update();
    }
    /**
     * Update Sticky position.
     */

  }, {
    key: "update",
    value: function update() {
      var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

      if (disabled) {
        if (this.state.status !== STATUS_ORIGINAL) {
          this.reset();
        }

        return;
      }

      var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
      // on document from viewport.

      var top = this.scrollTop + this.state.top;
      var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
      // 1. Reset Sticky to the original postion when "top" <= topBoundary
      // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

      if (top <= this.state.topBoundary) {
        // #1
        this.reset();
      } else if (bottom >= this.state.bottomBoundary) {
        // #2
        this.stickyBottom = this.state.bottomBoundary;
        this.stickyTop = this.stickyBottom - this.state.height;
        this.release(this.stickyTop);
      } else {
        if (this.state.height > winHeight - this.state.top) {
          // In this case, Sticky is higher then viewport minus top offset
          switch (this.state.status) {
            case STATUS_ORIGINAL:
              this.release(this.state.y);
              this.stickyTop = this.state.y;
              this.stickyBottom = this.stickyTop + this.state.height;
            // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
            // from ORIGINAL when calling window.scrollTo().
            // break;

            case STATUS_RELEASED:
              // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
              // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
              // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
              this.stickyBottom = this.stickyTop + this.state.height;

              if (delta > 0 && bottom > this.stickyBottom) {
                this.fix(this.state.bottom - this.state.height);
              } else if (delta < 0 && top < this.stickyTop) {
                this.fix(this.state.top);
              }

              break;

            case STATUS_FIXED:
              var toRelease = true;
              var pos = this.state.pos;
              var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
              // 1. it's top will stick to the screen top,
              // 2. it's bottom will stick to the screen bottom,
              // 3. if not the cases above, then it's height gets changed

              if (delta > 0 && pos === this.state.top) {
                // case 1, and scrolling down
                this.stickyTop = top - delta;
                this.stickyBottom = this.stickyTop + height;
              } else if (delta < 0 && pos === this.state.bottom - height) {
                // case 2, and scrolling up
                this.stickyBottom = bottom - delta;
                this.stickyTop = this.stickyBottom - height;
              } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                // case 3
                // This case only happens when Sticky's bottom sticks to the screen bottom and
                // its height gets changed. Sticky should be in RELEASE status and update its
                // sticky bottom by calculating how much height it changed.
                var deltaHeight = pos + height - this.state.bottom;
                this.stickyBottom = bottom - delta + deltaHeight;
                this.stickyTop = this.stickyBottom - height;
              } else {
                toRelease = false;
              }

              if (toRelease) {
                this.release(this.stickyTop);
              }

              break;
          }
        } else {
          // In this case, Sticky is shorter then viewport minus top offset
          // and will always fix to the top offset of viewport
          this.fix(this.state.top);
        }
      }

      this.delta = delta;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.status !== this.state.status && this.props.onStateChange) {
        this.props.onStateChange({
          status: this.state.status
        });
      }

      var arePropsChanged = !(0, _shallowequal.default)(this.props, prevProps);

      if (arePropsChanged) {
        // if the props for enabling are toggled, then trigger the update or reset depending on the current props
        if (prevProps.enabled !== this.props.enabled) {
          if (this.props.enabled) {
            this.setState({
              activated: true
            }, function () {
              _this2.updateInitialDimension();

              _this2.update();
            });
          } else {
            this.setState({
              activated: false
            }, function () {
              _this2.reset();
            });
          }
        } // if the top or bottomBoundary props were changed, then trigger the update
        else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
            this.updateInitialDimension();
            this.update();
          }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var subscribers = this.subscribers || [];

      for (var i = subscribers.length - 1; i >= 0; i--) {
        this.subscribers[i].unsubscribe();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Only initialize the globals if this is the first
      // time this component type has been mounted
      if (!win) {
        win = window;
        doc = document;
        docEl = doc.documentElement;
        docBody = doc.body;
        winHeight = win.innerHeight || docEl.clientHeight;
        M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

        if (M && M.prefixed) {
          canEnableTransforms = M.csstransforms3d;
          TRANSFORM_PROP = M.prefixed('transform');
        }
      } // when mount, the scrollTop is not necessary on the top


      this.scrollTop = docBody.scrollTop + docEl.scrollTop;

      if (this.props.enabled) {
        this.setState({
          activated: true
        });
        this.updateInitialDimension();
        this.update();
      } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


      this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
        useRAF: true
      }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
        useRAF: true,
        enableScrollInfo: true
      }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
        enableResizeInfo: true
      })];
    }
  }, {
    key: "translate",
    value: function translate(style, pos) {
      var enableTransforms = canEnableTransforms && this.props.enableTransforms;

      if (enableTransforms && this.state.activated) {
        style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
      } else {
        style.top = pos + 'px';
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.props.shouldFreeze() && !((0, _shallowequal.default)(this.props, nextProps) && (0, _shallowequal.default)(this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      // TODO, "overflow: auto" prevents collapse, need a good way to get children height
      var innerStyle = {
        position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
        top: this.state.status === STATUS_FIXED ? '0px' : '',
        zIndex: this.props.innerZ
      };
      var outerStyle = {}; // always use translate3d to enhance the performance

      this.translate(innerStyle, this.state.pos);

      if (this.state.status !== STATUS_ORIGINAL) {
        innerStyle.width = this.state.width + 'px';
        outerStyle.height = this.state.height + 'px';
      }

      var outerClasses = (0, _classnames.default)('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
      var innerClasses = (0, _classnames.default)('sticky-inner-wrapper', this.props.innerClass, _defineProperty({}, this.props.innerActiveClass, this.state.status === STATUS_FIXED));
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(outer) {
          _this3.outerElement = outer;
        },
        className: outerClasses,
        style: outerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(inner) {
          _this3.innerElement = inner;
        },
        className: innerClasses,
        style: innerStyle
      }, typeof children === 'function' ? children({
        status: this.state.status
      }) : children));
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  shouldFreeze: function shouldFreeze() {
    return false;
  },
  enabled: true,
  top: 0,
  bottomBoundary: 0,
  enableTransforms: true,
  activeClass: 'active',
  releasedClass: 'released',
  onStateChange: null,
  innerClass: '',
  innerActiveClass: ''
};
/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */

Sticky.propTypes = {
  enabled: _propTypes.default.bool,
  top: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  bottomBoundary: _propTypes.default.oneOfType([_propTypes.default.object, // TODO, may remove
  _propTypes.default.string, _propTypes.default.number]),
  enableTransforms: _propTypes.default.bool,
  activeClass: _propTypes.default.string,
  releasedClass: _propTypes.default.string,
  innerClass: _propTypes.default.string,
  innerActiveClass: _propTypes.default.string,
  className: _propTypes.default.string,
  onStateChange: _propTypes.default.func,
  shouldFreeze: _propTypes.default.func,
  innerZ: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;
module.exports = Sticky;

/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Q4oW":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("zKkv"),
    createBaseEach = __webpack_require__("bz5b");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "QRET":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var DOMIterables = __webpack_require__("YQkA");
var DOMTokenListPrototype = __webpack_require__("k4ez");
var ArrayIteratorMethods = __webpack_require__("I2c1");
var createNonEnumerableProperty = __webpack_require__("g51W");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "QknU":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var REGEXP_SPAN_MATCH = /<span class="match">([^<]*)<\/span>/g;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || item.section || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_2___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getDescription(item) {
  return striptags__WEBPACK_IMPORTED_MODULE_2___default()(item.description || '', '<span>');
}

function getQueryMatches(item) {
  var queryMatches = [];
  var valueMatches = item.value ? item.value.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator = _createForOfIteratorHelper(valueMatches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var valueMatch = _step.value;
      queryMatches.push(valueMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var descriptionMatches = item.description ? item.description.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator2 = _createForOfIteratorHelper(descriptionMatches),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var descriptionMatch = _step2.value;
      queryMatches.push(descriptionMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(new Set(queryMatches));
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_3___default.a('/');

  if (isDynamicCruise(item)) {
    productUrl.segment('c').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["url"].normalizePath((item.product_id || '').split('_').join('/')));
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : item.url;
}

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].ADDRESS;
  }
}

function getImage(item) {
  return isItemResort(item) ? item.immersive_image : item.backgroundurl || '';
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].DEEP_BLUE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WATER_GREEN;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE;
};

function getResultItem(item) {
  return _objectSpread({
    description: getDescription(item),
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    image: getImage(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    queryMatches: getQueryMatches(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "Qosd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POPIN_NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWSLETTER_SUBSCRIPTION_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopinNewsletter; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uDfI");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ljKo");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("UCZK");
/* harmony import */ var _profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("p9RO");
/* harmony import */ var _views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("TnNS");
/* harmony import */ var _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_form_errors_FormErrors__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("8miM");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("/HC4");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("MWZw");
/* harmony import */ var _newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("9KBE");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var POPIN_NEWSLETTER = 'POPIN_NEWSLETTER';
var NEWSLETTER_SUBSCRIPTION_VALIDATION = 'NEWSLETTER_SUBSCRIPTION_VALIDATION';
function PopinNewsletter(_ref) {
  var _ref$checkboxes = _ref.checkboxes,
      checkboxes = _ref$checkboxes === void 0 ? [] : _ref$checkboxes,
      _ref$legalInformation = _ref.legalInformations,
      legalInformations = _ref$legalInformation === void 0 ? [] : _ref$legalInformation,
      onClose = _ref.onClose;
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"]);
  var defaultPayload = {
    categoryGA: 'newsletter',
    actionGA: 'shopping'
  };
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])(defaultPayload);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      submitErrors = _useState[0],
      setSubmitErrors = _useState[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useDispatch */ "d"])();

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]),
      isTablet = _useContext.isTablet;

  var labelConfirmation = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.confirmation.headline'), " \n ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.confirmation.description'));
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    return track({
      labelGA: 'displayPopin'
    });
  }, []);
  return __jsx(_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_21__[/* Modal */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.popin.title'),
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "F"],
    backdropColor: "#000",
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('common.close'),
    onClose: onClose,
    size: "large"
  }, __jsx("div", {
    className: "sm:flex"
  }, __jsx("div", {
    className: "flex-none relative w-full sm:w-12/25 md:w-1/3"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_20__[/* default */ "b"], {
    className: "sm:absolute sm:inset-0",
    dimensions: isTablet ? {
      w: 320,
      h: 700
    } : {
      w: 500,
      h: 200
    },
    imageUrl: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.popin.imageUrl'),
    ratioDisplay: 1 / 2,
    ratioKey: _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"].XS
  })), __jsx("div", {
    className: "m-px25"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_23__[/* Title */ "a"], {
    iconColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__[/* ICONS */ "a"].NEWSLETTER,
    iconSize: "1.5rem",
    id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "F"],
    theme: "title-brand-2"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.popin.title')), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: "my-px10",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.popin.subtitle')
  }), __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Formik */ "d"], {
    validationSchema: _newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_24__[/* subscriptionSchema */ "b"],
    initialValues: _objectSpread({}, checkboxes.reduce(function (newslettersCheckbox, newsletter) {
      newslettersCheckbox[newsletter.id] = false;
      return newslettersCheckbox;
    }, {})),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(values) {
        var response, error;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* submitSubscriptionForm */ "b"])({
                  appContext: appContext,
                  data: Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* formatedData */ "a"])(values),
                  isSubscription: true
                });

              case 2:
                response = _context.sent;
                track({
                  labelGA: 'registrationPopin',
                  user: {
                    neolaneID: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.neolaneId')
                  }
                });
                error = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.error.errorDescription', '');

                if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(error)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", setSubmitErrors([error]));

              case 7:
                dispatch({
                  payload: {
                    toastLabel: labelConfirmation
                  },
                  type: NEWSLETTER_SUBSCRIPTION_VALIDATION
                });
                onClose && onClose();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid;
    return __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Form */ "c"], null, __jsx(_newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_24__[/* NewsletterForm */ "a"], null), checkboxes.map(function (checkbox) {
      return __jsx("div", {
        className: "mt-px15",
        key: checkbox.id
      }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_19__[/* FormikInput */ "a"], {
        label: checkbox.description,
        name: checkbox.id,
        onChange: function onChange(e) {
          return Object(_profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__[/* onCheckboxChange */ "b"])(e.target, setFieldValue);
        },
        type: "checkbox",
        value: checkbox.id
      }));
    }), __jsx("div", {
      className: "mt-px15 text-right"
    }, !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(submitErrors) && __jsx(_frameworks_form_errors_FormErrors__WEBPACK_IMPORTED_MODULE_18__[/* FormErrors */ "a"], {
      texts: submitErrors
    }), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      isDisabled: !isValid,
      type: "submit"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "g"])('newsletter.popin.cta'))));
  }), __jsx("div", {
    className: "mt-px15"
  }, legalInformations.map(function (info) {
    return !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(info.description) ? __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
      key: info.id,
      text: info.description,
      theme: "text-sans-2"
    }) : null;
  })))));
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R3QM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_BOOKING_DETAILS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_BOOKING_DETAILS_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_BOOKING_STAY_FORMALITIES_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_BOOKING_STAY_FORMALITIES_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_BOOKING_TRANSPORT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED; });
/* unused harmony export FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("30WP");


var BOOKING_DETAILS = 'BOOKING_DETAILS';
var BOOKING_ATTENDEES_PACKAGE = 'BOOKING_ATTENDEES_PACKAGE';
var BOOKING_PRICE_AND_PAYMENT = 'BOOKING_PRICE_AND_PAYMENT';
var BOOKING_STAY_FORMALITIES = 'BOOKING_STAY_FORMALITIES';
var BOOKING_TRANSPORT = 'BOOKING_TRANSPORT';
var PACKAGE_UPSELL_INFORMATIONS_MODAL = 'PACKAGE_UPSELL_INFORMATIONS_MODAL';
var FETCH_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_DETAILS);
var CLEAR_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_DETAILS);
var FETCH_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var CLEAR_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var CLEAR_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_STAY_FORMALITIES);
var CLEAR_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(BOOKING_TRANSPORT);
var FETCH_BOOKING_TRANSPORT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_TRANSPORT);
var CLEAR_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_TRANSPORT);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "b"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* open */ "c"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);

/***/ }),

/***/ "R3TX":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("zWgn"),
    overRest = __webpack_require__("UAs9"),
    setToString = __webpack_require__("7Pat");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "R5u7":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("pPzx"),
    isArrayLike = __webpack_require__("9y2L"),
    isIndex = __webpack_require__("pnw1"),
    isObject = __webpack_require__("tQYX");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var flexibility = _ref11.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RNvQ":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("tQYX"),
    now = __webpack_require__("ENE1"),
    toNumber = __webpack_require__("nvU9");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "RWDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUGGESTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalSearchSuggestionsList; });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("0IQ5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  EDITO: 'edito',
  RESORT: 'resort'
};
var GlobalSearchSuggestionsList = function GlobalSearchSuggestionsList(_ref) {
  var blockSuggestions = _ref.blockSuggestions,
      blockType = _ref.blockType,
      isDesktop = _ref.isDesktop,
      onClick = _ref.onClick;
  var maxNumberOfSuggestions = !isDesktop || blockType === SUGGESTION_TYPES.EDITO ? 3 : 5;

  var onPress = function onPress(suggestion) {
    onClick(suggestion);
  };

  return __jsx("ul", {
    className: "reset-list mb-px25"
  }, blockSuggestions.slice(0, maxNumberOfSuggestions).map(function (suggestion) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        link = suggestion.link,
        queryMatches = suggestion.queryMatches,
        type = suggestion.type;
    return {
      description: description,
      image: image,
      label: striptags__WEBPACK_IMPORTED_MODULE_3___default()(label),
      link: link,
      queryMatches: queryMatches,
      type: type
    };
  }).map(function (suggestion, index) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        _suggestion$queryMatc = suggestion.queryMatches,
        queryMatches = _suggestion$queryMatc === void 0 ? [] : _suggestion$queryMatc,
        type = suggestion.type;

    if (type === SUGGESTION_TYPES.EDITO) {
      var defaultPicture = {
        alt: label,
        src: image
      };
      var stripedDescription = striptags__WEBPACK_IMPORTED_MODULE_3___default()(description || '');
      var truncatedDescription = stripedDescription.length > 65 ? "".concat(stripedDescription.substring(0, 62), "...") : stripedDescription;
      var decoratedDescription = truncatedDescription;
      queryMatches.forEach(function (queryMatch) {
        decoratedDescription = decoratedDescription.replace(new RegExp("(".concat(queryMatch, ")"), 'ig'), "<span class='match'>$1</span>");
      });
      return __jsx("li", {
        key: label,
        className: "flex mb-px30 cursor-pointer",
        "data-testid": "".concat(type, "-link"),
        onClick: function onClick() {
          return onPress(suggestion);
        },
        onKeyUp: function onKeyUp(event) {
          /* Space & Enter */
          if (event.keyCode === 32 || event.keyCode === 13) {
            onPress(suggestion);
          }
        }
      }, isDesktop && __jsx("div", {
        className: "relative rtl:pr-px20 w-1/3"
      }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"], {
        altMsg: defaultPicture.alt,
        imageUrl: defaultPicture.src,
        key: defaultPicture.src,
        groupKey: "thumbnails",
        ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].XL,
        ratioDisplay: 1 / 3,
        hasLazyLoading: false
      })), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('flex flex-col flex-start overflow-hidden', {
          'w-1/2': isDesktop,
          'w-full': !isDesktop
        }),
        role: "button",
        tabIndex: index
      }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
        className: "leading-tight font-bold text-lg",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].GRAY,
        hLevel: 3,
        role: "presentation",
        theme: "none"
      }, label), __jsx("div", {
        className: "leading-tight text-base text-gray decorator-match pt-px10 flex-1" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: decoratedDescription
        }
      }), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('font-bold text-sm text-gray underline', {
          'pt-px10': !isDesktop
        })
      }, Object(lodash__WEBPACK_IMPORTED_MODULE_1__["upperFirst"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('common.readMoreLabel')))));
    }

    return __jsx("li", {
      key: label,
      className: "flex mb-px10",
      "data-testid": "".concat(type, "-link")
    }, __jsx("span", {
      role: "button",
      tabIndex: index,
      className: "cursor-pointer font-bold leading-tight text-gray text-xl lg:text-2xl",
      onClick: function onClick() {
        return onPress(suggestion);
      },
      onKeyUp: function onKeyUp(event) {
        /* Space & Enter */
        if (event.keyCode === 32 || event.keyCode === 13) {
          onPress(suggestion);
        }
      }
    }, label));
  }));
};

/***/ }),

/***/ "RWUY":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("pfAP");
var isSymbol = __webpack_require__("km0D");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n  }\n");

/***/ }),

/***/ "SRps":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "TVUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TrackingPageLoad_TrackingPageLoad; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.jsx


var __jsx = react["createElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var tracking_component_TrackingComponent = function TrackingComponent(_ref) {
  var children = _ref.children,
      track = _ref.track,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "track"]);

  var appContext = react["useContext"](ReactAppContext["b" /* default */]);
  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var leadScoring = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]); // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided

  var siteSection = props.siteSection || pageContext.siteSection;
  react["useEffect"](function () {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      // $FlowFixMe
      id: props.resortCode,
      be: false,
      timestamp: Date.now()
    });
  }, [props.pageName]);
  react["useEffect"](function () {
    // pageId is not actually needed here, since the categoryGA is only used for events
    // not for page loading (the analytics team doesn't care), but it makes our API more
    // consistent
    tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      siteSection: siteSection
    }, siteSection && siteSection.includes(constants["l" /* PLE */]) ? {
      BE_customerStatus: appContext.customerStatus
    } : undefined), leadScoring ? {
      leadScoring: leadScoring
    } : null), appContext, pageContext.pageId);

    if (track) {
      track();
    }
  }, [props.pageName]);
  return __jsx("div", null, children);
};

/* harmony default export */ var tracking_component = (tracking_component_TrackingComponent);
// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.js

/* harmony default export */ var tracking_tracking_component = (tracking_component);
// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx


var TrackingPageLoad_jsx = react_default.a.createElement;

function TrackingPageLoad_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TrackingPageLoad_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TrackingPageLoad_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TrackingPageLoad_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TrackingPageLoad_TrackingPageLoad = function TrackingPageLoad(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackingPageLoadAppendSuffix = location.queryParams.trackingPageLoadAppendSuffix;
  var profile = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  function getTrackingProps() {
    var _profile$loyaltyProgr;

    var baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, props.trackingKey ?
    /**
     * We need to omit ski data because in case of 2 bookings from the same session,
     * when the first one has ski equipments and second one has none,
     * the second one get wrong ski data from locale storage
     * In case of new ski data exist, it will be added from props anyway
     */
    Object(lodash["omit"])(tracking_storage_api["a" /* get */](props.trackingKey), 'skiEquipment', 'skiingEquipment', 'snowboardingEquipment', 'hikingEquipment') : {}), {}, {
      event: constants["y" /* VIRTUAL_PAGE_LOAD */],
      fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
    }, Object(lodash["omit"])(props, 'children', 'location', 'history', 'match', 'trackingKey'));

    if (trackingPageLoadAppendSuffix) {
      baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, baseProps), {}, {
        pageName: "".concat(baseProps.pageName, "_").concat(trackingPageLoadAppendSuffix)
      });
    }

    if (props.pageName === constants["b" /* BE_OPTION_CONFIRMATION */]) {
      return Object(lodash["omit"])(baseProps, ['upsellExcursion', 'upsellRevenue', 'donation', 'paymentDeposit', 'paymentMethod', 'paymentPlan', 'paymentStatus', 'paymentType', 'donation']);
    }

    return baseProps;
  }

  var trackingProps = getTrackingProps();
  react_default.a.useEffect(function () {
    if (props.event) {
      tracking_storage_api["b" /* set */](trackingProps);
    }
  }, [props.event]);
  return TrackingPageLoad_jsx(tracking_tracking_component, Object(esm_extends["a" /* default */])({}, trackingProps, {
    track: props.track
  }));
};

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhenIsOpen: true
          });
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaDisplayContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "TnNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitSubscriptionForm; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Nhxn");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function filterObjectWithMapping(data) {
  var rules = {
    email: 'email',
    civility: 'gender',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions',
    conditions: 'legalInformations'
  };
  return Object.keys(data).reduce(function (result, currentAttribute) {
    var mappedField = rules[currentAttribute];

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }

    return result;
  }, {});
}

var LIST_INPUTS = ['civility', 'firstName', 'lastName', 'email', 'unicodeFirstName', 'unicodeLastName', 'conditions'];
var formatedData = function formatedData(values) {
  var subscriptions = Object.keys(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["omitBy"])(values, function (value) {
    return value === false;
  }));
  return _objectSpread(_objectSpread({}, values), {}, {
    subscriptions: lodash__WEBPACK_IMPORTED_MODULE_1__["without"].apply(void 0, [subscriptions].concat(LIST_INPUTS))
  });
};
function submitSubscriptionForm(_ref) {
  var appContext = _ref.appContext,
      subscriptionId = _ref.subscriptionId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      isSubscription = _ref.isSubscription;
  var filteredData = filterObjectWithMapping(data);

  if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }

  filteredData.isSubscription = isSubscription;
  var selection = Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__[/* attributesToString */ "a"])(filteredData);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery("mutation RootMutationType {subscription (".concat(selection, ") { id neolaneId error { errorDescription }}}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* NEWSLETTER_SUBMIT_SUBSCRIPTION */ "Hc"]
  });
}

/***/ }),

/***/ "U9LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var buildings = [{
  id: 'floors',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['!=', 'building_id', ''],
  interactive: false,
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(47, 43%, 55%)'], [1, 'hsl(48, 45%, 62%)'], [2, 'hsl(48, 49%, 69%)'], [3, 'hsl(47, 55%, 76%)'], [4, 'hsl(49, 64%, 84%)'], [5, 'hsl(49, 64%, 84%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['<=', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current_dimmed',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['>', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 0.3,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_highlight',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['==', 'building_id', ''],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (buildings);

/***/ }),

/***/ "UAs9":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("zaNA");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_PROMO_CODE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INSURANCE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INIT_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TOGGLE_TERMS; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_DELETED = 'INSURANCE_DELETED';
var INSURANCE_ADDED = 'INSURANCE_ADDED';
var INIT_INSURANCES = 'INIT_INSURANCES';
var TOGGLE_TERMS = 'TOGGLE_TERMS';

/***/ }),

/***/ "Uey1":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "Uq20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTING_CHANGE; });
var ROUTING_CHANGE = 'ROUTING_CHANGE';

/***/ }),

/***/ "Uqkn":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");
var inspectSource = __webpack_require__("/ExG");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "V/va":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (it instanceof Constructor) return it;
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
};


/***/ }),

/***/ "V8Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),

/***/ "VrMI":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var IndexedObject = __webpack_require__("F9U4");
var toObject = __webpack_require__("A+R+");
var toLength = __webpack_require__("DOIJ");
var arraySpeciesCreate = __webpack_require__("kjCq");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ldK3");







var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_CALENDAR */ "yd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_BOOKABLE_DATES */ "xd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_0___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_5__[/* getSpecificQueryParam */ "j"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_0___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_1__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* momentFromApiDate */ "h"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* momentFromApiDate */ "h"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "WSQK":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "X95k":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var className = _ref.className,
      _ref$discount = _ref.discount,
      discount = _ref$discount === void 0 ? {} : _ref$discount,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? {} : _ref$i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || i18n.defaultLabel || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || i18n.defaultColor || null;
  return Object(lodash["get"])(discount, 'amount.value') ? __jsx("div", {
    className: classnames_default()(className, 'bg-current font-bold p-px5 text-center text-sm uppercase'),
    style: {
      backgroundColor: backgroundColor
    }
  }, __jsx("span", {
    className: "text-white"
  }, offerName)) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none flex-shrink items-center text-".concat(color, " rtl:text-right")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-no-wrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx
var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].EMERALD,
      icon: icons["a" /* ICONS */].SMALL_CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].SMALL_CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var id = _ref2.id,
        ageMin = _ref2.ageMin,
        ageMax = _ref2.ageMax,
        availability = _ref2.availability,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-px10 reset-paragraph text-base text-gray-darker"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal ml-px5 text-sm', {
        'text-blue': isIncluded,
        'text-red': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["g" /* t */])('common.included') : Object(src_i18n["g" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;
  if (!isEligible) return ProductComparison_jsx("div", {
    className: "relative"
  }, ProductComparison_jsx("div", {
    className: "absolute bg-overlay-white-60 flex font-bold items-center justify-center inset-0 p-px20 text-base text-center z-1"
  }, eligibilityLabel));
  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'absolute', 'z-1', 'inset-0', 'w-full', 'h-full', 'reset-button')
  }, buttonProps), ProductComparison_jsx("span", {
    className: classnames_default()('bg-overlay-gray-darker-40', 'flex', 'items-center', 'justify-center', 'p-px15', 'text-white', 'rounded-tiny', 'h-full', 'w-full', {
      'cursor-pointer': isSelectable
    })
  }, isSelectable && ProductComparison_jsx("span", {
    className: classnames_default()('flex', 'flex-col', 'items-center', 'opacity-100', 'p-px10', 'rounded-full', 'border-2', 'transition-colors', {
      'bg-transparent border-white': !isSelected
    }, {
      'bg-emerald border-emerald': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx

var ProductThumbnail_jsx = react_default.a.createElement;










var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var ProductThumbnail_ProductThumbnail = /*#__PURE__*/Object(react["memo"])(function ProductThumbnail(_ref) {
  var closedLabel = _ref.closedLabel,
      className = _ref.className,
      hasBorder = _ref.hasBorder,
      hasTransport = _ref.hasTransport,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      openingSoonLabel = _ref.openingSoonLabel,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$productTags = _ref.productTags,
      productTags = _ref$productTags === void 0 ? [] : _ref$productTags,
      _ref$tagsColor = _ref.tagsColor,
      tagsColor = _ref$tagsColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$tagsColor,
      _ref$tagsTextColor = _ref.tagsTextColor,
      tagsTextColor = _ref$tagsTextColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref$tagsTextColor,
      transportLabel = _ref.transportLabel,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? icons["a" /* ICONS */].TRANSPORT : _ref$transportIcon,
      isSliderDisabled = _ref.isSliderDisabled,
      hasLazyLoading = _ref.hasLazyLoading;
  var TagName = isLinkDisabled ? 'div' : DynamicLink["a" /* default */];
  var defaultPicture = pictures[0] || {};
  return ProductThumbnail_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('block relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? ProductThumbnail_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasInsetBorder: hasBorder,
    hasLazyLoading: true,
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL,
    ratioDisplay: 1 / 3
  }) : ProductThumbnail_jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    className: classnames_default()({
      'inset-border-after': hasBorder
    }),
    hasInsetBorder: hasBorder,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: ratios_utils["a" /* default */].XL,
    ratioDisplay: 1 / 3,
    hasLazyLoading: hasLazyLoading
  }), hasTransport && ProductThumbnail_jsx("div", {
    className: "bg-blue inline-flex items-center overflow-hidden p-px10 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-px20 rtl:mr-px20 rounded-tiny font-brand",
    "data-testid": "ProductThumbnail-transport"
  }, ProductThumbnail_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-px5",
    name: transportIcon,
    width: "calc(10rem / 16)"
  }), ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-transportLabel"
  }, transportLabel)), openingStatus === OPENING_STATUS.OPENING_SOON && ProductThumbnail_jsx("div", {
    className: "bg-orange inline-flex items-center overflow-hidden p-px10 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-px20 rtl:mr-px20 rounded-tiny font-bold",
    "data-testid": "ProductThumbnail-openingSoon"
  }, ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-openingSoonlabel"
  }, openingSoonLabel)), openingStatus === OPENING_STATUS.CLOSED && ProductThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-tiny text-white text-xl uppercase",
    "data-testid": "ProductThumbnail-closed"
  }, ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-closedLabel"
  }, closedLabel)), !!(productTags === null || productTags === void 0 ? void 0 : productTags.length) && ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-bottomTags",
    className: classnames_default()('absolute flex leading-one font-brand uppercase left-1/2 bottom-0 rounded-tiny text-center text-xs -translate-x-50 whitespace-no-wrap max-w-9/10 truncate z-1')
  }, productTags.map(function (productTag, i) {
    return ProductThumbnail_jsx("div", {
      className: classnames_default()('p-px10 mb-px20 truncate', "bg-".concat(tagsColor, " text-").concat(tagsTextColor), {
        'rtl:ml-px10': i !== 0
      }),
      key: i
    }, productTag);
  })));
});
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx



var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice;

  var _ref$callToAction = _ref.callToAction,
      callToAction = _ref$callToAction === void 0 ? {} : _ref$callToAction,
      childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      thumbnail = _ref.thumbnail,
      url = _ref.url,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["g" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["g" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor((minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && Object(lodash["isEmpty"])(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: classnames_default()(className, 'relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx("div", {
    className: "relative"
  }, Product_jsx("div", {
    "data-testid": "Product-Header-Wrapper",
    className: "relative"
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx("div", {
    className: "bg-white p-px10 z-2 absolute rtl:left-0 -mt-px20 rtl:ml-px10 rounded-tiny font-brand border-1 border-turquoise shadow-xs",
    "data-testid": "Product-departure"
  }, Product_jsx("div", {
    className: "leading-tight text-base text-black",
    "data-testid": "Product-departureLabel"
  }, departureDateOn)), hasDiscount && // $FlowFixMe
  Product_jsx(OfferDiscount_OfferDiscount, Object(esm_extends["a" /* default */])({}, offerDiscount, {
    className: "absolute opacity-75 inset-x-0 z-1"
  })), Product_jsx(ProductThumbnail_ProductThumbnail, Object(esm_extends["a" /* default */])({
    className: "rounded-tiny overflow-hidden"
  }, thumbnail, {
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["g" /* t */])('common.next'),
    previousLabel: Object(src_i18n["g" /* t */])('common.previous')
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: "pt-px20",
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["d" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "border-1 flex p-px10 rounded-tiny text-sm"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    color: colors["a" /* COLORS */].BLACK,
    name: icons["a" /* ICONS */].SMALL_WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "bg-turquoise focus:bg-turquoise-active hover:bg-turquoise-active cursor-pointer font-bold leading-one p-px10 flex rounded-tiny text-initial text-sm text-white transition-colors",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["g" /* t */])('faceting.availabilities.enterBirthdate')), !!(callToAction === null || callToAction === void 0 ? void 0 : callToAction.label) && Product_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, callToAction, {
    className: "mt-px10 w-full",
    colorBg: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    colorBorder: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    isDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  }), callToAction.label), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !Object(lodash["isEmpty"])(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XmKO":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var setPrototypeOf = __webpack_require__("iBXc");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "Xvk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID; });
var FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID = 'FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID';

/***/ }),

/***/ "XywU":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'reset-button w-full',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-px5',
    thContent: 'arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after mb-px20 rounded-tiny shadow-md',
    thCloseButton: 'absolute p-px5 reset-button rtl:right-0 text-gray-dark',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'reset-button w-full sm:w-auto',
    thContainer: 'absolute top-full fadeIn mt-px5 rounded-tiny',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-px5 reset-button rtl:right-0 text-gray-dark',
    thCloseIconWidth: '0.875rem'
  },
  fancy: {
    thTrigger: 'reset-button',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-px5',
    thContent: 'arrow-bg arrow-bg-blue arrow-downLeft arrow-large arrow-white bg-white border-1 border-blue filter-drop-shadow-after mb-px20 rounded-tiny shadow-md',
    thCloseButton: 'absolute leading-none p-px10 reset-button rtl:right-0 top-0 text-gray-dark',
    thCloseIconWidth: '0.625rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      containerStyle = _ref.containerStyle,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", {
    className: classnames_default()(className, 'relative')
  }, __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();
      setIsVisible(!isVisible);
      !isVisible && _onClick && _onClick(e);
    },
    type: "button"
  }, children), isVisible && __jsx(react["Fragment"], null, isDesktop ? __jsx(ClickOutside["a" /* ClickOutside */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(thContainer, containerClassName),
    onClick: function onClick() {
      return setIsVisible(false);
    }
  }, containerStyle ? {
    style: containerStyle
  } : {}), __jsx("div", {
    className: classnames_default()(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SMALL_CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["g" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "Y8c0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var userAgent = __webpack_require__("xe/R");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "YQkA":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "YpBQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("y/9h"),
    isFlattenable = __webpack_require__("oCTG");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "ZHK4":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__("1TCz");
      }
    ]);
  

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZP80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FETCH_PREBOOKING_TRAVELERS; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetchPrebookingTravelers; });

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js


function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["a" /* getCxoAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js





var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["cb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("RPju");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;









var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_8__[/* ReactPageContext */ "a"]),
      pageType = _useContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.buttonLabel');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    className: "p-px20",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].GRAY_DARKER,
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.roomAvailability')].join(' '),
    theme: "text-sans-2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-gray-light p-px20"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap sm:justify-center max-w-full reset-paragraph text-center text-gray-darker text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "font-brand rtl:ml-px5 text-blue text-md"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].WATER_GREEN,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "mt-px10",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BOOKING,
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZVqJ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var aConstructor = __webpack_require__("jCye");
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var bind = __webpack_require__("C56r");
var fails = __webpack_require__("fhLv");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "ZiN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var IS_PURE = __webpack_require__("SRps");
var FunctionName = __webpack_require__("mu8A");
var isCallable = __webpack_require__("ANQd");
var createIteratorConstructor = __webpack_require__("oScl");
var getPrototypeOf = __webpack_require__("yvHl");
var setPrototypeOf = __webpack_require__("iBXc");
var setToStringTag = __webpack_require__("CGO5");
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");
var IteratorsCore = __webpack_require__("JpEK");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "Znn2":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("ep/x");
var defineProperties = __webpack_require__("HKx7");
var enumBugKeys = __webpack_require__("WSQK");
var hiddenKeys = __webpack_require__("qXr/");
var html = __webpack_require__("QknU");
var documentCreateElement = __webpack_require__("a4SZ");
var sharedKey = __webpack_require__("mmil");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "ZoVA":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ZoZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PYR_MAP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_POLYGONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIGHLIGHT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_BUILDING_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_MAP_FLOOR_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIT_BOUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("U9LJ");
/* harmony import */ var _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ogu6");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PYR_MAP_ERROR = 'PYR_MAP_ERROR';
var LOAD_STYLE = 'LOAD_STYLE';
var LOAD_POLYGONS = 'LOAD_POLYGONS';
var SET_RESORT = 'SET_RESORT_PYR';
var HIGHLIGHT_BUILDING = 'HIGHLIGHT_BUILDING';
var TOGGLE_BUILDING_SELECTION = 'TOGGLE_BUILDING_SELECTION';
var RESET_BUILDING = 'RESET_BUILDING';
var SELECT_MAP_FLOOR_LEVEL = 'SELECT_MAP_FLOOR_LEVEL';
var FIT_BOUNDS = 'FIT_BOUNDS';
var initialState = {
  mapStyle: null,
  maxBounds: null,
  amenities: [],
  geoJSON: null,
  currentBounds: null,
  highlightedBuildingId: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PYR_MAP_ERROR:
      {
        var error = action.payload.error;
        return _objectSpread(_objectSpread({}, state), {}, {
          error: error
        });
      }

    case LOAD_STYLE:
      {
        var mapStyle = action.payload.mapStyle;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: mapStyle
        });
      }

    case SET_RESORT:
      {
        var resortData = action.payload.resortData;

        if (!resortData) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          baseViewport: resortData.initialViewport,
          targetViewport: resortData.targetViewport,
          maxBounds: resortData.maxBounds,
          amenities: resortData.amenities.features
        });
      }

    case LOAD_POLYGONS:
      {
        var geoJSON = action.payload.geojson;
        var _mapStyle = state.mapStyle;
        var layers = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_mapStyle.layers || []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"] || []));
        var layerIndexes = {
          floors: layers.findIndex(function (layer) {
            return layer.id === 'floors';
          }),
          floorsCurrent: layers.findIndex(function (layer) {
            return layer.id === 'floors_current';
          }),
          floorsCurrentDimmed: layers.findIndex(function (layer) {
            return layer.id === 'floors_current_dimmed';
          }),
          floorsHighlight: layers.findIndex(function (layer) {
            return layer.id === 'floors_highlight';
          })
        };
        var newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(state.mapStyle);
        newMapStyle.sources.buildingsSource = {
          type: 'geojson',
          data: geoJSON
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          geoJSON: geoJSON,
          layerIndexes: layerIndexes,
          mapStyle: _objectSpread(_objectSpread({}, newMapStyle), {}, {
            layers: layers
          })
        });
      }

    case _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__[/* SELECT_BUILDING */ "i"]:
      {
        var buildingId = action.payload.buildingId;
        var _layerIndexes = state.layerIndexes,
            _mapStyle2 = state.mapStyle;

        var _newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle2);

        _newMapStyle.layers[_layerIndexes.floors].filter[2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrent].filter[1][2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrentDimmed].filter[1][2] = buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle2), _newMapStyle)
        });
      }

    case RESET_BUILDING:
      {
        var _layerIndexes2 = state.layerIndexes,
            _mapStyle3 = state.mapStyle;

        var _newMapStyle2 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle3);

        _newMapStyle2.layers[_layerIndexes2.floors].filter[2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrent].filter[1][2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrentDimmed].filter[1][2] = '';
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle3), _newMapStyle2),
          highlightedBuildingId: ''
        });
      }

    case SELECT_MAP_FLOOR_LEVEL:
      {
        var _layerIndexes3 = state.layerIndexes,
            _mapStyle4 = state.mapStyle;
        var level = action.payload.level;

        var _newMapStyle3 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle4);

        _newMapStyle3.layers[_layerIndexes3.floorsCurrent].filter[2][2] = level;
        _newMapStyle3.layers[_layerIndexes3.floorsCurrentDimmed].filter[2][2] = level;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle4), _newMapStyle3)
        });
      }

    case HIGHLIGHT_BUILDING:
      {
        var _layerIndexes4 = state.layerIndexes,
            _mapStyle5 = state.mapStyle;
        var _buildingId = action.payload.buildingId;

        var _newMapStyle4 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle5);

        _newMapStyle4.layers[_layerIndexes4.floorsHighlight].filter[2] = _buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle5), _newMapStyle4),
          highlightedBuildingId: _buildingId
        });
      }

    case TOGGLE_BUILDING_SELECTION:
      {
        var _layerIndexes5 = state.layerIndexes,
            _mapStyle6 = state.mapStyle;
        var allow = action.payload.allow;

        var _newMapStyle5 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle6);

        _newMapStyle5.layers[_layerIndexes5.floors].interactive = allow;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _newMapStyle5
        });
      }

    case FIT_BOUNDS:
      {
        var bounds = action.payload.bounds;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentBounds: bounds
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "ZuH9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var isArrayIteratorMethod = __webpack_require__("zcYo");
var toLength = __webpack_require__("DOIJ");
var bind = __webpack_require__("mwRp");
var getIterator = __webpack_require__("cUh7");
var getIteratorMethod = __webpack_require__("MU85");
var iteratorClose = __webpack_require__("yUod");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(String(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "a4SZ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("y316");








function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
        var _yield$fetchAutocompl, _yield$fetchAutocompl2, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _yield$fetchAutocompl = _context.sent;
                _yield$fetchAutocompl2 = _yield$fetchAutocompl.answers;
                answers = _yield$fetchAutocompl2 === void 0 ? [] : _yield$fetchAutocompl2;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__[/* getResultItem */ "b"]).sort(function (_ref2, _ref3) {
                  var productIdA = _ref2.productId;
                  var productIdB = _ref3.productId;

                  if (productIdA && !productIdB) {
                    return -1;
                  }

                  if (!productIdA && productIdB) {
                    return 1;
                  }

                  return 0;
                });
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "bFjY":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW"),
    isArrayLike = __webpack_require__("9y2L");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "bJ4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isTokenValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleInvalidToken; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("L7OA");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6jSF");




var isTokenValid = function isTokenValid(userInfo) {
  return userInfo && moment__WEBPACK_IMPORTED_MODULE_0___default()(userInfo.expirationDate, 'X').startOf('second').isAfter();
};
var handleInvalidToken = function handleInvalidToken(_ref) {
  var appContext = _ref.appContext,
      currentUri = _ref.currentUri,
      res = _ref.res,
      userInfo = _ref.userInfo;
  var redirectUri = Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* isCxoSellerContext */ "n"])(currentUri.search()) ? Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildSellerSigninUrl */ "e"])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildErrorUrl */ "c"])(currentUri.toString(), appContext.locale)
  }) : Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildSigninUrl */ "f"])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildErrorUrl */ "c"])(currentUri.toString(), appContext.locale),
    isQuickLoginFirst: currentUri.toString().includes("provider=".concat(_index__WEBPACK_IMPORTED_MODULE_3__[/* QUICK_LOGIN_QUERY_PARAM */ "a"])) || Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.isQuickLoginFirst')
  }); // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {

  if (!appContext.isUserLogged && !appContext.isUserQuickLogged && !appContext.isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].setLocation(redirectUri);
    }
  } else if ((appContext.isUserLogged || appContext.isUserQuickLogged) && !isTokenValid(userInfo)) {
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].setLocation(redirectUri);
  }
};

/***/ }),

/***/ "bMl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("HnW7");
var redefineAll = __webpack_require__("Bg8+");
var InternalMetadataModule = __webpack_require__("wKkN");
var collection = __webpack_require__("IYAN");
var collectionWeak = __webpack_require__("LFxm");
var isObject = __webpack_require__("1YFU");
var enforceIternalState = __webpack_require__("9jKB").enforce;
var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "bz5b":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "c7Qd":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIsNaN = __webpack_require__("z9Jh"),
    strictIndexOf = __webpack_require__("n1QJ");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("45yR");




var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isKidMinor */ "g"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cUh7":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");
var anObject = __webpack_require__("ep/x");
var getIteratorMethod = __webpack_require__("MU85");

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};


/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE = 'CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "dGB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_CLASS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANIES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LAYOVERS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIME_RANGES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CABIN_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CABIN_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FLIGHT_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLIGHT_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLIGHT_CLASS_ALIZEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FLIGHT_CLASS_EMERALD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FLIGHT_CLASS_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FLIGHT_CLASS_PREMIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ZERO_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ONE_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TWO_LAYOVERS_ICON; });
var CABIN_CLASS_CATEGORY = 'cabinClass';
var COMPANIES_CATEGORY = 'companies';
var LAYOVERS_CATEGORY = 'layovers';
var TIME_RANGES_CATEGORY = 'timeRanges';
var CABIN_CLASS_ECO = 'ECO';
var CABIN_CLASS_BUSINESS = 'BUSINESS';
var FLIGHT_CLASS_ECO = 'ECO';
var FLIGHT_CLASS_BUSINESS = 'BUS';
var FLIGHT_CLASS_ALIZEE = 'EC+';
var FLIGHT_CLASS_EMERALD = 'DIB';
var FLIGHT_CLASS_FIRST = 'FIR';
var FLIGHT_CLASS_PREMIUM = 'PRE';
var ZERO_LAYOVERS_ICON = 'noStop';
var ONE_LAYOVERS_ICON = '1Stop';
var TWO_LAYOVERS_ICON = '2Stops';

/***/ }),

/***/ "dIgr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": [
		"tGlX",
		49
	],
	"./de-at": [
		"s+uk",
		47
	],
	"./de-at.js": [
		"s+uk",
		47
	],
	"./de-ch": [
		"u3GI",
		48
	],
	"./de-ch.js": [
		"u3GI",
		48
	],
	"./de.js": [
		"tGlX",
		49
	],
	"./en-SG": [
		"zavE",
		50
	],
	"./en-SG.js": [
		"zavE",
		50
	],
	"./en-au": [
		"Dmvi",
		51
	],
	"./en-au.js": [
		"Dmvi",
		51
	],
	"./en-ca": [
		"OIYi",
		52
	],
	"./en-ca.js": [
		"OIYi",
		52
	],
	"./en-gb": [
		"Oaa7",
		53
	],
	"./en-gb.js": [
		"Oaa7",
		53
	],
	"./en-ie": [
		"4dOw",
		54
	],
	"./en-ie.js": [
		"4dOw",
		54
	],
	"./en-il": [
		"czMo",
		55
	],
	"./en-il.js": [
		"czMo",
		55
	],
	"./en-nz": [
		"b1Dy",
		56
	],
	"./en-nz.js": [
		"b1Dy",
		56
	],
	"./es": [
		"iYuL",
		59
	],
	"./es-do": [
		"CjzT",
		57
	],
	"./es-do.js": [
		"CjzT",
		57
	],
	"./es-us": [
		"Vclq",
		58
	],
	"./es-us.js": [
		"Vclq",
		58
	],
	"./es.js": [
		"iYuL",
		59
	],
	"./fr": [
		"nyYc",
		62
	],
	"./fr-ca": [
		"2fjn",
		60
	],
	"./fr-ca.js": [
		"2fjn",
		60
	],
	"./fr-ch": [
		"Dkky",
		61
	],
	"./fr-ch.js": [
		"Dkky",
		61
	],
	"./fr.js": [
		"nyYc",
		62
	],
	"./he": [
		"x6pH",
		63
	],
	"./he.js": [
		"x6pH",
		63
	],
	"./id": [
		"UDhR",
		64
	],
	"./id.js": [
		"UDhR",
		64
	],
	"./it": [
		"bpih",
		66
	],
	"./it-ch": [
		"bxKX",
		65
	],
	"./it-ch.js": [
		"bxKX",
		65
	],
	"./it.js": [
		"bpih",
		66
	],
	"./ja": [
		"B55N",
		67
	],
	"./ja.js": [
		"B55N",
		67
	],
	"./ko": [
		"Ivi+",
		68
	],
	"./ko.js": [
		"Ivi+",
		68
	],
	"./nl": [
		"+s0g",
		70
	],
	"./nl-be": [
		"2ykv",
		69
	],
	"./nl-be.js": [
		"2ykv",
		69
	],
	"./nl.js": [
		"+s0g",
		70
	],
	"./pt": [
		"8mBD",
		72
	],
	"./pt-br": [
		"0tRk",
		71
	],
	"./pt-br.js": [
		"0tRk",
		71
	],
	"./pt.js": [
		"8mBD",
		72
	],
	"./ru": [
		"lXzo",
		73
	],
	"./ru.js": [
		"lXzo",
		73
	],
	"./th": [
		"EOgW",
		74
	],
	"./th.js": [
		"EOgW",
		74
	],
	"./tr": [
		"DoHr",
		75
	],
	"./tr.js": [
		"DoHr",
		75
	],
	"./uk": [
		"raLr",
		76
	],
	"./uk.js": [
		"raLr",
		76
	],
	"./zh-cn": [
		"XDpg",
		77
	],
	"./zh-cn.js": [
		"XDpg",
		77
	],
	"./zh-tw": [
		"kOpN",
		78
	],
	"./zh-tw.js": [
		"kOpN",
		78
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dIgr";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "dNjr":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("F9U4");
var requireObjectCoercible = __webpack_require__("4gXF");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "dnX/":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "eGzU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var tryToString = __webpack_require__("xS1b");

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "eHpp":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseGet = __webpack_require__("w2Tz"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    baseSortBy = __webpack_require__("4jPf"),
    baseUnary = __webpack_require__("SU8Q"),
    compareMultiple = __webpack_require__("5WP5"),
    identity = __webpack_require__("zWgn"),
    isArray = __webpack_require__("wxYD");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "eN33":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "edYw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ep/x":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLastVisitedProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProducts() {
  var _lastVisitedProducts$;

  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"]);
  var lastVisitedProducts = (trackingShopping === null || trackingShopping === void 0 ? void 0 : trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"]]) || []; // $FlowFixMe
  // it handles old data: string[]
  // to delete when it's safe

  if ((lastVisitedProducts === null || lastVisitedProducts === void 0 ? void 0 : lastVisitedProducts.length) && !((_lastVisitedProducts$ = lastVisitedProducts[0]) === null || _lastVisitedProducts$ === void 0 ? void 0 : _lastVisitedProducts$.id)) {
    return lastVisitedProducts.map(function (visitedProductId, index) {
      return {
        id: visitedProductId,
        be: false,
        timestamp: Date.now() + index
      };
    });
  }

  return lastVisitedProducts;
}
function getLastVisitedProductIds() {
  return getLastVisitedProducts().map(function (visitedProduct) {
    return visitedProduct.id;
  });
}
function trackLastVisitedProducts(pageType, product) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageType) && (product === null || product === void 0 ? void 0 : product.id)) {
    var lastVisitedProducts = getLastVisitedProducts();
    var targetProduct = lastVisitedProducts.find(function (visitedProduct) {
      return visitedProduct.id === product.id;
    });

    if (targetProduct) {
      // once it's true (BE) it can't go back to false
      targetProduct.be = product.be || targetProduct.be;
    } else {
      lastVisitedProducts = [product].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(lastVisitedProducts));
    }

    lastVisitedProducts = lastVisitedProducts.sort(function (a, b) {
      return Number(b.be) - Number(a.be) || b.timestamp - a.timestamp;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "t"]);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* setInLocalStorage */ "c"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"], lastVisitedProducts));
  }
}

/***/ }),

/***/ "fO+d":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "w"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "fhLv":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "g51W":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "gIGD":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("XywU");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("k9PE");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nv//");








var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "C"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]];

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _ref;

  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDateDisplayValue */ "d"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* formatDepartureDateForStore */ "a"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _ref = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "C"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "C"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* serializeKidsToQueryParam */ "h"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _ref;
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      location = args.location,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  }); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(searchPageUrl, {
    replace: isShallow,
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var location = args.location,
      query = args.query,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).pathname(query.link).setQuery(queryParams);
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(resortPageUrl);
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(location) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "C"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(location) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("i5Mr");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ICONS_HEIGHT = 32;
var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(function ProductHeader(_ref) {
  var badge = _ref.badge,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE : _ref$badgeColor,
      _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      className = _ref.className,
      hasECLogo = _ref.hasECLogo,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"];
  return __jsx("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex'),
    onClick: onClick,
    "data-testid": "Product-Header"
  }, __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "reset-anchor flex flex-1 z-1 min-w-0",
    "data-testid": "ProductHeader-link"
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx("div", {
    className: "relative flex-1 flex flex-col-reverse justify-center -mb-px overflow-hidden rtl:pr-px5"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex items-center font-brand leading-one text-lg",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    hasEllipsis: true,
    hLevel: 2,
    role: "presentation",
    theme: "none"
  }, title), __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex min-w-0 items-center font-bold font-sans text-sm uppercase tracking-tight",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_MEDIUM,
    hasEllipsis: true,
    hLevel: 3,
    role: "presentation",
    theme: "none"
  }, subtitle), !!badge && __jsx("div", {
    "data-testid": "ProductHeader-seasonBadge",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-".concat(badgeColor), 'leading-one p-px5 font-bold uppercase rounded-tiny text-center text-white text-xs whitespace-no-wrap rtl:ml-px10')
  }, __jsx("div", {
    className: "-mb-px"
  }, badge))))), __jsx("div", {
    className: "flex -mx-px5"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, badgeIcon, {
    className: "mx-px5 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && __jsx("span", {
    className: "font-brand leading-none text-sm self-center"
  }, "&"), hasECLogo && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__[/* ECBadge */ "a"], {
    className: "flex-none mx-px5",
    height: ICONS_HEIGHT,
    iconWidth: "95%"
  })));
});

/***/ }),

/***/ "i2OK":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var redefine = __webpack_require__("L1Xj");
var toString = __webpack_require__("3dm5");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "iBXc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("ep/x");
var aPossiblePrototype = __webpack_require__("2CYk");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "ieZH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toObject = __webpack_require__("A+R+");
var nativeGetPrototypeOf = __webpack_require__("yvHl");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "j2ob":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "jCye":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("ydRd");
var tryToString = __webpack_require__("xS1b");

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink_TextLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-px10 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-px10',
      thIconRight: 'text-white rtl:ml-px10'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start text-base underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







var TextLink_TextLink = function TextLink(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      color = _ref.color,
      iconLeftName = _ref.iconLeftName,
      _ref$iconRightName = _ref.iconRightName,
      iconRightName = _ref$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _ref$iconRightName,
      isExternalLink = _ref.isExternalLink,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      target = _ref.target,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData,
      url = _ref.url;

  if (!label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
};

/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release,
      isMice = args.isMice;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));

  if (isMice) {
    return "\n    mice {\n      bestPrice {\n        value\n        formattedValue\n      }\n      unit(".concat(cmsArgs, ")\n    }\n    ");
  }

  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        numberOfAdults\n        departureCity {\n          value\n          name\n        }\n        accommodationComfortLabel\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var isMice = args.isMice,
      offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    accommodationsIntroduction {\n      roomsCount\n    }\n    badgeIcon\n    childcareDetails {\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    ").concat(isMice ? "productMeetingRooms {\n      meetingRooms {\n        shapes {\n          maxCapacity\n        }\n      }\n    }" : '', "\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    transportType\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    isMice: args.isMice,
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "k4ez":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("a4SZ");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qm5D");
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6jSF");





 // TODO This was a curried function. It should be just redirectTo(uri: string): void

function redirectTo(currentUrl) {
  return function (uri, options) {
    if (true) {
      var dynamicLinkHelper = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](currentUrl || window.location.href, uri);

      if (dynamicLinkHelper.isExternalUrl()) {
        _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].setLocation(uri);
      } else {
        var objectUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(uri); // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided

        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(window.location.href);

        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options === null || options === void 0 ? void 0 : options.shallow) {
            if (options.replace) {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowReplaceRoute(objectUri.resource());
            } else {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowPushRoute(objectUri.resource());
            }
          } else if (options === null || options === void 0 ? void 0 : options.replace) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].replaceRoute(objectUri.resource());
          } else {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

function redirectToUri() {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocation(), uri).toString();
      redirectTo()(redirectUri);
    };
  };
}

function redirectToOidc(appContext) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_4__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_5__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_5__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  redirectTo: redirectTo,
  redirectToUri: redirectToUri,
  redirectToOidc: redirectToOidc
});

/***/ }),

/***/ "kD/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateBookingCartSequencially; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartAll; });
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Nhxn");




var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var cartQuery = "\n    cart {\n        childcares {\n            id\n            productId\n            label\n            type\n            attendees {\n                id\n                price\n            }\n            startDate\n            endDate\n            schedules {\n              startDate\n              endDate\n              attendees {\n                id\n                price\n              }\n            }\n        }\n        transfers {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        insurance {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        rentals {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n          attendees {\n            id\n            schedules {\n              price {\n                value\n              }\n              startDate\n              endDate\n            }\n          }\n        }\n        activities {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        pickRoom { \n          id\n          type\n          accommodations {\n            id \n            rooms {\n              id\n            }\n          }\n        }\n        price {\n            total {\n                formattedValue(precision: 2)\n                value\n                currency\n            }\n            currency\n            detail {\n              service\n              amount\n            }\n        }\n        isEmpty\n    }\n";
var getBookingCartQuery = function getBookingCartQuery(bookingId) {
  return "query {\n        userBooking(bookingId : \"".concat(bookingId, "\") {\n          ").concat(cartQuery, "\n        }\n    }");
};
var fetchBookingCart = function fetchBookingCart(stay, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(FETCH_BOOKING_CART, {
      stay: stay
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(getBookingCartQuery(stay.bookingId), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_GET_BOOKING_CART */ "h"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var id = _ref.id,
      bookingId = _ref.bookingId,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName;
  return "mutation {\n            addServiceCart(\n             bookingId : \"".concat(bookingId, "\",\n             serviceCart: {\n                 id: \"").concat(id, "\",\n                 ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n                 ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n             }\n             serviceName: \"").concat(serviceName, "\") {\n                ").concat(cartQuery, "\n             }\n          }");
};

var removeService = function removeService(id, bookingId) {
  return "mutation {\n              removeServiceCart(\n               bookingId : \"".concat(bookingId, "\",\n               itemId: \"").concat(id, "\")\n               {\n                ").concat(cartQuery, "\n               }\n            }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      context = _ref2.context,
      action = _ref2.action,
      successMsg = _ref2.successMsg;
  return function (dispatch) {
    dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        id: id,
        bookingId: bookingId,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName
      }) : removeService(id, bookingId), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "R"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "O"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params) {
  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      context = _params$.context,
      action = _params$.action;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    id: id,
    bookingId: bookingId,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName
  }) : removeService(id, bookingId), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "R"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "O"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
var updateBookingCartAll = function updateBookingCartAll(params) {
  return Promise.all(params.map(function (_ref3) {
    var id = _ref3.id,
        bookingId = _ref3.bookingId,
        schedules = _ref3.schedules,
        accommodations = _ref3.accommodations,
        serviceName = _ref3.serviceName,
        context = _ref3.context,
        action = _ref3.action;
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
      id: id,
      bookingId: bookingId,
      schedules: schedules,
      accommodations: accommodations,
      serviceName: serviceName
    }) : removeService(id, bookingId), context, {
      requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "R"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "O"]
    });
  }));
};

/***/ }),

/***/ "kD1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfigWithNoThirdPartySupport; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1mr4");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



 // makes inexact to allow other query params

var shouldIgnoreThirdParty = function shouldIgnoreThirdParty(queryParams) {
  return lodash_has__WEBPACK_IMPORTED_MODULE_1___default()(queryParams, _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["appQueryParameters"].noThirdParty);
};

var appLocaleConfig;
var getConfigWithNoThirdPartySupport = function getConfigWithNoThirdPartySupport(_ref) {
  var name = _ref.name,
      locale = _ref.locale,
      queryParams = _ref.queryParams; // cache if on browser

  if (!appLocaleConfig || false) {
    appLocaleConfig = _config__WEBPACK_IMPORTED_MODULE_3___default.a.locale(locale);
  }

  var originalConfig = appLocaleConfig.get(name);
  return shouldIgnoreThirdParty(queryParams) ? _objectSpread(_objectSpread({}, originalConfig), {}, {
    enabled: false
  }) : originalConfig;
};

/***/ }),

/***/ "kG2z":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureDateDisplayValue; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCities; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* CHILDCARE_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "f"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "f"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_2___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_2___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate;

    if (!birthdate || !kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"]);
    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });

    if (childcareIncluded) {
      serializedOutput = "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref2) {
  var birthdate = _ref2.birthdate,
      departureDate = _ref2.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()().add(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "j"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zwLB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_2__[/* ReactPageContext */ "a"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_4__[/* getSearchMappedTypeForLabelGA */ "d"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "kdyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAnalyticsEnabled; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_widgets_cookie_warning_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("+LXU");
/* harmony import */ var _locale_localeUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1tzK");




var isAnalyticsEnabled = function isAnalyticsEnabled(locale) {
  var didomiCookieValue = js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(_client_components_widgets_cookie_warning_constants__WEBPACK_IMPORTED_MODULE_1__[/* COOKIE_PREFERENCES_DIDOMI_CONSENT */ "b"]);
  return !Object(_locale_localeUtils__WEBPACK_IMPORTED_MODULE_2__[/* isLocaleToDisplayDidomi */ "b"])(locale) || !!didomiCookieValue && didomiCookieValue.includes('c:ga-');
};



/***/ }),

/***/ "kjCq":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("yhbn");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "km0D":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var getBuiltIn = __webpack_require__("x90g");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ "l5FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["a"] = (/*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  departureCities: [],
  setDepartureCities: function setDepartureCities() {}
}));

/***/ }),

/***/ "l6h7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var setGlobal = __webpack_require__("edYw");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetCalendarCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setIsSearchEnabled; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6wD6");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("9QcM");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_TOGGLE_FACET_SELECTED */ "p"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["times"])(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_SEARCH_QUERY */ "o"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_8__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_17__[/* searchQuerySelector */ "m"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_INITIAL_PRICES */ "j"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "m"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_CLEAR_FACETS */ "b"], {
    categoryId: categoryId
  });
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_REDIRECTION */ "f"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_SEARCH */ "g"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_FILTERS */ "i"], {
    filters: filters
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_UPDATE_FILTERS */ "s"], {
    filters: filters
  });
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(updateFilters([]));
                dispatch(setSearchQuery({
                  label: ''
                }));
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function resetCalendarCriteria() {
  return /*#__PURE__*/function () {
    var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__[/* updateTripDateCriteria */ "a"])({
                  day: null
                }));
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_DATE_REQUIRED */ "k"], {
    isDateRequired: isDateRequired
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_SEARCH_ENABLED */ "l"], {
    isSearchEnabled: isSearchEnabled
  });
}

/***/ }),

/***/ "m9Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return entryRouteReducer; });
var SET_ENTRY_ROUTE = 'SET_ENTRY_ROUTE';
var UNSET_ENTRY_ROUTE = 'UNSET_ENTRY_ROUTE';
var initialState = '';
var entryRouteReducer = function entryRouteReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_ENTRY_ROUTE:
      return action.payload;

    case UNSET_ENTRY_ROUTE:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "mmil":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("8+jV");
var uid = __webpack_require__("rvZv");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "mu8A":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var has = __webpack_require__("DZWw");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = has(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "mwRp":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "n1QJ":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "nJrx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var shared = __webpack_require__("8+jV");
var has = __webpack_require__("DZWw");
var uid = __webpack_require__("rvZv");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nnRT":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("NYSw");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "nnm9":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "nvU9":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("I1fX"),
    isObject = __webpack_require__("tQYX"),
    isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "oCTG":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("aPQG");






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && !this.props.useNativeErrorHandling) {
        return null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_5___default.a.Component);

/***/ }),

/***/ "oMzG":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var has = __webpack_require__("DZWw");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineProperty = __webpack_require__("87KK").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "oScl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("JpEK").IteratorPrototype;
var create = __webpack_require__("Znn2");
var createPropertyDescriptor = __webpack_require__("OouP");
var setToStringTag = __webpack_require__("CGO5");
var Iterators = __webpack_require__("oa0l");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oa0l":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "ogu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADING_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADING_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADING_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_INTRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_ROOM_SELECTION_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SELECT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SELECT_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SELECT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIGHLIGHT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER_FIDELITY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("xl1w");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var initialState = {
  completedIntro: false,
  resort: null,
  stayWithVendor: null,
  selectableRooms: [],
  selectableRoomsUnitPrice: null,
  currentSelectedRoomIndex: null,
  currentSelectableRoomIds: [],
  currentSelectableFloorIds: [],
  currentSelectableBuildingIds: [],
  filteredBuildings: [],
  selectedBuildingId: null,
  filteredFloors: [],
  selectedFloorId: null,
  filteredRoomsForCurrentFloor: [],
  filteredRooms: [],
  selectedRooms: [],
  numRoomsLeftToPick: null,
  highlightedRoom: null,
  isLoadingResort: false,
  isLoadingSelectableRooms: false,
  resortPYRMail: null,
  errors: null,
  roomsInCart: []
};
var LOAD_RESORT = 'LOAD_RESORT';
var LOADING_ERROR = 'LOADING_ERROR';
var LOADING_RESORT = 'LOADING_RESORT';
var LOAD_SELECTABLE_ROOMS = 'LOAD_SELECTABLE_ROOMS';
var LOADING_SELECTABLE_ROOMS = 'LOADING_SELECTABLE_ROOMS';
var COMPLETE_INTRO = 'COMPLETE_INTRO';
var SET_ROOM_SELECTION_INDEX = 'SET_ROOM_SELECTION_INDEX';
var SELECT_BUILDING = 'SELECT_BUILDING';
var SELECT_FLOOR = 'SELECT_FLOOR';
var SELECT_ROOM = 'SELECT_ROOM';
var HIGHLIGHT_ROOM = 'HIGHLIGHT_ROOM';
var CUSTOMER_FIDELITY_STATUS = 'CUSTOMER_FIDELITY_STATUS';

function getResortFeatures(state) {
  return state.resort && state.resort.rooms_geo_json.features || [];
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CUSTOMER_FIDELITY_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          fidelityStatus: action.payload
        });
      }

    case LOADING_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: true
        });
      }

    case LOADING_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: false
        });
      }

    case LOAD_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          resort: action.payload,
          isLoadingResort: false
        });
      }

    case LOADING_SELECTABLE_ROOMS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: true
        });
      }

    case LOAD_SELECTABLE_ROOMS:
      {
        var _action$payload = action.payload,
            stayWithVendor = _action$payload.stayWithVendor,
            roomSelectionServices = _action$payload.roomSelectionServices,
            errors = _action$payload.errors,
            resortPYRMail = _action$payload.resortPYRMail;
        var selectableRooms = (roomSelectionServices || []).reduce(function (acc, roomSelectionService) {
          return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(new Array(roomSelectionService.quantity).fill(_objectSpread(_objectSpread({}, roomSelectionService.accommodations[0]), {}, {
            _serviceId: roomSelectionService.id,
            _unitPrice: roomSelectionService.unit_price
          }))));
        }, []);

        if (state.roomsInCart.length > 0) {
          var selectedRooms = state.roomsInCart.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            isLoadingSelectableRooms: false,
            stayWithVendor: stayWithVendor,
            selectableRooms: selectableRooms,
            errors: errors,
            resortPYRMail: resortPYRMail,
            selectedRooms: selectedRooms,
            numRoomsLeftToPick: selectableRooms.length - selectedRooms.length,
            highlightedRoom: null
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: false,
          stayWithVendor: stayWithVendor,
          selectableRooms: selectableRooms,
          numRoomsLeftToPick: selectableRooms.length,
          errors: errors,
          resortPYRMail: resortPYRMail
        });
      }

    case COMPLETE_INTRO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          completedIntro: true
        });
      }

    case SET_ROOM_SELECTION_INDEX:
      {
        var roomIndex = action.payload.roomIndex;
        var features = getResortFeatures(state);

        if (typeof roomIndex === 'undefined' || roomIndex === null) {
          return _objectSpread(_objectSpread({}, state), {}, {
            currentSelectedRoomIndex: null,
            currentSelectableRoomIds: [],
            currentSelectableFloorIds: [],
            currentSelectableBuildingIds: [],
            filteredBuildings: [],
            selectedBuildingId: null,
            filteredFloors: [],
            selectedFloorId: null,
            filteredRoomsForCurrentFloor: [],
            filteredRooms: []
          });
        }

        var isRoomSelected = function isRoomSelected(roomId) {
          return state.selectedRooms.some(function (selectedRoomItem) {
            return selectedRoomItem && selectedRoomItem.properties.id === roomId;
          });
        }; // collect all ids for the current selectable room


        var currentSelectableRoomIds = state.selectableRooms[roomIndex].rooms.map(function (room) {
          return room.id;
        }).filter(function (roomId) {
          return !isRoomSelected(roomId);
        }); // collect properties and geometries for those rooms

        var currentSelectableRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        }); // collect properties and geometries for those rooms
        // $FlowFixMe

        var currentSelectableFloorIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])(currentSelectableRooms.map(function (room) {
          return room.properties.floor_id;
        })); // collect all building ids that contain those floors
        // $FlowFixMe

        var currentSelectableBuildingIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])((state.resort && state.resort.floors || []).filter(function (floor) {
          return currentSelectableFloorIds.indexOf(floor.id) > -1;
        }).map(function (floor) {
          return floor.building_id;
        }));
        var filteredBuildings = (state.resort && state.resort.buildings || []).filter(function (building) {
          return currentSelectableBuildingIds.indexOf(building.id) > -1;
        });

        if (filteredBuildings.length === 0) {
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('SET_ROOM_SELECTION_INDEX no building found for building.id', 'currentSelectableBuildingIds:', currentSelectableBuildingIds, 'state.resort.buildings:', state.resort && state.resort.buildings);
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('currentSelectableBuildingIds:', currentSelectableBuildingIds, 'currentSelectableFloorIds:', currentSelectableFloorIds, 'currentSelectableRooms:', currentSelectableRooms, 'currentSelectableRoomIds:', currentSelectableRoomIds);
        }

        var filteredRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          currentSelectedRoomIndex: roomIndex,
          currentSelectableRoomIds: currentSelectableRoomIds,
          currentSelectableFloorIds: currentSelectableFloorIds,
          currentSelectableBuildingIds: currentSelectableBuildingIds,
          filteredBuildings: filteredBuildings,
          selectedBuildingId: null,
          filteredFloors: [],
          selectedFloorId: null,
          filteredRoomsForCurrentFloor: [],
          filteredRooms: filteredRooms
        });
      }

    case SELECT_BUILDING:
      {
        var buildingId = action.payload.buildingId;
        var filteredFloors = (state.resort && state.resort.floors || []).filter(function (floor) {
          return state.currentSelectableFloorIds.indexOf(floor.id) > -1 && floor.building_id === buildingId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedBuildingId: buildingId,
          filteredFloors: filteredFloors
        });
      }

    case SELECT_FLOOR:
      {
        var floorId = action.payload.floorId;
        var filteredRoomsForCurrentFloor = getResortFeatures(state).filter(function (room) {
          return state.currentSelectableRoomIds.indexOf(room.properties.id) > -1 && room.properties.floor_id === floorId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedFloorId: floorId,
          filteredRoomsForCurrentFloor: filteredRoomsForCurrentFloor
        });
      }

    case SELECT_ROOM:
      {
        var roomId = action.payload.roomId;

        var selectedRoom = _objectSpread({}, getResortFeatures(state).find(function (geoRoom) {
          return geoRoom.properties.id === roomId;
        }));

        var _selectedRooms = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.selectedRooms);

        if (state.currentSelectedRoomIndex || state.currentSelectedRoomIndex === 0) {
          _selectedRooms[state.currentSelectedRoomIndex] = selectedRoom;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedRooms: _selectedRooms,
          numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms.filter(function (r) {
            return r !== undefined;
          }).length,
          highlightedRoom: null
        });
      }

    case HIGHLIGHT_ROOM:
      {
        var _roomId = action.payload.roomId;
        var highlightedRoom = _roomId === undefined ? null : _objectSpread({}, getResortFeatures(state).find(function (room) {
          return room.properties.id === _roomId;
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          highlightedRoom: highlightedRoom
        });
      }

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__["resolve"])(_components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__[/* FETCH_BOOKING_CART */ "a"]):
      {
        var payload = action.payload;
        var roomIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(payload, 'userBooking.cart.pickRoom', []).reduce(function (acc, srv) {
          return acc.concat(srv.accommodations.reduce(function (r, a) {
            return r.concat(a.rooms.map(function (_ref) {
              var id = _ref.id;
              return id;
            }));
          }, []));
        }, []);

        if (getResortFeatures(state).length === 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            roomsInCart: roomIds
          });
        } else {
          var _selectedRooms2 = roomIds.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });

          return _objectSpread(_objectSpread({}, state), {}, {
            selectedRooms: _selectedRooms2,
            numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms2.length,
            highlightedRoom: null
          });
        }
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "p1C/":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "p9RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLegalInformationTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackForYouClub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onCheckboxChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d1HQ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);




var findLegalInformation = function findLegalInformation(ref, legalInformations) {
  return legalInformations && legalInformations.find(function (_ref) {
    var legalInfoRef = _ref.ref;
    return legalInfoRef === ref;
  });
};

var getLegalInformationTitle = function getLegalInformationTitle(ref, legalInformations) {
  return (findLegalInformation(ref, legalInformations) || {}).title || ref;
};
var trackForYouClub = function trackForYouClub(context) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__[/* setDataLayer */ "b"]({
    event: 'eventGA',
    categoryGA: 'PLE',
    actionGA: 'CTA_optin_foryouclub',
    labelGA: 'profilePage'
  }, context);
};
var CLUBMED = 'CLUBMED';
var PARTNERS = 'PARTNERS';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var FORYOUCLUB = 'FORYOUCLUB';
function onCheckboxChange(checkbox, setFieldValue) {
  var _fields;

  var fields = (_fields = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, CLUBMED, {
    checked: [CLUBMED],
    unchecked: [CLUBMED, PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, PARTNERS, {
    checked: [CLUBMED, PARTNERS],
    unchecked: [PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FOSUN_PARTNERS, {
    checked: [FOSUN_PARTNERS],
    unchecked: [FOSUN_PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FORYOUCLUB, {
    checked: [FORYOUCLUB],
    unchecked: [FORYOUCLUB]
  }), _fields);

  if (checkbox.checked) {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].checked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, true);
    });
  } else {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].unchecked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, false);
    });
  }
}

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pPFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegexp = __webpack_require__("1dAi");
var isPlainObj = __webpack_require__("I8qj");

module.exports = function (val, opts, pad) {
	var seen = [];

	return (function stringify(val, opts, pad) {
		opts = opts || {};
		opts.indent = opts.indent || '\t';
		pad = pad || '';
		var tokens;
		if(opts.inlineCharacterLimit == void 0) {
			tokens = {
				newLine: '\n',
				newLineOrSpace: '\n',
				pad: pad,
				indent: pad + opts.indent
			};
		} else {
			tokens = {
				newLine: '@@__STRINGIFY_OBJECT_NEW_LINE__@@',
				newLineOrSpace: '@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@',
				pad: '@@__STRINGIFY_OBJECT_PAD__@@',
				indent: '@@__STRINGIFY_OBJECT_INDENT__@@'
			}
		}
		var expandWhiteSpace = function(string) {
			if (opts.inlineCharacterLimit == void 0) { return string; }
			var oneLined = string.
				replace(new RegExp(tokens.newLine, 'g'), '').
				replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').
				replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');

			if(oneLined.length <= opts.inlineCharacterLimit) {
				return oneLined;
			} else {
				return string.
					replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').
					replace(new RegExp(tokens.pad, 'g'), pad).
					replace(new RegExp(tokens.indent, 'g'), pad + opts.indent);
			}
		};

		if (seen.indexOf(val) !== -1) {
			return '"[Circular]"';
		}

		if (val === null ||
			val === undefined ||
			typeof val === 'number' ||
			typeof val === 'boolean' ||
			typeof val === 'function' ||
			isRegexp(val)) {
			return String(val);
		}

		if (val instanceof Date) {
			return 'new Date(\'' + val.toISOString() + '\')';
		}

		if (Array.isArray(val)) {
			if (val.length === 0) {
				return '[]';
			}

			seen.push(val);

			var ret = '[' + tokens.newLine + val.map(function (el, i) {
				var eol = val.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				return tokens.indent + stringify(el, opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + ']';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		if (isPlainObj(val)) {
			var objKeys = Object.keys(val);

			if (objKeys.length === 0) {
				return '{}';
			}

			seen.push(val);

			var ret = '{' + tokens.newLine + objKeys.map(function (el, i) {
				if (opts.filter && !opts.filter(val, el)) {
					return '';
				}

				var eol = objKeys.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				var key = /^[a-z$_][a-z$_0-9]*$/i.test(el) ? el : stringify(el, opts);
				return tokens.indent + key + ': ' + stringify(val[el], opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + '}';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		val = String(val).replace(/[\r\n]/g, function (x) {
			return x === '\n' ? '\\n' : '\\r';
		});

		if (opts.singleQuotes === false) {
			return '"' + val.replace(/"/g, '\\\"') + '"';
		}

		return '\'' + val.replace(/'/g, '\\\'') + '\'';
	})(val, opts, pad);
};


/***/ }),

/***/ "pfAP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var getMethod = __webpack_require__("Uey1");
var ordinaryToPrimitive = __webpack_require__("ZoVA");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCALES_TO_DISPLAY_DIDOMI; });
var LOCALES = {
  EN_CN: 'en-CN',
  PT_BR: 'pt-BR',
  ZH_CN: 'zh-CN',
  FR_FR: 'fr-FR',
  UK_UA: 'uk-UA'
};
var LOCALES_TO_DISPLAY_DIDOMI = [LOCALES.FR_FR];


/***/ }),

/***/ "qPLk":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "qXr/":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "qd7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signout; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var SIGNOUT = 'SIGNOUT';

function cleanCookies() {
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__[/* USER_INFO */ "d"]);
}

function signout() {
  cleanCookies();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(SIGNOUT);
}

/***/ }),

/***/ "qs2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("LTtw");
var DESCRIPTORS = __webpack_require__("uGjT");
var global = __webpack_require__("HnW7");
var has = __webpack_require__("DZWw");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var defineProperty = __webpack_require__("87KK").f;
var copyConstructorProperties = __webpack_require__("sfoL");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "rAD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_QUICKLOGIN_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_QUICKLOGIN_INFOS; });
var UPDATE_QUICKLOGIN_INFOS = 'UPDATE_QUICKLOGIN_INFOS';
var RESET_QUICKLOGIN_INFOS = 'RESET_QUICKLOGIN_INFOS';

/***/ }),

/***/ "rvZv":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "s+R0":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    cacheHas = __webpack_require__("S0iI"),
    createSet = __webpack_require__("9TP6"),
    setToArray = __webpack_require__("XlL0");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "sCL+":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sfoL":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var ownKeys = __webpack_require__("1m4l");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "tJAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment Address on Address {\n    streetNumber\n    streetName\n    additionalInformation1\n    additionalInformation2\n    addOn\n    zipCode\n    city\n    town\n    stateOrDistrict\n    country\n    countryCode\n  }\n");

/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "u6DZ":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseOrderBy = __webpack_require__("eHpp"),
    baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "u9tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAuthenticationMiddleware; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6jSF");



function createAuthenticationMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        try {
          var _action$meta; // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
          // $FlowFixMe


          var redirectUri = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.redirect_uri;

          if (!!redirectUri && _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__[/* hasAuthResponseError */ "l"](action.payload)) {
            _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["windowWrapper"].setLocation(redirectUri);
          }
        } catch (e) {
          _logger__WEBPACK_IMPORTED_MODULE_1___default.a.warn(e);
        }

        return next(action);
      };
    };
  };
}

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "e"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uGjT":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUserInfosToAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCustomerSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterProposalBySamePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdditionalTransportsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsError; });
/* unused harmony export getFilteredAdditionalAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSearchCriteriaTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getSearchCriteriaTransportsInbound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdditionalTransportsFilters; });
/* unused harmony export getFilteredAdditionalTransports */
/* unused harmony export getAdditionalTransportsSorters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProposalsWithMappedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCurrentTotalPrice; });
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttendeesWithInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getInsurancesStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getStreetViews; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref3) {
  var paymentProviders = _ref3.paymentProviders;
  return paymentProviders;
});
var getInsurancesStore = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref4) {
  var insurance = _ref4.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref5) {
  var searchCriteria = _ref5.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var transports = _ref7.transports;
  return transports;
});
var getAdditionalTransportsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var filters = _ref8.filters;
  return filters;
});
var getFilteredAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var filteredTransports = _ref9.filteredTransports;
  return filteredTransports;
});
var getAdditionalTransportsSorters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var sorters = _ref10.sorters;
  return sorters || [];
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref11) {
  var error = _ref11.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref12) {
  var isLoading = _ref12.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref13) {
  var additionalAccommodations = _ref13.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var isLoading = _ref14.isLoading;
  return isLoading;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var accommodationsSets = _ref15.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var filters = _ref16.filters;
  return filters;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var error = _ref17.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var filteredAccommodations = _ref18.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref19) {
  var proposals = _ref19.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref20) {
  var resort = _ref20.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref21) {
  var selectedProposalId = _ref21.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref22) {
  var proposals = _ref22.proposals,
      selectedProposalId = _ref22.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__[/* getDefaultProposal */ "f"])(proposals)
  );
});
var getCurrentTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, function (proposal) {
  return proposal.price.total.value;
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  }

  return proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(proposalsSelector, getCurrentProposal, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref23) {
  var rentalEquipments = _ref23.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, function (_ref24) {
  var attendees = _ref24.attendees;
  return attendees;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omit"])(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getStreetViews = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref25) {
  var streetViews = _ref25.streetViews;
  return streetViews;
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref26) {
  var suggestions = _ref26.suggestions;
  return suggestions;
});
/**
 * The comparator does not put proposal in store
 * We need to use this function instead of the getAttendeesWithInfos selector
 */

var addUserInfosToAttendees = function addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo) {
  var getSortAttendeesByGmNumber = function getSortAttendeesByGmNumber(attendee1, attendee2) {
    if (!attendee1.gmNumber || !attendee2.gmNumber) {
      return 0;
    }

    return tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee1.gmNumber;
    }) - tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee2.gmNumber;
    });
  }; // defensive code if store is not available (ex: confirmation page)


  if (!tripAttendees || !proposalAttendees) {
    return {
      adults: [],
      children: []
    };
  }

  var sortedAdultsAttendees = tripAttendees.adults.sort(getSortAttendeesByGmNumber);
  var adultsList = proposalAttendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread(_objectSpread({}, index === 0 ? connectedUserInfo : null), adult), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(sortedAdultsAttendees[index], function (value) {
      return value === undefined;
    }));
  });
  var childrenList = proposalAttendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(tripAttendees.kids.find(function (kid) {
      if (kid.id) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.id === child.id;
      }

      if (kid.neolid && child.customerId) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.neolid === child.customerId;
      }

      return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate);
    }), function (value, key) {
      return value === undefined || key === 'birthdate';
    }));
  }).sort(getSortAttendeesByGmNumber).sort(function (child1, child2) {
    // for seller set children with neolid (so with his fields already filled) first
    if (child1.neolid && !child2.neolid) {
      return -1;
    }

    if (!child1.neolid && child2.neolid) {
      return 1;
    }

    return 0;
  });
  return {
    adults: adultsList,
    children: childrenList
  };
};
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});

var addSearchDataToAttendees = function addSearchDataToAttendees(attendeesWithInfo, attendeesFromSearch) {
  var enrichedAdults = attendeesWithInfo.adults.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.adults[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  var enrichedChildren = attendeesWithInfo.children.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.children[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  return {
    adults: enrichedAdults,
    children: enrichedChildren
  };
};

var enrichAttendeesWithAvailableData = function enrichAttendeesWithAvailableData(proposalAttendees, tripAttendees, connectedUserInfo, searchResult) {
  var attendeesWithInfo = addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo);
  return searchResult && searchResult.data ? addSearchDataToAttendees(attendeesWithInfo, searchResult.data) : attendeesWithInfo;
};

var getAttendeesWithInfos = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getAttendees, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], getConnectedUserInfoSelector, getCustomerSearchResult, enrichAttendeesWithAvailableData);
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, getAttendeesWithInfos, function (_ref27, attendeesWithInfos) {
  var additionalServices = _ref27.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.attendees.forEach(function (attendee) {
      var product = {
        price: attendee.rentedAmount.value,
        services: [service]
      };

      if (attendee.rentedAmount.value > 0) {
        if (!acc[attendee.id]) {
          acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, productInfo.id, _objectSpread({}, product));
        } else if (!acc[attendee.id][productInfo.id]) {
          acc[attendee.id][productInfo.id] = _objectSpread({}, product);
        } else {
          acc[attendee.id][productInfo.id].services.push(service);
        }
      }
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref28) {
    var _ref29 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref28, 2),
        id = _ref29[0],
        rentedServices = _ref29[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref30) {
  var booking = _ref30.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.themes.js
var themes = {
  "default": {
    thRoot: 'flex pt-px10 w-full',
    thContent: 'bg-white flex flex-wrap relative content-center h-full w-full',
    thButton: 'absolute bottom-0 flex left-0 justify-center w-full',
    thPlaceholders: 'w-full flex'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx
var __jsx = react_default.a.createElement;








var PLACEHOLDER_URLS = ['https://ns.clubmed.com/it/2019/shop/dummy.png', 'https://ns.clubmed.com/it/2019/shop/dummy2.png', 'https://ns.clubmed.com/it/2019/shop/dummy3.png'];
var overallMaxNumberOfPlaceholders = 3;
var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      maxPlaceholders = _ref.maxPlaceholders;

  if (!number) {
    return null;
  }

  var _themes$theme = themes[theme],
      thContent = _themes$theme.thContent,
      thButton = _themes$theme.thButton,
      thPlaceholders = _themes$theme.thPlaceholders,
      thRoot = _themes$theme.thRoot;

  var renderPlaceholders = function renderPlaceholders() {
    var placeholders = [];
    var numberOfPlaceholders = Math.min(maxPlaceholders, overallMaxNumberOfPlaceholders);

    for (var i = 0; i < number && i < numberOfPlaceholders; i++) {
      placeholders.push(__jsx("div", {
        className: "px-px10 w-full sm:w-1/2 md:w-1/3 lg:w-1/3",
        key: "product-".concat(i)
      }, __jsx(Image["b" /* default */], {
        className: "fadeIn",
        imageUrl: PLACEHOLDER_URLS[i % 3],
        key: PLACEHOLDER_URLS[i % 3] + i,
        ratioKey: ratios_utils["a" /* default */].R_1_BY_5,
        ratioDisplay: 1 / 3
      })));
    }

    return placeholders;
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("div", {
    className: thContent
  }, __jsx("div", {
    className: thPlaceholders
  }, renderPlaceholders(), __jsx("div", {
    style: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)'
    }
  })), __jsx("div", {
    className: thButton
  }, __jsx(Button["a" /* Button */], {
    onClick: onClick,
    dataTestId: "more-results-btn",
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    minWidth: "220px",
    isLoading: isLoading
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx









var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 6 ? 'w-full' : "w-1/".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "h-full",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore,
        grid: this.getGrid(),
        maxPlaceholders: this.getItemsByLine()
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn p-px10', _this2.getGrid(), _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return [].concat(Object(toConsumableArray["a" /* default */])(this.getChildren()), [this.getSeeMore()]).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx("div", {
        className: classnames_default()(className, 'flex flex-wrap -m-px10'),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "ubam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROFILE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyProfileChanged; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rJ95");




var PROFILE_CHANGED = 'PLE_PROFILE_CHANGED';

function refreshCookie(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      unicodeFirstName = _ref.unicodeFirstName,
      unicodeLastName = _ref.unicodeLastName;
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__[/* USER_INFO */ "d"], _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["oidc"].toUriEncodedState({
    firstName: firstName,
    lastName: lastName,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName
  }));
}

function notifyProfileChanged(newProfile) {
  refreshCookie(newProfile);
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(PROFILE_CHANGED, newProfile);
}

/***/ }),

/***/ "unIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_SCORE_SESSION_STORAGE_KEY; });
var SET_DATA_SCORE = 'SET_DATA_SCORE';
var DATA_SCORE_SESSION_STORAGE_KEY = 'cmLeadScore';


/***/ }),

/***/ "v315":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ rootReducer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfo.reducer.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var initialState = {
  score: parseFloat(Object(sessionStorageApi["b" /* getFromSessionStorage */])(constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */])) || 0
};

var leadInfo_reducer_leadInfosReducer = function leadInfosReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  if (type === constants["b" /* SET_DATA_SCORE */]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      score: payload.score
    });
  }

  return state;
};


// EXTERNAL MODULE: /opt/webapp/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/store/streetViews/constants.js
var streetViews_constants = __webpack_require__("Xvk6");

// CONCATENATED MODULE: ./src/client/store/streetViews/streetViews.reducer.js



var streetViews_reducer_initialState = [];
function streetViewsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : streetViews_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case proposals_constants["q" /* PREPARE_BE */]:
    case Object(build["resolve"])(streetViews_constants["a" /* FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID */]):
      {
        var _action$payload;

        return (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.streetViews) || [];
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/customer-search/customerSearch.reducer.js
var customerSearch_reducer = __webpack_require__("E3ZW");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.utils.js


function proposals_reducer_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function getTransportsWithTransfer(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
    inbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.inbound')), {}, {
      transferIncluded: true
    }),
    outbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.outbound')), {}, {
      transferIncluded: true
    })
  });
}

function setTransferIncludedInProposal(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), Object(lodash["has"])(proposal, 'transports.inbound') && Object(lodash["has"])(proposal, 'transports.outbound') ? {
    transports: getTransportsWithTransfer(proposal)
  } : null);
}

function updateProposal(proposalId, state, updateFn) {
  var indexToUpdate = state.findIndex(function (p) {
    return Object(lodash["get"])(p, 'id') === proposalId;
  });
  return indexToUpdate !== -1 ? state.map(function (proposal, index) {
    return index === indexToUpdate ? updateFn(proposal) : proposal;
  }) : state;
}

function updateTransfers(state, proposalFields) {
  if (Object(lodash["isEmpty"])(proposalFields)) return state;

  var updateFn = function updateFn(proposal) {
    var currentProposal = proposalFields.find(function (_ref) {
      var id = _ref.id;
      return id === Object(lodash["get"])(proposal, 'id');
    }) || {};
    var price = currentProposal.price,
        availableTransfers = currentProposal.availableTransfers,
        paymentSchedule = currentProposal.paymentSchedule,
        selectedTransfers = currentProposal.selectedTransfers;
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.price), price),
      paymentSchedule: paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers
    });
  };

  return state.map(updateFn);
}

function updateTransportError(state, proposalId, error) {
  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      transports: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
        error: error
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state, proposalFields) {
  if (!proposalFields) return state;
  var price = proposalFields.price,
      attendees = proposalFields.attendees;

  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: price,
      attendees: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.attendees), {}, {
        list: attendees.list
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalFields.id, state, updateFn);
}


// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.js



function proposals_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var proposals_reducer_initialState = [];
function proposalsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : proposals_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case proposals_constants["q" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var proposals = Object(lodash["get"])(action, 'payload.proposals.proposals', []).map(setTransferIncludedInProposal).sort(proposalUtils["c" /* compareProposalsByComfort */]);
        var errors = Object(lodash["get"])(action, 'payload.proposals.errors', []);
        proposals.forEach(function (proposal) {
          if (proposal.transports) {
            Object(proposalUtils["B" /* saveRecommendedTransport */])(proposal.transports, proposal.id);
          }
        });
        return [].concat(Object(toConsumableArray["a" /* default */])(proposals), Object(toConsumableArray["a" /* default */])(errors));
      }

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      {
        var paymentSchedule = action.payload.proposal.paymentSchedule;
        var selectedProposalId = Object(lodash["get"])(action, 'meta.payload.selectedProposalId');
        return state.map(function (proposal) {
          return proposal.id === selectedProposalId ? proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            paymentSchedule: paymentSchedule
          }) : proposal;
        });
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        // $FlowFixMe
        return [{
          errorCode: 500
        }];
      }

    case proposals_constants["y" /* SET_PROPOSALS */]:
      return Object(lodash["get"])(action, 'payload.proposals');

    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
      return action.payload.addAccommodation || state;

    case proposals_constants["B" /* UPDATE_ATTENDEES */]:
      return updateAttendees(state, Object(lodash["get"])(action, 'payload.proposal'));

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["x" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return proposals_reducer_initialState;

    case Object(build["resolve"])(proposals_constants["d" /* ADD_TRANSFER_TO_PROPOSALS */]):
      {
        var transfersAdded = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'addTransfer');
        }).flat();
        return updateTransfers(state, transfersAdded);
      }

    case Object(build["resolve"])(proposals_constants["u" /* REMOVE_TRANSFER_FROM_PROPOSALS */]):
      {
        var transfersRemoved = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'removeTransfer');
        }).flat();
        return updateTransfers(state, transfersRemoved);
      }

    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      {
        if (!action.payload.addTransport) {
          return state;
        }

        return action.payload.addTransport.map(function (proposal) {
          return setTransferIncludedInProposal(proposal);
        });
      }

    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      var transportExpiredError = Object(lodash["get"])(action, 'payload.errors', []).find(function (error) {
        return Object(lodash["get"])(error, 'statusCode') === 400;
      });
      var proposalId = Object(lodash["get"])(action, 'meta.payload.proposalId');
      var errorInfo = Object(lodash["pick"])(transportExpiredError, ['statusCode', 'message']);
      return transportExpiredError ? updateTransportError(state, proposalId, errorInfo) : state;

    case Object(build["resolve"])(proposals_constants["x" /* SET_PROMO_CODE */]):
      return state.map(function (proposal) {
        if (proposal.id === Object(lodash["get"])(action, 'payload.promoCodeProposal.id')) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
              aggregateDiscount: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscount'),
              aggregateDiscountPromoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscountPromoCode'),
              promoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.promoCode'),
              total: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.total')
            }),
            paymentSchedule: Object(lodash["get"])(action, 'payload.promoCodeProposal.paymentSchedule')
          });
        }

        return proposal;
      });

    case proposals_constants["C" /* UPDATE_INSURANCES */]:
      var proposalFields = Object(lodash["get"])(action, 'payload.modifyInsurances.proposal');
      if (!proposalFields) return state;
      return updateProposal(proposalFields.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalFields.listInsurances),
          price: proposalFields.price,
          paymentSchedule: proposalFields.paymentSchedule
        });
      });

    case proposals_constants["g" /* DELETE_INSURANCES */]:
      var proposalDeleteInsurances = Object(lodash["get"])(action, 'payload.deleteInsurances.proposal');
      if (!proposalDeleteInsurances) return state;
      return updateProposal(proposalDeleteInsurances.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalDeleteInsurances.listInsurances),
          price: proposalDeleteInsurances.price,
          paymentSchedule: proposalDeleteInsurances.paymentSchedule
        });
      });

    case proposals_constants["w" /* SAVE_DONATION_TO_PROPOSALS */]:
      return state.map(function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
            donation: action.payload
          })
        });
      });

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["D" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
      {
        // $FlowFixMe
        var data = Object.values(action.payload)[0];
        return state.map(function (proposal, proposalIndex) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), data[proposalIndex]);
        });
      }

    case Object(build["resolve"])(proposals_constants["z" /* SWITCH_PROPOSALS_OFFERS */]):
      return state.map(function (proposal) {
        var proposalData = action.payload.proposals.find(function (_ref) {
          var id = _ref.id;
          return id === proposal.id;
        });

        if (proposalData) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), proposalData);
        }

        return proposals_reducer_objectSpread({}, proposal);
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/proposals/insurance/insurance.reducer.js


function insurance_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function insurance_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      insurance_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      insurance_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var insurance_reducer_initialState = {};
var insurance_reducer_insuranceReducer = function insuranceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insurance_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case proposals_constants["n" /* INIT_INSURANCES */]:
      return payload;

    case proposals_constants["o" /* INSURANCE_ADDED */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        isDeleted: false,
        isAdded: true
      })));

    case proposals_constants["p" /* INSURANCE_DELETED */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        isAdded: false,
        isDeleted: true
      })));

    case proposals_constants["A" /* TOGGLE_TERMS */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        // $FlowFixMe
        termsChecked: !(state[payload] && state[payload].termsChecked)
      })));

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/booking/resort/resort.reducer.js






var resort_reducer_initialState = null;
function resortReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : resort_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        return Object(lodash["get"])(action, 'payload.proposals.resort', null);
      }

    case proposals_constants["q" /* PREPARE_BE */]:
      return Object(lodash["get"])(action, 'payload.resort', null);

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["x" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return resort_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// CONCATENATED MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalIdReducer.reducer.js


var selectedProposalIdReducer_reducer_initialState = null;

function selectedProposalIdReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedProposalIdReducer_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["q" /* PREPARE_BE */]:
    case selectedProposalId_action["b" /* SELECT_PROPOSAL */]:
      return action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.proposalId;

    case selectedProposalId_action["a" /* CLEAR_SELECTED_PROPOSAL */]:
      return selectedProposalIdReducer_reducer_initialState;

    default:
      return state;
  }
}


// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// CONCATENATED MODULE: ./src/client/store/booking/best-proposal-id/bestProposalId.reducer.js










var bestProposalId_reducer_initialState = null;
function bestProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bestProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var proposals = Object(toConsumableArray["a" /* default */])(Object(lodash["get"])(action, 'payload.proposals.proposals', [])).sort(proposalUtils["c" /* compareProposalsByComfort */]);

        return Object(lodash["get"])(proposals, '[0].id', null);
      }

    case proposals_constants["y" /* SET_PROPOSALS */]:
      {
        return Object(lodash["get"])(action, 'payload.proposals[0].id', null);
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["x" /* UPDATE_TRIP_DATE_CRITERIA */]:
      {
        return bestProposalId_reducer_initialState;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
var additionalAccommodations_action = __webpack_require__("06Jt");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-loading/isLoading.reducer.js



var isLoading_reducer_initialState = false;

function isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return true;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var isLoading_reducer = (isLoadingReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/accommodations-sets/accommodationsSets.reducer.js


function accommodationsSets_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function accommodationsSets_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      accommodationsSets_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      accommodationsSets_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var accommodationsSets_reducer_initialState = [];

function accommodationsSetsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accommodationsSets_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return accommodationsSets_reducer_initialState;

    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return ((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.additionalAccommodations) || []).filter(function (additionalAccommodationSet) {
        return additionalAccommodationSet.accommodations && additionalAccommodationSet.accommodations.length > 0;
      }).map(function (accommodation, index) {
        return accommodationsSets_reducer_objectSpread(accommodationsSets_reducer_objectSpread({}, accommodation), {}, {
          accommodationSetNumber: index + 1
        });
      });

    default:
      return state;
  }
}

/* harmony default export */ var accommodationsSets_reducer = (accommodationsSetsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/error/error.reducer.js



var error_reducer_initialState = null;

function additionalAccommodationsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return error_reducer_initialState;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_reducer = (additionalAccommodationsErrorReducer);
// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/store/filters/filtersHelper.js



function filtersHelper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filtersHelper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filtersHelper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filtersHelper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var defaultMatch = function defaultMatch(a, b) {
  return a === b;
};

function _getMatcher(filter) {
  return filter.match || defaultMatch;
}

function _matchFilter(data) {
  return function (filter) {
    var dataValue = Object(lodash["get"])(data, filter.path);
    var filterValue = filter.value;
    return _getMatcher(filter)(dataValue, filterValue);
  };
}

function _toggleFilter(filters) {
  return function (toggledFilter) {
    return filters.map(function (filter) {
      var shouldToggleFilter = filter.path === toggledFilter.path && filter.value === toggledFilter.value;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: shouldToggleFilter ? !filter.selected : filter.selected
      });
    });
  };
}

function _filterDataSet(dataSet, filters) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var activeFilters = filters.filter(function (f) {
    return condition(f) === true;
  });
  return dataSet.filter(function (data) {
    var match = _matchFilter(data);

    return Object(lodash["isEmpty"])(activeFilters) || activeFilters.some(function (activeFilter) {
      return match(activeFilter);
    });
  });
}

function _removeUnusedFilters(filters) {
  return filters.map(function (filter) {
    return filter.selected === true && filter.matchedOccurrences === 0 ? filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
      selected: false
    }) : filter;
  });
}

function filterDataSetWithSelectedAndMatchedFilters(dataSet, filters) {
  return _filterDataSet(dataSet, filters, function (filter) {
    return filter.selected && Object(lodash["get"])(filter, 'matchedOccurrences', 0) > 0;
  });
}

function getDataSetIfFilterWasSelected(dataSet, filter) {
  return _filterDataSet(dataSet, [filter]);
}

function getFiltersWithMatchedOccurrences(dataSet) {
  return function (filters) {
    // First, we group all filters by their path
    var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
    return filters.map(function (filter) {
      // Then, for every filter, we get all data objects matching all active filters in all other categories
      var matchedResultsInOtherCategories = Object.keys(filtersByCategory).filter(function (category) {
        return category !== filter.category;
      }).map(function (filterKey) {
        return filterDataSetWithSelectedAndMatchedFilters(dataSet, Object(lodash["get"])(filtersByCategory, filterKey));
      }); // Then, we activate the current filter (whether its current activation state) and get all data objects matching only this filter

      var matchedResultsForCurrentFilter = getDataSetIfFilterWasSelected(dataSet, filter); // Finally, The intersection gives us the list of results matching all our active filters
      // prettier-ignore

      var matchedOccurrences = ( // $FlowFixMe
      lodash["intersectionBy"].apply(void 0, Object(toConsumableArray["a" /* default */])(matchedResultsInOtherCategories).concat([matchedResultsForCurrentFilter, 'id'])) || []).length;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        matchedOccurrences: matchedOccurrences
      });
    });
  };
}

function _activateFilter(filters, valuesToActivate) {
  return filters.map(function (filter) {
    var matchedOccurrences = Object(lodash["get"])(filter, 'matchedOccurrences', 0);

    if (matchedOccurrences > 0 && valuesToActivate.includes(filter.value)) {
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: true
      });
    }

    return filter;
  });
}

function getPreselectedFilters(filters, selectedProposal) {
  var accommodationFilters = filters.filter(function (f) {
    return f.category === 'accommodations' && Object(lodash["get"])(f, 'matchedOccurrences', 0) > 0;
  }); // categoryId is the comfort level of the room, used as value for comfort filters

  var selectedProposalComfort = Object(lodash["get"])(selectedProposal, 'accommodations[0].categoryId');
  var selectedProposalComfortOrder = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(selectedProposalComfort); // at first, activate filters equal to selected proposal comfort level
  // and those with higher comfort level

  var higherComfortCodes = Object(lodash["slice"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder);
  var filtersToActivate = higherComfortCodes.filter(function (code) {
    return Object(lodash["find"])(accommodationFilters, {
      value: code
    });
  }); // if no equal or higher comfort level filter found,
  // activate the one below the selected proposal comfort level

  if (filtersToActivate.length === 0) {
    var lowerComfortCodes = Object(lodash["take"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder); // use findLast to start from the end of the array
    // and get the highest comfort level possible

    var codeToActivate = Object(lodash["findLast"])(lowerComfortCodes, function (code) {
      return Object(lodash["find"])(accommodationFilters, {
        value: code
      });
    });
    codeToActivate && filtersToActivate.push(codeToActivate);
  }

  switch (selectedProposalComfort) {
    // if selected proposal comfort level is club, club seaside view
    // or superior (default state), do not activate any filter
    case '000017': // club

    case '000048': // club seaside view

    case '000061':
      // superior
      return filters;

    default:
      return _activateFilter(filters, filtersToActivate);
  }
}

function toggleFilter(dataSet) {
  return function (filters, toggledFilter) {
    var updateMatchOccurrences = getFiltersWithMatchedOccurrences(dataSet);

    var updatedToggleFilters = _toggleFilter(filters)(toggledFilter);

    var updatedOccurrencesFilters = updateMatchOccurrences(updatedToggleFilters);
    return _removeUnusedFilters(updatedOccurrencesFilters);
  };
}

function filterDataSet(dataSet, filters) {
  if (!filters) {
    return dataSet;
  }

  var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
  return Object.keys(filtersByCategory) // $FlowFixMe
  .reduce(function (filteredResults, category) {
    return filterDataSetWithSelectedAndMatchedFilters(filteredResults, filtersByCategory[category]);
  }, dataSet);
}


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js
var filterUtils = __webpack_require__("KxdP");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filters.reducer.js





var filters_reducer_initialState = null;
function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var proposal = Object(lodash["get"])(action, 'payload.selectedProposal') || null; // remove initial accommodation (related to selected proposal) from additional accommodations

  var filteredAdditionalAccommodations = proposal && additionalAccommodations.length ? Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, additionalAccommodations) : additionalAccommodations;
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(filteredAdditionalAccommodations);

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filters_reducer_initialState;

    case additionalAccommodations_action["b" /* CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS */]:
      {
        var _action$payload = action.payload,
            selectedProposal = _action$payload.selectedProposal,
            shouldPreselectFilters = _action$payload.shouldPreselectFilters,
            resort = _action$payload.resort;
        var filters = Object(filterUtils["a" /* createFilters */])(filteredAdditionalAccommodations, resort);
        var filtersWithOccurences = getFiltersWithOccurrences(filters);
        return filtersWithOccurences && shouldPreselectFilters ? getPreselectedFilters(filtersWithOccurences, selectedProposal) : filtersWithOccurences;
      }

    case additionalAccommodations_action["d" /* TOGGLE_ACCOMMODATIONS_FILTER */]:
      var filter = action.payload.filter;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case additionalAccommodations_action["e" /* TOGGLE_EXTRA_FEATURES */]:
      {
        var _action$payload2 = action.payload,
            i18n = _action$payload2.i18n,
            accommodationsSets = _action$payload2.accommodationsSets,
            reducedMobilityVisibility = _action$payload2.reducedMobilityVisibility;
        return Object(filterUtils["c" /* handleReducedMobilityFilter */])(i18n, accommodationsSets, reducedMobilityVisibility, state);
      }

    case additionalAccommodations_action["f" /* UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY */]:
      var category = action.payload.category;
      var updatedFilters = Object(filterUtils["d" /* unselectCategory */])(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-data-fetched/isDataFetched.reducer.js


var isDataFetched_reducer_initialState = false;
function isDataFetched() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isDataFetched_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
      return false;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return true;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filtered-accommodations/filteredAccommodations.reducer.js



var filteredAccommodations_reducer_initialState = null;

function filteredAccommodationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredAccommodations_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filteredAccommodations_reducer_initialState;

    case additionalAccommodations_action["g" /* UPDATE_FILTERED_ACCOMMODATIONS_RESULTS */]:
      return filterDataSet(additionalAccommodations, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredAccommodations_reducer = (filteredAccommodationsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.reducer.js







var additionalAccommodations_reducer_additionalAccommodations = Object(redux["c" /* combineReducers */])({
  error: error_reducer,
  isLoading: isLoading_reducer,
  accommodationsSets: accommodationsSets_reducer,
  filters: filtersReducer,
  filteredAccommodations: filteredAccommodations_reducer,
  isDataFetched: isDataFetched
});
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/is-loading/isLoading.reducer.js




var is_loading_isLoading_reducer_initialState = false;

function isLoading_reducer_isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : is_loading_isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
    case proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]:
      return true;

    case Object(build["resolve"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["reject"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var is_loading_isLoading_reducer = (isLoading_reducer_isLoadingReducer);
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/transports/transports.reducer.js
var transports_reducer = __webpack_require__("Fk4B");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/error/error.reducer.js




var error_error_reducer_initialState = null;

function additionalTransportsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return error_error_reducer_initialState;

    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["reject"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_error_reducer = (additionalTransportsErrorReducer);
// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp.js
var fp = __webpack_require__("h/fj");

// EXTERNAL MODULE: ./src/utils/transport/additionalTransports.constants.js
var additionalTransports_constants = __webpack_require__("dGB2");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filterUtils.js



function filterUtils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filterUtils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filterUtils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filterUtils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function geIntValue(time) {
  return time.hours * 60 + time.minutes;
}

function isTimeBefore(time, refTime) {
  return geIntValue(time) < geIntValue(refTime);
}

function isTimeAfter(time, refTime) {
  return geIntValue(time) >= geIntValue(refTime);
}

function isTimeInRange(time) {
  return function (timeRange) {
    return isTimeAfter(time, timeRange.start) && isTimeBefore(time, timeRange.end);
  };
}

function timeRangeValueToString(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes;
  return "".concat(hours, ":").concat(minutes < 10 ? "0".concat(minutes) : minutes);
}

function timeRangeToString(time) {
  return "".concat(timeRangeValueToString(time.start), " - ").concat(timeRangeValueToString(time.end));
}

var STRICT_EQUALITY_MATCHER = function STRICT_EQUALITY_MATCHER(a, b) {
  return a === b;
};

var ARRAY_INCLUSION_MATCHER = function ARRAY_INCLUSION_MATCHER(array, item) {
  return array.includes(item);
};

var COMPANIES_MATCHER = function COMPANIES_MATCHER(companies, companyId) {
  return !!companies.find(function (c) {
    return c.id === companyId;
  });
};

var TIME_RANGE_MATCHER = function TIME_RANGE_MATCHER(time, timeRange) {
  return isTimeInRange(time)(timeRange);
};

function createCompaniesFilters(transports // $FlowFixMe
) {
  var companies = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.companies')), fp["flatten"], fp["compact"], Object(fp["uniqBy"])('id')])(transports);
  return companies.map(function (company) {
    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["d" /* COMPANIES_CATEGORY */],
      match: COMPANIES_MATCHER,
      meta: {
        imageUrl: company.logo,
        label: company.label
      },
      path: 'filterValues.companies',
      selected: false,
      value: company.id
    };
  });
}

function getLayoversInfo(i18n) {
  return function (layovers) {
    switch (layovers) {
      case 0:
        return {
          label: Object(lodash["get"])(i18n, 'filters.layovers.direct'),
          icon: additionalTransports_constants["o" /* ZERO_LAYOVERS_ICON */]
        };

      case 1:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_1')),
          icon: additionalTransports_constants["l" /* ONE_LAYOVERS_ICON */]
        };

      default:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_n')),
          icon: additionalTransports_constants["n" /* TWO_LAYOVERS_ICON */]
        };
    }
  };
}

function createLayoversFilters(transports, i18n) {
  var layoversInfo = getLayoversInfo(i18n);
  var layovers = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.layovers')), Object(fp["filter"])(fp["isNumber"]), Object(fp["sortBy"])(fp["identity"]), fp["sortedUniq"]])(transports);
  return layovers.map(function (layover) {
    var _layoversInfo = layoversInfo(layover),
        label = _layoversInfo.label,
        icon = _layoversInfo.icon;

    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["k" /* LAYOVERS_CATEGORY */],
      match: STRICT_EQUALITY_MATCHER,
      meta: {
        icon: icon,
        label: label
      },
      path: 'filterValues.layovers',
      selected: false,
      value: layover
    };
  });
}

function getTimeRangeTransformations(timeRanges) {
  return function (pathValue) {
    function getTimeRange(time) {
      return time && timeRanges.find(isTimeInRange(time));
    }

    return [Object(fp["map"])(Object(fp["path"])(pathValue)), Object(fp["map"])(getTimeRange), fp["compact"], fp["uniq"], Object(fp["sortBy"])(function (timeRange) {
      return timeRange.start.hours;
    })];
  };
}

function createTimeRangeFilters(transports, timeRanges) {
  return function (pathValue) {
    var values = Object(fp["pipe"])(getTimeRangeTransformations(timeRanges)(pathValue))(transports);
    return values.map(function (value) {
      return {
        id: shortid_default.a.generate(),
        category: additionalTransports_constants["m" /* TIME_RANGES_CATEGORY */],
        match: TIME_RANGE_MATCHER,
        meta: {
          icon: value.icon,
          label: value.label,
          subLabel: timeRangeToString(value)
        },
        path: pathValue,
        selected: false,
        value: value
      };
    });
  };
}

function createCabinClassFilters(transports, i18n) {
  var cabinClassPath = 'filterValues.cabinClasses';
  var cabinClasses = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.cabinClasses')), fp["compact"]])(transports);
  return !Object(lodash["isEmpty"])(cabinClasses) ? [{
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.economy')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["c" /* CABIN_CLASS_ECO */] // temporairement en dur car on ne récupère que des ECO pour les vols

  }, {
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.business')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["a" /* CABIN_CLASS_BUSINESS */]
  }] : [];
}

function createFilters(transports, timeRanges, i18n) {
  var timeRangeFilters = createTimeRangeFilters(transports, timeRanges);
  return [].concat(Object(toConsumableArray["a" /* default */])(createCabinClassFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(createCompaniesFilters(transports)), Object(toConsumableArray["a" /* default */])(createLayoversFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundArrivalTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundArrivalTime')));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (f) {
      return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
        selected: f.category === category ? false : f.selected
      });
    });
  };
}

function unselectFilters(filters, filtersToDisable) {
  return filters.map(function (f) {
    var filterToDisable = filtersToDisable.find(function (_ref2) {
      var id = _ref2.id;
      return id === f.id;
    });
    return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
      selected: filterToDisable ? false : f.selected
    });
  });
}


// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filters.reducer.js




var filters_filters_reducer_initialState = null;
function filters_reducer_filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(additionalTransports);

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filters_filters_reducer_initialState;

    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
      var i18n = Object(lodash["get"])(action, 'payload.i18n') || {};
      var timeRanges = Object(lodash["get"])(i18n, 'filters.departureArrival.timeRanges') || [];
      var filters = createFilters(additionalTransports, timeRanges, i18n);
      return getFiltersWithOccurrences(filters);

    case additionalTransports_action["g" /* TOGGLE_FILTER */]:
      var filter = Object(lodash["get"])(action, 'payload.filter');
      return toggleFilter(additionalTransports)(state || [], filter);

    case additionalTransports_action["h" /* UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY */]:
      var category = Object(lodash["get"])(action, 'payload.category', '');
      var updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    case additionalTransports_action["c" /* DISABLE_FILTERS */]:
      var filtersToDisable = Object(lodash["get"])(action, 'payload.filters', []);
      return getFiltersWithOccurrences(unselectFilters(state || [], filtersToDisable));

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filtered-transports/filteredTransports.reducer.js



var filteredTransports_reducer_initialState = null;

function filteredTransportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredTransports_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filteredTransports_reducer_initialState;

    case additionalTransports_action["f" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var sorterPath = Object(lodash["get"])(action, 'payload.sorter.path');
      return Object(lodash["sortBy"])(filterDataSet(additionalTransports, filters), sorterPath);

    case additionalTransports_action["i" /* UPDATE_FILTERED_RESULTS */]:
      return filterDataSet(additionalTransports, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredTransports_reducer = (filteredTransportsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/constants.js
var sorterByPrice = {
  selected: false,
  id: 'best-price',
  name: 'sortByBestPrices',
  path: 'totalDifferentialPrice.value'
};
var sorterByRecommendation = {
  selected: false,
  id: 'recommendation',
  name: 'sortByRecommendation',
  path: ''
};

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/sorters.reducer.js


function sorters_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function sorters_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      sorters_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      sorters_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var sorters_reducer_initialState = [sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorterByRecommendation), {}, {
  selected: true
}), sorterByPrice];
function sortersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sorters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
      return sorters_reducer_initialState;

    case additionalTransports_action["f" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var selectedSorterId = Object(lodash["get"])(action, 'payload.sorter.id');
      return state.map(function (sorter) {
        return sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorter), {}, {
          selected: sorter.id === selectedSorterId
        });
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/transports/searchCriteria.reducer.js


var searchCriteria_reducer_initialState = [];

function searchCriteriaReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchCriteria_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case additionalTransports_action["e" /* SEARCH_CRITERIA_TRANSPORTS */]:
      var criterias = (action === null || action === void 0 ? void 0 : action.payload) || [];
      return Object(toConsumableArray["a" /* default */])(criterias);

    default:
      return state;
  }
}

/* harmony default export */ var searchCriteria_reducer = (searchCriteriaReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/additionalTransports.reducer.js








/* harmony default export */ var additionalTransports_reducer = (Object(redux["c" /* combineReducers */])({
  error: error_error_reducer,
  isLoading: is_loading_isLoading_reducer,
  transports: transports_reducer["a" /* default */],
  filters: filters_reducer_filtersReducer,
  sorters: sortersReducer,
  filteredTransports: filteredTransports_reducer,
  searchCriteria: searchCriteria_reducer
}));
// CONCATENATED MODULE: ./src/client/store/booking/payment-providers/paymentProviders.reducer.js



var paymentProviders_reducer_initialState = [];

function paymentProvidersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paymentProviders_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      return Object(lodash["get"])(action, 'payload.paymentProviders', paymentProviders_reducer_initialState);

    default:
      return state;
  }
}

/* harmony default export */ var paymentProviders_reducer = (paymentProvidersReducer);
// CONCATENATED MODULE: ./src/client/store/booking/booking-engine-entry/bookingEngineEntry.reducer.js

var bookingEngineEntry_reducer_initialState = null;
function bookingEngineEntry() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookingEngineEntry_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
      {
        return action.payload.bookingEngineEntry;
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/attendees/attendees.reducer.js



function attendees_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function attendees_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      attendees_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      attendees_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var attendees_reducer_initialState = {
  adultsAttendees: [],
  kidsAttendees: []
};
function attendeesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : attendees_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case proposals_constants["q" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var _action$payload = action.payload,
            adultsAttendees = _action$payload.adultsAttendees,
            kidsAttendees = _action$payload.kidsAttendees;
        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          adultsAttendees: adultsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.adultsAttendees), Object(toConsumableArray["a" /* default */])(adultsAttendees)) : state.adultsAttendees,
          kidsAttendees: kidsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.kidsAttendees), Object(toConsumableArray["a" /* default */])(kidsAttendees)) : state.kidsAttendees
        });
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/suggestions/suggestions.reducer.js


function suggestions_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function suggestions_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      suggestions_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      suggestions_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var suggestions_reducer_initialState = {
  dates: [],
  durations: [],
  resorts: []
};
function suggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : suggestions_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var dates = Object(lodash["get"])(action, 'payload.proposals.dateSuggestion', []);
        var durations = Object(lodash["get"])(action, 'payload.proposals.durationSuggestions', []);
        var resorts = Object(lodash["get"])(action, 'payload.proposals.suggestions', []);
        return suggestions_reducer_objectSpread(suggestions_reducer_objectSpread({}, state), {}, {
          dates: dates,
          resorts: resorts,
          durations: durations
        });
      }

    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
      return suggestions_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/criteria-list/criteriaList.reducer.js
var criteriaList_reducer = __webpack_require__("FcTP");

// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryRoute.reducer.js
var entryRoute_reducer = __webpack_require__("m9Sl");

// EXTERNAL MODULE: ./src/client/store/booking/option-validity/optionValidity.reducer.js
var optionValidity_reducer = __webpack_require__("O7yO");

// CONCATENATED MODULE: ./src/client/store/booking/booking.reducer.js

















var booking = Object(redux["c" /* combineReducers */])({
  additionalAccommodations: additionalAccommodations_reducer_additionalAccommodations,
  additionalTransports: additionalTransports_reducer,
  attendees: attendeesReducer,
  bestProposalId: bestProposalIdReducer,
  bookingEngineEntry: bookingEngineEntry,
  criteriaList: criteriaList_reducer["b" /* criteriaListReducer */],
  customerSearch: customerSearch_reducer["b" /* customerSearch */],
  entryRoute: entryRoute_reducer["c" /* entryRouteReducer */],
  insurance: insurance_reducer_insuranceReducer,
  paymentProviders: paymentProviders_reducer,
  proposals: proposalsReducer,
  resort: resortReducer,
  selectedProposalId: selectedProposalIdReducer,
  streetViews: streetViewsReducer,
  suggestions: suggestionsReducer,
  optionValidityDuration: optionValidity_reducer["c" /* optionValidityReducer */]
});
// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// EXTERNAL MODULE: ./src/client/store/utils/createReducer.js
var createReducer = __webpack_require__("4Bi9");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.reducer.js


var _createReducer;

function calendar_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function calendar_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      calendar_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      calendar_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var calendar_reducer_initialState = {
  basePrice: null,
  blockInputDepartureDate: true,
  bookableDateLastRequestId: -1,
  bookableDates: {},
  byDays: {},
  calendar: {},
  departureCity: null,
  initialDuration: null,
  isLoading: true,
  errorResponse: {},
  selectedMonth: Object(calendar_helper["c" /* getDefaultSelectedMonth */])(),
  lastRequestId: -1,
  productId: null,
  tripPrice: {},
  tripPriceLastRequestId: -1,
  tripPriceIsLoading: false
};
var calendarReducer = Object(createReducer["a" /* default */])(calendar_reducer_initialState, (_createReducer = {}, Object(defineProperty["a" /* default */])(_createReducer, store_constants["u" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload$locat = action.payload.location.queryParams,
      queryParams = _action$payload$locat === void 0 ? {} : _action$payload$locat;

  if (!queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["c" /* getDefaultSelectedMonth */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] || state.selectedMonth, uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["g" /* FETCH_CALENDAR */], function (state, action) {
  var _action$payload, _action$payload2;

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    // $FlowFixMe
    departureCity: action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.departureCity,
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1),
    // $FlowFixMe
    productId: action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.productId
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["g" /* FETCH_CALENDAR */]), function (state, action) {
  var _action$optimist = action.optimist;
  _action$optimist = _action$optimist === void 0 ? {} : _action$optimist;
  var _action$optimist$id = _action$optimist.id,
      id = _action$optimist$id === void 0 ? -1 : _action$optimist$id,
      calendar = action.payload.calendar; // If there is another request in progress

  if (id !== state.lastRequestId || !calendar) {
    return state;
  }

  var selectedMonth = state.selectedMonth;
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    basePrice: calendar.basePrice,
    byDays: Object(calendar_helper["d" /* getPricesByDays */])(calendar),
    calendar: calendar,
    selectedMonth: Object(calendar_helper["e" /* getSelectedMonth */])(calendar, selectedMonth),
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["g" /* FETCH_CALENDAR */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    byDays: {},
    errorResponse: {
      errors: errors
    },
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["e" /* FETCH_BOOKABLE_DATES */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDatesLoading: true,
    bookableDateLastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["e" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var _action$optimist2 = action.optimist;
  _action$optimist2 = _action$optimist2 === void 0 ? {} : _action$optimist2;
  var _action$optimist2$id = _action$optimist2.id,
      id = _action$optimist2$id === void 0 ? -1 : _action$optimist2$id,
      bookableDates = action.payload.bookableDates;

  if (id !== state.bookableDateLastRequestId || !bookableDates) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: bookableDates,
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["e" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    errorResponse: {
      errors: errors
    },
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["a" /* CALENDAR_CHANGE_MONTH */], function (state, action) {
  var selectedMonth = action.payload.selectedMonth || calendar_helper["a" /* INITIAL_MONTH */];
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["d" /* CLEAR_CALENDAR */], function () {
  return calendar_reducer_initialState;
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["w" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */], function (state, action) {
  if (!action.payload.departureDate) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["c" /* getDefaultSelectedMonth */])(action.payload.departureDate);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["b" /* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    blockInputDepartureDate: action.payload.blockInputDepartureDate
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["c" /* CALENDAR_SET_INITIAL_DURATION */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    initialDuration: action.payload.duration
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["i" /* FETCH_CALENDAR_TRIP_PRICE */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPriceIsLoading: true,
    tripPriceLastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["i" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state, action) {
  var _action$optimist3 = action.optimist;
  _action$optimist3 = _action$optimist3 === void 0 ? {} : _action$optimist3;
  var _action$optimist3$id = _action$optimist3.id,
      id = _action$optimist3$id === void 0 ? -1 : _action$optimist3$id,
      _action$payload3 = action.payload;
  _action$payload3 = _action$payload3 === void 0 ? {} : _action$payload3;
  var tripPrice = _action$payload3.price;

  if (id !== state.tripPriceLastRequestId) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: tripPrice,
    tripPriceIsLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["i" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: {},
    tripPriceIsLoading: false
  });
}), _createReducer));
// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// CONCATENATED MODULE: ./src/client/store/cms/cms.reducer.js


function cms_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function cms_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      cms_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      cms_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var cms_reducer_initialState = {};
function cmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cms_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(cms_actions["a" /* GET_BOOKING_ENGINE_I18N */]):
    case cms_actions["b" /* SET_CMS */]:
      {
        var data = Object(lodash["merge"])({}, state, cms_reducer_objectSpread(cms_reducer_objectSpread(cms_reducer_objectSpread({}, Object(lodash["get"])(action, 'payload.config', {})), Object(lodash["get"])(action, 'payload.legalInformations', {})), {}, {
          paymentProviders: Object(lodash["get"])(action, 'payload.paymentProviders', {})
        }));
        Object(src_i18n["a" /* addTranslationKeys */])(data);
        return data;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/faceting/faceting.reducer.js
var faceting_reducer = __webpack_require__("8WCa");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var faceting_constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting-trip-information/facetingTripInformation.reducer.js






var facetingTripInformation_reducer_initialState = {
  departureCities: []
};
var facetingTripInformation = Object(createReducer["a" /* default */])(facetingTripInformation_reducer_initialState, Object(defineProperty["a" /* default */])({}, Object(build["resolve"])(faceting_constants["h" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  return {
    departureCities: Object(facetingUtils["c" /* getDepartureCities */])(Object(lodash["get"])(action, 'payload.catalogs', []))
  };
}));
/* harmony default export */ var facetingTripInformation_reducer = (facetingTripInformation);
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// CONCATENATED MODULE: ./src/client/store/global-loader/label/label.reducer.js




var label_reducer_initialState = '';
/* harmony default export */ var label_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : label_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return Object(lodash["get"])(action, 'payload.globalLoaderLabel', null);

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return label_reducer_initialState;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/navigation/navigation.reducer.js

var navigation_reducer_initialState = false;
var navigation_reducer_isNavigation = function isNavigation() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case globalLoader_action["b" /* START_LOADING */]:
      return !!(action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.isNavigation);

    case globalLoader_action["a" /* END_LOADING */]:
      return navigation_reducer_initialState;

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/global-loader/should-display/shouldDisplay.reducer.js




var shouldDisplay_reducer_initialState = false;
/* harmony default export */ var shouldDisplay_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDisplay_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]:
    case proposals_constants["v" /* SAVE_CUSTOMER_PROPOSAL */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return true;

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["reject"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["resolve"])(proposals_constants["v" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["reject"])(proposals_constants["v" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return false;

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      return Object(lodash["get"])(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/globalLoader.reducer.js




/* harmony default export */ var globalLoader_reducer = (Object(redux["c" /* combineReducers */])({
  isNavigation: navigation_reducer_isNavigation,
  label: label_reducer,
  shouldDisplay: shouldDisplay_reducer
}));
// EXTERNAL MODULE: ./src/client/components/widgets/profile-info/travel-companions/travelCompanions.reducer.js
var travelCompanions_reducer = __webpack_require__("xAOE");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare-layer/ChildcareLayer.reducer.js


var ChildcareLayer_reducer_createReducer;

function ChildcareLayer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ChildcareLayer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ChildcareLayer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ChildcareLayer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_BOOKING_CHILDCARE = 'FETCH_BOOKING_CHILDCARE';
var UPDATE_CART = 'UPDATE_CART';
var ChildcareLayer_reducer_initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
var childcareLayerReducer = Object(createReducer["a" /* default */])(ChildcareLayer_reducer_initialState, (ChildcareLayer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, FETCH_BOOKING_CHILDCARE, function (state) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash["get"])(action, 'payload', {}),
    errorResponse: {}
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    data: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data), {}, {
      userBooking: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
    })
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), ChildcareLayer_reducer_createReducer));
// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.reducer.js
var bookingCart_reducer = __webpack_require__("xl1w");

// EXTERNAL MODULE: ./src/client/store/member-space/booking/booking.constants.js
var booking_constants = __webpack_require__("R3QM");

// CONCATENATED MODULE: ./src/client/store/member-space/booking/details/details.reducer.js


var details_reducer_createReducer;

function details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_reducer = (Object(createReducer["a" /* default */])(details_reducer_initialState, (details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["j" /* FETCH_BOOKING_DETAILS */], function (state) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["l" /* FETCH_BOOKING_DETAILS_RESOLVED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["k" /* FETCH_BOOKING_DETAILS_REJECTED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["b" /* CLEAR_BOOKING_DETAILS */], function () {
  return details_reducer_initialState;
}), details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/package/package.reducer.js


var package_reducer_createReducer;

function package_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function package_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      package_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      package_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var package_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var package_reducer = (Object(createReducer["a" /* default */])(package_reducer_initialState, (package_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["g" /* FETCH_BOOKING_ATTENDEES_PACKAGE */], function (state) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["i" /* FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    data: {
      attendees: Object(lodash["get"])(action, 'payload.userBooking.attendees') || [],
      "package": Object(lodash["get"])(action, 'payload.package')
    },
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["h" /* FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["a" /* CLEAR_BOOKING_ATTENDEES_PACKAGE */], function () {
  return package_reducer_initialState;
}), package_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/price-and-payment/priceAndPayment.reducer.js


var priceAndPayment_reducer_createReducer;

function priceAndPayment_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceAndPayment_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceAndPayment_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceAndPayment_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var priceAndPayment_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var priceAndPayment_reducer = (Object(createReducer["a" /* default */])(priceAndPayment_reducer_initialState, (priceAndPayment_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["m" /* FETCH_BOOKING_PRICE_AND_PAYMENT */], function (state) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["o" /* FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    data: priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state.data), {}, {
      priceDetails: Object(lodash["get"])(action, 'payload.userBooking.priceDetails'),
      paymentDetails: Object(lodash["get"])(action, 'payload.userBooking.paymentDetails')
    }),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["n" /* FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["c" /* CLEAR_BOOKING_PRICE_AND_PAYMENT */], function () {
  return priceAndPayment_reducer_initialState;
}), priceAndPayment_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/transport/transport.reducer.js


var transport_reducer_createReducer;

function transport_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function transport_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      transport_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      transport_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */




var transport_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var transport_reducer = (Object(createReducer["a" /* default */])(transport_reducer_initialState, (transport_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["s" /* FETCH_BOOKING_TRANSPORT */], function (state) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["t" /* FETCH_BOOKING_TRANSPORT_REJECTED */], function (state, action) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["e" /* CLEAR_BOOKING_TRANSPORT */], function () {
  return transport_reducer_initialState;
}), transport_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/package-upsell/packageUpsell.reducer.js


var packageUpsell_reducer_createReducer;

function packageUpsell_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function packageUpsell_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      packageUpsell_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      packageUpsell_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var packageUpsell_reducer_initialState = {
  content: null,
  isOpen: false
};
/* harmony default export */ var packageUpsell_reducer = (Object(createReducer["a" /* default */])(packageUpsell_reducer_initialState, (packageUpsell_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["w" /* OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function (state, _ref) {
  var payload = _ref.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, {
    isOpen: true,
    content: Object(lodash["get"])(state, "package_".concat(payload.productId, "_").concat(payload.packageId))
  });
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["v" /* FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED */], function (state, _ref2) {
  var payload = _ref2.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, "package_".concat(payload["package"].productId, "_").concat(payload["package"].id), payload["package"]));
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["f" /* CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function () {
  return packageUpsell_reducer_initialState;
}), packageUpsell_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/modals.reducer.js


/* harmony default export */ var modals_reducer = (Object(redux["c" /* combineReducers */])({
  packageUpsell: packageUpsell_reducer
}));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/stay-formalities/stayFormalities.reducer.js


var stayFormalities_reducer_createReducer;

function stayFormalities_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function stayFormalities_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      stayFormalities_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      stayFormalities_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var stayFormalities_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var stayFormalities_reducer = (Object(createReducer["a" /* default */])(stayFormalities_reducer_initialState, (stayFormalities_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["p" /* FETCH_BOOKING_STAY_FORMALITIES */], function (state) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["r" /* FETCH_BOOKING_STAY_FORMALITIES_RESOLVED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking.stayFormalities') || [],
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["q" /* FETCH_BOOKING_STAY_FORMALITIES_REJECTED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["d" /* CLEAR_BOOKING_STAY_FORMALITIES */], function () {
  return stayFormalities_reducer_initialState;
}), stayFormalities_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/booking.reducer.js







/* harmony default export */ var booking_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_reducer,
  packageUpsell: package_reducer,
  priceAndPayment: priceAndPayment_reducer,
  transport: transport_reducer,
  modals: modals_reducer,
  stayFormalities: stayFormalities_reducer
}));
// EXTERNAL MODULE: ./src/client/store/member-space/constants.helper.js
var constants_helper = __webpack_require__("30WP");

// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.constants.js


var PRE_PAYMENT_DETAILS = 'PRE_PAYMENT/DETAILS';
var PRE_PAYMENT_PAYLOAD_DATAS = 'PRE_PAYMENT/PAYLOAD_DATAS';
var FETCH_PRE_PAYMENT_DETAILS = Object(constants_helper["b" /* fetch */])(PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_DETAILS);
var CLEAR_PRE_PAYMENT_DETAILS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_DETAILS);
var SET_PRE_PAYMENT_PROVIDER = 'SET_PRE_PAYMENT_PROVIDER';
var SET_PRE_PAYMENT_PAYMENT_METHOD_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_ID';
var SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID';
var CLEAR_PRE_PAYMENT_BUTTON = 'CLEAR_PRE_PAYMENT_BUTTON';
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["b" /* fetch */])(PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var CLEAR_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_PAYLOAD_DATAS);
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/details/details.reducer.js


var details_details_reducer_createReducer;

function details_details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var details_details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_details_reducer = (Object(createReducer["a" /* default */])(details_details_reducer_initialState, (details_details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS, function (state) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_RESOLVED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_REJECTED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, CLEAR_PRE_PAYMENT_DETAILS, function () {
  return details_details_reducer_initialState;
}), details_details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/button/button.reducer.js


var button_reducer_createReducer;

function button_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function button_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      button_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      button_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var button_reducer_initialState = {
  selectedProviderId: null,
  paymentMethodId: null,
  paymentConditionId: null
};
/* harmony default export */ var button_reducer = (Object(createReducer["a" /* default */])(button_reducer_initialState, (button_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PROVIDER, function (state, _ref) {
  var payload = _ref.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    selectedProviderId: payload.providerId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_ID, function (state, _ref2) {
  var payload = _ref2.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentMethodId: payload.id
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID, function (state, _ref3) {
  var payload = _ref3.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentConditionId: payload.conditionId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, CLEAR_PRE_PAYMENT_BUTTON, function () {
  return button_reducer_initialState;
}), button_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.reducer.js



/* harmony default export */ var prePayment_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_details_reducer,
  button: button_reducer
}));
// CONCATENATED MODULE: ./src/client/store/member-space/customer/customer.constants.js

var FETCH_CUSTOMER = 'FETCH_CUSTOMER';
var FETCH_CUSTOMER_RESOLVED = Object(build["resolve"])(FETCH_CUSTOMER);
var FETCH_CUSTOMER_REJECTED = Object(build["reject"])(FETCH_CUSTOMER);
// CONCATENATED MODULE: ./src/client/store/member-space/customer/customer.reducer.js


var customer_reducer_createReducer;

function customer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function customer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      customer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      customer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var customer_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var customer_reducer = (Object(createReducer["a" /* default */])(customer_reducer_initialState, (customer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(customer_reducer_createReducer, FETCH_CUSTOMER, function (state) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, FETCH_CUSTOMER_RESOLVED, function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, FETCH_CUSTOMER_REJECTED, function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), customer_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/user-searches/userSearches.reducer.js


var userSearches_reducer_createReducer;

function userSearches_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userSearches_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userSearches_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userSearches_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var userSearches_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ var userSearches_reducer = (Object(createReducer["a" /* default */])(userSearches_reducer_initialState, (userSearches_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["p" /* FETCH_USER_SEARCHES */], function (state) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["q" /* FETCH_USER_SEARCHES_RESOLVED */], function (state, action) {
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.bookings', []);
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: fetchedTripsList
    }
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, Object(build["reject"])(store_constants["p" /* FETCH_USER_SEARCHES */]), function (state, action) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), userSearches_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/future-trips/futureTrips.reducer.js


var futureTrips_reducer_createReducer;

function futureTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function futureTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      futureTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      futureTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var futureTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var futureTrips_reducer = (Object(createReducer["a" /* default */])(futureTrips_reducer_initialState, (futureTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["l" /* FETCH_USER_FUTURE_TRIPS_FETCHED */], function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    data: {
      bookings: Object(lodash["get"])(action, 'payload.bookings.data', [])
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["k" /* FETCH_USER_FUTURE_TRIPS */], function (state) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["m" /* FETCH_USER_FUTURE_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var trips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedTripsList);
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: trips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, Object(build["reject"])(store_constants["k" /* FETCH_USER_FUTURE_TRIPS */]), function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["r" /* RESET_USER_FUTURE_TRIPS */], function () {
  return futureTrips_reducer_initialState;
}), futureTrips_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/past-trips/pastTrips.reducer.js


var pastTrips_reducer_createReducer;

function pastTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pastTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pastTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pastTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var pastTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var pastTrips_reducer = (Object(createReducer["a" /* default */])(pastTrips_reducer_initialState, (pastTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["n" /* FETCH_USER_PAST_TRIPS */], function (state) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["o" /* FETCH_USER_PAST_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedPastTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var pastTrips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedPastTripsList);
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: pastTrips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, Object(build["reject"])(store_constants["n" /* FETCH_USER_PAST_TRIPS */]), function (state, action) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["s" /* RESET_USER_PAST_TRIPS */], function () {
  return pastTrips_reducer_initialState;
}), pastTrips_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/member-space/quick-login/quickLogin.constants.js
var quickLogin_constants = __webpack_require__("rAD9");

// CONCATENATED MODULE: ./src/client/store/member-space/quick-login/quickLogin.reducer.js


var quickLogin_reducer_createReducer;




var quickLogin_reducer_initialState = {
  bookingId: null,
  stayId: null
};
var quickLogin = Object(createReducer["a" /* default */])(quickLogin_reducer_initialState, (quickLogin_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["b" /* UPDATE_QUICKLOGIN_INFOS */], function (state, _ref) {
  var payload = _ref.payload;
  return {
    bookingId: Object(lodash["get"])(payload, 'bookingId') || null,
    stayId: Object(lodash["get"])(payload, 'stayId') || null
  };
}), Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["a" /* RESET_QUICKLOGIN_INFOS */], function () {
  return quickLogin_reducer_initialState;
}), quickLogin_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/member-space/memberSpace.reducer.js











var memberSpace = Object(redux["c" /* combineReducers */])({
  booking: booking_reducer,
  prePayment: prePayment_reducer,
  customer: customer_reducer,
  userSearches: userSearches_reducer,
  futureTrips: futureTrips_reducer,
  pastTrips: pastTrips_reducer,
  travelCompanions: travelCompanions_reducer["b" /* default */],
  quickLogin: quickLogin,
  bookingChildcare: childcareLayerReducer,
  bookingCart: bookingCart_reducer["b" /* bookingCartReducer */]
});
// EXTERNAL MODULE: ./src/client/store/pick-your-room/app/pickYourRoom.reducer.js
var pickYourRoom_reducer = __webpack_require__("ogu6");

// EXTERNAL MODULE: ./src/client/store/pick-your-room/map/map.reducer.js
var map_reducer = __webpack_require__("ZoZw");

// CONCATENATED MODULE: ./src/client/store/pick-your-room/pickYourRoom.reducer.js



var pickYourRoom = Object(redux["c" /* combineReducers */])({
  app: pickYourRoom_reducer["m" /* default */],
  mapper: map_reducer["j" /* default */]
});
/* harmony default export */ var pick_your_room_pickYourRoom_reducer = (pickYourRoom);
// CONCATENATED MODULE: ./src/client/store/search/query/searchQuery.reducer.js


function searchQuery_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function searchQuery_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      searchQuery_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      searchQuery_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var searchQuery_reducer_initialState = {
  keywords: ''
};
var searchQueryReducer = Object(createReducer["a" /* default */])(searchQuery_reducer_initialState, Object(defineProperty["a" /* default */])({}, store_constants["t" /* SEARCH_SET_KEYWORDS */], function (state, action) {
  return searchQuery_reducer_objectSpread(searchQuery_reducer_objectSpread({}, state), {}, {
    keywords: Object(lodash["get"])(action, 'payload.keywords')
  });
}));
// CONCATENATED MODULE: ./src/client/store/search/search.reducer.js


var searchReducer = Object(redux["c" /* combineReducers */])({
  query: searchQueryReducer
});
// CONCATENATED MODULE: ./src/client/store/seller/neolidsReducer.js
var neolidsReducer_initialState = [];
var neolidsReducer = function neolidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : neolidsReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined; // there is just a switch with a default case because data is initialized in src/client/store/getInitialReduxState.client.js
  // and is never changed after that (data come from query params)

  switch (action.type) {
    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/store/seller/sellerReducer.js



/* harmony default export */ var sellerReducer = (Object(redux["c" /* combineReducers */])({
  neolids: neolidsReducer,
  sellerInfo: sellerInfoReducer["b" /* sellerInfoReducer */]
}));
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.reducer.js





var departureCity_reducer_initialState = null;

function departureCityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureCity_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case store_constants["u" /* SYNC_WITH_LOCATION */]:
      var _ref = action || {},
          _ref$payload = _ref.payload;

      _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
      var queryParams = _ref$payload.location.queryParams; // in cases where params is not in the url, we should just keep the state as it is.

      return queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] ? queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] : state;

    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
      return Object(lodash["get"])(action, 'payload.value', departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]);

    case signout["a" /* SIGNOUT */]:
      return departureCity_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var departureCity_reducer = (departureCityReducer);
// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.reducer.js




var departureDate_reducer_initialState = null;

function departureDateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureDate_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["u" /* SYNC_WITH_LOCATION */]:
      // in cases where params is not in the url, we should just keep the state as it is.
      return payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] ? Object(dateUtils["d" /* getTimestamp */])(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]) : state;

    case store_constants["w" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */]:
      return Object(lodash["get"])(payload, 'departureDate');

    default:
      return state;
  }
}

/* harmony default export */ var departureDate_reducer = (departureDateReducer);
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/duration/duration.reducer.js
/* eslint-disable no-duplicate-imports */








var duration_reducer_initialState = null;
function tripDurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : duration_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["u" /* SYNC_WITH_LOCATION */]:
      {
        var _ref2 = payload,
            queryParams = _ref2.location.queryParams;
        if (queryParams[uri_constants["g" /* QUERY_DURATION */]]) return parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10);
        return state ? state : duration_constants["a" /* DEFAULT_NO_DURATION */];
      }

    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
      var _ref3 = payload,
          value = _ref3.value;

      if (value === duration_constants["a" /* DEFAULT_NO_DURATION */]) {
        return null;
      }

      return Number(value) || state;

    case Object(build["resolve"])(faceting_constants["h" /* FACETING_SEARCH_REQUEST */]):
      var _ref4 = payload,
          search = _ref4.search;
      var products = search ? search.products : [];
      var durationQueryParam = Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["g" /* QUERY_DURATION */]);
      var defaultDuration = durationQueryParam ? Number(durationQueryParam) : state;
      var durationFromPrice = Object(lodash["get"])(products, '0.price.termsAndConditions.duration');
      return durationFromPrice ? Number(durationFromPrice) : defaultDuration;

    case signout["a" /* SIGNOUT */]:
      return duration_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.reducer.js

var flexibility_reducer_initialState = null;
function flexibilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flexibility_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */]:
      return payload.value;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-criteria/tripCriteria.reducer.js





/* harmony default export */ var tripCriteria_reducer = (Object(redux["c" /* combineReducers */])({
  departureCity: departureCity_reducer,
  departureDate: departureDate_reducer,
  duration: tripDurationReducer,
  flexibility: flexibilityReducer
}));
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.reducer.js



var tripDateCriteria_reducer_createReducer;








var tripDateCriteria_reducer_initialState = {
  departureDate: null,
  arrivalDate: null
};
/* harmony default export */ var tripDateCriteria_reducer = (Object(createReducer["a" /* default */])(tripDateCriteria_reducer_initialState, (tripDateCriteria_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["u" /* SYNC_WITH_LOCATION */], function (state, _ref) {
  var payload = _ref.payload;

  if (!payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var formattedDate = Object(dateUtils["a" /* formatDate */])('YYYYMMDD')(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return {
    arrivalDate: Number(formattedDate),
    departureDate: Number(formattedDate)
  };
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]), function (state, action) {
  var _get = Object(lodash["get"])(action, 'payload.proposals.proposals', [tripDateCriteria_reducer_initialState]),
      _get2 = Object(slicedToArray["a" /* default */])(_get, 1),
      proposal = _get2[0];

  if (proposal) {
    var arrivalDate = proposal.arrivalDate,
        departureDate = proposal.departureDate;
    return {
      arrivalDate: Number(arrivalDate),
      departureDate: Number(departureDate)
    };
  }

  return state;
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["x" /* UPDATE_TRIP_DATE_CRITERIA */], function (state, action) {
  var day = Object(lodash["get"])(action, 'payload.day', {});
  var departureDate = Number(Object(lodash["get"])(day, 'id')) || null;
  var arrivalDate = Number(Object(lodash["get"])(day, 'arrivalDate', departureDate)) || null;
  return {
    departureDate: departureDate,
    arrivalDate: arrivalDate
  };
}), tripDateCriteria_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.reducer.js


var priceOfStay_reducer_createReducer;

function priceOfStay_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceOfStay_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceOfStay_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceOfStay_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceOfStay_reducer_initialState = {
  data: null,
  error: null,
  isLoading: true,
  lastRequestId: -1
};
var priceOfStayReducer = Object(createReducer["a" /* default */])(priceOfStay_reducer_initialState, (priceOfStay_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], function (state, action) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["resolve"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  var priceOfStay = action.payload.priceOfStay;

  if (priceOfStay && priceOfStay.errors) {
    return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
      isLoading: false,
      data: null,
      error: priceOfStay.errors
    });
  }

  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: priceOfStay,
    error: null
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["reject"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["c" /* RESET_PRICE_OF_STAY */], function () {
  return priceOfStay_reducer_initialState;
}), priceOfStay_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.reducer.js


var allInclusiveServices_reducer_createReducer;

function allInclusiveServices_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function allInclusiveServices_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      allInclusiveServices_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      allInclusiveServices_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var allInclusiveServices_reducer_initialState = {
  isLoading: true,
  data: [],
  lastRequestId: -1
};
var allInclusiveServicesReducer = Object(createReducer["a" /* default */])(allInclusiveServices_reducer_initialState, (allInclusiveServices_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], function (state, action) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["resolve"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: action.payload.allInclusiveServices
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["reject"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), allInclusiveServices_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.reducer.js



var priceRemoteReducer = Object(redux["c" /* combineReducers */])({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer
});
// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.reducer.js


var priceTicket_reducer_createReducer;

function priceTicket_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceTicket_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceTicket_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceTicket_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceTicket_reducer_initialState = {
  isLoading: true,
  price: {}
};
/* harmony default export */ var priceTicket_reducer = (Object(createReducer["a" /* default */])(priceTicket_reducer_initialState, (priceTicket_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, priceTicket_constants["a" /* default */], function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["resolve"])(priceTicket_constants["a" /* default */]), function (state, action) {
  var price = Object(lodash["get"])(action, 'payload.price') || {};
  return {
    isLoading: false,
    price: price
  };
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["reject"])(priceTicket_constants["a" /* default */]), function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), priceTicket_reducer_createReducer)));
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/store/prebooking-form/prebookingform.action.js + 1 modules
var prebookingform_action = __webpack_require__("ZP80");

// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.action.js
var TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME = 'TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME';

function setParticipantsLastNameWithMainContacts(userInfos, adultCount, kidCount) {
  return {
    type: TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME,
    payload: {
      userInfos: userInfos,
      adultCount: adultCount,
      kidCount: kidCount
    }
  };
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/trip-information/kids/kids.reducer.js



function kids_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function kids_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      kids_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      kids_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */











var kids_reducer_initialState = [];

function updateKid(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var kidsState = state || [];
  return Array(index >= kidsState.length ? index + 1 : kidsState.length).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    if (i !== index) return kidsState[i] ? kidsState[i] : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kids_reducer_objectSpread({}, kidsState[i] ? kidsState[i] : defaultKid)), valuesToUpdate);
  });
}

function updateKidsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      kidCount = _action$payload.kidCount;

  if (userInfos.lastName === '') {
    return state;
  }

  var kids = state || [];
  return Array(kidCount).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    return kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, defaultKid), kids[i]), {}, {
      lastName: kids[i] && !Object(lodash["isEmpty"])(kids[i].lastName) ? kids[i].lastName : userInfos.lastName
    });
  });
}

var kids_reducer_updateKids = function updateKids(state, _ref) {
  var payload = _ref.payload;

  if (!payload.kidsAttendees) {
    return state.map(function (kid) {
      return {
        birthdate: kid.birthdate,
        neolid: kid.neolid,
        childcareIncluded: kid.childcareIncluded,
        mainContactId: undefined
      };
    });
  }

  return state.map(function (kid, index) {
    var _get2 = Object(lodash["get"])(payload, "kidsAttendees[".concat(index, "]"), {}),
        birthdate = _get2.birthdate,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_get2, ["birthdate"]);

    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: kid.birthdate,
      neolid: kid.neolid,
      childcareIncluded: kid.childcareIncluded,
      mainContactId: undefined
    });
  });
};

function kidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : kids_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case kids_constants["e" /* TRIP_INFORMATION_UPDATE_KID */]:
      return updateKid(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return updateKidsWithMainContactLastName(state, action);

    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
      {
        var kids = Object(lodash["get"])(action, 'payload.kids') || [];
        return kids.map(function (kid) {
          return kid || kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case kids_constants["d" /* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */]:
      {
        var _kids = Object(lodash["get"])(action, 'payload.kids') || [];

        return _kids.map(function (kid, index) {
          return kid ? kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, state[index]), kid), {}, {
            birthdate: typeof kid.birthdate === 'string' ? Object(apiDate["d" /* apiDateToTimestamp */])(kid.birthdate) : kid.birthdate,
            neolid: kid.neolid || Object(lodash["get"])(state[index], 'neolid'),
            mainContactId: kid.neolid ? undefined : kid.mainContactId
          }) : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return kids_reducer_updateKids(state, action);

    case proposals_constants["B" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (kid) {
          var updatedKid = action.payload.attendees.find(function (_ref2) {
            var id = _ref2.id;
            return id === kid.id;
          }) || {};
          return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kid), {}, {
            neolid: updatedKid.customerId,
            gmNumber: updatedKid.gmNumber
          });
        });
      }

    case kids_constants["b" /* TRIP_INFORMATION_RESET_KIDS */]:
      return kids_reducer_initialState;

    case signout["a" /* SIGNOUT */]:
      return kids_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/adults/adults.reducer.js



function adults_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function adults_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      adults_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      adults_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var adults_reducer_initialState = [];

function updateAdult(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var adults = state || [];
  return Array(index >= adults.length ? index + 1 : adults.length).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    if (i !== index) return adults[i] ? adults[i] : adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]);
    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult)), valuesToUpdate);
  });
}

function setAdultsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      adultCount = _action$payload.adultCount;
  var lastName = userInfos.lastName;

  if (lastName === '') {
    return state;
  }

  var adults = state || [];
  return Array(adultCount).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    // First adult = mainContact so update it with userInfosData
    if (i === 0) {
      return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), Object(lodash["pick"])(userInfos, ['lastName', 'firstName', 'birthdate', 'email', 'civility', 'unicodeFirstName', 'unicodeLastName']));
    }

    return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), {}, {
      lastName: adults[i] && !Object(lodash["isEmpty"])(adults[i].lastName) ? adults[i].lastName : userInfos.lastName
    });
  });
}

function setAdultsNumber(state, action) {
  var adultsNumber = Object(lodash["get"])(action, 'payload.adultsNumber');

  if (adultsNumber === 0) {
    return [];
  }

  if (!Number.isFinite(adultsNumber)) {
    return state;
  }

  var adults = state || [];
  return Array(adultsNumber).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    return adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult);
  });
}

var adults_reducer_setAdults = function setAdults(state, _ref) {
  var payload = _ref.payload;

  if (!payload.adultsAttendees) {
    return state.map(function (adult) {
      return {
        neolid: adult.neolid
      };
    });
  }

  return state.map(function (adult, index) {
    var _ref2 = payload.adultsAttendees[index] || {},
        birthdate = _ref2.birthdate,
        homePhoneNumber = _ref2.homePhoneNumber,
        mobilePhoneNumber = _ref2.mobilePhoneNumber,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_ref2, ["birthdate", "homePhoneNumber", "mobilePhoneNumber"]);

    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: birthdate ? Object(apiDate["d" /* apiDateToTimestamp */])(birthdate) : null,
      phoneNumber: mobilePhoneNumber || homePhoneNumber,
      neolid: adult.neolid
    });
  });
};

function adultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : adults_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      return updateAdult(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return setAdultsWithMainContactLastName(state, action);

    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
      return setAdultsNumber(state, action);

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return adults_reducer_setAdults(state, action);

    case proposals_constants["B" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (adult) {
          var updatedAdult = action.payload.attendees.find(function (_ref3) {
            var id = _ref3.id;
            return id === adult.id;
          }) || {};
          return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adult), {}, {
            neolid: updatedAdult.customerId,
            gmNumber: updatedAdult.gmNumber,
            mainContactId: undefined
          });
        });
      }

    case adults_constants["c" /* SET_ADULTS */]:
      return action.payload.map(function (adult, index) {
        return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, state[index]), adult), {}, {
          mainContactId: adult.neolid ? undefined : adult.mainContactId,
          neolid: adult.neolid || Object(lodash["get"])(state[index], 'neolid')
        }, adult.address ? {
          address: adults_reducer_objectSpread(adults_reducer_objectSpread({}, Object(lodash["get"])(state[index], 'address')), adult.address)
        } : null);
      });

    case signout["a" /* SIGNOUT */]:
      return adults_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.reducer.js



/* harmony default export */ var tripInformation_reducer = (Object(redux["c" /* combineReducers */])({
  kids: kidsReducer,
  adults: adultsReducer
}));
// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var routing_constants = __webpack_require__("Uq20");

// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.actions.js
var bookingCart_actions = __webpack_require__("kD/R");

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// CONCATENATED MODULE: ./src/client/store/toast/toast.reducer.js


function toast_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function toast_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      toast_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      toast_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var toast_reducer_initialState = {
  color: colors["a" /* COLORS */].WATER_GREEN,
  icon: icons["a" /* ICONS */].CONFIRMATION,
  label: '',
  shouldDisplay: false
};
var toast_reducer_toast = function toast() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toast_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case toast_actions["b" /* OPEN_TOAST */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      return {
        className: Object(lodash["get"])(action, 'payload.className', ''),
        color: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.color) || colors["a" /* COLORS */].WATER_GREEN,
        icon: icons["a" /* ICONS */].CONFIRMATION,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: true,
        style: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.style
      };

    case proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */]:
    case PopinNewsletter["a" /* NEWSLETTER_SUBSCRIPTION_VALIDATION */]:
      return {
        shouldDisplay: true,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["D" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
    case Object(build["resolve"])(bookingCart_actions["a" /* UPDATE_BOOKING_CART */]):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        shouldDisplay: !!(Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel')),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        shouldDisplay: !!Object(lodash["get"])(action, 'payload.toastLabel'),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PAYMENT_BUTTON_ERROR':
    case proposals_constants["b" /* ADD_ACCOMMODATION_ERROR */]:
      return {
        shouldDisplay: !!action.payload.toastLabel,
        label: action.payload.toastLabel,
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].RED
      };

    case proposals_constants["D" /* UPDATE_SERVICES */]:
    case proposals_constants["h" /* DELETE_SERVICE */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    case toast_actions["a" /* CLOSE_TOAST */]:
    case routing_constants["a" /* ROUTING_CHANGE */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/user-info/actions/notifyProfileChanged.js
var notifyProfileChanged = __webpack_require__("ubam");

// CONCATENATED MODULE: ./src/client/store/user-info/reducers/userInfoReducer.js


function userInfoReducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userInfoReducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userInfoReducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userInfoReducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var MAIN_CONTACT_INDEX = 0; // $FlowFixMe known flow bug. Faultly rejects empty object.

var userInfoReducer_initialState = {};
function userInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userInfoReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case signout["a" /* SIGNOUT */]:
      return userInfoReducer_initialState;

    case notifyProfileChanged["a" /* PROFILE_CHANGED */]:
      return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), action.payload);

    case adults_constants["d" /* SET_ATTENDEES */]:
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      var profile = action.payload.profile; // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable

      if (profile) {
        return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), profile);
      }

      return state;

    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      if (Object(lodash["isEmpty"])(state)) return state;
      var _action$payload = action.payload,
          index = _action$payload.index,
          valuesToUpdate = _action$payload.valuesToUpdate;
      var updatedDateOfBirth = Object(lodash["get"])(valuesToUpdate, 'birthdate');
      var optinEmail = Object(lodash["get"])(valuesToUpdate, 'optinEmail');
      var optinSms = Object(lodash["get"])(valuesToUpdate, 'optinSms');
      var optinMail = Object(lodash["get"])(valuesToUpdate, 'optinMail');
      var optinPhone = Object(lodash["get"])(valuesToUpdate, 'optinPhone');
      var optinClubmedPlus = Object(lodash["get"])(valuesToUpdate, 'optinClubmedPlus');
      if (index !== MAIN_CONTACT_INDEX) return state;
      var newState = state;

      if (updatedDateOfBirth) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          updatedDateOfBirth: updatedDateOfBirth
        });
      }

      if (!Object(lodash["isNil"])(optinEmail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinEmail: optinEmail
        });
      }

      if (!Object(lodash["isNil"])(optinSms)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinSms: optinSms
        });
      }

      if (!Object(lodash["isNil"])(optinMail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinMail: optinMail
        });
      }

      if (!Object(lodash["isNil"])(optinPhone)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinPhone: optinPhone
        });
      }

      if (!Object(lodash["isNil"])(optinClubmedPlus)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinClubmedPlus: optinClubmedPlus
        });
      }

      return newState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/validation-schema/constants.js
var validation_schema_constants = __webpack_require__("Kb9x");

// CONCATENATED MODULE: ./src/client/store/validation-schema/validationSchema.reducer.js


function validationSchema_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function validationSchema_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      validationSchema_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      validationSchema_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var validationSchema_reducer_initialState = {
  'profile.address': []
};

var validationSchema_reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : validationSchema_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case validation_schema_constants["a" /* UPDATE_VALIDATION_SCHEMA */]:
      {
        var validationSchema = action.payload.validationSchema;
        if (!validationSchema) return state;
        var addressEntry = validationSchema.find(function (entry) {
          return entry.name === 'address';
        });
        return addressEntry ? {
          'profile.address': addressEntry.fields.map(function (validation) {
            return validationSchema_reducer_objectSpread(validationSchema_reducer_objectSpread({}, validation), {}, {
              validators: validation.validators.map(function (validator) {
                return validator.name === 'pattern' ? {
                  name: 'pattern',
                  value: new RegExp(validator.value)
                } : validator;
              })
            });
          })
        } : state;
      }

    default:
      return state;
  }
};

/* harmony default export */ var validationSchema_reducer = (validationSchema_reducer_reducer);
// CONCATENATED MODULE: ./src/client/store/rootReducer.js




















var rootReducer = Object(redux["c" /* combineReducers */])({
  booking: booking,
  calendar: calendarReducer,
  cms: cmsReducer,
  faceting: faceting_reducer["a" /* facetingReducer */],
  facetingTripInformation: facetingTripInformation_reducer,
  globalLoader: globalLoader_reducer,
  memberSpace: memberSpace,
  pickYourRoom: pick_your_room_pickYourRoom_reducer,
  priceRemote: priceRemoteReducer,
  priceTicket: priceTicket_reducer,
  search: searchReducer,
  seller: sellerReducer,
  tripDateCriteria: tripDateCriteria_reducer,
  tripInformation: tripInformation_reducer,
  userInfo: userInfoReducer,
  leadInfos: leadInfo_reducer_leadInfosReducer,
  tripCriteria: tripCriteria_reducer,
  toast: toast_reducer_toast,
  validationSchema: validationSchema_reducer
});

/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js





var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !Object(lodash["includes"])(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = Object(lodash["isEmpty"])(facets) ? constants["g" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["e" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return Object(lodash["inRange"])(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["d" /* CHILDCARE_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(Object(lodash["uniqWith"])(childcareFilters, lodash["isEqual"]));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return Object(lodash["isEmpty"])(kids) ? this : this.addFilter({
        id: constants["c" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return Object(lodash["pick"])(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js


/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeFacets = _ref2.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var query = _ref3.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var facets = _ref4.facets;
  return facets || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var filters = _ref5.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var prices = _ref6.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var _ref7$products = _ref7.products,
      products = _ref7$products === void 0 ? [] : _ref7$products;
  return products;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var _ref8$recommandedProd = _ref8.recommandedProducts,
      recommandedProducts = _ref8$recommandedProd === void 0 ? [] : _ref8$recommandedProd;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var banners = _ref9.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$products = _ref10.products,
      products = _ref10$products === void 0 ? [] : _ref10$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref11) {
    var id = _ref11.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$kidsValidation = _ref12.kidsValidationState,
      kidsValidationState = _ref12$kidsValidation === void 0 ? [] : _ref12$kidsValidation;
  return kidsValidationState;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref13) {
      var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
          filter = _ref14[0],
          isSelected = _ref14[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["c" /* ADULTS_ONLY_FACET_ID */], constants["d" /* CHILDCARE_FACET_ID */], constants["i" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["q" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["b" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["i" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vnfA":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "vuE1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var getBuiltIn = __webpack_require__("x90g");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var fails = __webpack_require__("fhLv");
var has = __webpack_require__("DZWw");
var isArray = __webpack_require__("gIGD");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var anObject = __webpack_require__("ep/x");
var toObject = __webpack_require__("A+R+");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var $toString = __webpack_require__("vnfA");
var createPropertyDescriptor = __webpack_require__("OouP");
var nativeObjectCreate = __webpack_require__("Znn2");
var objectKeys = __webpack_require__("X95k");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternal = __webpack_require__("Ed3r");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var redefine = __webpack_require__("L1Xj");
var shared = __webpack_require__("8+jV");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");
var uid = __webpack_require__("rvZv");
var wellKnownSymbol = __webpack_require__("nJrx");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineWellKnownSymbol = __webpack_require__("oMzG");
var setToStringTag = __webpack_require__("CGO5");
var InternalStateModule = __webpack_require__("9jKB");
var $forEach = __webpack_require__("VrMI").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  var valueOf = $Symbol[PROTOTYPE].valueOf;
  redefine($Symbol[PROTOTYPE], TO_PRIMITIVE, function () {
    return valueOf.apply(this, arguments);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "wEFx":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("Y8c0");
var fails = __webpack_require__("fhLv");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "wKkN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var hiddenKeys = __webpack_require__("qXr/");
var isObject = __webpack_require__("1YFU");
var has = __webpack_require__("DZWw");
var defineProperty = __webpack_require__("87KK").f;
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternalModule = __webpack_require__("Ed3r");
var uid = __webpack_require__("rvZv");
var FREEZING = __webpack_require__("+pJz");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "wpQC":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "wxLG":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "x90g":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "xAOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRAVEL_COMPANIONS_RESOLVED; });
/* unused harmony export initialState */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4Bi9");


var _createReducer;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_TRAVEL_COMPANIONS = 'FETCH_TRAVEL_COMPANIONS';
var UPDATE_TRAVEL_COMPANION = 'UPDATE_TRAVEL_COMPANION';
var FETCH_TRAVEL_COMPANIONS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRAVEL_COMPANIONS);
var initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ __webpack_exports__["b"] = (Object(_store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(initialState, (_createReducer = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS_RESOLVED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload.travelCompanions', [])
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRAVEL_COMPANIONS), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, UPDATE_TRAVEL_COMPANION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload
  });
}), _createReducer)));

/***/ }),

/***/ "xS1b":
/***/ (function(module, exports) {

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "xVJP":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "xe/R":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "xl1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_BOOKING_CART; });
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bookingCartReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var initialState = {
  data: {},
  errorResponse: {},
  editingServiceId: '',
  stay: {}
};
var bookingCartReducer = function bookingCartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        stay: action.payload.stay
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload', {}),
        errorResponse: {}
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        errorResponse: {
          errors: action.payload.errors
        }
      });

    case UPDATE_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: action.payload.id
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          userBooking: _objectSpread(_objectSpread(_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
        })
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        errorResponse: {
          errors: action.payload.errors
        }
      });

    default:
      return state;
  }
};

/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");






var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* LOCALE_FACET_ID */ "v"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["findLast"])(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "o"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* PRODUCT_FACET_ID */ "B"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "z"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "o"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "z"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(filters);
}

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js





var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "yUod":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var getMethod = __webpack_require__("Uey1");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';


/***/ }),

/***/ "ydRd":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("3LIW");
var getBuiltIn = __webpack_require__("x90g");
var inspectSource = __webpack_require__("/ExG");

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["g" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["g" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      startDate: startDate,
      unit: unit
    }),
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "yhbn":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("gIGD");
var isConstructor = __webpack_require__("ydRd");
var isObject = __webpack_require__("1YFU");
var wellKnownSymbol = __webpack_require__("nJrx");

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "yvHl":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var isCallable = __webpack_require__("ANQd");
var toObject = __webpack_require__("A+R+");
var sharedKey = __webpack_require__("mmil");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (has(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "z7Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BOAT */
/* unused harmony export PLANE */
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSPORT_CLASS_TO_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SNCF_ID; });
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatConnectionLabel; });
/* unused harmony export getStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isTransportPlaneTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCancellationPolicyDescription; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oL6k");







var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIV: 'economyClassLabel',
  DIB: 'emeraldClassLabel',
  'EC+': 'alizeeClassLabel',
  ECO: 'economyClassLabel',
  FIR: 'firstClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiTime */ "i"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  var _i18n$common, _i18n$common$transpor, _i18n$common2, _i18n$common2$transpo;

  if (way === 'INBOUND') return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  if (way === 'OUTBOUND') return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_1___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_1___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'connectionDurationInMin');
    var stopOverDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'stopDurationInMin');
    var information = !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(stopOverDuration) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.reference'),
      type: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.type'),
      information: information,
      operator: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.label'),
      operatorId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.id'),
      operatorLogo: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.logo'),
      start: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.date')
      },
      end: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.date')
      },
      technicalStops: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportPlaneTicket(inboundFlight, outboundFlight) {
  return hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(travelSections) ? (travelSections || []).some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'arrival.time') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var numberMinutes = Number(minutes); // TODO cms translate h & m

  return Math.floor(numberMinutes / 60) + ' h ' + (numberMinutes % 60).toString().padStart(2, '0') + ' min';
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$inbound2, _transport$outbound; // in case of AlternativeTransport


  if ((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "v"])(((_transport$inbound$jo = transport.inbound.journey) === null || _transport$inbound$jo === void 0 ? void 0 : _transport$inbound$jo.cancellationPolicyType) || '') || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.some(function (outbound) {
        var _outbound$journey;

        return (// $FlowFixMe at this point it's an AlternativeTransport object
          Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "v"])(((_outbound$journey = outbound.journey) === null || _outbound$journey === void 0 ? void 0 : _outbound$journey.cancellationPolicyType) || '')
        );
      })
    );
  } // in case of Transport


  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "v"])(((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "v"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound3, _transport$inbound4, _transport$outbound2; // in case of AlternativeTransport


  if ((_transport$inbound3 = transport.inbound) === null || _transport$inbound3 === void 0 ? void 0 : _transport$inbound3.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo2;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      ((_transport$inbound$jo2 = transport.inbound.journey) === null || _transport$inbound$jo2 === void 0 ? void 0 : _transport$inbound$jo2.cancellationPolicyType) || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.find(function (outbound) {
        var _outbound$journey2;

        return !!((_outbound$journey2 = outbound.journey) === null || _outbound$journey2 === void 0 ? void 0 : _outbound$journey2.cancellationPolicyType);
      })
    );
  } // in case of Transport
  // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound4 = transport.inbound) === null || _transport$inbound4 === void 0 ? void 0 : _transport$inbound4.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;
  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "z9Jh":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_1___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_START */ "x"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_END */ "w"]);
}

/***/ }),

/***/ "zSnQ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toIndexedObject = __webpack_require__("dNjr");
var nativeGetOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var DESCRIPTORS = __webpack_require__("uGjT");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "zaNA":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "zcYo":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "zr3P":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return noCase; });
/* unused harmony export pascalCase */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].PAGE_TYPES;
var formatPayload = function formatPayload(payload, options) {
  return Object.keys(payload).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, key, Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["messageFormat"])(payload[key]).format(options)));
  }, {});
};
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_3__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_3__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(_ref) {
  var isOption = _ref.isOption,
      isUserQuickLogged = _ref.isUserQuickLogged;

  if (isOption) {
    return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_3__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_3__[/* PLE_OPTION */ "m"];
  } else {
    return getPLECategoryGA(isUserQuickLogged);
  }
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_3__[/* SEARCH_LABEL_GA_MAP */ "r"][type || 'none'];
}
function getSiteSection(_ref2) {
  var _ref2$isOption = _ref2.isOption,
      isOption = _ref2$isOption === void 0 ? false : _ref2$isOption,
      _ref2$isUserQuickLogg = _ref2.isUserQuickLogged,
      isUserQuickLogged = _ref2$isUserQuickLogg === void 0 ? false : _ref2$isUserQuickLogg,
      pageType = _ref2.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_3__[/* STATIC_PAGE_TYPES */ "v"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_3__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_3__[/* STATIC_PAGE_TYPES */ "v"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_3__[/* STATIC_PAGE_TYPES */ "v"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection({
        isOption: isOption,
        isUserQuickLogged: isUserQuickLogged
      });

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
function noCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_1__["startCase"], lodash__WEBPACK_IMPORTED_MODULE_1__["toLower"])(string);
}
function pascalCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_1__["camelCase"], lodash__WEBPACK_IMPORTED_MODULE_1__["upperFirst"])(string);
}

/***/ })

},[[5,1,2,4,5,80,0,3,6,7,8,9,10,11,12,14,13,16,15,17,19,20,21,22,24,23,79]]]);